import { trDemo } from "./tr-demo.js";
import { trWork } from "./tr-work.js";

/**
 * Türkçe arayüz metinleri. Anahtarlar İngilizce, metinler Türkçe (AGENTS.md §3.9).
 * Koddaki her `t("...")` anahtarı burada bulunmalıdır; `tr.test.ts` kaynak kodu tarayıp eksikleri yakalar.
 * Türkçede çoğul eki sayıyla birlikte kullanılmaz ("3 istasyon"), bu yüzden `_one/_other` ayrımı yoktur.
 */
export const tr = {
  demo: trDemo,
  work: trWork,
  common: {
    actions: "İşlemler",
    add: "Ekle",
    edit: "Düzenle",
    required: "Bu alan zorunludur",
    activate: "Etkinleştir",
    active: "Etkin",
    address: "Adres",
    all: "Tümü",
    back: "Geri",
    cancel: "Vazgeç",
    city: "İl",
    clearFilters: "Filtreleri temizle",
    close: "Kapat",
    continue: "Devam et",
    copied: "Panoya kopyalandı",
    copy: "Kopyala",
    deactivate: "Pasife al",
    delete: "Sil",
    district: "İlçe",
    inactive: "Pasif",
    loading: "Yükleniyor",
    next: "İleri",
    no: "Hayır",
    off: "Kapalı",
    on: "Açık",
    pageNumber: "Sayfa {{page}}",
    phone: "Telefon",
    retry: "Yeniden dene",
    save: "Kaydet",
    saved: "Değişiklikler kaydedildi",
    search: "Ara",
    select: "Seçin",
    skip: "Şimdilik atla",
    status: "Durum",
    total: "Toplam",
    yes: "Evet",
  },
  errors: {
    notFound: {
      title: "Sayfa bulunamadı",
      description: "Aradığınız sayfa taşınmış ya da hiç var olmamış olabilir.",
      action: "Ana sayfaya dön",
    },
    unexpected: { title: "Beklenmeyen bir hata oluştu" },
  },
  enums: {
    businessUnit: {
      FUEL: "Akaryakıt",
      LPG: "LPG",
      MARKET: "Market",
      WASH: "Araç yıkama",
      EV: "Elektrikli araç şarjı",
      CAFE: "Kafe",
      RENTAL: "Kiralık alanlar",
    },
    scopeType: {
      TENANT: "Tüm hesap",
      COMPANY: "Şirket",
      REGION: "Bölge",
      STATION: "İstasyon",
      COUNTERPARTY: "Filo carisi",
    },
    stationStatus: { ACTIVE: "Etkin", INACTIVE: "Pasif", TRANSFERRED_OUT: "Devredildi" },
    membershipStatus: { ACTIVE: "Etkin", SUSPENDED: "Askıda", REMOVED: "Kaldırıldı" },
    productType: {
      FUEL: "Akaryakıt",
      LPG: "LPG",
      MARKET_ITEM: "Market ürünü",
      LUBRICANT: "Madeni yağ",
      WASH_SERVICE: "Yıkama hizmeti",
      EV_ENERGY: "EV şarj enerjisi",
      CAFE_ITEM: "Kafe ürünü",
      SERVICE: "Hizmet",
      OTHER: "Diğer",
      CONSUMABLE: "Sarf malzemesi",
    },
    productUnit: { LITRE: "Litre", KG: "Kilogram", PIECE: "Adet", KWH: "kWh", MINUTE: "Dakika" },
    fuelGrade: {
      GASOLINE_95: "Kurşunsuz benzin 95",
      GASOLINE_97: "Kurşunsuz benzin 97",
      DIESEL: "Motorin",
      DIESEL_PREMIUM: "Motorin (premium)",
      LPG_AUTOGAS: "LPG otogaz",
      KEROSENE: "Gazyağı",
      ADBLUE: "AdBlue",
      OTHER: "Diğer",
    },
    assetStatus: { ACTIVE: "Etkin", OUT_OF_SERVICE: "Hizmet dışı", DECOMMISSIONED: "Kullanımdan kaldırıldı" },
    deviceType: {
      TANK_GAUGE: "Tank otomasyonu",
      PUMP_CONTROLLER: "Pompa otomasyonu",
      FISCAL_DEVICE: "Yeni nesil ÖKC",
      POS_TERMINAL: "Banka POS terminali",
      EV_CHARGER: "EV şarj ünitesi",
      WASH_UNIT: "Yıkama ünitesi",
      TTS_READER: "Taşıt tanıma okuyucusu",
      CAMERA: "Kamera",
      OTHER: "Diğer",
    },
    connectorType: { CCS2: "CCS2", TYPE2: "Type 2", CHADEMO: "CHAdeMO" },
    washUnitType: {
      TUNNEL: "Tünel",
      ROLLOVER: "Fırçalı portal",
      SELF_SERVICE_BAY: "Self-servis bölme",
      HAND_WASH: "El yıkama",
    },
    priceChangeStatus: {
      DRAFT: "Taslak",
      PENDING_APPROVAL: "Onay bekliyor",
      SCHEDULED: "Planlandı",
      APPLIED: "Uygulandı",
      CANCELLED: "İptal edildi",
    },
    priceSource: {
      DISTRIBUTOR: "Dağıtıcı bildirimi",
      MANUAL: "Elle",
      INITIAL: "İlk fiyat",
      IMPORT: "İçe aktarma",
    },
    invitationStatus: {
      PENDING: "Bekliyor",
      ACCEPTED: "Kabul edildi",
      REVOKED: "İptal edildi",
      EXPIRED: "Süresi doldu",
    },
    journalEntryType: {
      TAHSIL: "Tahsil",
      TEDIYE: "Tediye",
      MAHSUP: "Mahsup",
      ACILIS: "Açılış",
      KAPANIS: "Kapanış",
    },
    journalEntryStatus: { DRAFT: "Taslak", POSTED: "Kesinleşti", REVERSED: "Ters kaydı alındı" },
    journalSource: {
      MANUAL: "Elle",
      ACCOUNTING: "Muhasebe (otomatik)",
      COUNTERPARTY: "Cari hesaplar",
      CASH: "Kasa",
      BANK: "Banka",
      CHEQUE: "Çek / senet",
      INVOICE: "Fatura",
      FUEL: "Akaryakıt",
      LPG: "LPG",
      MARKET: "Market",
      WASH: "Araç yıkama",
      EV: "EV şarj",
      CAFE: "Kafe",
      RENTAL: "Kira",
      SHIFT: "Vardiya",
      STOCK: "Stok",
    },
    fiscalPeriodStatus: { OPEN: "Açık", SOFT_CLOSED: "Geçici kapalı", CLOSED: "Kapalı" },
    fiscalYearStatus: { OPEN: "Açık", CLOSED: "Kapalı" },
    accountType: {
      ASSET: "Varlık",
      LIABILITY: "Yabancı kaynak",
      EQUITY: "Özkaynak",
      REVENUE: "Gelir",
      EXPENSE: "Gider",
      MEMO: "Nazım",
    },
    balanceSide: { DEBIT: "Borç", CREDIT: "Alacak" },
    checkStatus: { OK: "Tamam", WARNING: "Uyarı", BLOCKER: "Engelleyici", NOT_APPLICABLE: "Uygulanmaz" },
    postingExceptionReason: {
      MAPPING_MISSING: "Eşleştirme yok",
      ACCOUNT_NOT_POSTABLE: "Hesap kayda kapalı",
      DIMENSION_MISSING: "Zorunlu boyut eksik",
    },
  },
  auth: {
    email: "E-posta",
    password: "Parola",
    newPassword: "Yeni parola",
    confirmPassword: "Yeni parola (tekrar)",
    passwordHint: "En az 10 karakter. Tahmin edilmesi zor, birkaç sözcükten oluşan bir parola seçin.",
    fullName: "Ad soyad",
    backToLogin: "Giriş ekranına dön",
    login: {
      title: "Giriş yapın",
      description: "İstasyonlarınızı yönetmek için hesabınıza giriş yapın.",
      submit: "Giriş yap",
      forgot: "Parolamı unuttum",
      deviceBrowser: "Web tarayıcı",
      deviceMobile: "Mobil tarayıcı",
    },
    mfa: {
      title: "İki adımlı doğrulama",
      description: "Doğrulama uygulamanızdaki 6 haneli kodu girin.",
      code: "Doğrulama kodu",
      hint: "Telefonunuza erişemiyorsanız kurtarma kodlarınızdan birini de girebilirsiniz.",
      submit: "Doğrula",
      back: "Farklı bir hesapla giriş yap",
    },
    forgot: {
      title: "Parolanızı mı unuttunuz?",
      description: "E-posta adresinizi yazın; parolanızı sıfırlamanız için bir bağlantı gönderelim.",
      submit: "Sıfırlama bağlantısı gönder",
      sentTitle: "E-postanızı kontrol edin",
      sentDescription:
        "Bu adresle kayıtlı bir hesap varsa sıfırlama bağlantısı birkaç dakika içinde ulaşır. Bağlantının süresi sınırlıdır; gecikmeden kullanın.",
    },
    reset: {
      title: "Yeni parola belirleyin",
      description: "Parolanız değişince tüm cihazlardaki oturumlarınız kapatılır.",
      submit: "Parolayı değiştir",
      doneTitle: "Parolanız değiştirildi",
      doneDescription: "Yeni parolanızla giriş yapabilirsiniz.",
      missingToken:
        "Sıfırlama bağlantısı eksik ya da bozuk. Lütfen e-postadaki bağlantıyı yeniden açın veya yeni bir bağlantı isteyin.",
    },
    invite: {
      title: "Daveti kabul edin",
      summary: "{{tenant}} sizi şu rol(ler)le davet etti: {{roles}}",
      invalidTitle: "Davet geçersiz",
      invalidDescription:
        "Bu davetin süresi dolmuş, iptal edilmiş ya da daha önce kullanılmış. Sizi davet eden kişiden yeni bir davet isteyin.",
      acceptExisting: "Daveti kabul et",
      acceptNew: "Hesabı oluştur ve daveti kabul et",
      loginFirst: "Bu davet {{email}} hesabına gönderildi. Kabul etmek için önce bu hesapla giriş yapın.",
    },
  },
  menu: {
    groups: {
      main: "Genel",
      catalog: "Ürün ve fiyat",
      fuel: "Akaryakıt",
      shifts: "Vardiya",
      accounting: "Muhasebe",
      counterparties: "Cari hesaplar",
      invoicing: "Fatura ve e-belge",
      finance: "Finans",
      expensesBudget: "Gider ve bütçe",
      instruments: "Çek ve senet",
      devices: "Cihazlar ve ajanlar",
      market: "Market",
      customers: "Müşteriler",
      fleet: "Filo",
      loyalty: "Sadakat",
      wash: "Yıkama",
      ev: "Şarj",
      privacy: "KVKK",
      settings: "Ayarlar",
      alarms: "Alarmlar",
      reports: "Raporlar",
      maintenance: "Bakım ve uyum",
    },
    reportsCenter: "Rapor merkezi",
    reportsComparison: "İstasyon karşılaştırma",
    reportsFuel: "Akaryakıt analitiği",
    reportsProfitability: "Kârlılık ve tutarlılık",
    reportsFinance: "Nakit ve finans",
    reportsSchedules: "Zamanlanmış raporlar",
    reportsSettings: "Rapor ayarları",
    maintenanceWorkOrders: "Bakım iş emirleri",
    maintenancePlans: "Bakım planları",
    maintenanceAssets: "Varlıklar",
    maintenanceReports: "Bakım raporu",
    maintenanceSettings: "Bakım ayarları",
    complianceCalendar: "Uyum takvimi",
    complianceDocuments: "Uyum belgeleri",
    complianceInspections: "Denetimler",
    complianceTypes: "Belge türleri",
    customers: "Müşteriler",
    fleetAccounts: "Filo hesapları",
    fleetVehicleRequests: "Araç talepleri",
    fleetConsumption: "Tüketim raporu",
    loyaltyProgram: "Program ve marka",
    loyaltyTiers: "Seviyeler",
    loyaltyEarnRules: "Kazanım kuralları",
    loyaltyReviews: "İnceleme kuyruğu",
    loyaltyCoupons: "Kuponlar",
    loyaltySubscriptions: "Abonelikler",
    loyaltyReports: "Sadakat raporları",
    washUnits: "Üniteler",
    washPrograms: "Programlar",
    washCycles: "Çalışmalar",
    washCredits: "Yıkama kredileri",
    washChemicals: "Kimyasallar",
    washAppointments: "Randevular",
    washWorkOrders: "İş emirleri",
    washQueue: "Sıra ekranı",
    washReports: "Yıkama raporları",
    washSettings: "Yıkama ayarları",
    evDashboard: "Şarj panosu",
    evChargers: "Şarj üniteleri",
    evSessions: "Şarj oturumları",
    evTariffs: "Şarj tarifeleri",
    evPartnerImports: "Şarj ağı aktarımları",
    evExports: "Şarj dışa aktarımı",
    evReports: "Şarj raporları",
    evSettings: "Şarj ayarları",
    privacyTexts: "KVKK metinleri",
    privacyRequests: "KVKK başvuruları",
    marketingMessages: "Pazarlama iletisi",
    privacySettings: "KVKK ayarları",
    agents: "Ajanlar",
    posSales: "Kasa satışları",
    posCampaigns: "Kampanyalar",
    posSettings: "Kasa ayarları",
    marketStock: "Market stoğu",
    marketMovements: "Stok hareketleri",
    marketLots: "SKT ve partiler",
    marketTransfers: "Transferler",
    marketWriteOffs: "Fire / imha",
    marketCounts: "Sayımlar",
    marketDailyClosings: "Market gün kapanışı",
    marketSettings: "Market ayarları",
    marketOrderSuggestions: "Market sipariş önerisi",
    marketPurchaseOrders: "Tedarikçi siparişleri",
    marketGoodsReceipts: "Mal kabul",
    marketInvoiceMatches: "Fatura eşleştirme",
    marketPriceSuggestions: "Fiyat önerisi",
    marketLabels: "Raf etiketleri",
    marketReports: "Market raporları",
    marketLicenses: "Satış belgeleri",
    approvals: "Onaylar",
    fuelTanks: "Tanklar",
    fuelSales: "Akaryakıt satışları",
    fuelTotalizers: "Endeks",
    fuelOrders: "Siparişler",
    fuelDeliveries: "Tanker dolumları",
    fuelReconciliation: "Mutabakat",
    fuelCost: "Stok maliyeti",
    fuelSettings: "Akaryakıt ayarları",
    fuelOrderSuggestions: "Sipariş önerileri",
    fuelPriceDifference: "Fiyat farkı",
    fuelLossReport: "Fire raporu",
    shiftBoard: "Vardiya panosu",
    shifts: "Vardiyalar",
    shiftStaff: "Personel",
    shiftTemplates: "Vardiya şablonları",
    shiftSettings: "Vardiya ayarları",
    shiftDayEnd: "Gün sonu",
    shiftZReports: "Z raporları",
    shiftReports: "Vardiya raporları",
    expenses: "Giderler",
    payments: "Ödeme planlama",
    taxCalendar: "Vergi takvimi",
    cashFlow: "Nakit akış",
    budget: "Bütçe",
    expenseDefinitions: "Tanımlar",
    invoices: "Faturalar",
    invoiceNew: "Yeni fatura",
    invoiceInbox: "Gelen kutusu",
    despatches: "İrsaliyeler",
    earchiveRequests: "POS e-Arşiv talepleri",
    invoicingSettings: "Fatura ayarları",
    instrumentPortfolio: "Çek / senet portföyü",
    instrumentNewBatch: "Yeni bordro",
    instrumentBatches: "Bordrolar",
    instrumentBooks: "Çek karneleri",
    instrumentCalendar: "Vade takvimi",
    instrumentReports: "Çek raporları",
    instrumentSettings: "Çek ayarları",
    cashPosition: "Nakit pozisyonu",
    cashRegisters: "Kasalar",
    bankAccounts: "Banka hesapları",
    treasuryTransactions: "Kasa / banka hareketleri",
    bankStatements: "Banka ekstresi",
    pos: "POS",
    guarantees: "Teminatlar",
    dbs: "DBS",
    loans: "Krediler",
    treasurySettings: "Finans ayarları",
    counterparties: "Cariler",
    counterpartyTransaction: "Yeni cari hareketi",
    counterpartyReports: "Cari raporları",
    counterpartyRisk: "Risk panosu",
    journalEntries: "Fişler",
    chartOfAccounts: "Hesap planı",
    accountingReports: "Raporlar",
    fiscalPeriods: "Dönemler",
    accountMappings: "Eşleştirmeler",
    accountingTools: "Araçlar",
    products: "Ürün kataloğu",
    prices: "Fiyatlar",
    home: "Ana sayfa",
    companies: "Şirketler",
    regions: "Bölgeler",
    stations: "İstasyonlar",
    station: "İstasyon",
    users: "Kullanıcılar",
    roles: "Roller",
    security: "Güvenlik",
    profile: "Profil",
    subscription: "Abonelik ve faturalar",
    supportAccess: "Destek erişimi",
    stationTransfers: "İstasyon devirleri",
    announcements: "Duyurular",
    alarms: "Alarmlar",
    alarmRules: "Alarm kuralları",
    notifications: "Bildirimler",
    notificationPreferences: "Bildirim tercihleri",
  },
  shell: {
    skipToContent: "İçeriğe geç",
    mainNavigation: "Ana menü",
    openMenu: "Menüyü aç",
    search: "Ara",
    noTenant: {
      title: "Etkin bir hesabınız yok",
      description: "Hiçbir işletmeye üye değilsiniz. Bir davet aldıysanız e-postanızdaki bağlantıyı açın.",
    },
    readOnly: {
      title: "Hesap salt okunur durumda",
      description:
        "Verilerinizi görüntüleyebilir ve dışa aktarabilirsiniz; yeni kayıt girilemez. Ayrıntı için destek ekibine ulaşın.",
    },
    mfaRequired: {
      title: "İki adımlı doğrulama zorunlu",
      description:
        "İşletmeniz tüm kullanıcılar için iki adımlı doğrulamayı zorunlu kıldı. Devam etmek için kurulumu tamamlayın.",
      action: "Kurulumu başlat",
    },
    onboarding: {
      title: "Kurulumu tamamlayın",
      description: "Şirket ve istasyon bilgilerinizi girerek hesabınızı kullanıma hazırlayın.",
      action: "Kuruluma devam et",
    },
    tenantSwitcher: {
      label: "Etkin hesap: {{tenant}}. Değiştirmek için tıklayın",
      title: "Hesap değiştir",
      current: "Etkin",
    },
    scope: { label: "Kapsam", all: "Tüm istasyonlar", regions: "Bölgeler", stations: "İstasyonlar" },
    notifications: {
      label: "Bildirimler",
      emptyTitle: "Yeni bildirim yok",
      emptyDescription: "Alarmlar ve onay bekleyen işlemler burada görünecek.",
    },
    palette: { placeholder: "Sayfa ya da istasyon arayın…", pages: "Sayfalar", stations: "İstasyonlar" },
    realtime: {
      connected: "Canlı bağlantı kuruldu",
      disconnected: "Canlı bağlantı yok; yeniden bağlanılıyor",
    },
    userMenu: {
      label: "Kullanıcı menüsü: {{name}}",
      lightTheme: "Açık tema",
      darkTheme: "Koyu tema",
      systemTheme: "Sistem teması",
      platform: "Platform paneli",
      logout: "Çıkış yap",
    },
  },
  home: {
    overviewDescription: "{{count}} istasyonun özeti",
    cards: {
      alerts: "Alarmlar",
    },
    noStations: { title: "Henüz istasyon yok", description: "İstasyon ekleyince özetler burada görünecek." },
    asOf: "{{at}} itibarıyla",
    issues: {
      expiredDays: "{{count}} gün önce bitti",
      expiresInDays: "{{count}} gün kaldı",
      runOut: "tahmini bitiş {{at}}",
      lastSeen: "son bağlantı {{at}}",
      neverSeen: "hiç bağlanmadı",
    },
    today: {
      title: "Bugün",
      live: "Canlı",
      summary: "Özet (canlı sayaç yok)",
      revenue: "Ciro (KDV dahil)",
      litres: "Pompa satışı",
      vsYesterday: "Düne göre",
      vsLastWeek: "Geçen haftaya göre",
      byUnit: "İş birimlerine göre (düne göre)",
      stations: "İstasyonlara göre bugün",
      hint: "Karşılaştırmalar dünün ve geçen haftanın AYNI SAATİNE kadardır (yarım gün tam günle karşılaştırılmaz).",
    },
    trend: {
      title: "Son 14 gün",
      revenue: "Ciro (₺)",
      litres: "Pompa litresi",
      aria: "Son 14 günün günlük cirosu ve pompa litresi grafiği",
      table: "Son 14 günün günlük cirosu ve litresi",
      allReports: "Rapor merkezi",
    },
  },
  onboarding: {
    title: "Kurulum sihirbazı",
    description:
      "Birkaç adımda hesabınızı kullanıma hazırlayın. İstediğiniz an bırakıp kaldığınız yerden devam edebilirsiniz.",
    steps: "Kurulum adımları",
    stepDone: "tamamlandı",
    step: {
      companies: {
        title: "Şirket",
        description: "İstasyonlarınızın bağlı olduğu, faturaların kesildiği şirket bilgilerini girin.",
        required: "Devam etmek için en az bir şirket ekleyin.",
      },
      stations: {
        title: "İstasyonlar",
        description: "İstasyonlarınızı tek tek ekleyin ya da Excel şablonuyla toplu yükleyin.",
        required: "Devam etmek için en az bir istasyon ekleyin.",
      },
      businessUnits: {
        title: "İş birimleri",
        description:
          "Her istasyonda hangi iş birimlerinin bulunduğunu işaretleyin. Sonradan değiştirebilirsiniz.",
        required: "",
      },
      invitations: {
        title: "Kullanıcılar",
        description:
          "Ekip arkadaşlarınızı ve mali müşavirinizi davet edin. Bu adımı atlayıp sonra da yapabilirsiniz.",
        required: "",
      },
      summary: {
        title: "Özet",
        description:
          "Her şey hazır. Girdiğiniz bilgileri Ayarlar menüsünden dilediğiniz zaman değiştirebilirsiniz.",
        required: "",
      },
    },
    summary: { companies: "Şirket", stations: "İstasyon", invitations: "Davet" },
    addAnotherCompany: "Başka bir şirket ekle",
    addAnotherStation: "Başka bir istasyon ekle",
    bulkImport: "Excel ile toplu yükle",
    finish: "Kurulumu tamamla",
    completed: "Kurulum tamamlandı. Hoş geldiniz!",
  },
  companies: {
    description: "Muhasebe defteri şirket bazında tutulur; her istasyon bir şirkete bağlıdır.",
    add: "Şirket ekle",
    editDescription: "Vergi bilgileri faturalarda ve resmî belgelerde kullanılır.",
    eInvoice: "e-Fatura",
    eInvoiceRegistered: "Mükellef",
    multiCompanyNotInPlan:
      "Aboneliğiniz tek şirketi kapsıyor. Birden fazla şirket eklemek için planınızı yükseltin.",
    activateHint: "Şirket pasif. Etkinleştirdiğinizde yeni istasyon ve belgelerde yeniden seçilebilir.",
    deactivateHint: "Pasife alınan şirket yeni kayıtlarda seçilemez; geçmiş kayıtları korunur.",
    empty: {
      title: "Henüz şirket yok",
      description: "İstasyon ekleyebilmek için önce bir şirket tanımlayın.",
    },
    fields: {
      legalName: "Ticari unvan",
      shortName: "Kısa ad",
      shortNameHint: "Listelerde ve raporlarda görünür.",
      companyType: "Şirket türü",
      taxId: "VKN / TCKN",
      taxIdHint: "Tüzel kişilerde 10 haneli VKN, şahıs şirketinde 11 haneli TCKN.",
      taxOffice: "Vergi dairesi",
      isEInvoiceRegistered: "e-Fatura mükellefi",
    },
  },
  regions: {
    description:
      "Bölgeler istasyonları gruplar; bölge müdürlerine kapsamlı yetki vermek ve raporları kırmak için kullanılır.",
    add: "Bölge ekle",
    rename: "Yeniden adlandır",
    empty: {
      title: "Henüz bölge yok",
      description: "İstasyonlarınızı gruplamak isterseniz bölge ekleyin. Bölge kullanmak zorunlu değildir.",
    },
    fields: { name: "Bölge adı", stationCount: "İstasyon sayısı" },
  },
  stations: {
    description: "İstasyon bilgileri, iş birimleri ve lisanslar.",
    add: "İstasyon ekle",
    created: "{{name}} eklendi",
    searchPlaceholder: "Kod, ad ya da il",
    businessUnits: "İş birimleri",
    businessUnitsHint: "Kapatılan iş birimi yeni işlemlerde seçilemez; geçmiş kayıtları korunur.",
    unitNotInPlan: "Aboneliğinizde yok",
    unitActiveSince: "{{date}} tarihinden beri etkin",
    areaM2: "Alan (m²)",
    areaM2Label: "{{unit}} iş biriminin alanı (m²)",
    empty: {
      title: "Henüz istasyon yok",
      description: "İlk istasyonunuzu ekleyin ya da Excel şablonuyla toplu yükleyin.",
      filteredTitle: "Eşleşen istasyon yok",
      filteredDescription: "Arama metnini ya da filtreleri değiştirerek yeniden deneyin.",
    },
    notFound: {
      title: "İstasyon bulunamadı",
      description: "İstasyon silinmiş, devredilmiş ya da erişim kapsamınızın dışında olabilir.",
    },
    tabs: {
      label: "İstasyon ayrıntıları",
      general: "Genel",
      businessUnits: "İş birimleri",
      assets: "Varlıklar",
      licenses: "Lisanslar",
    },
    activate: {
      title: "İstasyonu etkinleştir",
      description: "İstasyon yeniden işlem kabul eder ve listelerde etkin görünür.",
    },
    deactivate: {
      title: "İstasyonu pasife al",
      description: "Pasif istasyonda yeni işlem yapılamaz; geçmiş veriler ve raporlar korunur.",
      confirm: "Bu kritik bir işlemdir. Onaylamak için istasyon kodunu ({{code}}) yazın.",
    },
    transferredOut: {
      title: "Bu istasyon devredildi",
      description:
        "İstasyon {{date}} tarihinde başka bir işletmeye devredildi. Geçmiş veriler salt okunur olarak sizde kalır.",
    },
    licenses: {
      epdk: "EPDK bayilik lisansı",
      editHint: "Lisans bilgilerini Genel sekmesinden güncelleyebilirsiniz.",
      moreLater:
        "Çevre izni, işyeri açma ruhsatı, ölçü ve tartı muayenesi gibi diğer belgeler uyum modülüyle birlikte bu sekmede izlenecek.",
      state: {
        missing: "Tarih girilmemiş",
        expired: "Süresi {{count}} gün önce doldu",
        expiring: "{{count}} gün içinde doluyor",
        valid: "Geçerli ({{count}} gün)",
      },
    },
    fields: {
      code: "İstasyon kodu",
      codeHint: "Kısa ve benzersiz; ör. IST01. Raporlarda ve belgelerde görünür.",
      name: "İstasyon adı",
      company: "Şirket",
      region: "Bölge",
      noRegion: "Bölge yok",
      distributor: "Dağıtıcı",
      epdkLicenseNo: "EPDK lisans no",
      epdkLicenseExpiresOn: "Lisans bitiş tarihi",
      activeFrom: "Faaliyet başlangıcı",
    },
    import: {
      action: "Toplu içe aktar",
      description:
        "Şablonu indirip doldurun, sonra dosyayı yükleyin. Kaydetmeden önce satırları önizleyip hataları görebilirsiniz.",
      template: "Şablonu indir",
      chooseFile: "Dosya seç (.xlsx, .csv)",
      validRows: "{{count}} geçerli satır",
      invalidRows: "{{count}} hatalı satır",
      newRegions: "Oluşturulacak yeni bölgeler: {{regions}}",
      previewCaption: "İçe aktarma önizlemesi",
      row: "Satır",
      result: "Sonuç",
      ok: "Uygun",
      fixAndRetry:
        "Hatalı satırlar içe aktarılmaz. Dosyayı düzeltip yeniden yükleyebilir ya da yalnızca geçerli satırlarla devam edebilirsiniz.",
      commit: "{{count}} istasyonu içe aktar",
      done: "{{count}} istasyon içe aktarıldı",
    },
  },
  catalog: {
    description:
      "Sattığınız ürün ve hizmetler. Fiyatlar burada değil, istasyona göre Fiyatlar ekranında yönetilir.",
    add: "Ürün ekle",
    readOnly: "Ürün bilgilerini görüntüleyebilirsiniz; değiştirmek için katalog yönetimi yetkisi gerekir.",
    searchPlaceholder: "Ad, kod ya da barkod",
    noCategory: "Kategorisiz",
    consumableHint:
      "Sarf malzemesi (yıkama kimyasalı) kasada SATILMAZ: kasa kataloğunda ve ajanın ürün listesinde yer almaz. Stoğu istasyonun yıkama deposunda tutulur, program reçetesiyle tüketilir.",
    posSection: "Yerel kasa",
    marketSection: "Market",
    stockCardHint:
      "Stok, partiler (SKT), tedarikçiler ve istasyon ayarları (min / max, raf yeri) stok kartındadır.",
    openStockCard: "Market stok kartını aç",
    fuelSection: "Akaryakıt / LPG bilgileri",
    activateHint: "Ürün pasif. Etkinleştirdiğinizde satışta ve yeni kayıtlarda yeniden seçilebilir.",
    deactivateHint: "Pasife alınan ürün satışta ve yeni kayıtlarda seçilemez; geçmiş kayıtları korunur.",
    empty: {
      title: "Henüz ürün yok",
      description: "Akaryakıt, market ürünü ya da hizmet ekleyerek kataloğunuzu oluşturun.",
      filteredTitle: "Eşleşen ürün yok",
      filteredDescription: "Arama metnini, kategoriyi ya da filtreleri değiştirerek yeniden deneyin.",
    },
    fields: {
      productType: "Ürün türü",
      code: "Ürün kodu",
      codeHint: "Kısa ve benzersiz; ör. B95, SU05.",
      codeLocked: "Ürün kodu sonradan değiştirilemez.",
      name: "Ürün adı",
      shortName: "Kısa ad",
      shortNameHint: "Fişte ve pompa ekranında görünür (en çok 40 karakter).",
      category: "Kategori",
      unit: "Birim",
      businessUnit: "İş birimi",
      vatRate: "KDV oranı",
      vatRateHint:
        "Oran belge tarihine göre çözülür; mevzuat değişince ürünleri tek tek güncellemeniz gerekmez.",
      accountingGroup: "Muhasebe grubu",
      accountingGroupHint: "Muhasebe hesap eşleştirmesinde kullanılan anahtar (ör. FUEL_GASOLINE).",
      fuelGrade: "Yakıt sınıfı",
      color: "Ürün rengi",
      colorHint: "Tank ve pompa şemalarında kullanılır.",
      defaultDensity: "Varsayılan yoğunluk (kg/L)",
      defaultDensityHint: "15 °C'deki yoğunluk. LPG'de kg ↔ litre dönüşümü için zorunludur.",
      thermalExpansion: "Isıl genleşme katsayısı (1/°C)",
      thermalExpansionHint: "Ölçülen hacmi 15 °C'ye düzeltmek için kullanılır.",
      isAgeRestricted: "Yaş sınırlı ürün (tütün / alkol)",
      isAgeRestrictedHint: "Kasada satılırken personelden açık yaş onayı istenir.",
      isAgeRestrictedShort: "Yaş sınırlı",
      posQuickKeySlot: "Hızlı tuş yuvası",
      posQuickKeySlotHint: "Kasa ekranındaki hızlı tuş sırası (1–48). Boş bırakılırsa hızlı tuşta yer almaz.",
      posQuickKeySlotEmpty: "Hızlı tuşta yok",
      brand: "Marka",
      packSize: "Koli içi adet",
      packSizeHint: "Sipariş önerisi bu katlara yukarı yuvarlanır (ör. 24).",
      netContent: "Net içerik",
      netContentHint: "Etiketteki birim fiyat için (ör. 500 g → 500). Birimiyle birlikte girilir.",
      netContentUnit: "Net içerik birimi",
      netContentUnitEmpty: "Birim seçin",
      trackExpiry: "Son kullanma tarihi (SKT) takibi",
      trackExpiryHint:
        "Mal kabulde parti no ve SKT istenir; satış ve fire önce SKT'si en yakın partiden düşer (FEFO).",
      sctIncluded: "ÖTV fiyata dâhil",
      sctIncludedHint: "Bilgi alanıdır: akaryakıtta ÖTV satış fiyatının içindedir ve maliyete dâhildir.",
    },
    barcodes: {
      title: "Barkodlar",
      empty: "Bu ürüne barkod tanımlanmamış.",
      add: "Barkod ekle (okutabilirsiniz)",
      primary: "Ana barkod",
      remove: "{{barcode}} barkodunu kaldır",
      save: "Barkodları kaydet",
    },
    categories: {
      title: "Kategoriler",
      all: "Tüm ürünler",
      addTitle: "Kategori ekle",
      editTitle: "Kategoriyi düzenle",
      edit: "{{name}} kategorisini düzenle",
      name: "Kategori adı",
      parent: "Üst kategori",
      root: "Üst kategori yok (ana kategori)",
      targetMargin: "Hedef brüt marj (%)",
      targetMarginHint:
        "Market satış fiyatı önerisi bu marjı kullanır. Boş bırakılırsa şirketin market ayarındaki varsayılan geçerlidir.",
    },
  },
  pricing: {
    description:
      "İstasyon bazında güncel fiyatlar, fiyat geçmişi ve planlı fiyat değişiklikleri. Tüm fiyatlar KDV dâhildir.",
    unitPrice: "Birim fiyat",
    product: "Ürün",
    source: "Kaynak",
    requestNo: "Talep no",
    effectiveAt: "Yürürlük zamanı",
    tabs: { current: "Güncel fiyatlar", requests: "Değişiklik talepleri", groups: "Fiyat grupları" },
    groups: {
      intro:
        "Fiyat grubu, toplu fiyat değişikliğinde istasyonları tek tıkla seçtiren bir kısayoldur. Fiyat yine istasyon bazında tutulur; bir istasyon en çok bir grupta olabilir.",
      company: "Şirket",
      title: "Fiyat grupları",
      add: "Grup ekle",
      addTitle: "Fiyat grubu ekle",
      editTitle: "Fiyat grubunu düzenle",
      dialogDescription: "Grup kodu sonradan değiştirilemez. Üyesi olan grup pasife alınamaz.",
      editLabel: "{{code}} grubunu düzenle",
      empty: "Bu şirkette fiyat grubu yok.",
      noStations: "Üye istasyon yok",
      code: "Grup kodu",
      codeHint: "2–30 karakter; büyük harf, rakam, - ve _ (ör. EGE).",
      codeLocked: "Grup kodu değiştirilemez.",
      name: "Grup adı",
      stations: "Üye istasyonlar",
      inOtherGroup: "{{code}} grubunda",
      members: "Üyeler",
      membersLabel: "{{code}} grubunun üyelerini düzenle",
      membersTitle: "{{code}} — üye istasyonlar",
      membersDescription:
        "Başka bir gruptaki istasyon eklenemez; önce o gruptan çıkarılmalıdır. Kayıt üye listesini tümüyle değiştirir.",
      membersSaved: "Üye istasyonlar kaydedildi",
      saved: "Fiyat grubu kaydedildi",
    },
    current: {
      caption: "İstasyon ve ürüne göre güncel fiyatlar",
      empty: "Henüz fiyat girilmemiş",
      emptyHint:
        "Toplu fiyat değişikliğiyle ilk fiyatlarınızı girin. Tank tanımladığınız ürünler burada kendiliğinden listelenir.",
      noPrice: "Fiyat yok",
      cellLabel: "{{station}}, {{product}}: {{price}}. Fiyat geçmişini aç",
      legend:
        "Hücreye tıklayınca fiyat geçmişi açılır. Mavi satır, planlanmış bir sonraki fiyatı ve yürürlük zamanını gösterir.",
    },
    history: {
      description: "Fiyat geçmişi",
      validFrom: "Yürürlük başlangıcı",
      upcomingTitle: "Planlanmış fiyat değişikliği",
      upcoming: "{{date}} tarihinde {{price}} olacak ({{requestNo}}).",
    },
    requests: {
      empty: "Fiyat değişikliği talebi yok",
      emptyHint: "Toplu fiyat değişikliği sihirbazıyla yeni bir talep oluşturabilirsiniz.",
      detailTitle: "Fiyat değişikliği talebi",
      scope: "Kapsam",
      scopeValue: "{{stations}} istasyon · {{items}} fiyat",
      createdBy: "Hazırlayan",
      approvedBy: "Onaylayan",
      appliedAt: "Uygulanma zamanı",
      note: "Not",
      items: "Talepteki fiyatlar",
      currentPrice: "Güncel fiyat",
      previous: "Önceki fiyat",
      newPrice: "Yeni fiyat",
      change: "Değişim",
      submit: "Onaya gönder",
      approve: "Onayla ve planla",
      cancel: "Talebi iptal et",
      cancelScheduled: "Planlı değişikliği iptal et",
      cancelTitle: "Talep iptal edilsin mi?",
      cancelDescription:
        "İptal edilen talep uygulanmaz ve yeniden açılamaz. Gerekirse yeni bir talep oluşturabilirsiniz.",
      cancelReason: "İptal nedeni",
      waitingApproval: "Talep onay bekliyor. Onaylama yetkisi olan bir kullanıcı planlayabilir.",
      cannotApproveOwn: "Onay bekliyor — kendi talebinizi onaylayamazsınız.",
      done: {
        submit: "Talep onaya gönderildi",
        approve: "Talep onaylandı ve planlandı",
        cancel: "Talep iptal edildi",
      },
    },
    bulk: {
      action: "Toplu fiyat değişikliği",
      title: "Toplu fiyat değişikliği",
      description:
        "İstasyon ve ürünleri seçin, artışı uygulayın, sonucu önizleyip yürürlük zamanını planlayın.",
      steps: "Sihirbaz adımları",
      step: { scope: "Kapsam", adjust: "Ayarla ve önizle", schedule: "Planla" },
      products: "Ürünler",
      priceGroups: "Fiyat grupları",
      priceGroupsHint:
        "Grubu işaretlemek grubun tüm istasyonlarını seçer; istasyonları ayrıca tek tek değiştirebilirsiniz.",
      groupPartial: "Kısmen seçili",
      groupStations: "{{count}} istasyon",
      selectAll: "Tümünü seç",
      selectNone: "Seçimi kaldır",
      mode: "Değişiklik türü",
      modes: { PERCENT: "Yüzde artır / azalt", AMOUNT: "Tutar ekle / çıkar", SET: "Sabit fiyat belirle" },
      valueLabel: { PERCENT: "Yüzde (%)", AMOUNT: "Tutar (₺)", SET: "Yeni fiyat (₺)" },
      valueHint: "İndirim için eksi değer girin (ör. -2).",
      roundTo: "Yuvarlama",
      decimals: "{{count}} ondalık basamak",
      preview: "Önizle",
      previewCaption: "Yeni fiyatların önizlemesi",
      previewHint: "Değeri girip Önizle'ye basın. Hesaplanan fiyatları hücre hücre elle düzeltebilirsiniz.",
      cellLabel: "{{station}}, {{product}} için yeni fiyat",
      skipped: "{{count}} hücre atlandı: güncel fiyatı yok ya da sonuç sıfırın altına düşüyor.",
      summary: "{{stations}} istasyonda {{prices}} fiyat değişecek.",
      effectiveDate: "Yürürlük tarihi",
      effectiveTime: "Saat",
      effectiveHint: "İstanbul saatiyle. Fiyatlar tam bu anda yürürlüğe girer.",
      saveDraft: "Taslak olarak kaydet",
      saveAndSubmit: "Kaydet ve onaya gönder",
      created: "{{requestNo}} numaralı talep oluşturuldu",
    },
  },
  assets: {
    editItem: "{{name}} kaydını düzenle",
    fields: { name: "Ad", brand: "Marka", model: "Model", serialNo: "Seri no" },
    tanks: {
      title: "Tanklar",
      description: "Yer altı tankları, kapasiteleri ve kalibrasyon tabloları.",
      empty: "Bu istasyonda tank tanımlı değil",
      emptyHint: "Tank ekleyip kalibrasyon tablosunu yükleyin; stok ve mutabakat hesapları buna dayanır.",
      tankNo: "Tank {{no}}",
      addTitle: "Tank ekle",
      editTitle: "Tank {{no}} — düzenle",
      capacity: "Nominal kapasite",
      safeFill: "Güvenli dolum",
      minCritical: "Minimum / kritik",
      nozzles: "Bağlı tabanca",
      diagram:
        "Tank şeması: güvenli doluluk üst sınırı %{{safe}}; sarı çizgi minimum, kırmızı çizgi kritik seviye",
      fields: {
        tankNo: "Tank no",
        product: "Ürün",
        nominalCapacity: "Nominal kapasite (L)",
        safeFillPercent: "Güvenli doluluk üst sınırı (%)",
        safeFillHint: "Dolumda bu oranın üzerine çıkılmaması gerekir (LPG'de genellikle %85).",
        minLevel: "Minimum seviye (L)",
        criticalLevel: "Kritik seviye (L)",
        probeId: "Prob kimliği",
        probeIdHint: "Tank otomasyon sistemindeki prob / kanal numarası.",
      },
    },
    strapping: {
      title: "Tank {{no}} — kalibrasyon tablosu",
      description:
        "Prob yüksekliğini (mm) hacme (L) çeviren tablo. Yüklenen sürüm değiştirilemez; düzeltme yeni sürümle yapılır.",
      upload: "Kalibrasyon tablosu",
      missing: "Kalibrasyon tablosu yok",
      active: "Kalibrasyon: sürüm {{version}}, {{rows}} satır, {{date}} tarihinden beri",
      chooseFile: "CSV dosyası seç",
      format: "İki sütun: yükseklik (mm); hacim (L). Başlık satırı isteğe bağlıdır.",
      valid: "Tablo geçerli",
      invalid: "{{count}} hata bulundu",
      summary: "{{rows}} satır · en yüksek {{height}} mm → {{volume}} L",
      issues: "Hatalı satır raporu",
      sample: "İlk ve son satırlardan örnek",
      height: "Yükseklik (mm)",
      volume: "Hacim (L)",
      validFrom: "Geçerlilik başlangıcı",
      validFromHint: "Bu tarihten sonraki ölçümler yeni tabloyla hesaplanır.",
      save: "Yeni sürüm olarak kaydet",
      versions: "Yüklü sürümler",
      versionLine: "Sürüm {{version}} · {{date}} · {{rows}} satır · {{volume}} L",
    },
    dispensers: {
      title: "Pompalar ve tabancalar",
      description: "Her tabanca bir tanka bağlıdır; tabancanın ürünü bağlı olduğu tankın ürünüdür.",
      empty: "Bu istasyonda pompa tanımlı değil",
      emptyHint: "Önce tankları, sonra pompaları ve tabancalarını ekleyin.",
      dispenserNo: "Pompa {{no}}",
      island: "Ada {{no}}",
      edit: "Pompa {{no}} kaydını düzenle",
      addTitle: "Pompa ekle",
      editTitle: "Pompa {{no}} — düzenle",
      statusHint: "Pompa hizmet dışı bırakılınca tabancaları da aynı duruma alınır.",
      fields: { dispenserNo: "Pompa no", islandNo: "Ada no" },
    },
    nozzles: {
      title: "Tabancalar",
      empty: "Bu pompada tabanca tanımlı değil.",
      add: "Tabanca ekle",
      addTitle: "Pompa {{no}} — tabanca ekle",
      edit: "{{no}} tabancasını düzenle",
      editTitle: "Tabanca {{no}} — düzenle",
      totalizer: "Mevcut endeks (L)",
      fields: {
        side: "Taraf",
        nozzleNo: "Tabanca no",
        tank: "Bağlı tank",
        tankHint: "Tabancanın ürünü seçilen tankın ürünü olur.",
        totalizerHint: "Endeks geriye alınamaz.",
        lastStampOn: "Son damga / muayene tarihi",
        nextStampDueOn: "Sonraki muayene tarihi",
      },
    },
    devices: {
      title: "Cihazlar",
      description:
        "İstasyon ajanının konuşacağı cihazlar. Parola ve anahtarlar burada değil, ajanın yerel yapılandırmasında tutulur.",
      empty: "Bu istasyonda cihaz tanımlı değil.",
      addTitle: "Cihaz ekle",
      fields: { deviceType: "Cihaz türü", installedOn: "Kurulum tarihi", warrantyEndsOn: "Garanti bitişi" },
      connection: {
        transport: "Bağlantı türü",
        serial: "Seri port (RS-232/485)",
        host: "IP adresi / ana bilgisayar",
        port: "Port",
        serialPort: "Seri port",
        baudRate: "Baud hızı",
        terminalId: "Terminal no",
        bank: "Banka",
        streamUrl: "Görüntü akış adresi",
      },
    },
    ev: {
      title: "Elektrikli araç şarj üniteleri",
      description:
        "Şarj üniteleri ve soketleri. Şarj işlemleri ve OCPP bağlantısı EV şarj modülünde yönetilir.",
      empty: "Bu istasyonda şarj ünitesi tanımlı değil.",
      addTitle: "Şarj ünitesi ekle",
      noConnector: "Soket yok",
      fields: {
        ocppIdentity: "OCPP kimliği",
        ocppIdentityHint: "Ünitenin OCPP sunucusuna bağlanırken kullandığı benzersiz kimlik.",
        maxPowerKw: "En yüksek güç (kW)",
        connectorType: "Soket {{no}} — tip",
        connectorPower: "Soket {{no}} — güç (kW)",
      },
    },
    wash: {
      title: "Araç yıkama birimleri",
      description: "Yıkama üniteleri ve bölmeleri. Programlar ve satışlar yıkama modülünde yönetilir.",
      empty: "Bu istasyonda yıkama birimi tanımlı değil.",
      addTitle: "Yıkama birimi ekle",
      fields: { unitType: "Birim türü" },
    },
  },
  fuel: {
    station: "İstasyon",
    noPermission: "Akaryakıt operasyonunu görüntüleme yetkiniz yok.",
    noStationsTitle: "Görüntüleyebileceğiniz istasyon yok",
    noStationsDescription:
      "Akaryakıt operasyonu istasyon bazındadır. Önce bir istasyon tanımlayın ya da yetkili kişiden kapsamınıza istasyon eklenmesini isteyin.",
    showDataTable: "Veriyi tablo olarak göster",
    tanks: {
      description:
        "Tank doluluğu, su ve sıcaklık ölçümü, seviye uyarıları ve seçilen tankın seviye grafiği. Veriler 60 saniyede bir tazelenir.",
      title: "Tanklar",
      empty: "Bu istasyonda tank tanımlı değil",
      emptyHint: "Tanklar istasyon detayındaki Varlıklar sekmesinden tanımlanır.",
      tankTitle: "Tank {{tankNo}} · {{product}}",
      noReading: "Henüz okuma yok",
      volume: "Hacim (ortam)",
      capacity: "Kapasite",
      fillPercent: "Doluluk",
      netVolume: "Net hacim (15 °C)",
      temperature: "Sıcaklık",
      water: "Su seviyesi",
      mass: "Kütle (LPG)",
      safeFill: "Güvenli üst sınır",
      minLevel: "Minimum seviye",
      lastReading: "Son okuma",
      runOut: "Tahmini bitiş",
      runOutIn: "{{days}} gün {{hours}} saat sonra",
      runOutSoon: "{{hours}} saat içinde bitiyor — sipariş zamanı",
      runOutPast: "Hesapça tükenmiş olmalı; okuma ya da sipariş kontrol edin",
      stale: "Veri gecikmiş",
      showChart: "Seviye grafiği",
      enterReading: "Okuma gir",
      gaugeLabel: "Tank {{tankNo}} — {{product}}, %{{percent}} dolu, {{volume}}",
      age: {
        minute: "{{count}} dk önce",
        hour: "{{count}} sa önce",
        day: "{{count}} gün önce",
      },
      flags: {
        CRITICAL: "Kritik seviyenin altında",
        BELOW_MIN: "Minimum seviyenin altında",
        ABOVE_SAFE_FILL: "Güvenli üst sınır aşıldı",
      },
      status: {
        ACTIVE: "Etkin",
        OUT_OF_SERVICE: "Hizmet dışı",
        DECOMMISSIONED: "Kullanımdan kaldırıldı",
      },
    },
    series: {
      title: "Tank {{tankNo}} · {{product}} seviye grafiği",
      range: "Aralık",
      ranges: {
        "24h": "Son 24 saat",
        "7d": "Son 7 gün",
        "30d": "Son 30 gün",
        "90d": "Son 90 gün",
      },
      resolution: "Çözünürlük: {{resolution}}",
      downgraded:
        "Seçilen aralıkta ham okuma sayısı çok yüksek olduğu için grafik saatlik çözünürlükte çizildi.",
      ariaLabel: "Tank {{tankNo}} — {{product}} seviye grafiği, {{range}}",
      tableLabel: "Tank seviye ölçümleri",
      empty: "Bu aralıkta okuma yok",
      emptyHint: "Daha geniş bir aralık seçin ya da tank probundan veri geldiğini doğrulayın.",
      gross: "Brüt hacim",
      net: "Net hacim (15 °C)",
      temperature: "Sıcaklık",
      volumeAxis: "L",
      temperatureAxis: "°C",
      safeFill: "Güvenli üst sınır",
      minLevel: "Minimum seviye",
      fields: {
        at: "Zaman",
        grossVolume: "Brüt hacim",
        netVolume: "Net hacim (15 °C)",
        level: "Seviye",
        water: "Su",
        temperature: "Sıcaklık",
      },
    },
    readings: {
      title: "Elle tank okuması",
      description:
        "Tank {{tankNo}} · {{product}}. Hacim, ölçülen seviyeden kalibrasyon tablosuyla hesaplanır.",
      measuredAt: "Ölçüm zamanı",
      levelMm: "Seviye (mm)",
      waterMm: "Su seviyesi (mm)",
      waterHint: "Ölçülmediyse boş bırakın.",
      temperatureC: "Sıcaklık (°C)",
      temperatureHint: "Sıcaklık girilmezse net hacim (15 °C) hesaplanmaz.",
      levelRequired: "Seviye (mm) zorunludur.",
      invalidMeasuredAt: "Geçerli bir ölçüm zamanı girin.",
      saved: "Okuma kaydedildi",
      savedVolume: "Hesaplanan hacim: {{volume}}",
    },
    totalizers: {
      description:
        "Tabanca endeksleri ve ardışık okumalar arasındaki artış. Endeks yalnızca artar; azalan okuma taşma ya da anomali işaretidir.",
      nozzle: "Tabanca",
      nozzleLabel: "Pompa {{dispenserNo}} · {{side}}{{nozzleNo}} · {{product}}",
      enterReading: "Endeks gir",
      noNozzles: "Bu istasyonda tabanca tanımlı değil",
      noNozzlesHint: "Pompa ve tabancalar istasyon detayındaki Varlıklar sekmesinden tanımlanır.",
      tableTitle: "{{nozzle}} endeks okumaları",
      tableLabel: "Endeks okumaları",
      current: "Anlık endeks",
      deltaHint:
        "Artış, aynı sayfadaki bir önceki okumaya göre hesaplanır; sayfa başındaki ilk satırda artış gösterilmez.",
      empty: "Bu tabanca için endeks okuması yok",
      emptyHint: "Endeks istasyon ajanından gelir ya da buradan elle girilir.",
      decreasing: "Taşma ya da anomali — onaylı düzeltme gerekir",
      pagination: "Endeks sayfalama",
      previousPage: "Önceki",
      nextPage: "Sonraki",
      fields: {
        readAt: "Zaman",
        electronic: "Elektronik",
        mechanical: "Mekanik",
        mechanicalDiff: "Fark (E − M)",
        delta: "Artış",
        source: "Kaynak",
      },
      dialogTitle: "Elle endeks girişi",
      dialogDescription: "{{nozzle}} tabancasının sayaç değeri.",
      readAt: "Okuma zamanı",
      electronicL: "Elektronik endeks (L)",
      mechanicalL: "Mekanik endeks (L)",
      mechanicalHint: "Mekanik sayaç okunmadıysa boş bırakın.",
      electronicRequired: "Elektronik endeks zorunludur.",
      saved: "Endeks okuması kaydedildi",
      tabs: "Endeks görünümü",
      tab: {
        readings: "Okumalar",
        report: "Endeks raporu",
        adjustments: "Düzeltmeler",
      },
      report: {
        range: "Rapor aralığı",
        caption: "Endeks raporu",
        totalsTitle: "Toplamlar",
        totalsHint:
          "Endeks satışı taşma güvenlidir ve onaylı düzeltme noktalarında bölünür. İşlem satışı test çekişlerini de içerir; iki yol bu yüzden karşılaştırılabilir.",
        mismatchedNozzles: "Farkı sıfır olmayan tabanca",
        emptyTitle: "Bu aralıkta endeks okuması yok",
        emptyDescription: "Aralığı genişletin ya da tabancaların okuma gönderdiğini kontrol edin.",
        exportFileName: "endeks-raporu-{{from}}-{{to}}",
        difference: {
          totalizerHigher: "Endeks fazlası",
          transactionHigher: "İşlem fazlası",
        },
        fields: {
          nozzle: "Tabanca",
          first: "İlk endeks",
          last: "Son endeks",
          totalizerSales: "Endeks satışı",
          transactionSales: "İşlem satışı",
          difference: "Fark",
          rollovers: "Taşma",
          anomalies: "Anomali",
          adjustments: "Düzeltme",
          mechanicalDifference: "Mekanik fark",
          readingCount: "Okuma sayısı",
        },
      },
    },
    adjustments: {
      dialogTitle: "Endeks düzeltme talebi",
      dialogDescription:
        "Sayaç değişimi, sıfırlama ya da yanlış okuma düzeltmesi. Talep gerekçelidir ve onaya gider; onaylanınca düzeltme kaynaklı yeni bir okuma yazılır.",
      currentHint: "Tabancanın anlık endeksi: {{current}}",
      kind: "Düzeltme türü",
      kindHint: "Belge, mutabakatta endeks serisini bu noktada böler.",
      newElectronicL: "Yeni elektronik endeks (L)",
      newMechanicalL: "Yeni mekanik endeks (L)",
      effectiveAt: "Yürürlük anı",
      effectiveAtHint: "Gelecekte olamaz; yürürlük anındaki son okuma belgede dondurulur.",
      reason: "Gerekçe",
      reasonHint: "En az 5 karakter. Denetim izine yazılır ve onaycı bunu okur.",
      submit: "Talebi gönder",
      created: "Endeks düzeltme talebi oluşturuldu",
      createdStatus: {
        PENDING_APPROVAL: "Talep onay bekliyor.",
        APPROVED: "Onay politikası yok; talep anında onaylandı ve endeks güncellendi.",
        REJECTED: "Talep reddedildi.",
        CANCELLED: "Talep geri çekildi.",
      },
      nozzleRequired: "Tabanca seçilmelidir.",
      electronicRequired: "Yeni elektronik endeks zorunludur.",
      reasonTooShort: "Gerekçe en az 5 karakter olmalıdır.",
      invalidEffectiveAt: "Yürürlük anı geçersiz.",
      shortcut: "Düzeltme talebi oluştur",
      caption: "Endeks düzeltmeleri",
      newRequest: "Düzeltme talebi",
      rowHint: "Belgenin onay akışını görmek için bir satıra tıklayın.",
      emptyTitle: "Endeks düzeltmesi yok",
      emptyDescription:
        "Sayaç değiştiğinde ya da yanlış bir okuma girildiğinde buradan gerekçeli düzeltme talebi açılır.",
      detailTitle: "{{nozzle}} endeks düzeltmesi",
      cancel: "Talebi geri çek",
      cancelled: "Düzeltme talebi geri çekildi",
      noApprovalRequest: "Bu belge onay motoruna düşmedi; politika tanımlı değilken talep anında sonuçlanır.",
      fields: {
        effectiveAt: "Yürürlük",
        kind: "Tür",
        previousElectronic: "Önceki endeks",
        newElectronic: "Yeni endeks",
        newMechanical: "Yeni mekanik endeks",
        reason: "Gerekçe",
        createdAt: "Talep zamanı",
        decidedAt: "Karar zamanı",
      },
    },
    sales: {
      description:
        "Günlük ve saatlik satış özetleri ile pompa işlemleri. Test çekişleri litre toplamına girmez, ayrı gösterilir.",
      tabs: "Satış görünümü",
      dailyTab: "Günlük özet",
      hourlyTab: "Saatlik",
      transactionsTab: "İşlemler",
      litresAxis: "L",
      businessDate: "İş günü",
      day: "Gün",
      empty: "Bu aralıkta satış özeti yok",
      emptyHint: "Tarih aralığını genişletin ya da satış verisinin alındığını doğrulayın.",
      hourlyEmpty: "Bu günde saatlik satış yok",
      hourlyEmptyHint: "Başka bir gün seçin.",
      dailyChartTitle: "Ürün bazında günlük litre",
      dailyChartAria: "{{from}} – {{to}} arası ürün bazında günlük satış litresi (yığılmış sütun grafiği)",
      dailyTableLabel: "Günlük satış özeti",
      hourlyChartTitle: "{{date}} saatlik satış",
      hourlyChartAria: "{{date}} günü ürün bazında saatlik satış litresi (çizgi grafiği)",
      hourlyTableLabel: "Saatlik satış özeti",
      totals: "Toplamlar",
      paymentTable: "Ödeme türü kırılımı",
      test: "Test",
      onlyTest: "Yalnızca test çekişleri",
      includePlate: "Plakayı dışa aktarıma ekle (KVKK)",
      occurredAtRange: "İşlem tarihi",
      exportFileName: "akaryakit-islemleri",
      fields: {
        businessDate: "İş günü",
        occurredAt: "Zaman",
        product: "Ürün",
        nozzle: "Tabanca",
        hour: "Saat",
        litres: "Litre",
        unitPrice: "Birim fiyat",
        amount: "Tutar",
        transactionCount: "İşlem sayısı",
        testLitres: "Test litresi",
        paymentType: "Ödeme türü",
        plate: "Plaka",
        isTest: "Test",
        source: "Kaynak",
      },
    },
    orders: {
      list: {
        description:
          "Dağıtıcıya verilen akaryakıt siparişleri. Sipariş bir SÖZ'dür: stok hareketi ve muhasebe kaydı üretmez; stoğa giriş tanker dolumunun onaylanmasıyla olur.",
        caption: "Akaryakıt siparişleri",
        emptyTitle: "Bu süzgeçlerle sipariş yok",
        emptyDescription: "Tarih aralığını genişletin ya da yeni bir sipariş taslağı açın.",
        from: "Başlangıç",
        to: "Bitiş",
      },
      new: {
        title: "Yeni sipariş",
        description:
          "Dağıtıcı, istenen teslim tarihi ve ürün bazında miktar. Ürünler istasyonun tanklarından gelir.",
        noPermission: "Sipariş oluşturma yetkiniz yok.",
      },
      fields: {
        orderNo: "Sipariş no",
        distributor: "Dağıtıcı carisi",
        requestedDeliveryDate: "İstenen teslim tarihi",
        product: "Ürün",
        quantityL: "Miktar",
        deliveredL: "Teslim alınan",
        remainingL: "Kalan",
        totalL: "Toplam litre",
        estimatedAmount: "Tahmini tutar",
        note: "Not",
        sentAt: "İletilme zamanı",
        createdAt: "Oluşturulma",
      },
      form: {
        lines: "Ürün satırları",
        addLine: "Satır ekle",
        removeLine: "{{index}}. satırı kaldır",
        selectProduct: "Ürün seçin",
        noProducts: "Bu istasyonda tank tanımlı olmadığı için sipariş verilebilecek ürün yok.",
        distributorHint: "Yalnızca tedarikçi rolündeki cariler listelenir.",
        total: "Toplam: {{total}}",
        create: "Siparişi oluştur",
        saved: "Sipariş kaydedildi",
        fixProblems: "Siparişi kaydetmek için şunları düzeltin",
      },
      problems: {
        distributorRequired: "Dağıtıcı carisi seçilmelidir.",
        dateRequired: "İstenen teslim tarihi girilmelidir.",
        linesRequired: "En az bir ürün satırı doldurulmalıdır.",
        duplicateProduct: "Aynı ürün iki satırda olamaz.",
      },
      dbs: {
        title: "DBS limiti aşılıyor",
        body: "Tahmini tutar {{estimated}}. Bu uyarı siparişi ENGELLEMEZ; limit bilgisi {{checkedAt}} tarihinde alınmıştır.",
        limit: "Limit",
        used: "Kullanılan",
        available: "Kullanılabilir",
      },
      detail: {
        title: "Sipariş",
        summary: "Sipariş özeti",
        linesLabel: "Sipariş satırları",
        approval: "Onay süreci",
        submit: "Onaya gönder",
        reopen: "Taslağa döndür",
        markSent: "Dağıtıcıya iletildi",
        startDelivery: "Bu siparişten dolum başlat",
        cancel: "Siparişi iptal et",
        cancelTitle: "Siparişi iptal et",
        cancelDescription: "İptal geri alınamaz; bekleyen onay talebi varsa geri çekilir.",
        cancelReason: "İptal gerekçesi",
        cancelledTitle: "Sipariş iptal edildi",
        done: {
          submit: "Sipariş onaya gönderildi",
          reopen: "Sipariş taslağa döndürüldü",
          "mark-sent": "Sipariş dağıtıcıya iletildi olarak işaretlendi",
          cancel: "Sipariş iptal edildi",
        },
      },
    },
    deliveries: {
      list: {
        description:
          "Tanker dolumları ve irsaliye ile ölçülen teslim arasındaki fark. Plaka ve şoför adı kişisel veridir; yalnızca dolum belgesinde görünür.",
        caption: "Tanker dolumları",
        emptyTitle: "Bu süzgeçlerle dolum yok",
        emptyDescription: "Tarih aralığını genişletin ya da yeni bir dolum kaydı açın.",
        from: "Başlangıç",
        to: "Bitiş",
      },
      new: {
        title: "Yeni dolum",
        description:
          "İrsaliye bilgisi ve boşaltılacak tanklar. Kayıt açıldıktan sonra sihirbaz okuma ve ölçüm adımlarıyla devam eder.",
        noPermission: "Dolum kaydı açma yetkiniz yok.",
        orderMissing: "Bağlanmak istenen sipariş okunamadı; dolum siparişsiz açılacak.",
      },
      steps: {
        label: "Dolum adımları",
        despatch: "İrsaliye bilgisi",
        before: "Öncesi okuma",
        unload: "Boşaltma",
        after: "Sonrası okuma",
        result: "Sonuç ve fark",
        confirm: "Onay / itiraz",
      },
      fields: {
        deliveryNo: "Dolum no",
        distributor: "Dağıtıcı",
        despatchNo: "İrsaliye no",
        despatchDate: "İrsaliye tarihi",
        businessDate: "İş günü",
        truckPlate: "Çekici plakası",
        trailerPlate: "Dorse plakası",
        driverName: "Şoför",
        seals: "Mühür numaraları",
        product: "Ürün",
        tank: "Tank",
        tanks: "Boşaltılacak tank(lar)",
        documentL: "İrsaliye litresi",
        documentL15c: "15 °C litresi",
        documentTemperature: "İrsaliye sıcaklığı",
        documentDensity: "Yoğunluk",
        measuredL: "Ölçülen",
        differenceL: "Fark",
        differencePercent: "Fark %",
        toleranceL: "Tolerans",
        withinTolerance: "Tolerans",
        unitCost: "Birim maliyet",
        costAmount: "Maliyet tutarı",
        costStatus: "Maliyet durumu",
        note: "Not",
        arrivedAt: "Tanker geliş",
        unloadingStartedAt: "Boşaltma başlangıcı",
        unloadingFinishedAt: "Boşaltma bitişi",
        measuredAt: "Ölçüm zamanı",
        confirmedAt: "Onay zamanı",
        disputedAt: "İtiraz zamanı",
        purchaseInvoice: "Alış faturası",
      },
      form: {
        lines: "Ürün satırları",
        addLine: "Satır ekle",
        removeLine: "{{index}}. satırı kaldır",
        selectProduct: "Ürün seçin",
        selectProductFirst: "Tank seçebilmek için önce ürünü seçin.",
        noProducts: "Bu istasyonda tank tanımlı olmadığı için dolum yazılamaz.",
        noTanks: "Bu ürünün bu istasyonda kullanılabilir tankı yok.",
        tankOption: "Tank {{tankNo}} · {{product}}",
        optional: "İsteğe bağlı",
        densityHint: "İrsaliyede yazıyorsa girin (ör. 0.8350).",
        personalDataHint: "Kişisel veri: yalnızca bu belgede ve itiraz tutanağında görünür.",
        sealsHint: "Her mühür numarası ayrı alana yazılır; boş alanlar yok sayılır.",
        sealLabel: "{{index}}. mühür numarası",
        addSeal: "Mühür ekle",
        create: "Dolumu aç",
        saved: "Dolum kaydedildi",
        fixProblems: "Dolumu kaydetmek için şunları düzeltin",
        fromOrder: "Bu dolum {{orderNo}} numaralı siparişe bağlı.",
        duplicate: "Bu dağıtıcının aynı irsaliye numarası zaten kayıtlı. İrsaliye numarasını kontrol edin.",
      },
      problems: {
        distributorRequired: "Dağıtıcı carisi seçilmelidir (sipariş seçilmediyse zorunludur).",
        linesRequired: "En az bir ürün satırı doldurulmalıdır.",
        documentLRequired: "Her satırda ürün ve irsaliye litresi girilmelidir.",
        tankRequired: "Her satır için en az bir tank seçilmelidir.",
        duplicateProduct: "Aynı ürün iki satırda olamaz.",
      },
      readings: {
        beforeHint:
          "Boşaltma ÖNCESİ tank ölçümleri. Prob okuyan tanklarda son okumayı kullanabilir, okumayan tanklarda elle girebilirsiniz.",
        afterHint:
          "Oturma süresi dolduktan sonraki ölçümler. Ölçülen teslim = (sonrası hacim − öncesi hacim) + boşaltma sırasındaki satış.",
        beforeLabel: "Boşaltma öncesi okumalar",
        afterLabel: "Boşaltma sonrası okumalar",
        useProbe: "Son prob okumasını kullan",
        useProbeHint: "Bu tank için okuma gönderilmez; sunucu geçiş anına en yakın prob okumasını kullanır.",
        probeMissing: "Sunucu bu geçiş için yeterince yeni bir prob okuması bulamadı. Ölçümleri elle girin.",
        lastProbe: "Son prob okuması: {{at}} · {{level}} · {{volume}}",
        unknownTank: "Tank",
        incomplete: "Ölçüm zamanı ve seviye zorunludur.",
        incompleteHint: "Elle girilen tanklarda ölçüm zamanı ve seviye (mm) doldurulmalıdır.",
        saveBefore: "Öncesi okumayı kaydet",
        arrived: "Tanker geldi olarak kaydedildi",
        manualSales: "Boşaltma sırasındaki satış (elle)",
        manualSalesHint:
          "YALNIZCA endeks ve işlem verisi olmayan istasyonlar için. Boş bırakırsanız satış tabanca endeksinden (yoksa satış işlemlerinden) alınır.",
        measure: "Ölç ve farkı hesapla",
        measured: "Ölçüm kaydedildi",
        settleNotElapsed:
          "Oturma süresi henüz dolmadı ({{remaining}} kaldı). Yine de ölçmek için gerekçe girin.",
        forceTitle: "Oturma süresi dolmadan ölç",
        forceDescription:
          "Köpük ve dalgalanma dinmeden alınan ölçüm hatalı olabilir. Gerekçe denetim izine yazılır.",
        forceReason: "Gerekçe",
        forceConfirm: "Yine de ölç",
      },
      unload: {
        hint: "Boşaltma sürerken pompalar satışa devam edebilir; o satış ölçümde hesaba katılır.",
        start: "Boşaltmayı başlat",
        finish: "Boşaltma bitti",
        done: {
          "start-unloading": "Boşaltma başladı",
          "finish-unloading": "Boşaltma bitti; oturma süresi başladı",
        },
        settleTitle: "Oturma süresi",
        settleHint:
          "Köpük ve dalgalanma dinene kadar {{minutes}} dakika beklenir. Kalan süre sunucudaki boşaltma bitiş anından hesaplanır.",
        settleReady: "Süre doldu",
        goToAfter: "Sonrası okumaya geç",
        goToAfterAnyway: "Ölçüm ekranını yine de aç",
        forceHint: "Süre dolmadan ölçmek zorundaysanız ölçüm ekranında gerekçe girerek devam edebilirsiniz.",
      },
      tolerance: {
        inside: "Tolerans içinde",
        outside: "Tolerans dışında",
      },
      result: {
        suggestDisputeTitle: "Fark tolerans dışında",
        suggestDisputeBody:
          "Ölçülen teslim irsaliyeden tolerans sınırının ötesinde farklı. Dağıtıcıya itiraz etmeyi değerlendirin.",
        warnings: "Ölçüm uyarıları",
        totalDocument: "Toplam irsaliye",
        totalMeasured: "Toplam ölçülen",
        totalDifference: "Toplam fark",
        compareBasis: "Karşılaştırma tabanı",
        tolerancePerMille: "Tolerans (‰)",
        toleranceMinL: "Toleransın alt sınırı",
        frozenHint:
          "Karşılaştırma tabanı ve tolerans ölçüm anında belgeye dondurulmuştur; ayar sonradan değişse de bu belge değişmez.",
        tankDetail: "Tank ayrıntısı",
        beforeVolume: "Öncesi hacim",
        afterVolume: "Sonrası hacim",
        salesDuringUnload: "Boşaltmada satış",
        salesSource: "Satış kaynağı",
      },
      confirm: {
        confirm: "Onayla",
        settleDispute: "Anlaşıldı, onayla",
        dispute: "İtiraz et",
        disputeTitle: "Doluma itiraz et",
        disputeDescription: "İtiraz alarm olayı üretir ve dağıtıcıya verilecek tutanağı hazırlar.",
        disputeReason: "İtiraz gerekçesi",
        downloadReport: "İtiraz tutanağını indir (PDF)",
        done: {
          confirm: "Dolum onaylandı; ölçülen miktar stoğa girdi",
          dispute: "İtiraz kaydedildi",
        },
        stockHint:
          "Ölçülen miktar stoğa girdi. Dolum muhasebe fişi üretmez; stok girişinin fişi alış faturasınındır.",
        provisionalHint:
          "Maliyet son ortalamayla GEÇİCİ olarak değerlendi. Alış faturası eşleşince kesinleşir ve maliyet geçmişi yeniden oynatılır.",
        matchTitle: "Alış faturası eşleştir",
        matchHint:
          "Aynı dağıtıcının kesinleşmiş alış faturaları listelenir. Birim maliyet faturanın stok satırından alınır (ÖTV dâhil, KDV hariç).",
        invoice: "Alış faturası",
        selectInvoice: "Fatura seçin",
        noInvoices: "Bu dağıtıcının kesinleşmiş alış faturası bulunamadı.",
        match: "Eşleştir",
        matched: "Fatura eşleştirildi",
        openInvoice: "Faturayı aç",
      },
      detail: {
        title: "Dolum",
        readOnly: "Bu dolum kapandı; ekran salt okunur gösteriliyor.",
        linesLabel: "Dolum satırları",
        disputedTitle: "İtiraz edildi",
        cancelledTitle: "Dolum iptal edildi",
        cancel: "Dolumu iptal et",
        cancelTitle: "Dolumu iptal et",
        cancelDescription: "İptal yalnızca ölçüm başlamadan yapılabilir ve geri alınamaz.",
        cancelReason: "İptal gerekçesi",
        cancelled: "Dolum iptal edildi",
      },
    },
    reconciliation: {
      description:
        "Gün ve tank bazında ıslak stok mutabakatı: defter stoğu ile ölçülen kapanış arasındaki fark, kural bulguları ve onay.",
      caption: "Islak stok mutabakatı",
      emptyTitle: "Bu aralıkta mutabakat yok",
      emptyDescription: "Tarih aralığını genişletin ya da ilgili günü hesaplayın.",
      from: "Başlangıç",
      to: "Bitiş",
      computeTitle: "Gün hesapla",
      computeHint:
        "Seçilen günün tüm tankları için taslak mutabakat üretir. Gün bitmeden hesaplanamaz; onaylanmış satır yeniden hesaplanmaz.",
      computeDate: "İş günü",
      compute: "Günü hesapla",
      computed: "{{count}} satır hesaplandı, {{skipped}} tank atlandı",
      periodNotClosed: "Bu gün henüz kapanmadı; mutabakat gün bittikten sonra hesaplanabilir.",
      approved: "Mutabakat onaylandı",
      selectTankForChart: "Kümülatif fark grafiği için süzgeçten bir tank seçin.",
      direction: {
        loss: "Kayıp",
        surplus: "Fazla",
      },
      fields: {
        day: "Gün",
        tank: "Tank · ürün",
        opening: "Açılış",
        delivered: "Teslim alınan",
        totalizerSales: "Endeks satışı",
        transactionSales: "İşlem satışı",
        testReturned: "Test iadesi",
        book: "Defter stoğu",
        closing: "Kapanış",
        variance: "Fark",
        cumulative: "Kümülatif fark",
        classification: "Sınıf",
        salesCheck: "Endeks ↔ işlem farkı",
      },
      chart: {
        title: "{{tank}} kümülatif fark",
        ariaLabel: "{{tank}} günlük ve kümülatif stok farkı (sütun ve çizgi grafiği)",
        tableLabel: "Kümülatif fark verileri",
        daily: "Günlük fark",
        cumulative: "Kümülatif fark",
        summary: "Aralık sonundaki kümülatif fark: {{value}}",
        empty: "Bu aralıkta hesaplanmış mutabakat yok",
        emptyHint: "Tarih aralığını genişletin ya da günleri hesaplayın.",
      },
      drawer: {
        title: "{{date}} · Tank {{tankNo}} · {{product}}",
        empty: "Mutabakat ayrıntısı",
        formula: "Formül dökümü",
        formulaHint:
          "Defter stoğu = açılış + teslim alınan − endeks satışı + test iadesi. Fark = kapanış − defter stoğu (negatif = kayıp).",
        plusDelivered: "+ Teslim alınan",
        minusSales: "− Endeks satışı",
        plusTestReturned: "+ Test iadesi",
        salesCheckHint:
          "Endeks ↔ işlem farkı stok farkı DEĞİLDİR; otomasyon veya ajan veri kaybının işaretidir.",
        inconsistent:
          "Sunucunun bildirdiği defter stoğu, alanlardan yeniden hesaplanan değerle örtüşmüyor. Sayıları teyit edin.",
        findings: "Kural bulguları",
        noFindings: "Eşik aşan kural bulgusu yok.",
        findingValues: "Ölçülen: {{measured}} · Eşik: {{threshold}}",
        dataQuality: "Veri kalitesi uyarıları",
        loss: "Fire dökümü",
        normalLoss: "Normal fire",
        abnormalLoss: "Anormal fire",
        surplus: "Sayım fazlası",
        unitCost: "Birim maliyet",
        lossAmount: "Tutar",
        ledger: "Fiş durumu",
        openEntry: "Muhasebe fişini aç",
        explanation: "Açıklama",
        explanationHint:
          "Fark mutlak alt sınırı aşıyorsa açıklama zorunludur. Onay hassas işlemdir; kimlik doğrulaması istenebilir.",
        approve: "Mutabakatı onayla",
      },
    },
    cost: {
      description:
        "Hareketli ağırlıklı ortalama stok maliyeti ve gün kapanışında kesilen SMM fişleri. Birim maliyet 6 ondalıkla tutulur, ekranda 4 ondalık okunur.",
      tabs: "Maliyet görünümü",
      tab: {
        costs: "Stok maliyeti",
        closings: "Gün kapanışları",
      },
      caption: "Akaryakıt stok maliyeti",
      emptyTitle: "Henüz maliyet satırı yok",
      emptyDescription: "İlk onaylı dolumla birlikte stok maliyeti oluşur.",
      rowHint: "Maliyet geçmişini görmek için bir satıra tıklayın.",
      companyScope: "Şirket geneli",
      stationScope: "İstasyon",
      fields: {
        scope: "Kapsam",
        product: "Ürün",
        quantity: "Miktar",
        averageUnitCost: "Ortalama birim maliyet",
        stockValue: "Stok değeri",
        updatedAt: "Güncelleme",
      },
      history: {
        title: "{{product}} maliyet geçmişi",
        empty: "Maliyet geçmişi",
        emptyRows: "Bu satır için hareket kaydı yok.",
        tableLabel: "Maliyet hareketleri",
        includeSuperseded: "Eskiyen satırları göster",
        supersededHint:
          "Geriye dönük fatura düzeltmesinde eski satırlar silinmez, 'eskiyen' olarak işaretlenir.",
        superseded: "Eskiyen",
        pagination: "Maliyet geçmişi sayfalama",
        previous: "Önceki",
        next: "Sonraki",
        direction: {
          in: "Giriş",
          out: "Çıkış",
          none: "Hareketsiz",
        },
        fields: {
          effectiveAt: "Zaman",
          kind: "Hareket türü",
          source: "Kaynak",
          quantity: "Miktar (±)",
          unitCost: "Birim maliyet",
          amount: "Tutar",
          quantityAfter: "Sonraki miktar",
          averageAfter: "Sonraki ortalama",
        },
      },
      closings: {
        caption: "Gün kapanışları",
        emptyTitle: "Bu aralıkta gün kapanışı yok",
        emptyDescription: "Bir günü kapattığınızda satılan litre ve SMM tutarı burada görünür.",
        closeTitle: "Günü kapat",
        closeHint:
          "İstasyon × ürün başına SMM fişi kesilir (ayar açıksa satış özeti fişi de). Bir gün yalnızca bir kez kapatılır.",
        closeDate: "İş günü",
        close: "Günü kapat",
        closed: "{{count}} ürün için gün kapatıldı",
        warnings: "Gün kapanışı uyarıları",
        periodNotClosed: "Bu gün henüz bitmedi; kapanış gün bittikten sonra yapılabilir.",
        openEntry: "Fişi aç",
        fields: {
          businessDate: "Gün",
          soldL: "Satılan",
          salesAmount: "Satış tutarı",
          unitCost: "Birim maliyet",
          cogsAmount: "SMM tutarı",
          cogsLedger: "SMM fişi",
          salesLedger: "Satış fişi",
        },
      },
    },
    opening: {
      open: "Açılış stoğu gir",
      dialogTitle: "Açılış stoğu",
      dialogDescription:
        "Sisteme geçişte tanklarda bulunan yakıt. Kapsamın İLK hareketi olarak yazılır; muhasebe fişi üretmez (153'ün açılışı muhasebe açılış fişindedir).",
      productHint: "Ürünler istasyonun tanklarından gelir.",
      quantityL: "Miktar (L)",
      unitCost: "Birim maliyet (₺/L)",
      unitCostHint: "ÖTV dâhil, KDV hariç. En fazla 6 ondalık basamak (ör. 41,2354).",
      unitCostInvalid: "Birim maliyet geçersiz; en fazla 6 ondalık basamak yazın (ör. 41,2354).",
      asOf: "Ölçüm anı",
      asOfHint: "Stoğun sayıldığı an; gelecekte olamaz.",
      stationRequired: "İstasyon seçilmelidir.",
      productRequired: "Ürün seçilmelidir.",
      quantityRequired: "Miktar zorunludur.",
      asOfInvalid: "Ölçüm anı geçersiz.",
      submit: "Açılış stoğunu kaydet",
      saved: "Açılış stoğu kaydedildi",
      conflictHint: "Açılış stoğu yalnızca kapsamın ilk hareketi olarak girilebilir.",
    },
    suggestions: {
      description:
        "Tüketim profilinden çıkan ürün bazında sipariş önerisi. Öneri, tanker geldiğinde tanklara sığacak miktarı aşmaz; yolda olan sipariş düşülmüştür.",
      basis: "Son {{weeks}} haftanın gün × saat ortalamasına göre; {{at}} itibarıyla hesaplandı.",
      emptyTitle: "Sipariş önerisi çıkmadı",
      emptyDescription:
        "İstasyonun tankları ve son haftaların satışı olmadan tüketim profili kurulamaz. Tank tanımlarını ve okumaları kontrol edin.",
      leadTime: "Teslim süresi: {{hours}} saat",
      runOutUnknown: "14 günlük ufukta bitiş görünmüyor",
      runOutIn: "{{days}} gün {{hours}} saat sonra",
      runOutPast: "Hesapça tükenmiş olmalı",
      runOutWarning: "Tahmini bitiş 24 saatten yakın: sipariş bugün verilmelidir.",
      belowTarget:
        "Öneri, hedef asgari stoğu karşılamıyor (tank küçük ya da kompartıman büyük). Daha sık sipariş gerekebilir.",
      suggested: "Önerilen miktar: {{quantity}}",
      noCompartments: "Tanker kompartımanlarına sığan bir bileşim bulunamadı.",
      compartmentTable: "{{product}} kompartıman bileşimi",
      nothingToOrder: "Şimdilik sipariş gerekmiyor.",
      createOrder: "Bu öneriyle sipariş oluştur",
      fields: {
        current: "Mevcut stok",
        safeCapacity: "Güvenli kapasite",
        dailyAverage: "Günlük ortalama tüketim",
        runOut: "Tahmini bitiş",
        consumptionUntilDelivery: "Teslim süresince tüketim",
        maxReceivable: "Tanka sığacak en yüksek miktar",
        minimumTarget: "Hedef asgari stok",
        pendingOrder: "Bekleyen sipariş",
        compartmentNo: "Kompartıman",
        compartmentSize: "Miktar",
      },
    },
    priceReport: {
      description:
        "Fiyat değişimi anındaki stok ve fiyat farkı ile eski fiyattan satış alarmları. Fark bilgi amaçlıdır; muhasebe kaydı değildir.",
      range: "Yürürlük aralığı",
      allStations: "Şirket geneli (tüm istasyonlar)",
      summaryTitle: "Özet",
      notAccounting:
        "Fiyat farkı BİLGİ amaçlıdır: stok değerlemesini değiştirmez ve hiçbir muhasebe fişi üretmez. Stok maliyeti hareketli ağırlıklı ortalamayla yürür.",
      caption: "Fiyat değişimleri",
      rowHint: "Farkın dayandığı tank dökümünü görmek için bir satıra tıklayın.",
      emptyTitle: "Bu aralıkta fiyat değişimi yok",
      emptyDescription: "Planlı fiyat değişikliği yürürlüğe girdiğinde anlık görüntü burada oluşur.",
      detailTitle: "{{product}} · {{at}}",
      tankBreakdown: "Tank dökümü",
      tankBreakdownHint:
        "Yürürlük anındaki stok: en yakın önceki okuma − o okumadan yürürlüğe kadar satış + arada teslim alınan.",
      tankNo: "Tank {{tankNo}}",
      alertsTitle: "Eski fiyattan satış alarmları",
      alertsHint:
        "Yürürlükten sonra geçiş payı dolduğu hâlde eski birim fiyatla gelen satış: pompa otomasyonu yeni fiyatı almamış olabilir.",
      alertsTable: "Eski fiyattan satış alarmları",
      alertsEmptyTitle: "Eski fiyattan satış yok",
      alertsEmptyDescription: "Bu aralıkta tüm satışlar yürürlükteki fiyattan gerçekleşti.",
      direction: {
        increase: "Zam",
        decrease: "İndirim",
        none: "Değişmedi",
        unknown: "İlk fiyat",
      },
      fields: {
        effectiveAt: "Yürürlük",
        price: "Eski → yeni fiyat",
        previousPrice: "Eski fiyat",
        newPrice: "Yeni fiyat",
        stock: "Stok",
        difference: "Fark tutarı",
        totalDifference: "Toplam fiyat farkı",
        snapshotCount: "Fiyat değişimi sayısı",
        alertCount: "Alarm sayısı",
        requestNo: "Talep no",
        expectedPrice: "Beklenen fiyat",
        actualPrice: "Gerçekleşen fiyat",
        firstTransactionAt: "İlk işlem zamanı",
        tank: "Tank",
        lastReadingAt: "Son okuma",
        lastReadingVolume: "Son okuma hacmi",
        salesSince: "Sonrasındaki satış",
        deliveredSince: "Sonrasındaki teslim",
      },
    },
    lossReport: {
      description:
        "Onaylanmış mutabakatlardan çıkan fire özeti: tank ve ürün bazında normal / anormal fire, fazla ve fire tutarı.",
      range: "İş günü aralığı",
      summaryTitle: "Özet",
      summaryHint: "{{periods}} onaylı mutabakat döneminden hesaplandı.",
      chartTitle: "Ürün bazında fire",
      chartAria: "{{from}} – {{to}} arası ürün bazında fire (litre)",
      chartTableLabel: "Ürün bazında fire tablosu",
      groupTitle: "Tank {{tankNo}} · {{product}}",
      dayTableLabel: "Tank {{tankNo}} · {{product}} gün dökümü",
      periodCount: "{{days}} dönem",
      openEntry: "Fişi aç",
      emptyTitle: "Bu aralıkta onaylanmış mutabakat yok",
      emptyDescription:
        "Fire yalnızca ONAYLANMIŞ mutabakattan doğar. Mutabakat ekranından günleri hesaplayıp onaylayın.",
      truncatedTitle: "Rapor kesildi",
      truncatedBody:
        "Aralıkta {{pages}} sayfadan fazla dönem var; özet eksik olabilir. Tarih aralığını daraltın.",
      fields: {
        businessDate: "Gün",
        sales: "Satış",
        normalLoss: "Normal fire",
        abnormalLoss: "Anormal fire",
        surplus: "Fazla",
        lossAmount: "Fire tutarı",
        lossRatio: "Fire / satış",
        entry: "Fiş",
      },
    },
    settings: {
      description:
        "Akaryakıt operasyonunun tüm eşikleri. Hiçbir oran koda gömülü değildir; şirket bazında tanımlanır ve istasyon bazında geçersiz kılınabilir.",
      scope: "Ayar satırı",
      scopeHint:
        "Şirket satırı tüm istasyonlar için geçerlidir; bir istasyon seçerek geçersiz kılma yazabilirsiniz.",
      companyScope: "Şirket geneli",
      saved: "Akaryakıt ayarları kaydedildi",
      readOnly: "Bu ayarları değiştirme yetkiniz yok; alanlar salt okunur gösteriliyor.",
      conflictTitle: "Ayarlar başka bir kullanıcı tarafından değiştirilmiş",
      conflictBody: "Kaydetmeden önce güncel değerleri yeniden yükleyin.",
      reload: "Yeniden yükle",
      isDefaultTitle: "Henüz kayıt yok",
      isDefaultBody:
        "Aşağıdaki değerler ürün varsayılanlarıdır. Kaydettiğinizde bu şirket için ayar satırı oluşturulur.",
      noOverrideBody:
        "Bu istasyonun geçersiz kılması yok; şirket satırının değerleri gösteriliyor. Kaydederseniz yalnızca bu istasyon için geçerli bir satır oluşur.",
      needsVerificationTitle: "Bu eşikler doğrulanmalı",
      needsVerificationBody:
        "Değerler sektör kabulüne göre seçilmiştir; yasal bir dayanağı yoktur. Mali müşavirinizle ve dağıtıcı sözleşmenizle doğrulayın.",
      markVerified: "Doğrulandı olarak işaretle",
      verified: "Eşikler doğrulandı",
      sections: {
        volume: "Hacim",
        delivery: "Dolum",
        cost: "Maliyet",
        reconciliation: "Fire ve mutabakat eşikleri",
        totalizer: "Endeks",
        price: "Fiyat",
        forecast: "Tahmin ve sipariş",
        accounting: "Muhasebe",
      },
      temperatureStrategy: "Sıcaklık düzeltme stratejisi",
      temperatureStrategyHint:
        "Net hacmin (15 °C) nasıl hesaplanacağı. Sıcaklık ya da ürünün genleşme katsayısı yoksa net hacim boş kalır.",
      deliveryCompareBasis: "Karşılaştırma tabanı",
      deliveryCompareBasisHint:
        "İrsaliye ile ölçülen teslimin hangi hacim üzerinden karşılaştırılacağı; ölçüm anında belgede dondurulur.",
      deliveryTolerancePerMille: "Dolum toleransı (‰)",
      deliveryTolerancePerMilleHint:
        "İrsaliye miktarının binde kaçına kadar fark normal sayılır. Aşan fark itiraz tutanağı üretir.",
      deliveryToleranceMinL: "Toleransın alt sınırı (L)",
      deliveryToleranceMinLHint:
        "Küçük teslimatlarda binde oranı çok küçük kalır; tolerans bu litreden aşağı inmez.",
      settleMinutes: "Oturma süresi (dk)",
      settleMinutesHint:
        "Boşaltma bittikten sonra köpük ve dalgalanma dursun diye beklenen süre; sonrası okuma bu süre dolunca alınır.",
      costScope: "Maliyet kapsamı",
      costScopeHint:
        "Hareketli ağırlıklı ortalama maliyetin hangi düzeyde tutulacağı. Yalnızca şirket satırında değiştirilir.",
      normalLossPercent: "Normal fire sınırı (%)",
      normalLossPercentHint:
        "Satışın bu yüzdesine kadar kayıp normal fire sayılır; üstü anormal fire olarak kaydedilir.",
      thresholds: {
        dailyMinimumL: "Tek dönem farkı — alt sınır (L)",
        dailyMinimumLHint: "Bu litrenin altındaki farklarda kural hiç çalışmaz (ölçüm gürültüsü).",
        dailyWatchPercent: "Tek dönem farkı — izlenecek (%)",
        dailyWatchPercentHint: "Farkın satışa oranı bunu aşarsa dönem 'izlenecek' sınıfına girer.",
        dailySuspiciousPercent: "Tek dönem farkı — şüpheli (%)",
        dailySuspiciousPercentHint:
          "Farkın satışa oranı bunu aşarsa dönem 'şüpheli' sayılır ve alarm üretir.",
        dailyCriticalPercent: "Tek dönem farkı — kritik (%)",
        dailyCriticalPercentHint: "Farkın satışa oranı bunu aşarsa dönem 'kritik' sayılır.",
        cumulativePeriods: "Eğilim penceresi (dönem)",
        cumulativePeriodsHint: "Kümülatif kayıp eğiliminin kaç döneme bakarak aranacağı.",
        cumulativeNegativePeriods: "En az negatif dönem",
        cumulativeNegativePeriodsHint:
          "Penceredeki dönemlerin en az bu kadarı negatifse eğilim kuralı çalışır (günlük eşiğin altında kalan sızıntı).",
        cumulativeSuspiciousPercent: "Kümülatif kayıp — şüpheli (%)",
        cumulativeSuspiciousPercentHint:
          "Penceredeki toplam kaybın satışa oranı bunu aşarsa şüpheli sayılır.",
        cumulativeCriticalPercent: "Kümülatif kayıp — kritik (%)",
        cumulativeCriticalPercentHint: "Penceredeki toplam kaybın satışa oranı bunu aşarsa kritik sayılır.",
        idleSuspicious: "Satışsız seviye düşüşü — şüpheli (L/saat)",
        idleSuspiciousHint: "Satış yokken (gece) bu hızdan fazla seviye düşüşü sızıntı şüphesi doğurur.",
        idleCritical: "Satışsız seviye düşüşü — kritik (L/saat)",
        idleCriticalHint: "Satış yokken bu hızdan fazla düşüş kritik sayılır.",
        idleMinimumDropL: "Satışsız seviye düşüşü — gürültü tabanı (L)",
        idleMinimumDropLHint:
          "Aralıktaki TOPLAM düşüş bunun altındaysa satışsız seviye düşüşü değerlendirilmez (prob gürültüsü ve sıcaklık oynaması). Yavaş sızıntıyı kümülatif eğilim kuralı yakalar. Boş bırakırsanız sunucu varsayılanı kullanılır.",
        waterWatchMm: "Su artışı — izlenecek (mm)",
        waterWatchMmHint:
          "Dönem içinde su seviyesi bu kadar artarsa izlemeye alınır (sızdırma / kondensasyon).",
        waterCriticalMm: "Su artışı — kritik (mm)",
        waterCriticalMmHint: "Dönem içinde su seviyesi bu kadar artarsa kritik sayılır.",
        salesWatchL: "Endeks ↔ işlem farkı — izlenecek (L)",
        salesWatchLHint:
          "Endeksten ve işlem toplamından hesaplanan satış arasındaki fark; stok farkı değil, veri kaybı işaretidir.",
        salesSuspiciousL: "Endeks ↔ işlem farkı — şüpheli (L)",
        salesSuspiciousLHint: "Fark bu litreyi aşarsa otomasyon / ajan veri kaybı şüphesi doğar.",
      },
      totalizerRolloverWindowL: "Taşma penceresi (L)",
      totalizerRolloverWindowLHint:
        "Azalan endeks, önceki değer sayaç sınırına ve yeni değer sıfıra bu kadar yakınsa taşma sayılır; değilse anomali.",
      mechanicalMismatchL: "Elektronik ↔ mekanik fark eşiği (L)",
      mechanicalMismatchLHint: "İki sayacın artışı arasındaki fark bunu aşarsa uyarı üretilir.",
      priceGraceSeconds: "Fiyat geçiş payı (sn)",
      priceGraceSecondsHint:
        "Yeni fiyat yürürlüğe girdikten sonra süren dolumlar için tanınan süre; sonrasında eski fiyattan satış alarm üretir.",
      forecastWeeks: "Tahmin penceresi (hafta)",
      forecastWeeksHint: "Tüketim profili son kaç haftanın aynı gün ve saat ortalamasından çıkarılır.",
      leadTimeHours: "Teslim süresi (saat)",
      leadTimeHoursHint:
        "Sipariş verildikten kaç saat sonra tankerin geleceği; sipariş önerisi buna göre hesaplanır.",
      minimumStockDays: "Hedef asgari stok (gün)",
      minimumStockDaysHint: "Sipariş önerisi, stoğun bu kadar günün altına inmemesini hedefler.",
      compartments: "Tanker kompartıman boyutları (L)",
      compartmentsHint:
        "Sipariş önerisi bu boyutların bileşimine yuvarlanır; güvenli üst sınırı aşan bileşim önerilmez.",
      compartmentSize: "{{index}}. kompartıman",
      addCompartment: "Kompartıman ekle",
      removeCompartment: "{{index}}. kompartımanı kaldır",
      postDailySalesSummary: "Gün sonu satış özeti fişi kesilsin",
      postDailySalesSummaryHint:
        "Vardiya modülü kullanılıyorsa AÇMAYIN — çifte kayıt oluşur. Gelir ve tahsilat fişi vardiya kapanışında kesilir.",
    },
  },
  shifts: {
    station: "İstasyon",
    noPermission: "Vardiya ekranlarını görüntüleme yetkiniz yok.",
    noStationsTitle: "Görüntülenebilir istasyon yok",
    noStationsDescription:
      "Kapsamınızda istasyon bulunmuyor ya da henüz istasyon tanımlanmamış. Vardiya kayıtları istasyon bazındadır.",
    fields: {
      shiftNo: "Vardiya no",
      name: "Vardiya adı",
      businessDate: "İş günü",
      openedAt: "Açılış",
      closedAt: "Kapanış",
      plannedEndAt: "Planlanan bitiş",
      cashRegister: "Kasa",
      staff: "Personel",
      openingFloat: "Devir parası",
      cashDropTotal: "Ara teslim",
      cashExpenseTotal: "Kasadan masraf",
      creditSaleTotal: "Veresiye / filo",
      testDrawLitres: "Test çekişi",
      memberCount: "Kişi",
      nozzleCount: "Tabanca",
      target: "Atama",
      fromAt: "Başlangıç",
      toAt: "Bitiş",
      openingTotalizer: "Açılış endeksi",
      totalizerSource: "Endeks kaynağı",
      droppedAt: "Teslim anı",
      occurredAt: "Kayıt anı",
      expenseDocNo: "Gider belgesi",
      expenseLink: "Gider belgesini aç",
    },
    board: {
      description: "Açık ve kapanışı süren vardiyalar: kim nerede, hangi kasada, ne kadar nakit izleniyor.",
      elapsed: "Ne zamandır açık",
      trackedCash: "İzlenen nakit",
      noNozzles: "Tabanca atanmamış",
      emptyTitle: "Açık vardiya yok",
      emptyDescription:
        "Seçili istasyonda açık ya da kapanışı süren vardiya bulunmuyor. Yeni bir vardiya açabilirsiniz.",
    },
    list: {
      description: "İş günü, istasyon ve duruma göre vardiyalar.",
      caption: "Vardiyalar",
      emptyTitle: "Kayıtlı vardiya yok",
      emptyDescription: "Seçilen süzgeçlerle eşleşen vardiya bulunamadı.",
      from: "İş günü (başlangıç)",
      to: "İş günü (bitiş)",
    },
    detail: {
      title: "Vardiya ayrıntısı",
      tabs: "Vardiya bölümleri",
      tab: {
        members: "Üyeler ve atamalar",
        closings: "Hesaplar",
        cashDrops: "Ara teslimler",
        cashExpenses: "Kasadan masraflar",
        creditSales: "Veresiye / filo fişleri",
        testDraws: "Test çekişleri",
        report: "Rapor",
      },
      dayLocked: "İş günü kilitli",
      cancelHint: "Yalnızca hiç kaydı olmayan açık vardiya iptal edilebilir.",
      cancelledTitle: "Vardiya iptal edildi",
      previousUnclosedTitle: "Önceki vardiya kapanmadan açıldı",
      membersCaption: "Vardiya üyeleri",
      assignmentsCaption: "Atamalar ve açılış endeksleri",
      cashDropsCaption: "Ara teslimler",
      cashDropsEmpty: "Ara teslim yok",
      cashExpensesCaption: "Kasadan ödenen masraflar",
      cashExpensesEmpty: "Kasadan masraf yok",
      creditSalesCaption: "Veresiye / filo fişleri",
      creditSalesEmpty: "Veresiye ya da filo fişi yok",
      testDrawsCaption: "Test ve kalibrasyon çekişleri",
      testDrawsEmpty: "Test çekişi yok",
      emptyDescription: "Vardiya açıkken bu bölüme kayıt ekleyebilirsiniz.",
    },
    closing: {
      // ── Kapanışı başlat / geri al ──────────────────────────────────────────
      startTitle: "Kapanışı başlat",
      startDescription:
        "Satış penceresi kapanır: açık tabancaların kapanış endeksleri alınır, endeks litreleri dondurulur ve satışlar vardiyaya bağlanır. Hesaplar bundan sonra teslim edilebilir.",
      startSubmit: "Kapanışı başlat",
      started: "Kapanış başlatıldı",
      at: "Kapanış anı",
      atHint: "Kapanış endekslerinin okunduğu an; boş bırakmayın, varsayılan şimdidir.",
      atInvalid: "Kapanış anı geçerli bir tarih ve saat olmalıdır.",
      totalizers: "Kapanış endeksleri",
      totalizersHint:
        "Endeksler istasyon ajanından ya da son bilinen okumadan kendiliğinden alınır. Yalnızca gerekiyorsa elle girin.",
      manualTotalizers: "Endeksleri elle gir",
      noOpenNozzles: "Kapanışı bekleyen açık tabanca ataması yok.",
      totalizerFor: "{{nozzle}} kapanış endeksi",
      openingTotalizerValue: "Açılış endeksi: {{value}}",
      tankReadings: "Tank kapanış okumaları",
      withTankReadings: "Tank kapanış okuması gir",

      // ── Vardiya düzeyindeki işlemler ───────────────────────────────────────
      action: {
        close: {
          title: "Vardiyayı kapat",
          description:
            "Tüm hesaplar kabul edildiyse vardiya kapanır. Not isteğe bağlıdır ve belgeye yazılır.",
          confirm: "Vardiyayı kapat",
        },
        approve: {
          title: "Vardiyayı onayla",
          description: "Onaylanan vardiya gün sonuna girmeye hazırdır. Not isteğe bağlıdır.",
          confirm: "Onayla",
        },
        reopenShift: {
          title: "Kapanışı geri al",
          description:
            "Kapanış endeksleri ve dondurulan litreler temizlenir, satış bağları çözülür. Yalnızca hiçbir hesap teslim edilmemişken yapılabilir.",
          confirm: "Kapanışı geri al",
        },
        revokeApproval: {
          title: "Onayı geri al",
          description: "Vardiya kapalı duruma döner. Gerekçe denetim izine yazılır.",
          confirm: "Onayı geri al",
        },
      },
      done: {
        close: "Vardiya kapatıldı",
        approve: "Vardiya onaylandı",
        reopenShift: "Kapanış geri alındı",
        revokeApproval: "Vardiya onayı geri alındı",
      },
      incompleteTitle: "Kabul edilmemiş hesaplar var",

      // ── Hesaplar sekmesi ───────────────────────────────────────────────────
      caption: "Pompacı ve kasiyer hesapları",
      emptyTitle: "Hesap satırı yok",
      emptyDescription: "Vardiyaya kişi eklendiğinde her biri için bir hesap açılır.",
      provisionalTitle: "Geçici tutarlar (kapanış başlatılmadı)",
      provisionalBody:
        "Vardiya hâlâ açık: beklenen tutar son okumayla yapılan TAHMİNDİR ve hiçbir şey dondurulmamıştır. Hesap ancak kapanış başlatıldıktan sonra teslim edilebilir.",
      provisionalBadge: "Geçici",
      expected: "Beklenen",
      declared: "Beyan",
      difference: "Fark",
      direction: {
        NONE: "Fark yok",
        SHORTAGE: "Açık",
        SURPLUS: "Fazla",
      },
      outsideToleranceShort: "Tolerans dışı",
      totals: "Toplam — kabul edilen: {{accepted}} · bekleyen: {{pending}}",
      shortageTotal: "Açık toplamı",
      surplusTotal: "Fazla toplamı",
      enter: "Hesabı gir",
      view: "Hesabı görüntüle",
      handover: "Tutanağı indir",
      progress: "{{accepted}} / {{total}} hesap teslim edildi",
      reopenClosing: "Hesabı yeniden aç",
      reopenClosingTitle: "Hesabı yeniden aç",
      reopenClosingDescription:
        "{{staff}} için kabul edilen hesap yeniden açılır: kasa kaydı ters çevrilir, personel açık kalemi iptal edilir ve tutanak bağı çözülür.",
      reopenClosingConfirm: "Yeniden aç",
      reopened: "Hesap yeniden açıldı",

      // ── Sihirbaz ───────────────────────────────────────────────────────────
      wizardTitle: "Hesap",
      wizardDescription: "{{staff}} için beklenen tutar, beyan ve fark.",
      steps: {
        label: "Kapanış adımları",
        expected: "Satış",
        cash: "Nakit",
        card: "Kart",
        other: "Diğer",
        summary: "Özet",
      },
      liveSummary: "Beklenen, beyan ve fark özeti",
      stepProblemsTitle: "Eksik satırlar var",
      problem: {
        cardTerminalRequired: "Tutarı girilen kart satırında POS terminali seçilmelidir.",
        cardAmountRequired: "Kart satırının tutarı sıfırdan büyük olmalıdır.",
        otherAmountRequired: "Tahsilat satırının tutarı sıfırdan büyük olmalıdır.",
        manualSaleIncomplete: "Satış özeti satırında gelir grubu, KDV oranı ve tutar birlikte girilmelidir.",
        slipCountInvalid: "Slip adedi tam sayı olmalıdır.",
      },
      warningsTitle: "Beklenen tutar uyarıları",
      expectedHint:
        "Beklenen tutar ENDEKSTEN gelir: (kapanış − açılış) endeks farkından test çekişi düşülür ve fiyat dilimleriyle çarpılır.",
      intervalsCaption: "Tabanca aralıkları ve fiyat dilimleri",
      closingTotalizer: "Kapanış endeksi",
      totalizerLitres: "Endeks farkı",
      testLitres: "Test",
      saleLitres: "Satış",
      byProductCaption: "Ürün bazında toplam",
      recalculate: "Yeniden hesapla",
      recalculated: "Beklenen tutar yenilendi",

      posSalesTitle: "Satış özeti (kasadan)",
      posSalesHint:
        "Satırlar kasa fişlerinden türetildi; burada değiştirilemez. Düzeltme kasada (iptal / iade) yapılır.",
      posExpectedTitle: "Beklenen tutar kasa satışlarından geliyor",
      posExpectedBody:
        "Bu kasiyerin vardiyasında yerel kasa satışı var: beklenen tutar {{count}} özet satırından hesaplandı ve elle değiştirilemez.",
      posExpectedLink: "Bu vardiyanın kasa fişlerini aç",
      manualSalesTitle: "Satış özeti (elle)",
      manualSalesHint:
        "Kasiyer hesabında beklenen tutar, girilen satış özetinin toplamıdır. İş birimi, gelir grubu, KDV oranı ve KDV dâhil tutar girin.",
      businessUnit: "İş birimi",
      revenueGroup: "Gelir grubu",
      revenueGroupHint: "Ürünün muhasebe grubu (ör. MARKET_FOOD). Büyük harf, rakam ve alt çizgi.",
      gross: "KDV dâhil tutar",
      removeManualSale: "{{no}}. satış satırını sil",
      addRow: "Satır ekle",

      cashCounted: "Sayılan nakit",
      cashFactsTitle: "Nakit dökümü",
      cashFormula: "Satıştan gelen net nakit = sayılan − devir parası + ara teslimler + nakitten masraflar =",
      decrease: "{{denomination}} adedini azalt",
      increase: "{{denomination}} adedini artır",

      cardHint: "Her POS terminali için ayrı satır girin; tutar, slip adedi ve gün sonu (batch) numarası.",
      noTerminals: "Bu istasyonda etkin POS terminali tanımlı değil.",
      posTerminal: "POS terminali",
      slipCount: "Slip adedi",
      batchNo: "Gün sonu / batch no",
      batchNoHint: "POS gün sonu fişindeki numara (isteğe bağlı).",
      removeTender: "{{no}}. tahsilat satırını sil",

      derivedTitle: "Veresiye / filo (türetilmiş)",
      derivedHint:
        "Bu satırlar vardiya içinde kesilen fişlerden cari bazında kendiliğinden gelir; elle girilemez. Eksik fiş varsa önce fişi kaydedin.",
      derivedEmpty: "Bu kişiye ait veresiye ya da filo fişi yok.",
      addCreditSale: "Fiş ekle (vardiya ayrıntısı)",
      otherTendersTitle: "Diğer tahsilat araçları",
      otherTendersHint: "Taşıt tanıma, mobil ödeme, kupon ve sadakat puanı tutarları.",
      tenderType: "Araç",
      reference: "Referans",

      cashSales: "Nakit satış",
      nonCash: "Nakit dışı",
      toleranceLimit: "Tolerans sınırı: {{limit}}",
      withinTolerance: "Fark tolerans içinde: hesap kendiliğinden kabul edilir.",
      outsideTolerance:
        "Fark tolerans dışında: hesap onaya gidecek (politika yoksa kendiliğinden onaylanır).",
      settlementPreview: "Farkın karşılığı",
      settlementNone: "Karşılık gerekmiyor",
      settlementFallback:
        "Bu personelin carisi tanımlı değil: açık personele değil, kasa açığı giderine yazılacak.",
      explanation: "Açıklama",
      explanationHint: "İsteğe bağlı not; tutanağa ve onay talebine yazılır.",
      explanationRequiredHint: "Fark var: nedenini yazın. Açıklama tutanağa ve onay talebine geçer.",
      cannotSubmitTitle: "Hesap şimdilik teslim edilemez",
      cannotSubmitNotClosing:
        "Önce vardiyanın kapanışı başlatılmalıdır; kapanış endeksleri alınmadan beklenen tutar kesinleşmez. Taslağınızı şimdiden girebilirsiniz.",
      cannotSubmitOther: "Vardiyanın durumu hesabın teslim edilmesine uygun değil.",
      submitTitle: "Hesap teslim edilsin mi?",
      submitDescription:
        "Beklenen tutar dondurulur. Fark tolerans içindeyse hesap kabul edilir, dışındaysa onaya gider.",
      submit: "Teslim et",
      submitted: {
        accepted: "Hesap kabul edildi",
        pending: "Hesap onaya gönderildi",
      },
      resultAccepted: "Hesap kabul edildi: kasa girişi yapıldı, teslim-tesellüm tutanağı üretildi.",
      resultPending: "Fark tolerans dışında; hesap onay bekliyor. Onaylanınca kasa girişi ve tutanak oluşur.",
      nextMember: "Sıradaki hesaba geç",
      backToShift: "Vardiyaya dön",
      rejectedTitle: "Hesap reddedildi",
      noEditPermission:
        "Bu hesabı yalnızca görüntüleyebilirsiniz. Başkası adına hesap girmek için vardiya kapatma yetkisi gerekir.",
      dayLocked: "İş günü kilitli: bu vardiyaya artık yazılamaz.",
      conflictTitle: "Hesap başka bir cihazdan değiştirildi",
      conflictBody: "Değişikliklerinizi kaybetmemek için güncel değerleri yükleyip yeniden girin.",
    },
    open: {
      title: "Vardiya aç",
      description:
        "Şablonu, kasayı ve vardiyaya giren kişileri seçin. Açılış endeksleri kendiliğinden alınır; gerekirse elle düzeltebilirsiniz.",
      submit: "Vardiyayı aç",
      opened: "{{shiftNo}} numaralı vardiya açıldı",
      validationFailed: "Form eksik ya da hatalı",
      template: "Vardiya şablonu",
      templateHint: "Şablon seçilirse iş günü ve planlanan saatler şablondan gelir.",
      noTemplate: "Şablonsuz (adı elle yazılır)",
      name: "Vardiya adı",
      startDate: "Başlangıç günü",
      startDateHint: "Vardiyanın başladığı takvim günü; boş bırakılırsa bugün kabul edilir.",
      cashRegister: "Vardiyanın kasası",
      cashRegisterHint: "Ara teslimler ve devir parası bu kasaya işlenir.",
      noCashRegister: "Kasa seçilmedi",
      members: "Vardiyaya girenler",
      member: "{{no}}. kişi",
      removeMember: "{{no}}. kişiyi çıkar",
      addMember: "Kişi ekle",
      staff: "Personel",
      duty: "Görev",
      openingFloat: "Devir parası",
      openingFloatHint: "Ayardaki varsayılanla dolar; kişiye göre değiştirilebilir.",
      memberCashRegister: "Nakdin gireceği kasa",
      useShiftCashRegister: "Vardiyanın kasası",
      assignedCashRegister: "Sorumlu olduğu kasa",
      assignedCashRegisterHint: "Kasiyerin kasa ataması; kapanışta bu kasanın hesabı sorulur.",
      noAssignedCashRegister: "Kasa ataması yok",
      nozzles: "Tabancalar",
      nozzleTree: "Ada, pompa ve tabanca seçimi",
      island: "{{no}}. ada",
      noIsland: "Adası tanımsız pompalar",
      dispenser: "Pompa {{no}}",
      takenBy: "{{name}} üzerinde",
      noNozzles: "Bu istasyonda etkin tabanca bulunamadı.",
      duplicateTitle: "Aynı tabanca iki kişide",
      duplicateBody:
        "Şu tabancalar birden çok kişiye verilmiş: {{nozzles}}. Aynı tabanca aynı anda tek kişide olabilir.",
      totalizers: "Açılış endeksleri",
      totalizersHint:
        "Endeksler istasyon ajanından ya da son bilinen okumadan kendiliğinden alınır. Yalnızca gerekiyorsa elle düzeltin.",
      manualTotalizers: "Endeksleri elle düzelt",
      noSelectedNozzles: "Önce tabanca seçin.",
      totalizerFor: "{{nozzle}} endeksi",
      totalizerReason: "Gerekçe",
      totalizerReasonHint: "Son okumadan sapma toleransı aşılırsa gerekçe zorunludur.",
      tankReadings: "Tank açılış okumaları",
      withTankReadings: "Tank açılış okuması gir",
      tankLevel: "Tank {{tank}} seviyesi",
      tankWater: "Su seviyesi",
      tankTemperature: "Sıcaklık (°C)",
      previousUnclosedTitle: "Önceki vardiya kapanmamış",
      previousUnclosedReason: "Açılış gerekçesi",
      previousUnclosedReasonHint:
        "Önceki vardiya kapanmadan yeni vardiya açıyorsunuz; gerekçe denetim izine yazılır.",
      previousUnclosedBlocked:
        "Ayarlar önceki vardiya kapanmadan yeni vardiya açılmasına izin vermiyor. Önce açık vardiyayı kapatın ya da vardiya ayarlarından izni açın.",
      note: "Not",
    },
    members: {
      addTitle: "Kişi ekle",
      addDescription: "Vardiya sürerken yeni bir pompacı ya da kasiyer alın.",
      added: "Kişi vardiyaya eklendi",
      staffRequired: "Personel seçin.",
      memberRequired: "Üye seçin.",
      assignmentTitle: "Atama ekle",
      assignmentDescription: "Mevcut bir üyeye yeni tabanca ya da kasa verin.",
      assignmentAdded: "Atama eklendi",
      targetRequired: "En az bir tabanca ya da kasa seçin.",
      cashRegisterTarget: "Kasa ataması",
      noCashRegisterTarget: "Kasa ataması yok",
      handoverTitle: "Vardiya içi devir",
      handoverDescription:
        "Tabanca sorumluluğu ara endeksle başka kişiye geçer; eski atama kapanır, yenisi aynı değerle açılır.",
      handoverNozzles: "Devredilecek tabancalar",
      handoverTo: "Devralan",
      handoverAt: "Devir anı",
      handoverManualTotalizers: "Ara endeksi elle gir",
      handoverDone: "Devir kaydedildi",
      handoverNozzleRequired: "En az bir tabanca seçin.",
      handoverTargetRequired: "Devralan kişiyi seçin.",
      handoverTimeInvalid: "Devir anı geçerli bir tarih ve saat olmalıdır.",
      noActiveAssignments: "Devredilecek açık tabanca ataması yok.",
    },
    records: {
      member: "Kişi",
      amount: "Tutar",
      amountVatHint: "KDV dâhil tutar.",
      note: "Not",
      validationFailed: "Form eksik ya da hatalı",
      cashDropTitle: "Ara teslim",
      cashDropDescription: "Pompacının nakdi kasaya girer; muhasebe fişi gün sonunda kesilir.",
      cashDropSaved: "Ara teslim kaydedildi",
      withDenominations: "Küpür sayımı gir",
      denominationsCaption: "Küpür sayımı",
      denomination: "Küpür",
      quantity: "Adet",
      quantityFor: "{{denomination}} adedi",
      countedTotal: "Sayılan toplam",
      amountFromCount: "Teslim tutarı küpür sayımından alınır.",
      cashExpenseTitle: "Kasadan masraf",
      cashExpenseDescription: "Gider modülünde nakit gider belgesi açılır.",
      cashExpenseSaved: "Masraf kaydedildi",
      category: "Gider kategorisi",
      description: "Açıklama",
      netAmount: "Matrah",
      netAmountHint: "KDV hariç tutar.",
      vatRate: "KDV oranı",
      docKind: "Belge türü",
      documentNo: "Belge / fiş no",
      creditSaleTitle: "Veresiye fişi",
      creditSaleDescription: "Cari açık kalemi oluşur; gelir ve KDV gün sonu özet fişindedir.",
      creditSaleSaved: "Fiş kaydedildi",
      creditSaleKind: "Fiş türü",
      counterparty: "Cari",
      slipNo: "Fiş no",
      plate: "Plaka",
      nozzle: "Tabanca",
      product: "Ürün",
      productHint: "Fişin ürünü (isteğe bağlı).",
      noProduct: "Ürün seçilmedi",
      nozzleHint: "Fişin hangi tabancadan çekildiği (isteğe bağlı).",
      noNozzle: "Tabanca seçilmedi",
      litres: "Litre",
      creditLimitTitle: "Kredi limiti aşılıyor",
      creditLimit: "Kredi limiti",
      totalRisk: "Toplam risk",
      available: "Kullanılabilir",
      unlimited: "Limitsiz",
      counterpartyBlockedTitle: "Cari bloke",
      counterpartyBlocked: "Cari bu şirkette bloke: yeni veresiye / filo fişi kesilemez.",
      overrideCreditLimit: "Limiti aşarak kaydet",
      overrideNotAllowed: "Limit aşımını onaylama yetkiniz yok; yetkili bir kullanıcıya başvurun.",
      overriddenBadge: "Limit aşımı onaylandı",
      fleetVehicle: "Filo aracı",
      fleetVehicleHint: "Carinin etkin araçları. Seçilmezse plaka carinin araçlarında aranır.",
      fleetNoVehicle: "Araç seçilmedi (plakayla)",
      fleetDriver: "Sürücü (kart)",
      fleetDriverHint: "Sürücü kartı zorunlu kuralda sürücü seçilmelidir.",
      fleetNoDriver: "Sürücü seçilmedi",
      odometer: "Kilometre",
      odometerHint: "Araç sayacı; km zorunlu kuralda girilmelidir.",
      fleetBlockedTitle: "Filo kuralı fişi engelliyor",
      fleetBlockedHint:
        "Bu ihlal geçersiz kılınamaz: eksik bilgiyi tamamlayın ya da kuralı filo ekranında değiştirin.",
      fleetApprovalTitle: "Filo kuralı ihlali — yetkili onayı gerekir",
      fleetOverride: "Kuralı onaylayarak geç",
      fleetOverrideNotAllowed: "Kural ihlalini onaylama yetkiniz yok; yetkili bir kullanıcıya başvurun.",
      fleetNotOverridable: "geçersiz kılınamaz",
      fleetOverriddenBadge: "Filo kuralı onayla geçildi",
      testDrawTitle: "Test çekişi",
      testDrawDescription: "Test yakıtı gelir değildir; beklenen tutardan litre bazında düşülür.",
      testDrawSaved: "Test çekişi kaydedildi",
      returnedToTank: "Tanka geri döküldü",
      activeBadge: "Geçerli",
      cancelledBadge: "İptal edildi",
      cancelRecord: "İptal et",
      cancelRecordTitle: "Kaydı iptal et",
      cancelRecordDescription: "İptal gerekçesi denetim izine yazılır; kayıt silinmez.",
      cancelShiftTitle: "Vardiyayı iptal et",
      cancelShiftDescription:
        "Yanlış açılan vardiya iptal edilir. Vardiyanın herhangi bir kaydı varsa iptal edilemez.",
      reason: "Gerekçe",
      reasonRequired: "Gerekçe en az 3 karakter olmalıdır.",
      confirmCancel: "İptal et",
      cancelled: "Kayıt iptal edildi",
    },
    staff: {
      description: "Pompacı, kasiyer ve vardiya amiri kartları; kullanıcı hesabı ve personel carisi bağı.",
      caption: "İstasyon personeli",
      newTitle: "Yeni personel",
      editTitle: "Personeli düzenle",
      dialogDescription: "Personel kodu istasyon içinde tekildir. Ayrılan personel pasife alınır, silinmez.",
      created: "Personel kaydedildi",
      updated: "Personel güncellendi",
      emptyTitle: "Kayıtlı personel yok",
      emptyDescription: "Vardiya açabilmek için önce istasyonun personelini tanımlayın.",
      codeRequired: "Personel kodu zorunludur.",
      nameRequired: "Ad soyad en az 2 karakter olmalıdır.",
      stationRequired: "İstasyon seçin.",
      activeHint: "Pasif personel yeni vardiyalara alınamaz; geçmiş kayıtlarda adı kalır.",
      noCounterpartyHint: "Carisi olmayan personele açık yazılamaz; gidere düşer.",
      noCounterpartyShort: "Carisi yok",
      fields: {
        staffCode: "Personel kodu",
        staffCodeHint: "A–Z, 0–9, nokta, tire ve alt çizgi.",
        fullName: "Ad soyad",
        duty: "Görev",
        user: "Kullanıcı hesabı",
        userHint: "Hesabı olmayan personelin kaydını müdür girer.",
        noUser: "Hesap bağlanmadı",
        counterparty: "Personel carisi",
        counterpartyHint: "Yalnızca personel rolündeki cariler seçilebilir; kasa açığı buraya borç yazılır.",
      },
    },
    templates: {
      description: "İstasyonun tipik vardiya pencereleri ve 24 saatlik kapsama denetimi.",
      caption: "Vardiya şablonları",
      newTitle: "Yeni şablon",
      editTitle: "Şablonu düzenle",
      dialogDescription: "Bitiş saati başlangıçtan küçük ya da eşitse vardiya ertesi gün biter.",
      created: "Şablon kaydedildi",
      updated: "Şablon güncellendi",
      emptyTitle: "Şablon tanımlanmamış",
      emptyDescription: "Şablon zorunlu değildir; tanımlarsanız vardiya açmak hızlanır.",
      includeInactive: "Pasif şablonları da göster",
      nameRequired: "Şablon adı zorunludur.",
      stationRequired: "İstasyon seçin.",
      timeInvalid: "Başlangıç ve bitiş saati SS:DD biçiminde olmalıdır.",
      sortOrderInvalid: "Sıra 0 ile 999 arasında bir tam sayı olmalıdır.",
      durationValue: "Süre: {{duration}}",
      endsNextDay: "Ertesi gün biter",
      activeHint: "Pasif şablon vardiya açarken listelenmez.",
      offset: {
        same: "Vardiyanın başladığı gün",
        previous: "Bir önceki gün",
        next: "Ertesi gün",
      },
      fields: {
        name: "Şablon adı",
        startTime: "Başlangıç saati",
        endTime: "Bitiş saati",
        window: "Saat aralığı",
        duration: "Süre",
        businessDayOffset: "İş günü",
        businessDayOffsetHint: "Bu vardiyanın satışları hangi iş gününe yazılsın?",
        sortOrder: "Sıra",
        sortOrderHint: "Listelerde küçükten büyüğe sıralanır.",
      },
      coverage: {
        label: "24 saat kapsama",
        covered: "Kapsanan",
        gap: "Boşluk",
        overlap: "Çakışma",
        complete: "Gün boyunca boşluk ya da çakışma yok.",
        gapSummary: "Kapsanmayan aralıklar: {{ranges}}",
        overlapSummary: "Çakışan aralıklar: {{ranges}}",
      },
    },
    settings: {
      description:
        "Fark toleransı, açık politikası, açılış koşulları ve gün sonu ön koşulları. Değerler şirket genelinde ya da istasyon bazında tutulur.",
      scope: "Ayar kapsamı",
      scopeHint: "Şirket satırı tüm istasyonlar için geçerlidir; istasyon seçerseniz geçersiz kılma yazılır.",
      companyScope: "Şirket geneli",
      saved: "Ayarlar kaydedildi",
      readOnly: "Ayarları değiştirme yetkiniz yok; değerler yalnızca görüntülenebilir.",
      reload: "Yeniden yükle",
      conflictTitle: "Ayarlar başka bir kullanıcı tarafından değiştirildi",
      conflictBody: "Değişikliklerinizi kaybetmemek için güncel değerleri yükleyip yeniden kaydedin.",
      isDefaultTitle: "Kayıtlı ayar yok",
      isDefaultBody: "Gösterilen değerler ürün varsayılanlarıdır; kaydedince şirketin satırı oluşur.",
      noOverrideBody:
        "Bu istasyonun geçersiz kılması yok; gösterilen değerler şirket satırından geliyor. Kaydedince istasyona özel satır oluşur.",
      needsVerificationTitle: "Değerler doğrulanmalı",
      needsVerificationBody:
        "Bu eşiklerin yasal bir dayanağı yoktur; işletmenizin ve mali müşavirinizin onayından geçmelidir.",
      markVerified: "Doğrulandı olarak işaretle",
      verified: "Doğrulandı",
      sections: {
        difference: "Fark ve açık politikası",
        opening: "Vardiya açılışı",
        dayEnd: "Gün sonu ön koşulları",
      },
      differenceToleranceAmount: "Fark toleransı (₺)",
      differenceToleranceAmountHint: "Bu tutarın altındaki farklar kendiliğinden kabul edilir.",
      differenceTolerancePerMille: "Fark toleransı (‰)",
      differenceTolerancePerMilleHint: "Beklenen tutarın binde kaçı; mutlak sınırla büyüğü geçerlidir.",
      shortagePolicy: "Açık politikası",
      shortagePolicyHint: "Kasa açığı personel carisine mi borç yazılsın, gidere mi düşsün?",
      chargeWithinTolerance: "Tolerans içi açık da personele yazılsın",
      chargeWithinToleranceHint: "Kapalıyken küçük farklar yalnızca kayda geçer, personele borç yazılmaz.",
      allowOpenWithPreviousUnclosed: "Önceki vardiya kapanmadan açılışa izin ver",
      allowOpenWithPreviousUnclosedHint: "Açıkken gerekçe zorunludur ve denetim izine yazılır.",
      openingTotalizerToleranceL: "Açılış endeksi sapma toleransı (L)",
      openingTotalizerToleranceLHint:
        "Elle girilen endeks son okumadan bu kadar sapabilir; üstü gerekçe ister.",
      transactionMismatchL: "Endeks ↔ işlem uyarı eşiği (L)",
      transactionMismatchLHint: "Endeks farkı ile işlem litreleri bu kadar ayrışırsa uyarı verilir.",
      defaultOpeningFloat: "Varsayılan devir parası",
      defaultOpeningFloatHint: "Vardiya açarken kişi başına önerilen tutar.",
      openShiftAlertHours: "Açık kalan vardiya alarmı (saat)",
      openShiftAlertHoursHint: "Bu süreyi aşan açık vardiya için hatırlatma üretilir.",
      requireTankClosingReadings: "Gün sonunda tank kapanış okuması zorunlu",
      requireTankClosingReadingsHint: "Kapalıyken gün sonu tank okuması olmadan da kapatılabilir.",
      tankClosingReadingWindowMinutes: "Tank okuması penceresi (dk)",
      tankClosingReadingWindowMinutesHint: "Gün sonuna bu kadar yakın alınan okuma kapanış okuması sayılır.",
      requireZReports: "Gün sonunda Z raporu zorunlu",
      requireZReportsHint: "Kapalıyken Z raporu girilmeden de gün sonu yapılabilir.",
      zMismatchThreshold: "Z raporu fark eşiği",
      zMismatchThresholdHint: "Z toplamı ile sistem satışı bu tutardan fazla ayrışırsa alarm üretilir.",
      blockOnZMismatch: "Z farkı gün sonunu engellesin",
      blockOnZMismatchHint: "Açıkken eşiği aşan Z farkı gün sonunu durdurur.",
      zCompareExcludesCreditSales: "Z karşılaştırmasında veresiye / filo satışları düşülsün",
      zCompareExcludesCreditSalesHint:
        "Faturalı satışların fişi ÖKC'den kesilmiyorsa açık bırakın; sistem tutarından düşülür.",
      enforceDayOrder: "Gün sonları sırayla kapatılsın",
      enforceDayOrderHint: "Açıkken önceki iş günü kapanmadan sonraki gün kapatılamaz.",
    },

    // ── Gün sonu (kontrol listesi, kilit, düzeltme kaydı) ────────────────────
    dayEnd: {
      description:
        "İş gününün kontrol listesi, ön izleme toplamları ve kilidi. Kapanış geri alınamaz; sonraki değişiklikler düzeltme kaydıyla yapılır.",
      checklistTitle: "Kontrol listesi",
      canClose: "Gün sonu ön koşulları karşılandı; günü kapatabilirsiniz.",
      cannotClose: "Engelleyen maddeler var; giderilmeden gün kapatılamaz.",
      frozenChecklist:
        "Gün kapatılırken dondurulan kontrol listesi. Sonradan değişen veriler bu listeyi etkilemez.",
      checkStatus: {
        OK: "Tamam",
        WARNING: "Uyarı",
        BLOCKING: "Engel",
      },
      missingCount: "{{count}} eksik",
      goto: {
        previousDay: "Önceki iş gününe git",
        shifts: "Vardiya listesini aç",
        approvals: "Bekleyen fark onaylarını aç",
        tanks: "Tank okumalarını aç",
        zReports: "Z raporlarını aç",
        reconciliation: "Akaryakıt mutabakatını aç",
        mappings: "Eşleştirme bekleyenleri aç",
      },
      cash: "Nakit",
      previewTitle: "Gün ön izlemesi",
      warningsTitle: "Uyarılar",
      fields: {
        shiftCount: "Vardiya",
        closingCount: "Hesap",
        saleLitres: "Satış litresi",
        difference: "Açık / fazla",
        product: "Ürün",
        gross: "Tutar (KDV dâhil)",
        collectionKind: "Tahsilat türü",
        collectionRef: "Kaynak",
        closings: "Kabul / hesap",
        ledger: "Fiş durumu",
        closedAt: "Kapanış anı",
        posBatches: "POS partisi",
        corrections: "Düzeltme kaydı",
      },
      productsCaption: "Gün toplamı — ürün bazında",
      collectionsCaption: "Gün toplamı — tahsilat kırılımı",
      noProducts: "Bu iş gününde ürün satışı yok.",
      noCollections: "Bu iş gününde tahsilat kaydı yok.",
      shiftsTitle: "Vardiyalar ve hesap durumları",
      shiftsCaption: "İş gününün vardiyaları",
      noShifts: "Bu iş gününde vardiya yok.",
      acceptedOf: "{{accepted}} / {{total}}",
      zReportsTitle: "Z raporu özeti",
      zReportsCaption: "İş gününün ÖKC cihazları ve Z raporları",
      noZReports: "Tanımlı ÖKC cihazı yok.",
      calendarDayOpen: "Takvim günü henüz bitmedi",
      noOpenDays: "Bu istasyonda kapatılmamış iş günü kalmadı.",
      openLockedDay: "Kilitli günü aç",
      selectDay: "Bu günü seç",
      recentCaption: "Son iş günleri",
      noRecentDays: "Henüz iş günü kaydı yok.",
      blockedBy: "Engelleyen: {{items}}",
      unknown: "bilinmiyor",
      openEntry: "Fişi aç",
      queuedTitle: "Özet fiş eşleştirme bekliyor",
      queuedBody:
        "Gün sonu özet fişi, eksik hesap eşleştirmesi nedeniyle kuyruğa düştü. Eşleştirmeyi tamamlayın.",
      closeTitle: "Günü kapat",
      closeDescription: "{{station}} istasyonunun iş günü kapatılır ve kilitlenir.",
      closeAction: "Günü kapat",
      closed: "{{station}} iş günü kapatıldı ve kilitlendi.",
      irreversibleTitle: "Bu işlem geri alınamaz",
      irreversibleBody:
        "Gün kilitlenir: o güne vardiya, hesap ve kayıt yazılamaz. Kilit açılmaz; sonraki değişiklikler yalnızca düzeltme kaydıyla yapılır.",
      preconditionsTitle: "Gün sonu ön koşulları karşılanmadı",
      unbalancedTitle: "Gün sonu özet fişi dengelenemedi",
      meta: {
        debit: "Borç",
        credit: "Alacak",
        expectedAmount: "Beklenen",
        declaredTotal: "Beyan",
        shortage: "Açık",
        surplus: "Fazla",
      },
      note: "Kapanış notu",
      noteHint: "İsteğe bağlı; gün sonu belgesine yazılır.",
      correction: {
        title: "Düzeltme kaydı ekle",
        description:
          "Kilitli güne ek / ters fiş. Belge değiştirilemez ve kilidi açmaz; borç = alacak zorunludur.",
        listTitle: "Düzeltme kayıtları",
        listHint: "Kilitli güne girilen düzeltmeler ayrı ve değiştirilemez belgelerdir.",
        caption: "Gün sonu düzeltme kayıtları",
        no: "Belge no",
        empty: "Bu güne düzeltme kaydı girilmemiş.",
        reason: "Gerekçe",
        reasonHint: "En az 10 karakter; denetim izine yazılır.",
        lines: "Satırlar",
        key: "Kayıt anahtarı",
        side: "Borç / alacak",
        sideLabel: {
          DEBIT: "Borç",
          CREDIT: "Alacak",
        },
        businessUnit: "İş birimi",
        noBusinessUnit: "Belirtilmedi",
        addLine: "Satır ekle",
        removeLine: "{{index}}. satırı sil",
        balanced: "Borç = alacak",
        unbalanced: "Borç ve alacak eşit değil",
        postingDate: "Kayıt tarihi",
        postingDateHint: "Boş bırakılırsa iş günü kullanılır. Dönem kapalıysa açık bir tarih verin.",
        periodClosed: "İş gününün muhasebe dönemi kapalı; açık bir kayıt tarihi seçin.",
        invalid: "Düzeltme kaydı eksik ya da geçersiz.",
        created: "{{no}} numaralı düzeltme kaydı oluşturuldu.",
      },
    },

    // ── ÖKC cihazları ve Z raporları ────────────────────────────────────────
    zReports: {
      description:
        "ÖKC cihazlarının Z raporları ve sistem satışıyla karşılaştırması. Karşılaştırma cihaz bazında değil, kapsam (akaryakıt / market / tümü) toplamı bazındadır.",
      tabsLabel: "Z raporu bölümleri",
      tab: {
        reports: "Z raporları",
        devices: "ÖKC cihazları",
      },
      caption: "Z raporları",
      emptyTitle: "Z raporu yok",
      emptyDescription: "Seçilen süzgeçlerde Z raporu bulunamadı.",
      mismatchOnly: "Yalnızca farklılar",
      detail: "Ayrıntı",
      recompare: "Yeniden karşılaştır",
      recompared: "Z raporu yeniden karşılaştırıldı.",
      noBreakdown: "Kırılım girilmemiş.",
      fields: {
        device: "ÖKC cihazı",
        scope: "Kapsam",
        zNo: "Z no",
        totalAmount: "Z toplamı",
        totalAmountHint: "KDV dâhil gün toplamı.",
        systemAmount: "Sistem tutarı",
        difference: "Fark",
        reportAt: "Rapor anı",
        reportAtHint: "Z raporunun alındığı an (istasyon saati).",
        receiptCount: "Fiş adedi",
        ratePercent: "KDV oranı (%)",
        gross: "KDV dâhil tutar",
        vat: "KDV tutarı",
        paymentKind: "Ödeme türü",
        source: "Kaynak",
        file: "Rapor görseli",
        fileHint: "İsteğe bağlı: Z raporunun fotoğrafı ya da PDF'i.",
      },
      direction: {
        NONE: "Fark yok",
        OVER: "Z fazla",
        UNDER: "Z eksik",
      },
      status: {
        MISSING: "Z girilmedi",
        OK: "Uyumlu",
        MISMATCH: "Fark var",
        RESOLVED: "Fark çözüldü",
      },
      flag: {
        provisional: "Geçici karşılaştırma",
        comparedAsGroup: "Grup karşılaştırması",
        resolved: "Fark çözüldü",
        locked: "Gün kilitli",
      },
      paymentKind: {
        CASH: "Nakit",
        CARD: "Kart",
        MOBILE: "Mobil ödeme",
        COUPON: "Kupon",
        OTHER: "Diğer",
      },
      form: {
        title: "Z raporu gir",
        description: "Cihazın gün sonu Z raporu; girildiğinde sistem satışıyla karşılaştırılır.",
        invalid: "Z raporu eksik ya da geçersiz.",
        created: "{{zNo}} numaralı Z raporu kaydedildi.",
        noDevices: "Bu istasyonda etkin ÖKC cihazı yok; önce cihaz tanımlayın.",
        vatBreakdown: "KDV kırılımı",
        paymentBreakdown: "Ödeme kırılımı",
        addVatRow: "KDV satırı ekle",
        removeVatRow: "%{{rate}} KDV satırını sil",
        addPaymentRow: "Ödeme satırı ekle",
        removePaymentRow: "{{kind}} satırını sil",
        uploading: "Dosya yükleniyor…",
        fileUploaded: "Rapor görseli yüklendi.",
        fileAttached: "Rapor görseli eklendi.",
      },
      device: {
        newTitle: "Yeni ÖKC cihazı",
        editTitle: "ÖKC cihazını düzenle",
        description: "Hangi cihazdan Z beklenir ve hangi satışları kapsar.",
        caption: "ÖKC cihazları",
        serialNo: "Seri / sicil no",
        inServiceFrom: "Hizmete giriş tarihi",
        inServiceFromHint:
          "Cihaz bu günden önceki iş günlerinde 'Z beklenen cihaz' sayılmaz. Boş bırakılırsa her gün beklenir.",
        serialLocked: "Seri no ve istasyon değiştirilemez.",
        label: "Etiket",
        scope: "Kapsam",
        scopeHint: "Z toplamının hangi satışlarla karşılaştırılacağını belirler.",
        activeHint: "Pasif cihazdan Z beklenmez ve karşılaştırmaya girmez.",
        created: "ÖKC cihazı tanımlandı.",
        updated: "ÖKC cihazı güncellendi.",
        invalid: "Cihaz bilgileri eksik ya da geçersiz.",
        emptyTitle: "ÖKC cihazı yok",
        emptyDescription: "Z raporu girebilmek için önce cihaz tanımlayın.",
      },
      resolve: {
        title: "Z farkını çöz",
        description: "Fark gerekçeli olarak kabul edilir ve gün sonunda engel olmaktan çıkar.",
        note: "Gerekçe",
        noteHint: "Farkın neden kabul edildiğini yazın (en az 3 karakter).",
        noteTitle: "Çözüm notu",
        action: "Farkı çöz",
        done: "Z farkı çözüldü olarak işaretlendi.",
      },
    },

    // ── Raporlar ────────────────────────────────────────────────────────────
    reports: {
      description:
        "Pompacı performansı, açık / fazla trendi, Z mutabakatı ve gün sonu raporları. Tarih süzgeçleri iş gününe göredir.",
      range: "İş günü aralığı",
      emptyTitle: "Kayıt bulunamadı",
      emptyDescription: "Seçilen aralıkta ve istasyonda rapor satırı yok.",
      tab: {
        attendants: "Pompacı performansı",
        differences: "Açık / fazla trendi",
        "z-reconciliation": "Z mutabakatı",
        "day-end": "Gün sonu",
      },
      attendants: {
        caption: "Pompacı performansı",
        shiftCount: "Vardiya",
        turnover: "Ciro",
        shortage: "Açık (adet · tutar)",
        surplus: "Fazla (adet · tutar)",
        averageDifference: "Ortalama fark",
        lastDifferences: "Son farklar",
        noRecentDifference: "Son {{count}} vardiyada fark yok",
      },
      differences: {
        caption: "Açık / fazla dökümü",
        groupBy: "Gruplama",
        group: {
          day: "Güne göre",
          staff: "Personele göre",
          station: "İstasyona göre",
        },
        groupLabel: "Grup",
        net: "Net fark",
        amountAxis: "Tutar (₺)",
        chartAria: "{{from}} – {{to}} açık / fazla trendi",
        chartTableLabel: "Açık / fazla trendi verileri",
      },
      zReconciliation: {
        caption: "Z mutabakatı — gün × cihaz",
      },
      dayEnd: {
        caption: "Gün sonu — gün × istasyon",
        chainTotal: "ZİNCİR toplamı — {{stations}} istasyon · {{days}} gün ({{closed}} kilitli)",
      },
    },

    // ── Vardiya raporu ──────────────────────────────────────────────────────
    shiftReport: {
      title: "Vardiya raporu",
      print: "Yazdır",
      summaryTitle: "Özet",
      productsTitle: "Ürün bazında satış",
      collectionsTitle: "Tahsilat kırılımı",
      membersTitle: "Kişi bazında beklenen / beyan / fark",
      recordsTitle: "Vardiya içi kayıtlar",
      count: "{{count}} kayıt",
    },
  },
  accounting: {
    company: {
      label: "Şirket",
      noneTitle: "Etkin şirket bulunamadı",
      noneDescription:
        "Muhasebe defteri şirket bazındadır. Önce Ayarlar › Şirketler bölümünden bir şirket tanımlayın.",
      notInitializedTitle: "Hesap planı henüz kurulmamış",
      notInitializedDescription:
        "{{company}} için Tekdüzen Hesap Planı şablonu, varsayılan eşleştirmeler ve içinde bulunulan mali yıl kurulacak.",
      initialize: "Hesap planını kur",
      initializeNoPermission: "Hesap planını kurmak için hesap planı yönetme yetkisi gerekir.",
      initialized: "Hesap planı kuruldu",
    },
    validation: {
      tooSmall: "En az {{minimum}} karakter ya da değer girilmelidir",
      tooBig: "En fazla {{maximum}} karakter ya da değer girilebilir",
      invalidFormat: "Geçersiz biçim",
      invalidValue: "Geçersiz değer",
    },
    accountPicker: {
      placeholder: "Hesap kodu ya da adı",
      results: "Hesap önerileri",
      empty: "Eşleşen hesap bulunamadı",
    },
    dimensions: {
      STATION: "İstasyon",
      BUSINESS_UNIT: "İş birimi",
      COST_CENTER: "Masraf merkezi",
      COUNTERPARTY: "Cari",
      INSTRUMENT: "Çek / senet",
    },
    fields: {
      account: "Hesap",
      amount: "Tutar",
      createdAt: "Oluşturulma",
      createdBy: "Oluşturan",
      credit: "Alacak",
      dateFrom: "Başlangıç tarihi",
      dateTo: "Bitiş tarihi",
      debit: "Borç",
      description: "Açıklama",
      dimensions: "Boyutlar",
      docDate: "Belge tarihi (satır)",
      docNo: "Belge no",
      docType: "Belge türü",
      document: "Belge",
      documentDate: "Belge tarihi",
      entryNo: "Madde no",
      entryType: "Fiş türü",
      fiscalYear: "Mali yıl",
      lineCount: "Satır sayısı",
      periodStatus: "Dönem durumu",
      postedAt: "Kesinleşme",
      postingDate: "Kayıt tarihi",
      source: "Kaynak",
      sourceDocument: "Kaynak belge",
      total: "Toplam",
    },
    entries: {
      description: "Yevmiye fişleri: taslaklar, kesinleşmiş fişler ve ters kayıtlar.",
      new: "Yeni fiş",
      noEntryNo: "Taslak",
      searchPlaceholder: "Açıklama ya da madde no",
      empty: "Henüz fiş yok",
      emptyHint: "İlk fişi “Yeni fiş” düğmesiyle girin ya da açılış bakiyelerini içe aktarın.",
      emptyFiltered: "Filtreye uyan fiş yok",
      emptyFilteredHint: "Filtreleri değiştirerek yeniden deneyin.",
    },
    entry: {
      description:
        "Klavye öncelikli fiş girişi. Taslak dengesiz kaydedilebilir; kesinleştirmek için borç ve alacak eşit olmalıdır.",
      editTitle: "Taslak fişi düzenle",
      postingDateHint: "Açık bir döneme düşmelidir",
      linesCaption: "Fiş satırları",
      lineNo: "Sıra",
      linePrefix: "Satır {{line}}",
      cellLabel: "Satır {{line}} {{field}}",
      none: "Yok",
      requiredDimension: "bu hesap için zorunlu",
      unsupportedDimension:
        "Bu hesap, bu ekrandan seçilemeyen bir boyut ister (çek/senet modülü henüz yok ya da cari hesaplar modülüne erişiminiz yok). Boyut girilemediği sürece fiş kesinleştirilemeyebilir.",
      toggleDetail: "Satır {{line}} boyut ve belge ayrıntısını aç/kapat",
      removeLine: "Satır {{line}} sil",
      addLine: "Satır ekle",
      totalDebit: "Borç toplamı",
      totalCredit: "Alacak toplamı",
      difference: "Fark",
      differenceNone: "Fiş dengede",
      differenceDebit: "borç fazla",
      differenceCredit: "alacak fazla",
      balance: "Farkı yeni satıra yaz",
      keyboardHint:
        "Enter: sonraki satır (son satırda yeni satır açar) · Tab: son alanda yeni satır · Ctrl/⌘+Enter: taslağı kaydet · Hesap alanında ↓/↑ ile öneriler, Enter ile seçim.",
      saveDraft: "Taslak kaydet",
      saveAndPost: "Kaydet ve kesinleştir",
      copyNotice:
        "{{entry}} fişinden kopyalandı. Tarihler bugüne çekildi; kaydedince yeni bir taslak oluşur.",
      notEditableTitle: "Bu fiş düzenlenemez",
      notEditable:
        "Yalnızca taslak fişler düzenlenebilir. Kesinleşmiş fişte düzeltme ters kayıt ve yeni fişle yapılır.",
      backToDetail: "Fiş detayına dön",
      postBlocked: {
        tooFewLines: "Kesinleştirmek için en az iki satır gerekir.",
        noAmount: "Kesinleştirmek için satırlara tutar girin.",
        unbalanced: "Borç ve alacak toplamı eşit değil; fark kapanmadan fiş kesinleştirilemez.",
      },
      errors: {
        accountRequired: "Hesap seçin",
        fixAmounts: "Geçersiz tutar içeren satırlar var. Önce tutarları düzeltin.",
        noLines: "En az bir satır girin.",
        savedButNotPosted: "Taslak kaydedildi ancak kesinleştirilemedi: {{reason}}",
        checkLines: "{{reason}} İşaretli satırları düzeltin.",
      },
      errorField: {
        accountId: "Hesap",
        debit: "Borç",
        credit: "Alacak",
        description: "Açıklama",
        stationId: "İstasyon",
        businessUnit: "İş birimi",
        costCenterId: "Masraf merkezi",
        counterpartyId: "Cari",
        docType: "Belge türü",
        docNo: "Belge no",
        docDate: "Belge tarihi",
      },
      toast: { draftSaved: "Taslak kaydedildi", posted: "Fiş kesinleştirildi" },
    },
    detail: {
      title: "Fiş {{year}}/{{entryNo}}",
      draftTitle: "Taslak fiş",
      draftHint: "Madde numarası kesinleştirmede verilir.",
      summaryEntry: "Özet fiş",
      linesCaption: "Fiş satırları",
      copy: "Kopyala",
      delete: "Taslağı sil",
      deleteTitle: "Taslak fiş silinsin mi?",
      deleteDescription:
        "Taslak kalıcı olarak silinir. Kesinleşmiş fişler silinemez; bu işlem yalnızca taslaklar içindir.",
      deleted: "Taslak silindi",
      post: "Kesinleştir",
      reverse: "Ters kayıt al",
      reverseTitle: "Ters kayıt al",
      reverseDescription:
        "Satırların borç ve alacağı yer değiştirmiş yeni bir fiş kesinleştirilir; bu fiş “ters kaydı alındı” olarak işaretlenir. Kısmi ters kayıt yoktur.",
      reverseDate: "Ters kayıt tarihi",
      reverseDateHint: "Açık bir döneme düşmelidir",
      reverseDescriptionHint: "Boş bırakılırsa açıklama kendiliğinden üretilir",
      reverseConfirm: "Ters kaydı oluştur",
      reversed: "Ters kayıt oluşturuldu",
      reversalOf: "Bu fiş başka bir fişin ters kaydıdır.",
      openOriginal: "Özgün fişi aç",
      reversedBy: "Bu fişin ters kaydı alınmıştır; defterde birbirini sıfırlar.",
      openReversal: "Ters kayıt fişini aç",
      unbalancedDraft: "Bu taslak dengede değil; kesinleştirmeden önce düzenleyin.",
      sources: "Kaynak işlemler ({{count}})",
      sourcesTitle: "Kaynak işlemler",
      sourceType: "İşlem türü",
      sourceId: "İşlem kimliği",
    },
    chart: {
      description:
        "Tekdüzen Hesap Planı: sınıf, grup, ana hesap ve alt hesaplar. Yalnızca yaprak hesaplara kayıt atılır.",
      tabs: { accounts: "Hesaplar", costCenters: "Masraf merkezleri" },
      searchPlaceholder: "Kod ya da ad (ör. 600 ya da kasa)",
      showInactive: "Pasifleri göster",
      matchCount: "{{count}} hesap eşleşti",
      emptySearch: "Eşleşen hesap yok",
      emptySearchHint: "Aramayı değiştirin ya da pasif hesapları gösterin.",
      selectHint: "Ayrıntıları, kullanıldığı yerleri görmek ve alt hesap açmak için ağaçtan bir hesap seçin.",
      postable: "Kayda açık",
      notPostable: "Kayda kapalı (alt hesapları var)",
      postableShort: "kayda açık",
      requiredDimensions: "Zorunlu boyutlar",
      requiredDimensionsHint: "İşaretli boyutlar bu hesaba atılan her fiş satırında doldurulmak zorundadır.",
      fields: {
        code: "Hesap kodu",
        name: "Hesap adı",
        type: "Tür",
        normalBalance: "Normal bakiye",
        level: "Seviye",
        postable: "Kayıt",
      },
      usage: {
        title: "Kullanıldığı yerler",
        lines: "{{count}} fiş satırı",
        children: "{{count}} alt hesap",
        mappings: "Bu hesabı kullanan eşleştirmeler",
        noMappings: "Hiçbir eşleştirmede kullanılmıyor.",
      },
      child: {
        action: "Alt hesap aç",
        title: "{{code}} altına hesap aç",
        description:
          "Kod üst hesabın koduyla başlar. Önerilen kod bir sonraki boş numaradır; değiştirebilirsiniz.",
        codeHint: "{{code}} ile başlamalı; ana hesaptan itibaren {{code}}.01 biçiminde tek parça eklenir",
        codeRule:
          "Kod {{code}} ile başlamalı ve tek bir parça eklemelidir (ör. {{code}}.01; sınıf ve grupta tek hane).",
        parentCloses:
          "Alt hesap açıldığında {{code}} hesabı KAYDA KAPANIR: artık yalnızca alt hesaplarına kayıt atılabilir. Bu hesabı kullanan eşleştirmeleri alt hesaba taşımayı unutmayın.",
        parentHasLines:
          "{{code}} hesabında kayıt var; alt hesap açılamaz. Önce kayıtları ters kayıtla başka hesaba aktarın.",
        submit: "Alt hesabı aç",
        created: "{{code}} hesabı açıldı",
      },
    },
    costCenters: {
      add: "Masraf merkezi ekle",
      edit: "{{name}} masraf merkezini düzenle",
      editTitle: "Masraf merkezini düzenle",
      code: "Kod",
      name: "Ad",
      codeHint: "Büyük harf, rakam ve . _ - kullanılabilir",
      codeLocked: "Kod sonradan değiştirilemez",
      empty: "Masraf merkezi tanımlı değil",
      emptyHint: "Giderleri bölüm ya da proje bazında izlemek için masraf merkezi ekleyin.",
    },
    mappings: {
      description:
        "Modüllerin kullandığı kayıt anahtarlarının hesap planındaki karşılıkları ve eşleştirme bekleyen kayıtlar.",
      tabs: { mappings: "Eşleştirmeler", exceptions: "Eşleştirme bekleyenler" },
      resolutionNote:
        "Kayıt anahtarı en özelden en genele çözümlenir (parametre › istasyon › iş birimi › genel). Eşleştirme yoksa kayıt oluşturulmaz, bekleyenlere düşer; hiçbir kayıt sessizce varsayılan bir hesaba atılmaz.",
      add: "Eşleştirme ekle",
      editTitle: "Eşleştirmeyi düzenle",
      edit: "{{key}} → {{account}} eşleştirmesini düzenle",
      remove: "{{key}} → {{account}} eşleştirmesini sil",
      removeTitle: "Eşleştirme silinsin mi?",
      removeDescription: "Bu anahtar için daha genel bir eşleştirme yoksa yeni kayıtlar bekleyenlere düşer.",
      removeConfirm: "Eşleştirmeyi sil",
      removed: "Eşleştirme silindi",
      formHint: "Özelleştirme alanları boş bırakılırsa eşleştirme geneldir.",
      lockedHint:
        "Anahtar ve özelleştirme sonradan değiştirilemez; gerekirse eşleştirmeyi silip yeniden ekleyin.",
      key: "Kayıt anahtarı",
      keyParam: "Parametre",
      keyParamNone: "Bu anahtar parametre almaz",
      specialization: "Özelleştirme",
      general: "Genel (tüm istasyon ve iş birimleri)",
      note: "Not",
      module: "Modül: {{module}}",
      param: "Parametre: {{param}}",
      noneForKey: "Eşleştirme yok — bu anahtarla gelen kayıtlar bekleyenlere düşer.",
    },
    exceptions: {
      note: "Bu kayıtlar için fiş OLUŞTURULMADI. Eksik eşleştirmeyi ya da boyutu tamamladıktan sonra yeniden işleyin; iş belgeleri etkilenmez.",
      empty: "Eşleştirme bekleyen kayıt yok",
      emptyHint: "Modüllerden gelen tüm kayıtlar fişe dönüştü.",
      pendingSuffix: "eşleştirme bekleyen kayıt",
      reason: "Neden",
      missingKeys: "Eksik anahtarlar",
      attempts: "Deneme",
      select: "{{description}} kaydını seç",
      selectAll: "Tümünü seç",
      retryAll: "Tümünü yeniden işle",
      retrySelected: "Seçilenleri yeniden işle ({{count}})",
      retryResult: "{{attempted}} kayıt denendi: {{resolved}} fişe dönüştü, {{pending}} hâlâ bekliyor",
      dismiss: "Gerekçeyle kapat",
      dismissTitle: "Kayıt gerekçeyle kapatılsın mı?",
      dismissDescription: "Kapatılan kayıt için fiş oluşturulmaz. Gerekçe denetim izine yazılır.",
      dismissReason: "Gerekçe",
      dismissReasonHint: "En az 5 karakter",
      dismissed: "Kayıt kapatıldı",
      pagination: "Bekleyenler sayfalama",
    },
    periods: {
      description:
        "Mali yıllar ve aylık dönemler. Kapalı döneme kayıt atılamaz; geçici kapalı döneme yalnızca ek yetkiyle atılır.",
      newYear: "Yeni mali yıl",
      newYearDescription: "Mali yıl takvim yılıdır (1 Ocak – 31 Aralık) ve 12 aylık dönemle açılır.",
      year: "Yıl",
      yearInvalid: "2000–2999 arasında dört haneli bir yıl girin",
      createYear: "Mali yılı aç",
      yearCreated: "Mali yıl açıldı",
      yearTitle: "{{year}} mali yılı",
      caption: "{{year}} mali yılı dönemleri",
      period: "Dönem",
      periodLabel: "{{year}} yılı {{no}}. dönem",
      range: "Tarih aralığı",
      drafts: "Taslak",
      posted: "Kesinleşmiş",
      empty: "Mali yıl açılmamış",
      emptyHint:
        "İlk kayıtla içinde bulunulan yıl kendiliğinden açılır; geçmiş yılları buradan açabilirsiniz.",
      actions: { OPEN: "Yeniden aç", SOFT_CLOSED: "Geçici kapat", CLOSED: "Kapat" },
      dialogTitle: {
        OPEN: "{{year}}/{{no}} dönemini yeniden aç",
        SOFT_CLOSED: "{{year}}/{{no}} dönemini geçici kapat",
        CLOSED: "{{year}}/{{no}} dönemini kapat",
      },
      done: {
        OPEN: "Dönem yeniden açıldı",
        SOFT_CLOSED: "Dönem geçici olarak kapatıldı",
        CLOSED: "Dönem kapatıldı",
      },
      checklist: "Dönem kapama kontrol listesi",
      checklistDescription:
        "Kapatmadan önce dönemin durumu denetlenir. Engelleyici madde varken dönem kapatılamaz.",
      blocked: "Engelleyici maddeler giderilmeden dönem kapatılamaz.",
      softCloseNote:
        "Geçici kapalı döneme yalnızca “kapalı döneme kayıt” yetkisi olan kullanıcılar kayıt atabilir.",
      reopenDescription:
        "Yeniden açma denetim izine yazılır ve kimliğinizi yeniden doğrulamanızı gerektirir.",
      reason: "Gerekçe",
      reasonHint: "En az 5 karakter; denetim izine yazılır",
      checks: {
        PENDING_POSTING_EXCEPTIONS: "Eşleştirme bekleyen kayıtlar",
        DRAFT_ENTRIES: "Kesinleşmemiş taslak fişler",
        LEDGER_BALANCED: "Defter dengesi (borç = alacak)",
        SUBLEDGER_COUNTERPARTY: "Cari alt defter mutabakatı",
        SUBLEDGER_INSTRUMENT: "Çek / senet alt defter mutabakatı",
        PREVIOUS_PERIODS_CLOSED: "Önceki dönemlerin durumu",
      },
    },
    yearEnd: {
      action: "Yıl sonu sihirbazı",
      title: "{{year}} yıl sonu işlemleri",
      description:
        "Üç adım sırayla çalıştırılır. Her adım TASLAK fiş üretir; hiçbir fiş kendiliğinden kesinleşmez.",
      reviewWarning:
        "Üretilen taslakları inceleyip kesinleştirin. Bir sonraki adım, önceki adımın fişleri kesinleştikten sonra doğru sonuç verir.",
      steps: "Yıl sonu adımları",
      run: "{{step}}. adımı çalıştır",
      noDrafts: "Bu adımda taslak üretilmedi.",
      draftLink: "Taslak fiş {{no}}",
      step: {
        COST_REFLECTION: {
          title: "Maliyet hesaplarının yansıtılması",
          hint: "7 sınıfı gider hesapları yansıtma hesapları üzerinden gelir tablosu hesaplarına aktarılır.",
        },
        INCOME_CLOSING: {
          title: "Gelir tablosu hesaplarının kapatılması",
          hint: "6 sınıfı gelir ve gider hesapları 690 Dönem Kârı veya Zararı hesabına devredilir.",
        },
        CLOSING_AND_OPENING: {
          title: "Kapanış ve açılış fişleri",
          hint: "Bilanço hesapları kapanış fişiyle kapatılır; yeni yılın açılış fişi bunun tam aynasıdır.",
        },
      },
    },
    reports: {
      description:
        "Defter raporları yalnızca kesinleşmiş fişleri kullanır. Hepsi Excel'e aktarılabilir ve yazdırılabilir (PDF olarak kaydedilebilir).",
      tabs: {
        "trial-balance": "Mizan",
        "account-ledger": "Muavin",
        "journal-book": "Yevmiye defteri",
        "general-ledger": "Büyük defter",
        "balance-sheet": "Bilanço",
        "income-statement": "Gelir tablosu",
        profitability: "Kârlılık",
      },
      includeDrafts: "Taslakları dâhil et",
      draftsBannerTitle: "Bu rapor TASLAK fişleri içeriyor",
      draftsBanner: "Tutarlar kesinleşmemiş kayıtları da kapsar; resmî defter değerleri değildir.",
      excel: "Excel'e aktar",
      print: "Yazdır / PDF",
      printedAt: "Basım: {{date}}",
      empty: "Bu aralıkta kayıt yok",
      emptyHint: "Tarih aralığını ya da süzgeçleri değiştirin.",
      level: "Hesap seviyesi",
      levels: {
        "1": "1 — Sınıf",
        "2": "2 — Grup",
        "3": "3 — Ana hesap",
        "4": "4 — Alt hesap",
        "5": "5 — Alt hesap (2. kırılım)",
        "6": "6 — Alt hesap (3. kırılım)",
        "7": "7 — Alt hesap (4. kırılım)",
      },
      hideZero: "Sıfırları gizle",
      code: "Hesap kodu",
      accountName: "Hesap adı",
      mainAccount: "Ana hesap",
      groups: { opening: "Devir", period: "Dönem", total: "Toplam", balance: "Bakiye" },
      columns: {
        openingDebit: "Devir borç",
        openingCredit: "Devir alacak",
        periodDebit: "Dönem borç",
        periodCredit: "Dönem alacak",
        totalDebit: "Toplam borç",
        totalCredit: "Toplam alacak",
        balanceDebit: "Borç bakiyesi",
        balanceCredit: "Alacak bakiyesi",
      },
      openLedger: "{{code}} {{name}} hesabının muavinini aç",
      balance: "Bakiye",
      side: { DEBIT: "B", CREDIT: "A" },
      openingBalance: "Devreden bakiye",
      periodTotalAndClosing: "Dönem toplamı ve kapanış bakiyesi",
      noMovement: "Bu aralıkta hesapta hareket yok.",
      pickAccount: "Bir hesap seçin",
      pickAccountHint:
        "Üst hesap seçilirse alt hesaplarının tümü dâhil edilir. Mizandaki hesap kodlarına tıklayarak da gelebilirsiniz.",
      pagination: "Rapor sayfalama",
      pageOf: "Sayfa {{page}} / {{total}}",
      entryHeading: "Madde {{entryNo}}",
      bookTotal: "Genel toplam ({{count}} fiş)",
      codeFrom: "Ana hesap (ilk)",
      codeTo: "Ana hesap (son)",
      truncated:
        "Bu hesabın hareketleri çok fazla olduğu için liste kısaltıldı; tamamı için muavin raporunu kullanın.",
      asOf: "Bilanço tarihi",
      asOfLabel: "{{date}} itibarıyla",
      compareAsOf: "Karşılaştırma tarihi",
      compareFrom: "Karşılaştırma başlangıcı",
      compareTo: "Karşılaştırma bitişi",
      item: "Kalem",
      assets: "AKTİF (Varlıklar)",
      liabilities: "PASİF (Kaynaklar)",
      totalAssets: "Aktif toplamı",
      totalLiabilities: "Pasif toplamı",
      periodResult: "Kapatılmamış dönem net kârı / zararı (özkaynaklarda gösterilir)",
      notBalanced:
        "Aktif ve pasif toplamı eşit değil. Defter dengesini dönem kontrol listesinden denetleyin.",
      netResult: "Dönem net kârı / zararı",
      groupBy: "Kırılım",
      groupings: {
        STATION: "İstasyon",
        BUSINESS_UNIT: "İş birimi",
        STATION_BUSINESS_UNIT: "İstasyon × iş birimi",
      },
      revenue: "Gelir",
      expense: "Gider",
      net: "Net",
      unassigned: "Boyutsuz",
    },
    tools: {
      description: "Açılış bakiyelerini içe aktarma ve dış muhasebe programına aktarım.",
      tabs: { opening: "Açılış fişi içe aktarma", export: "Dışa aktarım" },
    },
    opening: {
      description:
        "Şablonu indirip hesap kodu, borç ve alacak sütunlarını doldurun. Dosya önce ÖNİZLENİR; geçerliyse taslak bir açılış fişi oluşturulur ve siz inceleyip kesinleştirirsiniz.",
      dateHint: "Genellikle mali yılın ilk günü",
      dateRequired: "Önce kayıt tarihini girin.",
      template: "Şablonu indir",
      templateFailed: "Şablon indirilemedi. Lütfen yeniden deneyin.",
      chooseFile: "Dosya seç ve önizle",
      valid: "Dosya geçerli",
      invalid: "Dosyada hata var",
      fileErrors: "Dosya düzeyindeki hatalar",
      previewCaption: "Açılış bakiyeleri önizlemesi",
      row: "Satır",
      result: "Sonuç",
      ok: "Geçerli",
      fixAndRetry: "Hataları dosyada düzeltip yeniden yükleyin. Hatalı dosyadan fiş oluşturulmaz.",
      commit: "Taslak açılış fişi oluştur",
      created: "Taslak açılış fişi oluşturuldu",
    },
    export: {
      description:
        "Kesinleşmiş fişleri seçilen tarih aralığı için dış muhasebe programının biçiminde indirir.",
      adapter: "Hedef program",
      format: "Biçim",
      needsConfirmation: "biçim teyidi gerekli",
      pendingAdapters: "Biçim teyidi bekleyen programlar",
      datesRequired: "Başlangıç ve bitiş tarihini girin.",
      run: "Dosyayı indir",
      done: "{{entries}} fiş, {{lines}} satır aktarıldı",
      eLedgerNote:
        "e-Defter (berat) üretimi bu sürümün kapsamı dışındadır; e-Defter için mali müşavirinizin kullandığı uyumlu yazılıma bu dosyayı aktarın.",
    },
  },
  counterparties: {
    badges: { blocked: "Blokeli", overLimit: "Limit aşıldı" },
    balance: {
      debitHint: "(B) borç bakiyesi: cari bize borçlu",
      creditHint: "(A) alacak bakiyesi: biz cariye borçluyuz",
    },
    months: {
      "1": "Ocak",
      "2": "Şubat",
      "3": "Mart",
      "4": "Nisan",
      "5": "Mayıs",
      "6": "Haziran",
      "7": "Temmuz",
      "8": "Ağustos",
      "9": "Eylül",
      "10": "Ekim",
      "11": "Kasım",
      "12": "Aralık",
    },
    picker: {
      placeholder: "Kod, ünvan ya da VKN ile arayın",
      results: "Cari arama sonuçları",
      empty: "Eşleşen cari bulunamadı",
    },
    reason: {
      label: "Gerekçe",
      tooShort: "Gerekçe en az 3 karakter olmalıdır",
    },
    fields: {
      accountHolder: "Hesap sahibi",
      addressType: "Adres türü",
      amount: "Tutar",
      balance: "Bakiye",
      bankName: "Banka",
      blockReason: "Blokaj nedeni",
      channel: "Kanal",
      chequeRiskLimit: "Çek risk limiti",
      code: "Cari kodu",
      companies: "Çalıştığı şirketler",
      contactName: "Ad soyad",
      contactTitle: "Görevi",
      counterparty: "Cari",
      country: "Ülke",
      countryCode: "Ülke kodu",
      creditLimit: "Kredi limiti",
      date: "Tarih",
      dateFrom: "Başlangıç tarihi",
      dateTo: "Bitiş tarihi",
      description: "Açıklama",
      direction: "Yön",
      discountRate: "İskonto oranı (%)",
      docNo: "Belge no",
      document: "Belge",
      documentDate: "Belge tarihi",
      dueDate: "Vade tarihi",
      eInvoiceAlias: "Posta kutusu etiketi",
      email: "E-posta",
      foreignTaxId: "Yurt dışı vergi no",
      fullName: "Ad soyad",
      iban: "IBAN",
      isBlocked: "Blokaj (satışı durdur)",
      isEInvoiceRegistered: "e-Fatura mükellefi",
      kind: "Tür",
      kvkkConsentStatus: "Açık rıza durumu",
      kvkkConsentVersion: "Rıza metni sürümü",
      kvkkNoticeVersion: "Aydınlatma metni sürümü",
      limitPolicy: "Limit aşımında",
      name: "Ünvan / ad soyad",
      netAmount: "KDV hariç tutar",
      offsetKey: "Karşı hesap anahtarı",
      offsetParam: "Anahtar parametresi",
      overduePayable: "Vadesi geçen borç",
      overdueReceivable: "Vadesi geçen alacak",
      paymentMethod: "Ödeme şekli",
      paymentTermDays: "Vade (gün)",
      postalCode: "Posta kodu",
      remaining: "Kalan",
      risk: "Risk",
      role: "Rol",
      roles: "Roller",
      tags: "Etiketler",
      targetCounterparty: "Hedef cari",
      taxId: "VKN / TCKN",
      taxOffice: "Vergi dairesi",
      title: "Ünvan",
      transferDirection: "Virman yönü",
      txnNo: "Hareket no",
      txnType: "Hareket türü",
    },
    list: {
      description:
        "Müşteri, tedarikçi, dağıtıcı ve personel carileri. Bakiye, vadesi geçen ve risk kolonları seçili şirkete göredir.",
      new: "Yeni cari",
      openingImport: "Açılış aktarımı",
      searchPlaceholder: "Kod, ünvan ya da VKN",
      stateBlocked: "Blokeli",
      stateWithBalance: "Bakiyesi olanlar",
      unlimited: "Limitsiz",
      empty: "Henüz cari kart yok",
      emptyHint: "İlk cari kartı açarak tahsilat, ödeme ve dekont girmeye başlayabilirsiniz.",
      emptyFiltered: "Bu filtrelere uyan cari yok",
      emptyFilteredHint: "Arama metnini ya da filtreleri değiştirmeyi deneyin.",
    },
    form: {
      description: "Cari kart kiracı genelinde tektir; bakiyesi çalıştığı her şirket için ayrı tutulur.",
      editTitle: "{{code}} kartını düzenle",
      create: "Cari kartı aç",
      checkFields: "Formda düzeltilmesi gereken alanlar var",
      duplicateTitle: "Bu VKN / TCKN ile kayıtlı cari var",
      duplicateList: "Aynı kimlik numaralı cariler",
      saveAnyway: "Yine de kaydet",
      codeHint: "Boş bırakılırsa otomatik üretilir (C000001).",
      codeLocked: "Cari kodu sonradan değiştirilemez.",
      taxIdHint: "Tüzel kişide 10 haneli VKN. Kontrol hanesi doğrulanır.",
      taxIdHintIndividual: "11 haneli TCKN ya da şahıs işletmesinde 10 haneli VKN.",
      foreignTaxIdHint: "Yalnızca yurt dışı cariler için.",
      countryCodeHint: "İki harf (TR, DE…).",
      companiesOnDetail:
        "Şirket bağlantıları ve cariye özel alt hesaplar kart sayfasının Genel sekmesinden yönetilir.",
      tagsHint: "Virgülle ayırın: filo, vadeli, bölge-ege",
      eInvoiceAliasHint: "Örn. urn:mail:defaultpk@firma.com.tr",
      noAddresses: "Adres eklenmedi.",
      addressNo: "Adres {{no}}",
      addressBilling: "Fatura adresi",
      addressShipping: "Teslimat adresi",
      addBillingAddress: "Fatura adresi ekle",
      addShippingAddress: "Teslimat adresi ekle",
      removeAddress: "Adres {{no}} çıkar",
      noContacts: "Yetkili eklenmedi.",
      contactNo: "Yetkili {{no}}",
      addContact: "Yetkili ekle",
      removeContact: "Yetkili {{no}} çıkar",
      noBankAccounts: "IBAN eklenmedi.",
      bankAccountNo: "Banka hesabı {{no}}",
      addBankAccount: "IBAN ekle",
      removeBankAccount: "Banka hesabı {{no}} çıkar",
      notSpecified: "Belirtilmedi",
      paymentTermDaysHint: "Vadesiz belge için 0. Dekontlarda vade bu güne göre önerilir.",
      discountRateHint: "Yüzde olarak: 2,5",
      limitsHint: "Risk, kredi limitiyle karşılaştırılır. Limit boşsa cari limitsizdir.",
      limitsNoPermission:
        "Limit ve blokaj alanlarını değiştirmek için “kredi limiti ve blokaj yönetimi” izni gerekir; değerler yalnızca görüntülenir.",
      creditLimitHint: "Boş bırakılırsa limitsiz.",
      limitPolicyHint: "Veresiye ve filo satışında kasa bu kurala göre davranır.",
      kvkkHint: "Gerçek kişi carilerde aydınlatma ve açık rıza kayıtları sürümlü tutulur (KVKK).",
      sections: {
        identity: "Kimlik",
        contact: "İletişim ve e-belge",
        addresses: "Adresler",
        contacts: "Yetkililer",
        bankAccounts: "Banka hesapları",
        terms: "Ticari şartlar",
        limits: "Limit ve blokaj",
        kvkk: "KVKK kayıtları",
      },
    },
    detail: {
      tabsLabel: "Cari kart bölümleri",
      collect: "Tahsilat",
      pay: "Ödeme",
      otherTransaction: "Dekont / virman",
      statement: "Ekstre",
      cardInfo: "Kart bilgileri",
      contactInfo: "Adresler, yetkililer ve banka hesapları",
      blockedTitle: "Bu cari blokeli: satış durdurulmuştur",
      days: "{{days}} gün",
      kvkkNoticeAt: "Aydınlatma tarihi",
      kvkkConsentAt: "Rıza tarihi",
      notLinked:
        "Bu cari seçili şirkete bağlı değil; o şirkette hareket girilemez. Genel sekmesinden şirkete bağlayabilirsiniz.",
    },
    tabs: {
      general: "Genel",
      transactions: "Hareketler",
      "open-items": "Açık kalemler",
      cheques: "Çekler",
      invoices: "Faturalar",
      letters: "Mutabakatlar",
      notes: "Notlar",
    },
    invoices: {
      openList: "Tüm faturaları aç",
      emptyTitle: "Bu cariye ait fatura yok",
      emptyDescription: "Kesilen ya da alınan faturalar burada listelenir.",
    },
    placeholders: {
      chequesTitle: "Çekler henüz burada listelenmiyor",
      chequesDescription:
        "Carinin çek ve senetleri Çek ve Senet modülüyle (Prompt 09) gelecek. O zamana dek çek tahsilatları Hareketler sekmesinde görünür.",
      invoicesTitle: "Faturalar henüz burada listelenmiyor",
      invoicesDescription:
        "Carinin faturaları e-Belge modülüyle (Prompt 10) gelecek. Vadeli belgeler şimdilik borç / alacak dekontu olarak girilir.",
    },
    risk: {
      title: "Risk ve limit",
      breakdown: "Risk kırılımı",
      component: "Bileşen",
      openBalance: "Açık bakiye",
      chequesInPortfolio: "Portföydeki çekler",
      endorsedChequesNotDue: "Ciro edilmiş, vadesi gelmemiş çekler",
      undeliveredOrders: "Teslim edilmemiş siparişler",
      totalRisk: "Toplam risk",
      available: "Kullanılabilir limit",
      chequeRisk: "Çek riski / limiti",
      oldestOverdue: "en eski gecikme {{days}} gün",
      policy: "Limit aşımında: {{policy}}",
      chequesNote:
        "Ciro edilen çek karşılıksız çıkarsa geri döneceği için vadesine kadar risk sayılır. Çek ve sipariş tutarları ilgili modüller geldiğinde dolacaktır.",
    },
    links: {
      title: "Şirket bağlantıları ve alt hesaplar",
      description:
        "Cariye özel alt hesap (ör. 120.01.0042) seçilirse muhasebe kayıtları o hesaba atılır; boş bırakılırsa şirketin hesap eşleştirmesi kullanılır.",
      receivableAccount: "Alacak alt hesabı (120.xx)",
      receivableHint: "Cari bize borçlandığında kullanılır.",
      payableAccount: "Borç alt hesabı (320.xx)",
      payableHint: "Biz cariye borçlandığımızda kullanılır.",
      save: "Hesapları kaydet",
      saved: "Alt hesaplar kaydedildi",
      addTo: "Şirkete bağla:",
      remove: "{{company}} bağlantısını kaldır",
      removeTitle: "Şirket bağlantısı kaldırılsın mı?",
      removeDescription:
        "{{company}} ile bağlantı kaldırılır. Cari o şirkette hareket gördüyse bağlantı kaldırılamaz.",
      removeConfirm: "Bağlantıyı kaldır",
    },
    transactions: {
      empty: "Bu carinin seçili şirkette hareketi yok",
      emptyHint: "Tahsilat, ödeme ya da dekont girerek başlayabilirsiniz.",
      includeCancelled: "İptal edilenleri göster",
      posted: "Kayıtlı",
      cancelled: "İptal edildi",
      ledgerQueued: "Eşleştirme bekliyor",
      openEntry: "Fişi aç",
      openEntryOf: "{{txnNo}} hareketinin muhasebe fişini aç",
      cancel: "İptal et",
      cancelOf: "{{txnNo}} hareketini iptal et",
      cancelTitle: "{{txnNo}} iptal edilsin mi?",
      cancelDescription:
        "Hareketin eşleştirmeleri geri alınır, açık kalemleri iptal olur ve muhasebe fişinin ters kaydı alınır. Gerekçe denetim izine yazılır.",
      cancelConfirm: "Hareketi iptal et",
      cancelledToast: "Hareket iptal edildi",
    },
    openItems: {
      receivables: "Alacak kalemleri (cari bize borçlu)",
      payables: "Borç kalemleri (biz cariye borçluyuz)",
      none: "Bu yönde kalem yok.",
      showClosed: "Kapalı ve iptal kalemleri de göster",
      truncated: "Yalnızca vadesi en eski 200 kalem gösteriliyor.",
      select: "Seç",
      selectItem: "Eşleştirme için seç: {{item}}",
      totalRemaining: "Açık kalan toplam",
      overdueDays: "{{days}} gün gecikti",
      notDue: "Vadesi gelmedi",
      autoMatch: "Otomatik eşleştir",
      autoMatched: "{{count}} eşleştirme yapıldı (vadesi en eski önce)",
      nothingToMatch: "Eşleştirilecek karşılıklı açık kalem yok",
      manualTitle: "Elle eşleştirme",
      manualHint:
        "Yukarıdan bir alacak ve bir borç kalemi seçin. Önerilen tutar iki kalanın küçüğüdür; kısmi kapama için düşürebilirsiniz.",
      matchAmount: "Eşleştirilecek tutar",
      match: "Eşleştir",
      matched: "Kalemler eşleştirildi",
      exceedsRemaining: "Tutar kalemin kalanını aşıyor",
      allocations: "Eşleştirmeler",
      noAllocations: "Henüz eşleştirme yok.",
      receivableDoc: "Alacak belgesi",
      payableDoc: "Borç belgesi",
      method: "Yöntem",
      methodAuto: "Otomatik (FIFO)",
      methodManual: "Elle",
      crossAccount: "mahsup fişli",
      allocationActive: "Geçerli",
      allocationReversed: "Geri alındı",
      reverse: "Geri al",
      reverseOf: "{{receivable}} ↔ {{payable}} eşleştirmesini geri al",
      reverseTitle: "Eşleştirme geri alınsın mı?",
      reverseDescription:
        "Kalemlerin kalan tutarları eski hâline döner; mahsup fişi varsa ters kaydı alınır. Gerekçe denetim izine yazılır.",
      reverseConfirm: "Eşleştirmeyi geri al",
      reversedToast: "Eşleştirme geri alındı",
    },
    letters: {
      title: "Mutabakat mektupları",
      type: "Tür",
      period: "Tarih / dönem",
      sentAt: "Gönderim",
      response: "Yanıt",
      empty: "Mutabakat mektubu yok",
      emptyHint: "Bakiye mutabakatı cari kartından, Ba/Bs mutabakat mektupları Ba/Bs raporundan üretilir.",
      emptyHintCard: "Belirli bir tarih itibarıyla bakiye mutabakat mektubu oluşturabilirsiniz.",
      create: "Mektup oluştur",
      createTitle: "Bakiye mutabakat mektubu",
      createDescription: "Mektup, seçilen tarih itibarıyla carinin bu şirketteki bakiyesini taşır.",
      asOfDate: "Bakiye tarihi",
      created: "Mutabakat mektubu oluşturuldu",
      pdf: "PDF",
      pdfOf: "{{letter}} mektubunun PDF'ini indir",
      send: "Gönder",
      sendOf: "{{letter}} mektubunu gönder",
      sendTitle: "Mektubu e-postayla gönder",
      sendDescription: "Mektup PDF ekiyle gönderilir. Gönderilmiş mektup yeniden gönderilebilir.",
      to: "Alıcı e-posta",
      toHint: "Boş bırakılırsa carinin kayıtlı e-postası kullanılır.",
      sent: "Mektup gönderildi",
      respond: "Yanıt kaydet",
      respondOf: "{{letter}} mektubuna yanıt kaydet",
      respondTitle: "Carinin yanıtı",
      respondDescription: "Carinin bildirdiği sonucu ve varsa açıklamasını kaydedin.",
      outcome: "Sonuç",
      note: "Not",
      saveResponse: "Yanıtı kaydet",
      responded: "Yanıt kaydedildi",
      cancel: "İptal",
      cancelOf: "{{letter}} mektubunu iptal et",
      cancelled: "Mektup iptal edildi",
    },
    reminders: {
      email: "Hatırlatma e-postası",
      sms: "Hatırlatma SMS'i",
      sent: "Hatırlatma gönderildi: {{to}} · vadesi geçen {{amount}} ({{count}} kalem)",
    },
    notes: {
      new: "Yeni not",
      immutableHint: "Notlar silinmez ve değiştirilmez.",
      add: "Notu ekle",
      added: "Not eklendi",
      empty: "Bu cariye henüz not yazılmadı.",
      unknownAuthor: "Bilinmeyen kullanıcı",
    },
    txn: {
      description:
        "Tahsilat ve ödemede carinin açık kalemleri kapatılır; dekont, virman ve açılış yeni açık kalem doğurur.",
      save: "Hareketi kaydet",
      savedTitle: "{{txnNo}} kaydedildi",
      savedDescription: "{{count}} kalem eşleşti; açık kalan tutar {{unallocated}}.",
      instrumentChannelHint: "Çek ve senet bu formdan girilmez; bordroyla girilir.",
      instrumentChannelLink: "Çek / senet bordrosu oluştur",
      channelHint: "Kasa, banka ve POS hesapları ilgili modüllerle (Prompt 08–09) bağlanacak.",
      offsetKeyHint:
        "Hareketin karşı bacağının atılacağı kayıt anahtarı; hesabı şirketin eşleştirmesi belirler.",
      offsetParamHint: "İsteğe bağlı: {{param}} (ör. RENT). Boşsa anahtarın genel eşleştirmesi kullanılır.",
      dueDateHint: "Boş bırakılırsa belge tarihi + carinin vade günü.",
      netAmountHint: "Doldurulursa belge Ba/Bs raporuna KDV hariç bu tutarla girer; boşsa rapora girmez.",
      transferDirectionHint: "Tutar kaynak cariden hedef cariye aktarılır.",
      transferPayable: "Kaynak carinin borcu azalır → hedef cari borçlanır",
      transferReceivable: "Kaynak cari borçlanır → hedef carinin borcu azalır",
      openingNote:
        "Tek tek açılış kalemi girişi muhasebe fişi üretmez; açılış fişi muhasebe araçlarından ayrıca aktarılır.",
      settlementTitleCollection: "Kapatılacak alacak kalemleri",
      settlementTitlePayment: "Kapatılacak borç kalemleri",
      settlementHint:
        "Otomatik kipte vadesi en eski kalemden başlanır. Kalemlere dağıtılmayan tutar avans olarak açık kalır.",
      settlementMode: "Eşleştirme kipi",
      modes: {
        AUTO_FIFO: "Otomatik (FIFO)",
        MANUAL: "Elle seç",
        NONE: "Eşleştirme yapma",
      },
      pickCounterpartyFirst: "Açık kalemleri görmek için önce cariyi seçin.",
      noOpenItems: "Bu carinin kapatılacak açık kalemi yok; tutarın tamamı avans olarak açık kalır.",
      applyAmount: "Uygulanacak tutar",
      applyAmountFor: "{{item}} kalemine uygulanacak tutar",
      applySuggested: "{{amount}} uygula",
      applySuggestedFor: "{{item}} kalemine önerilen tutarı uygula",
      appliedTotal: "Seçilenlerin toplamı",
      unallocated: "Açık kalacak (avans)",
      overAllocated: "Hareket tutarını aşan",
      errors: {
        fixAmounts: "Tutar alanlarındaki yazım hatalarını düzeltin.",
        fixItems: "Açık kalem tutarlarını düzeltin.",
        noItemSelected: "Elle kipte en az bir kaleme tutar girin ya da başka bir kip seçin.",
        overAllocated: "Kalemlere dağıtılan toplam, hareket tutarını aşıyor.",
      },
    },
    opening: {
      title: "Cari açılış aktarımı",
      description:
        "Devreden alacak ve borçları açık kalem bazında, vadeleriyle birlikte Excel ya da CSV dosyasından aktarın.",
      ledgerNote:
        "Bu aktarım muhasebe fişi ÜRETMEZ: yalnızca cari alt defterini kurar. Açılış fişini Muhasebe › Araçlar ekranından ayrıca aktarın; alt defter mutabakatı ikisini karşılaştırır.",
      template: "Şablonu indir",
      templateFailed: "Şablon indirilemedi.",
      chooseFile: "Dosya seç ve önizle",
      valid: "Dosya aktarılabilir",
      invalid: "Dosyada hata var",
      totalReceivable: "Toplam alacak",
      totalPayable: "Toplam borç",
      fileErrors: "Dosya hataları",
      previewCaption: "Cari açılış kalemleri önizlemesi",
      row: "Satır",
      result: "Sonuç",
      ok: "Uygun",
      fixAndRetry: "Hatalı satırları dosyada düzeltip yeniden yükleyin.",
      commit: "Kalemleri içe aktar",
      imported: "{{count}} açılış kalemi oluşturuldu",
    },
    reports: {
      description: "Ekstre, yaşlandırma, vade takvimi, Ba/Bs, mutabakat mektupları ve alt defter mutabakatı.",
      datesRequired: "Başlangıç ve bitiş tarihi zorunludur.",
      rangeInvalid: "Başlangıç tarihi bitişten sonra olamaz.",
      exportExcel: "Excel'e aktar",
      tabs: {
        statement: "Ekstre",
        aging: "Yaşlandırma",
        "due-calendar": "Vade takvimi",
        "ba-bs": "Ba/Bs",
        letters: "Mutabakat mektupları",
        "ledger-reconciliation": "Alt defter mutabakatı",
      },
    },
    statement: {
      pickTitle: "Ekstre için cari seçin",
      pickDescription: "Devir bakiyesi, hareketler ve yürüyen bakiye seçilen tarih aralığı için listelenir.",
      caption: "Cari ekstre",
      opening: "Devir",
      debit: "Borç",
      credit: "Alacak",
      runningBalance: "Bakiye",
      totals: "Toplam / kapanış bakiyesi",
      noLines: "Bu aralıkta hareket yok.",
      pdf: "PDF indir",
      email: "Ekstreyi e-postala",
      emailTitle: "Ekstreyi e-postayla gönder",
      emailDescription: "Şirket antetli PDF ekstre cariye e-postayla gönderilir.",
      emailSend: "Gönder",
      emailed: "Ekstre gönderildi: {{to}}",
    },
    aging: {
      direction: "Kalemler",
      receivables: "Alacaklar (cari bize borçlu)",
      payables: "Borçlar (biz cariye borçluyuz)",
      asOf: "Tarih itibarıyla",
      boundaries: "Sınır günleri",
      boundariesHint: "Artan sırada, virgülle: 30,60,90",
      boundariesInvalid: "1–3650 arası, artan sırada en çok 6 gün sınırı girin",
      apply: "Uygula",
      caption: "{{date}} itibarıyla yaşlandırma",
      total: "Toplam",
      grandTotal: "Genel toplam",
      empty: "Açık kalem yok",
      emptyHint: "{{date}} itibarıyla bu yönde açık kalem bulunmuyor.",
    },
    dueCalendar: {
      caption: "Vade takvimi",
      items: "Kalemler",
      toCollect: "Tahsil edilecek",
      toPay: "Ödenecek",
      collect: "tahsil",
      pay: "ödeme",
      empty: "Bu aralıkta vadesi gelen kalem yok",
      emptyHint: "Tarih aralığını genişletmeyi deneyin.",
    },
    baBs: {
      form: "Form",
      formBa: "Ba — mal ve hizmet alışları",
      formBs: "Bs — mal ve hizmet satışları",
      year: "Yıl",
      month: "Ay",
      threshold: "Bildirim eşiği (KDV hariç)",
      belowThreshold: "eşiğin altında kalan {{count}} cari rapora girmedi",
      verifyTitle: "Eşik tutarı doğrulanmalı",
      verifyDescription:
        "Eşik, tarihli mevzuat parametresinden gelir ve henüz doğrulanmamış olarak işaretli. Beyan öncesinde mali müşavirinizle güncel tutarı teyit edin.",
      caption: "Form {{form}} — {{month}}.{{year}}",
      documentCount: "Belge sayısı",
      netTotal: "KDV hariç toplam",
      excel: "Excel indir",
      createLetters: "Mutabakat mektuplarını üret",
      lettersCreated: "{{count}} mutabakat mektubu üretildi",
      empty: "Bu dönemde eşiği aşan cari yok",
      emptyHint: "Rapora yalnızca KDV hariç tutarı girilmiş belgeler dâhil edilir.",
    },
    ledgerRec: {
      sourceOfTruth:
        "Her gece carilerin açık kalem bakiyesi, ana defterdeki kontrol hesabı (120, 320… + cari boyutu) bakiyesiyle karşılaştırılır. Fark varsa ana defter gerçeğin kaynağıdır; alt defter ona göre düzeltilir.",
      neverRan: "Henüz çalıştırılmadı",
      reconciled: "Mutabık",
      diffCount: "{{count}} fark",
      lastRun: "Son çalıştırma: {{when}} ({{trigger}}) · {{asOf}} itibarıyla {{checked}} bakiye denetlendi",
      triggerNightly: "gece işi",
      triggerManual: "elle",
      runNow: "Şimdi çalıştır",
      ranClean: "Mutabakat tamam: fark yok",
      ranWithDiffs: "Mutabakat çalıştı: {{count}} fark bulundu",
      cleanMessage: "Alt defter ile ana defter mutabık: fark yok.",
      caption: "Alt defter ile ana defter arasındaki farklar",
      account: "Hesap",
      accountLevel: "Hesap düzeyi (açılış)",
      subledger: "Alt defter",
      ledger: "Ana defter",
      difference: "Fark",
    },
    riskBoard: {
      description: "Limitini aşan, limitine yaklaşan ve vadesi geçmiş alacağı olan cariler.",
      nearPercent: "Yaklaşma eşiği (%)",
      nearPercentHint: "Limitinin bu yüzdesini aşan cariler “yaklaşan” sayılır.",
      nearPercentInvalid: "1–99 arası bir yüzde girin",
      count: "{{count}} cari",
      overLimit: "Limitini aşanlar",
      overLimitEmpty: "Limitini aşan cari yok.",
      nearLimit: "Limitine yaklaşanlar (%{{percent}} ve üzeri)",
      nearLimitEmpty: "Limitine yaklaşan cari yok.",
      overdue: "Vadesi geçmiş alacağı olanlar",
      overdueEmpty: "Vadesi geçmiş alacak yok.",
      riskOverLimit: "Risk / limit",
      usage: "Kullanım",
      oldest: "En eski gecikme",
    },
  },
  treasury: {
    fields: {
      account: "Hesap",
      accountKind: "Hesap türü",
      accountNo: "Hesap no",
      accounts: "Kasa / hesap",
      amount: "Tutar",
      availableBalance: "Kullanılabilir",
      balance: "Bakiye",
      bank: "Banka",
      bankAccount: "Banka hesabı",
      bankName: "Banka adı",
      bookingDate: "İşlem tarihi",
      branchCode: "Şube kodu",
      branchName: "Şube",
      businessDate: "İş günü",
      cashRegister: "Kasa",
      code: "Kod",
      createdAt: "Kayıt zamanı",
      description: "Açıklama",
      docNo: "Belge no",
      documentDate: "Belge tarihi",
      flow: "Yön",
      from: "Başlangıç",
      headOffice: "Merkez",
      iban: "IBAN",
      kind: "Tür",
      lastCount: "Son sayım",
      lastStatement: "Son ekstre",
      ledgerAccount: "Alt hesap",
      ledgerAccountHint: "Boş bırakılırsa şirketin genel eşleştirmesi kullanılır.",
      ledgerAccountPlaceholder: "Kod ya da hesap adı yazın",
      ledgerStatus: "Muhasebe",
      name: "Ad",
      offsetKey: "Karşı hesap anahtarı",
      offsetParam: "Anahtar parametresi",
      origin: "Kaynak",
      overdraftLimit: "KMH limiti",
      reference: "Referans",
      side: "Taraf",
      station: "İstasyon",
      terminal: "POS terminali",
      to: "Bitiş",
      transferFrom: "Kaynak",
      transferPreset: "Transfer türü",
      transferTo: "Hedef",
      txnNo: "Belge no",
      txnType: "Hareket türü",
    },
    flow: { in: "Giriş", out: "Çıkış" },
    side: { debit: "Borç", credit: "Alacak" },
    channel: {
      hint: "Tahsilatın girdiği / ödemenin çıktığı kasa, banka hesabı ya da POS terminali.",
    },
    position: {
      description: "Bugün elinizde ne var, bugün ne girecek ve ne çıkacak.",
      asOf: "Tarih",
      totalsHeading: "Toplamlar",
      breakdownHeading: "Kırılım",
      netHint: "Kasa + banka + bugün beklenen girişler − bugünkü çıkışlar",
      emptyTitle: "Görüntülenecek şirket yok",
      emptyDescription: "Nakit pozisyonu için en az bir şirkette kasa ya da banka hesabı tanımlı olmalıdır.",
      cashRegisters: "Kasalar",
      bankAccounts: "Banka hesapları",
      posPending: "POS'ta bekleyen",
      stations: "İstasyon kırılımı",
      pendingNet: "Bekleyen net",
      dueToday: "Bugün yatacak",
      overdue: "Geciken",
      overdueBadge: "Gecikti",
      overdraftIncluded: "KMH limiti dâhil",
      noCashRegisters: "Kasa tanımlı değil",
      noBankAccounts: "Banka hesabı tanımlı değil",
      noPos: "POS terminali tanımlı değil",
      noStations: "İstasyon kırılımı yok",
      totals: {
        cash: "Kasa",
        bank: "Banka",
        bankAvailable: "Kullanılabilir (KMH dâhil)",
        posPending: "POS'ta bloke",
        posDueToday: "Bugün yatacak POS",
        chequesDueToday: "Bugünkü çek girişi",
        chequesPayableToday: "Bugünkü çek çıkışı",
        dbsDueToday: "Bugünkü DBS",
        loanDueToday: "Bugünkü kredi taksiti",
        netToday: "Bugünkü net",
      },
    },
    cashRegisters: {
      description: "Kasa tanımları, bakiyeleri ve son sayım bilgileri.",
      create: "Kasa aç",
      edit: "Kasayı düzenle",
      editOne: "{{name}} kasasını düzenle",
      dialogDescription: "Kod ve ad zorunludur. Alt hesap boş bırakılırsa genel eşleştirme kullanılır.",
      codeHint: "Büyük harf, rakam ve . _ - içerebilir.",
      stationHint: "Boş bırakılırsa merkez kasa sayılır.",
      saved: "{{name}} kaydedildi",
      emptyTitle: "Henüz kasa tanımlanmamış",
      emptyDescription: "Kasa açtığınızda tahsilat ve tediye hareketleri buradan izlenir.",
      tabsLabel: "Kasa bölümleri",
      tabs: { book: "Kasa defteri", transactions: "Hareketler", counts: "Sayımlar" },
    },
    bankAccounts: {
      description: "Banka hesapları, IBAN'lar, KMH limitleri ve bakiyeler.",
      create: "Banka hesabı aç",
      edit: "Hesabı düzenle",
      editOne: "{{name}} hesabını düzenle",
      dialogDescription: "IBAN'ın sağlama basamağı sunucuda doğrulanır.",
      nameHint: "Ekranda görünecek kısa ad (ör. Ziraat vadesiz).",
      bankNameHint: "Katalogda olmayan banka için serbest yazın.",
      ibanHint: "Boşluklu yapıştırabilirsiniz; biçim kendiliğinden düzeltilir.",
      overdraftHint: "Kullanılabilir bakiyeye eklenir.",
      otherBank: "Katalogda yok (elle yaz)",
      saved: "{{name}} kaydedildi",
      emptyTitle: "Henüz banka hesabı tanımlanmamış",
      emptyDescription: "Hesap açtığınızda ekstre aktarımı ve mutabakat kullanılabilir olur.",
      tabsLabel: "Banka hesabı bölümleri",
      tabs: { transactions: "Hareketler", reconciliation: "Mutabakat" },
    },
    cashBook: {
      title: "Kasa defteri",
      range: "Tarih aralığı",
      export: "Excel'e aktar",
      openingBalance: "Dönem başı devir",
      totalIn: "Toplam giriş",
      totalOut: "Toplam çıkış",
      closingBalance: "Dönem sonu bakiye",
      daysCaption: "Günlük özet",
      linesCaption: "Hareket satırları",
      opening: "Devir",
      closing: "Bakiye",
      in: "Giriş",
      out: "Çıkış",
      runningBalance: "Yürüyen bakiye",
      emptyTitle: "Bu aralıkta hareket yok",
      emptyDescription: "Tarih aralığını genişleterek yeniden deneyin.",
    },
    counts: {
      description: "Küpür bazlı kasa sayımları ve fark kararları.",
      new: "Yeni sayım",
      caption: "Kasa sayımları",
      countedAt: "Sayım zamanı",
      countedTotal: "Sayılan",
      systemBalance: "Sistem bakiyesi",
      difference: "Fark",
      emptyTitle: "Henüz sayım yapılmamış",
      emptyDescription: "Sayım girdiğinizde fark varsa onay kuyruğuna düşer.",
      dialogTitle: "{{name}} sayımı",
      dialogDescription: "Küpür adetlerini girin; toplam ve fark anında hesaplanır.",
      denominationsCaption: "Küpür satırları",
      denomination: "Küpür",
      quantity: "Adet",
      quantityFor: "{{denomination}} adedi",
      note: "Not",
      save: "Sayımı kaydet",
      savedMatched: "Sayım kaydedildi; fark yok",
      savedPending: "Sayım kaydedildi; {{difference}} fark onay bekliyor",
      noDenominations: "En az bir küpür adedi girin",
      noBusinessDate: "İş günü seçin",
      matchedHint: "Sayılan tutar sistem bakiyesiyle aynı.",
      surplusHint: "Kasada fazla var; onaylanınca sayım fazlası kaydı kesilir.",
      shortageHint: "Kasada açık var; onaylanınca sayım açığı kaydı kesilir.",
      approve: "Farkı onayla",
      reject: "Reddet",
      approveTitle: "Sayım farkı onaylansın mı?",
      approveDescription: "Onaylanınca sayım açığı / fazlası belgesi ve muhasebe fişi kesilir.",
      rejectTitle: "Sayım reddedilsin mi?",
      rejectDescription: "Kayıt atılmaz; kasa yeniden sayılmalıdır.",
      decisionNote: "Gerekçe",
      noteRequired: "Gerekçe en az 3 karakter olmalıdır",
      approved: "Sayım farkı onaylandı",
      rejected: "Sayım reddedildi",
      pagination: "Sayım sayfalama",
      previous: "Önceki",
      next: "Sonraki",
    },
    txn: {
      new: "Yeni hareket",
      newDescription: "Kasa tahsil / tediye, havale, transfer, masraf, faiz ve açılış bakiyesi.",
      listDescription: "Şirketin tüm kasa ve banka hareketleri.",
      save: "Hareketi kaydet",
      saved: "{{txnNo}} kaydedildi",
      detailTitle: "Hareket ayrıntısı",
      movements: "Kasa / banka bacakları",
      offsetLines: "Fiş satırları",
      includeCancelled: "İptaller dâhil",
      cancel: "Hareketi iptal et",
      cancelTitle: "Hareket iptal edilsin mi?",
      cancelDescription: "Ters kayıt atılır. Başka bir belgeden doğan hareket kaynağından iptal edilir.",
      cancelled: "İptal edildi",
      emptyTitle: "Hareket bulunamadı",
      emptyDescription: "Filtreleri değiştirerek ya da yeni bir hareket girerek başlayın.",
      warningsTitle: "Kayıt tamam, ancak dikkat",
    },
    form: {
      checkFields: "Formda düzeltilmesi gereken alanlar var",
      fixAmounts: "Tutar alanlarını düzeltin",
      offsetTitle: "Karşı hesap satırları",
      offsetHint: "Satırların toplamı belge tutarına eşit olmalıdır.",
      offsetMismatch: "Karşı hesap satırlarının toplamı belge tutarını tutmuyor",
      offsetKeyFor: "{{row}}. satır karşı hesap anahtarı",
      offsetParamFor: "{{param}}",
      offsetStationFor: "{{row}}. satır istasyonu",
      offsetDescriptionFor: "{{row}}. satır açıklaması",
      offsetAmountFor: "{{row}}. satır tutarı",
      addLine: "Satır ekle",
      removeLine: "{{row}}. satırı sil",
      linesTotal: "Satır toplamı",
      difference: "Fark",
      balanced: "Belge dengeli",
      notBalanced: "Belge dengeli değil",
      pickCashRegister: "Kasa seçin",
      pickBankAccount: "Banka hesabı seçin",
      stationHint: "Analitik kırılım; zorunlu değildir.",
      noStation: "İstasyonsuz (merkez)",
      transferPresetHint: "Kaynak ve hedefin türünü belirler.",
      transferPresets: {
        CASH_TO_BANK: "Kasadan bankaya yatırma",
        BANK_TO_CASH: "Bankadan kasaya çekme",
        CASH_TO_CASH: "Kasadan kasaya",
        BANK_TO_BANK: "Bankadan bankaya (virman)",
      },
      openingFlowHint: "KMH kullanan hesabın devri eksi bakiyelidir.",
      openingPositive: "Artı bakiye",
      openingNegative: "Eksi bakiye (KMH)",
      openingNote:
        "Açılış hareketi muhasebe fişi ÜRETMEZ; toplam devir açılış fişinde yer alır ve dönem denetiminden muaftır.",
    },
    reconciliation: {
      asOf: "Mutabakat tarihi",
      statementBalance: "Ekstre bakiyesi",
      bookBalance: "Defter bakiyesi",
      difference: "Fark",
      unexplained: "Açıklanamayan",
      balanced: "Mutabık",
      unbalanced: "Fark var",
      noStatement: "Ekstre yok",
      unmatchedLines: "Ekstrede olup deftere işlenmemiş",
      unmatchedTotal: "Eşleşmeyen ekstre toplamı",
      noUnmatched: "Eşleşmeyen ekstre satırı yok",
      unlinkedMovements: "Defterde olup ekstrede görülmemiş",
      unlinkedTotal: "Bağlanmamış hareket toplamı",
      noUnlinked: "Bağlanmamış hareket yok",
    },
    statements: {
      description: "Ekstre içe aktarma, eşleşmeyenler kuyruğu, şablonlar ve otomatik eşleştirme kuralları.",
      tabs: { import: "İçe aktar", queue: "Eşleşmeyenler", templates: "Şablonlar", rules: "Kurallar" },
      format: "Dosya biçimi",
      formats: { CSV: "CSV", XLSX: "Excel", MT940: "MT940" },
      template: "Şablon",
      templateHint: "CSV ve Excel için zorunludur.",
      chooseFile: "Dosya seç",
      pickFirst: "Önce hesap, biçim ve şablon seçin.",
      previewCaption: "Ekstre önizlemesi",
      rowNo: "{{row}}. satır",
      rowNoShort: "Satır",
      valid: "Okunabilir",
      invalid: "Okunamadı",
      lineCount: "{{count}} satır",
      duplicateCount: "{{count}} mükerrer",
      openingBalance: "Açılış bakiyesi",
      closingBalance: "Kapanış bakiyesi",
      duplicate: "Mükerrer",
      new: "Yeni",
      fileErrors: "Okunamayan satırlar",
      allDuplicates: "Bu dosyadaki tüm satırlar daha önce aktarılmış görünüyor.",
      import: "İçe aktar",
      imported: "{{count}} satır aktarıldı",
      duplicateStatement:
        "Bu ekstre daha önce aktarılmış: dosyadaki tüm satırlar mükerrer. Farklı bir dosya seçin.",
      resultTitle: "İçe aktarma tamamlandı",
      resultLines: "Okunan satır: {{count}}",
      resultImported: "Aktarılan: {{count}}",
      resultDuplicates: "Mükerrer (atlandı): {{count}}",
      resultSuggested: "Öneri üretilen: {{count}}",
      resultAuto: "Otomatik eşleşen: {{count}}",
      goToQueue: "Eşleşmeyenler kuyruğuna git",
    },
    templates: {
      description: "Banka bazında kolon eşleştirmesi: başlık adı ya da sütun sırası.",
      create: "Şablon ekle",
      edit: "Şablonu düzenle",
      dialogDescription: "Sütunları başlık adıyla ya da 1'den başlayan sıra numarasıyla eşleyin.",
      caption: "Ekstre şablonları",
      bankHint: "Boş bırakılırsa her bankada kullanılabilir.",
      anyBank: "Tüm bankalar",
      delimiter: "Ayraç",
      delimiters: {
        ";": "Noktalı virgül ( ; )",
        ",": "Virgül ( , )",
        tab: "Sekme",
        "|": "Dikey çizgi ( | )",
      },
      headerRow: "Başlık satırı",
      headerRowHint: "0 yazarsanız başlık yok sayılır.",
      dateFormat: "Tarih biçimi",
      decimalSeparator: "Ondalık ayracı",
      comma: "Virgül ( , )",
      dot: "Nokta ( . )",
      amountMode: "Tutar sütunu",
      amountSingle: "Tek (işaretli) tutar",
      amountDebitCredit: "Borç + alacak",
      columns: "Kolon eşleştirmesi",
      columnHint: "Sayı yazarsanız sütun sırası, metin yazarsanız başlık adı olarak aranır.",
      debit: "Borç (çıkış)",
      credit: "Alacak (giriş)",
      optional: { valueDate: "Valör tarihi", balance: "Bakiye", reference: "Referans / dekont no" },
      saved: "Şablon kaydedildi",
      emptyTitle: "Henüz şablon yok",
      emptyDescription: "CSV ya da Excel ekstresi aktarabilmek için bir kolon eşleştirme şablonu ekleyin.",
    },
    queue: {
      action: "Eylem",
      showIgnored: "Yok sayılanlar",
      instruments: "Çek / senetler",
      instrumentsHint:
        "Tahsilde bu hesapta tahsilde / teminatta olan çekler, ödemede bu hesaptan ödenecek kendi çeklerimiz listelenir. Tahsilde seçilen çeklerin toplamı ile satır tutarı arasındaki fark banka masrafı sayılır.",
      resuggest: "Önerileri yeniden üret",
      resuggested: "{{suggested}} öneri, {{auto}} otomatik eşleşme",
      score: "Puan: {{score}}",
      noSuggestion: "Öneri üretilemedi; eylemi elle seçin.",
      confirmSuggestion: "Öneriyi onayla",
      chooseAction: "Başka eylem seç",
      chooseActionTitle: "Eylem seçin",
      confirm: "Onayla",
      confirmed: "Satır eşleştirildi",
      ignore: "Yok say",
      ignoreTitle: "Satır yok sayılsın mı?",
      ignoreDescription: "Gerekçe denetim izine yazılır; satır sonradan kuyruğa geri alınabilir.",
      ignored: "Satır yok sayıldı",
      ignoredReason: "Yok sayma gerekçesi: {{reason}}",
      reopen: "Kuyruğa geri al",
      reopened: "Satır kuyruğa geri alındı",
      counterparty: "Cari",
      openItem: "Açık kalem",
      openItemHint: "Boş bırakılırsa en eski kalemden başlayarak otomatik kapatılır.",
      autoFifo: "Otomatik (en eski önce)",
      posBatches: "POS gün sonu kayıtları",
      posBatchesHint: "Ctrl / ⌘ ile birden çok seçebilirsiniz.",
      dbsItem: "DBS kalemi",
      installment: "Kredi taksiti",
      movement: "Kayıtlı hareket",
      movementHint: "Deftere girilmiş ama ekstrede eşleşmemiş hareketler.",
      missingSelection: "Seçim yapılmadan onaylanamaz",
      emptyTitle: "Kuyruk boş",
      emptyDescription: "Eşleşmeyen ekstre satırı yok.",
      emptyIgnoredTitle: "Yok sayılan satır yok",
      emptyIgnoredDescription: "Yok sayılan bir satır olursa burada görünür.",
      pagination: "Kuyruk sayfalama",
    },
    rules: {
      description: "Öncelik sırasıyla denenir; eşleşen satıra öneri yazılır ya da otomatik onaylanır.",
      create: "Kural ekle",
      edit: "Kuralı düzenle",
      dialogDescription: "Koşullardan yalnızca doldurduklarınız aranır.",
      caption: "Eşleştirme kuralları",
      priority: "Öncelik",
      priorityHint: "Küçük sayı önce denenir.",
      conditions: "Koşullar",
      anyAccountHint: "Boş bırakılırsa tüm hesaplarda geçerli.",
      flows: { ANY: "Her yön", IN: "Giriş", OUT: "Çıkış" },
      amountMin: "En az tutar",
      amountMax: "En çok tutar",
      pattern: "Açıklama deseni",
      patternHint: "Düzenli ifade; büyük/küçük harf duyarsız.",
      iban: "Karşı taraf IBAN",
      ibanHint: "Havalenin geldiği / gittiği hesap.",
      counterpartyHint: "Kural eşleşince bu cariye yazılır.",
      autoApprove: "Otomatik onay",
      autoApproveLabel: "Eşleşen satır kullanıcı onayı beklemeden kaydedilsin",
      saved: "Kural kaydedildi",
      emptyTitle: "Henüz kural yok",
      emptyDescription: "Sık tekrar eden ekstre satırları için kural ekleyin (ör. banka masrafları).",
    },
    pos: {
      description: "Terminaller, gün sonu kayıtları, yatış mutabakatı, valör takvimi ve komisyon analizi.",
      tabs: {
        terminals: "Terminaller",
        batches: "Gün sonu",
        settlement: "Yatış mutabakatı",
        calendar: "Valör takvimi",
        commission: "Komisyon analizi",
      },
      terminalsDescription: "Terminal tanımları ve tarihli komisyon oranları.",
      createTerminal: "Terminal tanımla",
      editTerminal: "Terminali düzenle",
      terminalDialogDescription: "Yatışın geleceği banka hesabı ve valör gün sayısı zorunludur.",
      terminalSaved: "Terminal kaydedildi",
      terminalNo: "Terminal no",
      merchantNo: "Üye işyeri no",
      settlementAccount: "Yatış hesabı",
      settlementAccountHint: "Net tutarın geleceği banka hesabı.",
      valueDays: "Valör (gün)",
      valueDaysHint: "Tutarın kaç gün blokede kalacağı.",
      valueDaysShort: "{{days}} gün valör",
      ledgerAccountHint: "POS alacakları için alt hesap; boşsa genel eşleştirme kullanılır.",
      pendingAmount: "Bekleyen brüt",
      ratesCaption: "{{name}} komisyon oranları",
      cardType: "Kart türü",
      cardTypeFor: "{{row}}. satır kart türü",
      installments: "Taksit",
      installmentsFor: "{{row}}. satır taksit sayısı",
      rate: "Oran",
      ratePercent: "Oran (%)",
      rateInvalid: "Oranı 1,59 gibi yazın",
      validFrom: "Başlangıç",
      validFromRequired: "Başlangıç tarihi seçin",
      validTo: "Bitiş",
      openEnded: "Açık uçlu",
      noRates: "Oran tanımlanmamış",
      addRate: "Oran ekle",
      addRateDescription: "Aynı kart türü ve taksit için önceki açık uçlu oran bir gün öncesinde kapatılır.",
      rateAdded: "Oran eklendi",
      emptyTerminalsTitle: "Henüz terminal tanımlanmamış",
      emptyTerminalsDescription: "Terminal tanımlayınca gün sonu ve yatış mutabakatı kullanılabilir olur.",
      newBatch: "Gün sonu gir",
      newBatchDescription: "Kart türü ve taksit bazında brüt tutarlar; komisyon ve valör hesaplanır.",
      saveBatch: "Gün sonunu kaydet",
      batchSaved: "{{batchNo}} kaydedildi",
      batchResultTitle: "{{batchNo}} kaydedildi",
      batchNo: "Kayıt no",
      batchesCaption: "POS gün sonu kayıtları",
      linesCaption: "Gün sonu satırları",
      gross: "Brüt",
      grossFor: "{{row}}. satır brüt tutarı",
      expectedCommission: "Beklenen komisyon",
      expectedNet: "Beklenen net",
      valueDate: "Valör tarihi",
      addLine: "Satır ekle",
      removeLine: "{{row}}. satırı sil",
      missingRates:
        "Bazı satırlar için o tarihte geçerli komisyon oranı yok; beklenen komisyon eksik olabilir.",
      ledgerMode: "Muhasebe kipi",
      ledgerModeHint: "Fişi burada mı keseceğiz, yoksa kaynak belge mi kesecek?",
      ledgerModePost: "Fişi burada kes",
      ledgerModeExternal: "Fişi kaynak belge kesiyor",
      ledgerStatus: {
        POSTED: "Muhasebe fişi kesildi",
        QUEUED: "Fiş eşleştirme bekliyor",
        EXTERNAL: "Fiş kaynak belgede",
      },
      offsetTitle: "Karşı hesap satırları",
      offsetHint: "Gelir ve KDV satırlarının toplamı brüt tutara eşit olmalıdır.",
      offsetMismatch: "Karşı hesap satırlarının toplamı brüt tutarı tutmuyor",
      externalNote: "Fiş vardiya ya da cari belgesinde kesilecek; burada yalnızca POS alacağı izlenir.",
      pickTerminal: "Terminal seçin",
      pickBusinessDate: "İş günü seçin",
      noLines: "En az bir satıra brüt tutar girin",
      cancelBatch: "İptal et",
      cancelBatchTitle: "Gün sonu kaydı iptal edilsin mi?",
      cancelBatchDescription: "Yalnızca yatış bekleyen kayıtlar iptal edilebilir.",
      batchCancelled: "Gün sonu kaydı iptal edildi",
      emptyBatchesTitle: "Gün sonu kaydı yok",
      emptyBatchesDescription: "Filtreleri değiştirin ya da yeni bir gün sonu girin.",
      pagination: "Gün sonu sayfalama",
      calendarRange: "Takvim aralığı",
      calendarCaption: "Valör takvimi",
      calendarEmpty: "Bu aralıkta beklenen yatış yok",
      batchCount: "Kayıt",
      totalExpectedNet: "Toplam beklenen net",
      overdueExpectedNet: "Geciken bloke",
      overdue: "Gecikti",
      commissionRange: "Analiz aralığı",
      commissionCaption: "Banka bazında komisyon",
      commissionEmpty: "Bu aralıkta yatış yok",
      settledGross: "Yatan brüt",
      actualRate: "Gerçekleşen oran",
      expectedRate: "Beklenen oran",
      pendingGross: "Bekleyen brüt",
    },
    settlement: {
      description: "Bekleyen gün sonu kayıtlarını seçip bankaya yatan net tutarı girin.",
      pendingCaption: "Yatış bekleyen kayıtlar",
      select: "Seç",
      selectBatch: "{{batchNo}} kaydını seç",
      selectedTotal: "Seçilenlerin toplamı",
      settledOn: "Yatış tarihi",
      netAmount: "Yatan net tutar",
      netAmountHint: "Brüt ile arasındaki fark komisyon sayılır.",
      impliedCommission: "Hesaplanan komisyon",
      save: "Yatışı kaydet",
      savedToast: "Yatış mutabık kılındı",
      mismatchToast: "Yatış kaydedildi; komisyon farkı toleransı aştı",
      okTitle: "Yatış mutabık",
      mismatchTitle: "Komisyon farkı toleransı aşıyor",
      grossTotal: "Brüt toplam",
      actualCommission: "Gerçekleşen komisyon",
      difference: "Fark (gerçekleşen − beklenen)",
      pickBatches: "En az bir gün sonu kaydı seçin",
      pickAccount: "Banka hesabı seçin",
      pickDate: "Yatış tarihi seçin",
      pickAmount: "Yatan net tutarı girin",
      emptyTitle: "Yatış bekleyen kayıt yok",
      emptyDescription: "Tüm POS gün sonu kayıtları mutabık kılınmış.",
    },
    guarantees: {
      description: "Teminat mektupları, ipotekler ve rehinler; dağıtıcı bazında teminat açığı.",
      create: "Teminat ekle",
      edit: "Teminatı düzenle",
      dialogDescription: "Tutar ve yön kaydedildikten sonra değiştirilemez.",
      saved: "Teminat kaydedildi",
      direction: "Yön",
      beneficiary: "Muhatap",
      beneficiaryHint: "Genellikle dağıtıcı firma.",
      referenceNo: "Mektup / dosya no",
      issueDate: "Düzenleme tarihi",
      expiry: "Vade",
      expiryHint: "Boş bırakılırsa süresiz sayılır.",
      noExpiry: "Süresiz",
      expired: "Süresi doldu",
      daysLeft: "{{days}} gün kaldı",
      commissionRate: "Komisyon oranı (%)",
      commissionPeriod: "Komisyon dönemi (ay)",
      nextCommission: "Sonraki komisyon",
      nextCommissionDate: "Sonraki komisyon tarihi",
      advanceCommission: "Komisyon ödendi",
      commissionAdvanced: "Sonraki komisyon dönemine geçildi",
      memoPosted: "Nazım kaydı atıldı",
      attachment: "Belge ekle",
      changeStatus: "İade / nakde çevir",
      changeStatusDescription: "Nazım kaydı varsa ters kaydı alınır.",
      statusDate: "İşlem tarihi",
      statusNote: "Not",
      statusChanged: "Durum güncellendi",
      pickCounterparty: "Muhatap seçin",
      pickIssueDate: "Düzenleme tarihi seçin",
      emptyTitle: "Teminat kaydı yok",
      emptyDescription: "Verilen ya da alınan teminatları buradan izlersiniz.",
      pagination: "Teminat sayfalama",
      summaryTitle: "Dağıtıcı bazında teminat",
      summaryEmpty: "Henüz teminat ya da sözleşme tutarı kaydedilmemiş.",
      givenActive: "Verilen (yürürlükte)",
      requiredAmount: "Sözleşme gereği",
      requiredAmountFor: "{{name}} için istenen teminat",
      shortfall: "Açık",
      shortfallBadge: "Teminat açığı",
      nearestExpiry: "En yakın vade",
      setRequirement: "İstenen tutarı gir",
      requirementSaved: "Sözleşme tutarı kaydedildi",
    },
    dbs: {
      description: "Doğrudan Borçlandırma Sistemi anlaşmaları, limit kullanımı ve ödeme takvimi.",
      agreementsTitle: "Anlaşmalar",
      createAgreement: "Anlaşma ekle",
      editAgreement: "Anlaşmayı düzenle",
      agreementDialogDescription: "Banka hesabı ve dağıtıcı kaydedildikten sonra değiştirilemez.",
      agreementSaved: "Anlaşma kaydedildi",
      agreementMissing: "Banka hesabı ve dağıtıcı seçin",
      agreement: "Anlaşma",
      distributor: "Dağıtıcı",
      limit: "Limit",
      used: "Kullanılan",
      available: "Kalan",
      usage: "Doluluk",
      usageLabel: "Limit doluluğu %{{percent}}",
      note: "Not",
      emptyAgreementsTitle: "DBS anlaşması yok",
      emptyAgreementsDescription: "Dağıtıcıyla DBS anlaşmanız varsa limitini buraya girin.",
      calendarTitle: "DBS takvimi",
      planItem: "Kalem planla",
      planItemDescription: "Dağıtıcı faturasının DBS ile ödenecek tutarı ve vadesi.",
      itemPlanned: "Kalem planlandı",
      pickAgreement: "Anlaşma seçin",
      pickDueDate: "Vade seçin",
      limitExceeded: "Bu tutar DBS limitini aşıyor. Yine de planlamak istiyor musunuz?",
      planAnyway: "Yine de planla",
      invoiceNo: "Fatura no",
      dueDate: "Vade",
      markPaid: "Ödendi işaretle",
      markPaidTitle: "DBS tahsilatı gerçekleşti mi?",
      markPaidDescription: "Dağıtıcıya cari ödeme kesilir ve limit serbest kalır.",
      paidOn: "Ödeme tarihi",
      paid: "Kalem ödendi",
      cancelItem: "İptal et",
      cancelItemTitle: "Planlanmış kalem iptal edilsin mi?",
      cancelItemDescription: "Limit serbest kalır; gerekçe denetim izine yazılır.",
      itemCancelled: "Kalem iptal edildi",
      emptyItemsTitle: "Planlanmış kalem yok",
      emptyItemsDescription: "Filtreleri değiştirin ya da yeni bir kalem planlayın.",
      pagination: "DBS sayfalama",
    },
    loans: {
      description: "Banka kredileri, taksit planları ve ödemeler.",
      create: "Kredi ekle",
      dialogDescription: "Taksit planını satır satır girebilir ya da sonradan Excel'den yükleyebilirsiniz.",
      saved: "Kredi kaydedildi",
      emptyTitle: "Kredi kaydı yok",
      emptyDescription: "Kullandığınız banka kredilerini ve taksit planlarını buradan izlersiniz.",
      status: { ACTIVE: "Sürüyor", CLOSED: "Kapandı" },
      referenceNo: "Kredi no",
      principal: "Anapara",
      annualRate: "Yıllık oran (%)",
      startDateLabel: "Kullandırım tarihi",
      startDate: "Kullandırım: {{date}}",
      remainingPrincipal: "Kalan anapara",
      nextDue: "Sonraki taksit",
      recordDisbursement: "Kullandırımı banka hesabına giriş olarak kaydet",
      planTitle: "Taksit planı",
      planHint: "Boş bırakabilir, planı sonradan Excel'den yükleyebilirsiniz.",
      planCaption: "Taksit satırları",
      planEmpty: "En az bir taksit satırı girin",
      planSaved: "Taksit planı güncellendi",
      planImported: "Taksit planı yüklendi",
      importPlan: "Excel'den yükle",
      editPlan: "Planı değiştir",
      editPlanDescription: "Yalnızca ödenmemiş taksitler değiştirilir.",
      showPlan: "Taksitleri göster",
      hidePlan: "Taksitleri gizle",
      installmentsCaption: "{{name}} taksitleri",
      installment: "taksit",
      installmentNo: "No",
      principalAmount: "Anapara",
      interestAmount: "Faiz",
      otherAmount: "Diğer",
      addInstallment: "Taksit ekle",
      removeRow: "{{row}}. taksiti sil",
      dueDateFor: "{{row}}. taksit vadesi",
      principalFor: "{{row}}. taksit anaparası",
      interestFor: "{{row}}. taksit faizi",
      otherFor: "{{row}}. taksit diğer tutarı",
      pay: "Taksiti öde",
      payTitle: "Taksit ödendi mi?",
      payDescription: "Anapara kredi hesabından, faiz ve masraf gider olarak kaydedilir.",
      paid: "Taksit ödendi",
      pickAccount: "Banka hesabı seçin",
      pickStartDate: "Kullandırım tarihi seçin",
    },
    settings: {
      description: "Negatif kasa politikası, nazım kayıt, POS toleransı ve hatırlatma günleri.",
      negativeCashPolicy: "Negatif kasa politikası",
      negativeCashPolicyHint:
        "Kasa bakiyesini eksiye düşüren hareket engellensin mi, yoksa uyarı mı verilsin?",
      guaranteeMemoPosting: "Teminat mektupları için nazım hesap kaydı atılsın",
      guaranteeMemoPostingHint:
        "9xx nazım hesaplarına borç / alacak kaydı yazılır; iadede ters kaydı alınır.",
      posMismatchTolerance: "POS komisyon farkı toleransı",
      posMismatchToleranceHint: "Beklenen ve gerçekleşen komisyon farkı bu tutarı aşarsa alarm üretilir.",
      reminderDays: "Hatırlatma günleri",
      reminderDaysHint: "Vadeden kaç gün önce hatırlatılsın? Virgülle ayırın (ör. 30, 7, 1).",
      reminderDaysInvalid: "En az bir geçerli gün sayısı girin (0–365)",
      readOnly: "Bu ayarları değiştirmek için yetkiniz yok.",
    },
  },

  instruments: {
    riskyDrawer: "Riskli keşideci",
    overdue: "Vadesi geçti",
    void: "İptal edildi",
    fields: {
      portfolioNo: "Portföy no",
      kind: "Tür",
      direction: "Yön",
      serialNo: "Seri no",
      drawer: "Keşideci",
      drawerName: "Keşideci adı / ünvanı",
      drawerTaxId: "Keşideci VKN / TCKN",
      payee: "Lehtar",
      counterparty: "Cari",
      bank: "Banka",
      bankName: "Banka adı",
      branch: "Şube",
      branchName: "Şube adı",
      branchCode: "Şube kodu",
      accountNo: "Hesap no",
      iban: "IBAN",
      bankAccount: "Banka hesabı",
      ownBankAccount: "Ödeme hesabı",
      cashRegister: "Kasa",
      leaf: "Karne yaprağı",
      location: "Konum",
      issueDate: "Düzenleme tarihi",
      dueDate: "Vade",
      amount: "Tutar",
      extraAmount: "Masraf (protesto vb.)",
      collectedAmount: "Tahsil edilen",
      remaining: "Kalan tutar",
      status: "Durum",
      notes: "Not",
      qrRaw: "Karekod metni",
      date: "Tarih",
      batch: "Bordro",
      batchDate: "Bordro tarihi",
      description: "Açıklama",
      controlKey: "Cari kontrol hesabı",
      settlement: "Açık kalem eşleştirme",
      commission: "Tahsil masrafı",
      expense: "Protesto masrafı",
      station: "İstasyon",
    },
    warnings: {
      title: "Uyarılar",
      riskyTitle: "Dikkat: riskli keşideci",
    },
    actions: {
      applicable: "Uygulanabilir bordrolar",
      none: "Bu seçime uygulanabilir bordro yok",
      extraPermission: "(ek yetki gerekir)",
    },
    list: {
      description:
        "Alınan ve verilen çek / senetler; durum sekmeleri, vade süzgeci ve toplu seçimle bordro oluşturma.",
      tabs: "Durum sekmeleri",
      totals: "Süzgece uyan {{count}} kayıt · kalan toplam",
      select: "Seç",
      selectOne: "{{no}} numaralı çek/senedi seç",
      selectPage: "Sayfadakileri seç",
      unselectPage: "Sayfa seçimini kaldır",
      selectionRegion: "Seçili çek/senetler",
      selected: "{{count}} kayıt seçildi · toplam",
      createBatch: "Bordro oluştur",
      clearSelection: "Seçimi temizle",
      print: "Yazdır / PDF",
      dueFrom: "Vade başlangıç",
      dueTo: "Vade bitiş",
      searchPlaceholder: "Portföy no, seri no, keşideci, cari",
      emptyTitle: "Bu durumda çek / senet yok",
      emptyDescription: "Süzgeçleri değiştirin ya da yeni bir giriş bordrosu kesin.",
    },
    detail: {
      title: "Çek / senet",
      actOn: "Bu çekle işlem yap",
      identity: "Kimlik bilgileri",
      voidTitle: "Bu kayıt bordro iptaliyle geçersiz kılındı",
      history: "Durum geçmişi",
      transition: "Geçiş",
      changedBy: "İşlemi yapan",
      new: "Yeni kayıt",
      to: "yeni durum",
      rollback: "Geri alma",
      system: "Sistem",
      endorsements: "Ciro zinciri",
      endorsedOn: "Ciro tarihi",
      from: "Kimden",
      toParty: "Kime",
      images: "Görseller",
      front: "Ön yüz",
      back: "Arka yüz",
      noImage: "Görsel yok",
      imageAlt: "{{no}} numaralı çekin {{side}} görseli",
      addImage: "Görsel ekle",
      replaceImage: "Görseli değiştir",
      uploadImage: "{{side}} görseli yükle",
      imageSaved: "Görsel kaydedildi",
      entries: "Muhasebe fişleri",
      noEntries: "Bu çek için kesilmiş fiş yok.",
      entryN: "{{n}}. fiş",
    },
    batches: {
      description: "Kesilen tüm çek / senet bordroları: giriş, çıkış, tahsil, karşılıksız, keşide ve ödeme.",
      batchNo: "Bordro no",
      type: "Bordro türü",
      party: "Karşı taraf",
      lineCount: "Satır",
      total: "Toplam",
      ledgerStatus: "Fiş durumu",
      createdBy: "Oluşturan",
      cancelled: "İptal edildi",
      includeCancelled: "İptal edilenleri göster",
      emptyTitle: "Bordro yok",
      emptyDescription: "Süzgeçleri değiştirin ya da yeni bir bordro kesin.",
    },
    batch: {
      title: "Bordro",
      lines: "Bordro satırları",
      pdf: "PDF indir",
      openEntry: "Fişi aç",
      cancel: "Bordroyu iptal et",
      cancelTitle: "{{no}} numaralı bordro iptal edilsin mi?",
      cancelDescription:
        "Fişin ters kaydı atılır, açık kalemler ve kasa/banka kaydı geri alınır, çekler önceki durumuna döner. Yalnızca her çekin SON işlemi olan bordro iptal edilebilir.",
      cancelled: "{{no}} numaralı bordro iptal edildi",
      cancelledTitle: "Bu bordro iptal edildi",
      cancelledHint: "Satırlardaki geçişler geri alındı.",
      createdTitle: "{{no}} numaralı bordro kesildi",
      unallocated: "Açık kalemlere uygulanamayan (avans olarak açık kalan) tutar:",
    },
    batchTypeHints: {
      RECEIPT_FROM_CUSTOMER:
        "Müşteriden alınan çek / senetleri portföye girer; cari tahsilat kalemi ve 101.01 / 121 kaydı üretir.",
      ENDORSE_TO_SUPPLIER: "Portföydeki çek / senedi tedarikçiye ciro eder; borcunuzu kapatır.",
      TO_BANK_COLLECTION: "Portföydeki çeki bankaya tahsile verir (101.02).",
      TO_BANK_COLLATERAL: "Portföydeki çeki bankaya teminat olarak verir (101.03).",
      COLLATERAL_RETURN: "Teminattaki çeki bankadan geri alır ve portföye döndürür.",
      RETURN_TO_CUSTOMER: "Portföydeki çek / senedi müşteriye iade eder; cariye yeniden alacak doğar.",
      COLLECTION:
        "Çek / senedi tahsil eder: bankadaki çekte masrafla birlikte, elden tahsilde kasa ya da banka girişiyle.",
      BOUNCE: "Bankadan karşılıksız dönen ya da tedarikçiden geri gelen çeki işler.",
      PROTEST: "Vadesinde ödenmeyen senedi protesto eder; masraf alacağa eklenir.",
      LEGAL_FOLLOWUP: "Karşılıksız / protestolu kaydı yasal takibe alır (fiş üretmez).",
      WRITE_OFF: "Yasal takipteki alacağı şüpheli alacak karşılığıyla siler (129).",
      ENDORSEMENT_CLOSE: "Ciro edilen çekin riskini kapatır (fiş üretmez).",
      ISSUE: "Kendi çek / senedimizi keşide eder; karne yaprağı kullanılmış olur.",
      PAYMENT: "Kendi çek / senedimizin hesabımızdan ödendiğini işler.",
      CANCEL: "Teslim edilmemiş kendi çekimizi iptal eder; borç geri doğar, yaprak iptal olur.",
    },
    wizard: {
      description: "Tür seçin, çekleri girin ya da seçin, karşı tarafı belirtin, fişi önizleyip onaylayın.",
      noPermission: "Bordro kesmek için yetkiniz yok.",
      stepsLabel: "Sihirbaz adımları",
      steps: {
        type: "Bordro türü",
        instruments: "Çek / senetler",
        counterpart: "Karşı taraf ve tutarlar",
        preview: "Önizleme ve onay",
      },
      groupReceived: "Müşteriden alınan çek / senetler",
      groupIssued: "Kendi çek / senetlerimiz",
      next: "İleri",
      preview: "Fişi önizle",
      confirm: "Onayla ve bordroyu kes",
      checkFields: "İşaretli alanları düzeltin.",
      fixAmounts: "Tutar alanlarındaki hataları düzeltin.",
      addAtLeastOne: "En az bir çek / senet satırı ekleyin.",
      selectAtLeastOne: "En az bir çek / senet seçin.",
      noRows: "Henüz satır yok. Aşağıdaki düğmelerle çek ya da senet ekleyin.",
      addCheque: "Çek ekle",
      addNote: "Senet ekle",
      rowTitle: "{{n}}. satır: {{kind}}",
      remove: "Kaldır",
      removeRow: "{{n}}. satırı kaldır",
      otherBank: "Diğer (listede yok)",
      noLeaves: "Bu hesapta kullanılmamış karne yaprağı yok; seri numarasını elle girin.",
      qrHint: "Çekteki karekodun ham metnini yapıştırın; tanınan alanlar kendiliğinden dolar.",
      qrParse: "Karekodu çöz",
      qrApplied: "Karekod alanları dolduruldu.",
      qrUnknown: "Karekod biçimi tanınmadı. Ham metin kayda eklenir; alanları elle girin.",
      noEligible: "Bu bordroya uygun durumda çek / senet yok.",
      eligibleCaption: "Bu bordroya uygun çek / senetler",
      skipped: "{{count}} kayıt bu bordroya uygun olmadığı için seçilmedi.",
      partialAmount: "Kısmi tutar",
      partialAmountFor: "{{no}} için tahsil tutarı",
      fullAmount: "Tamamı",
      counterpartyCustomer: "Çek / senedi veren müşteri.",
      counterpartyIssue: "Çeki verdiğimiz tedarikçi / cari.",
      counterpartySupplier: "Çeki ciro ettiğimiz tedarikçi.",
      controlKeyHint: "Boş bırakılırsa carinin rolüne göre seçilir (Alıcılar 120 / Satıcılar 320).",
      controlKeyDefault: "Carinin rolüne göre (varsayılan)",
      settlementHint: "Otomatik eşleştirme vadesi en eski açık kalemden başlar.",
      settlementFifo: "Otomatik (FIFO)",
      settlementNone: "Eşleştirme yapma",
      bankAccountHint: {
        collection: "Çeklerin tahsile verildiği banka hesabı.",
        collateral: "Çeklerin teminat olarak verildiği banka hesabı.",
      },
      expenseHint: "Masraf alacağa eklenir; girildiğinde kasadan ya da bankadan ödenir.",
      moneyKind: "Para hareketi",
      moneyFromInstrument: "Kasa / banka hesabı çekin bulunduğu yerden belirlenir.",
      commissionHint: "Bankanın tahsilde kestiği masraf; hesaba net tutar girer.",
      descriptionHint: "Boş bırakılırsa bordro türünden üretilir.",
      stationHint: "Muhasebede analitik boyut olarak taşınır.",
      noStation: "İstasyon yok (şirket geneli)",
      posting: "Önizleme fişi",
      noPosting: "Bu bordro muhasebe fişi üretmez.",
      account: "Hesap",
      postingKey: "Kayıt anahtarı",
      debit: "Borç",
      credit: "Alacak",
      unmapped: "Eşleştirme yok",
      missingMappingsTitle: "Fiş eşleştirme bekleyecek",
      missingMappings:
        "Şu kayıt anahtarlarının hesap eşleştirmesi yok: {{keys}}. Bordro kesilir, fiş 'eşleştirme bekleyen' kuyruğuna düşer.",
    },
    validation: {
      serialNo: "Çek seri numarası zorunludur",
      bankId: "Çekin bankasını seçin",
      bankName: "Banka adını yazın",
      drawerName: "Keşideci adı zorunludur",
      ownBankAccountId: "Kendi çekimizin ödeneceği banka hesabını seçin",
      chequeBookLeafId: "Karne yaprağı seçin ya da seri numarası girin",
      dueBeforeIssue: "Vade düzenleme tarihinden önce olamaz",
      counterparty: "Cari seçin",
      bankAccount: "Banka hesabı seçin",
      cashRegister: "Kasa seçin",
    },
    endorsementStatus: {
      ACTIVE: "Risk sürüyor",
      CLOSED: "Kapandı",
      RETURNED: "Geri geldi",
      CANCELLED: "İptal",
    },
    books: {
      description: "Kendi çek karnelerimiz ve yaprak durumları.",
      listTitle: "Karneler",
      create: "Karne tanımla",
      createSubmit: "Karneyi kaydet",
      createDescription: "Seri aralığındaki yapraklar kullanılmadı olarak açılır.",
      created: "{{range}} karnesi tanımlandı",
      checkFields: "İşaretli alanları düzeltin.",
      serialRange: "Seri aralığı",
      serialPrefix: "Seri harfi",
      serialPrefixHint: "Çek numarasının başındaki harf / rakam (ör. D).",
      firstNo: "İlk yaprak no",
      lastNo: "Son yaprak no",
      digits: "Hane sayısı",
      digitsHint: "Seri numarası kaç haneye tamamlanacak (ör. 7 → D0003301).",
      receivedOn: "Teslim tarihi",
      counts: "Yapraklar",
      showLeaves: "Yaprakları göster",
      leavesTitle: "{{range}} yaprakları",
      leafInstrument: "Kesilen çek",
      changeLeaf: "İptal / kayıp işaretle",
      changeLeafTitle: "{{serial}} yaprağı",
      changeLeafDescription: "Yalnızca kullanılmamış yaprak işaretlenir ve bu işlem geri alınamaz.",
      noteRequired: "Not en az 3 karakter olmalıdır",
      leafChanged: "Yaprak durumu güncellendi",
      emptyTitle: "Tanımlı çek karnesi yok",
      emptyDescription: "Bankadan aldığınız karneyi tanımlayın; keşide sihirbazı yaprakları buradan okur.",
    },
    calendar: {
      description: "Çek / senet vadeleri: ay, hafta ve gün görünümü.",
      viewLabel: "Görünüm",
      views: { month: "Ay", week: "Hafta", day: "Gün" },
      navigation: "Takvimde gezinme",
      previous: "Önceki",
      next: "Sonraki",
      today: "Bugün",
      weekTitle: "{{from}} – {{to}}",
      tableCaption: "{{title}} vade takvimi",
      dayLabel: "{{date}}: alınan {{receivable}}, verilen {{payable}}",
      dayListTitle: "{{date}} vadeli çek / senetler",
      dayListHint: "Satıra tıklayarak çek ayrıntısına gidebilirsiniz.",
      emptyDayTitle: "Bu günde vade yok",
      emptyDayDescription: "Başka bir gün seçin ya da süzgeçleri değiştirin.",
    },
    reports: {
      description: "Portföy, vade dağılımı, ödeme planı, risk ve alt defter mutabakatı.",
      tabs: {
        portfolio: "Portföy",
        maturity: "Vade dağılımı",
        "payment-plan": "Verilen çek ödeme planı",
        "counterparty-risk": "Cari riski",
        "drawer-risk": "Keşideci riski",
        reconciliation: "Alt defter mutabakatı",
      },
      asOf: "Tarih",
      count: "Adet",
      totals: {
        receivableOpen: "Elimizdeki + bankadaki",
        endorsedOpen: "Ciroda (risk sürüyor)",
        problemOpen: "Sorunlu (karşılıksız / protesto)",
        issuedOpen: "Ödenmemiş kendi çeklerimiz",
      },
      bucket: "Vade dilimi",
      receivableCount: "Alınan adet",
      receivableAmount: "Alınan tutar",
      payableCount: "Verilen adet",
      payableAmount: "Verilen tutar",
      noBankAccount: "Hesap belirtilmemiş (senet)",
      cumulative: "Birikimli ödeme",
      available: "Kullanılabilir bakiye",
      shortfall: "Açık",
      shortfallBadge: "Bakiye yetersiz",
      shortfallTitle: "Ödeme planında açık var",
      shortfallHint: "{{count}} günde birikimli ödeme kullanılabilir bakiyeyi aşıyor.",
      inPortfolio: "Portföy + banka",
      endorsedOpen: "Ciroda",
      problemOpen: "Sorunlu",
      bounceCount: "Karşılıksız adedi",
      totalExposure: "Toplam risk",
      trusted: "Güvenilir",
      markRisky: "Riskli işaretle",
      markTrusted: "Güvenilir işaretle",
      clearFlag: "İşareti kaldır",
      flagSaved: "{{name}} için risk işareti güncellendi",
      riskyOnly: "Yalnızca riskli",
      subledger: "Alt defter kalemi",
      subledgerBalance: "Alt defter",
      ledgerBalance: "Ana defter",
      difference: "Fark",
      reconciliationTitle: "Alt defter ↔ ana defter",
      balanced: "{{date}} itibarıyla alt defter ana defterle mutabık.",
      unbalanced: "Fark var: aşağıdaki satırları inceleyin (eksik fiş ya da elle atılmış kayıt).",
    },
    settings: {
      description: "Karşılıksız alacak hesabı, hatırlatma günleri, ciro kapama süresi ve risk eşiği.",
      bounceReceivableKey: "Karşılıksız / protestolu alacak hesabı",
      bounceReceivableKeyHint: "Karşılıksız dönen çek alacağı bu hesapta izlenir.",
      fields: {
        collectionReminderDays: "Tahsile verme hatırlatması (gün)",
        ownPaymentReminderDays: "Kendi çekimiz için bakiye kontrolü (gün)",
        collateralReminderDays: "Teminattaki çek hatırlatması (gün)",
        endorsementCloseDays: "Ciro riskinin kapanması (gün)",
        riskyBounceThreshold: "Riskli keşideci eşiği (adet)",
      },
      hints: {
        collectionReminderDays: "Vadesine bu kadar gün kalan portföy çeki için hatırlatma üretilir.",
        ownPaymentReminderDays: "Kendi çekimizin vadesine bu kadar gün kala hesap bakiyesi kontrol edilir.",
        collateralReminderDays: "Teminattaki çekin vadesi yaklaşınca hatırlatılır.",
        endorsementCloseDays: "Ciro edilen çekin riski vade + bu kadar gün sonra kapanır.",
        riskyBounceThreshold: "Keşideci bu sayıda karşılıksız / protestoda riskli sayılır.",
      },
      invalidDays: "0 ile 365 arasında bir gün sayısı girin",
      invalidThreshold: "1 ile 100 arasında bir adet girin",
      readOnly: "Bu ayarları değiştirmek için yetkiniz yok.",
    },
  },

  invoicing: {
    ledgerStatus: {
      NONE: "Fiş yok",
      POSTED: "Fişi kesildi",
      QUEUED: "Eşleştirme bekliyor",
      REVERSED: "Ters kayıt yapıldı",
    },
    postingKey: { INVENTORY: "Stok", EXPENSE: "Gider" },
    submissionOutcome: {
      SUCCESS: "Başarılı",
      RETRYABLE_ERROR: "Geçici hata",
      PERMANENT_ERROR: "Kalıcı hata",
    },
    fields: {
      invoiceNo: "Fatura no",
      issueDate: "Belge tarihi",
      issueTime: "Belge saati",
      dueDate: "Vade",
      counterparty: "Cari",
      station: "İstasyon",
      invoiceType: "Tür",
      scenario: "Senaryo",
      basis: "Dayanak",
      series: "Seri",
      ettn: "ETTN",
      pricingMode: "Giriş modu",
      settlement: "Tahsilat",
      cashRegister: "Kasa",
      posTerminal: "POS terminali",
      notes: "Notlar",
      documentDiscount: "Belge iskontosu",
      product: "Ürün",
      description: "Açıklama",
      quantity: "Miktar",
      unit: "Birim",
      unitPrice: "Birim fiyat",
      discount: "İskonto",
      vatRateCode: "KDV",
      withholdingCode: "Tevkifat",
      exemptionCode: "İstisna",
      postingKey: "Hedef",
      postingParam: "Grup / kategori",
      netAmount: "Matrah",
      vatAmount: "KDV",
      payableAmount: "Ödenecek",
      edocumentStatus: "e-Belge",
      ledgerStatus: "Defter",
    },
    actions: {
      preview: "Önizle",
      pdfPreview: "PDF önizleme",
      saveDraft: "Taslak kaydet",
      issue: "Kesinleştir",
      cancel: "İptal et",
      resend: "Yeniden gönder",
      refreshStatus: "Durumu yenile",
      pdf: "PDF",
      xml: "XML",
      createReturn: "İade faturası oluştur",
    },
    list: {
      description: "Satış ve alış faturaları, e-belge durumları ve defter durumu.",
      tabs: "Fatura yönü",
      caption: "{{direction}} faturaları",
      draftNo: "(taslak)",
      from: "Başlangıç",
      to: "Bitiş",
      searchPlaceholder: "Fatura no ya da cari adı",
      emptyTitle: "Fatura bulunamadı",
      emptyDescription: "Süzgeçleri değiştirin ya da yeni bir fatura oluşturun.",
      ledgerQueuedTitle: "Eşleştirme bekleyen fatura var",
      ledgerQueuedBody:
        "Bu sayfadaki {{count}} faturanın fişi, hesap eşleştirmesi tamamlanmadığı için kesilmedi.",
      resendQueued: "e-Belge yeniden gönderim kuyruğuna alındı.",
      resendFor: "{{no}} numaralı faturayı yeniden gönder",
      pdfFor: "{{no}} numaralı faturanın PDF'i",
    },
    form: {
      description:
        "Yön ve türe göre alanlar değişir. Satırlarda Enter yeni satıra geçer, Ctrl+Enter taslağı kaydeder.",
      directionTabs: "Fatura yönü",
      linesTitle: "Satırlar",
      linesCaption: "Fatura satırları giriş tablosu",
      addLine: "Satır ekle",
      removeLine: "{{line}}. satırı sil",
      cellLabel: "{{line}}. satır {{field}}",
      productPlaceholder: "Ürün kodu ya da adı",
      productResults: "Ürün sonuçları",
      returnable: "kalan: {{quantity}}",
      noStation: "İstasyon seçilmedi",
      defaultOf: "Varsayılan ({{value}})",
      seriesDefault: "Varsayılan seri",
      seriesHint: "Boş bırakılırsa belge ailesinin varsayılan serisi kullanılır.",
      scenarioAuto: "Senaryo, alıcının mükellefiyetine göre kesinleştirmede belirlenir.",
      automatic: "Otomatik",
      dueDateHint: "Boş bırakılırsa belge tarihi + varsayılan vade günü.",
      discountNone: "Yok",
      discountRate: "Oran (%)",
      discountAmount: "Tutar (₺)",
      discountValue: "İskonto değeri",
      draftSaved: "Taslak kaydedildi.",
      issued: "Fatura kesinleşti: {{no}}",
      fixNumbers: "Önce hatalı sayı alanlarını düzeltin.",
      noLines: "En az bir dolu satır gereklidir.",
      hasErrors: "Formda düzeltilmesi gereken alanlar var.",
      generalErrors: "Doğrulama hataları",
      readOnly: "Bu faturayı düzenleme yetkiniz yok; ekran salt okunurdur.",
      noPermission: "Bu belgeyi oluşturma yetkiniz yok",
      noPermissionBody: "Satış ya da alış faturası yetkisi için yöneticinizle görüşün.",
      receiptsMismatch: "Fiş toplamı fatura toplamına eşit olmalı; kesinleştirme kapalı.",
      calculationBlocked: "Toplam hesaplanamıyor; satırları düzeltin.",
      confirmTitle: "Faturayı kesinleştir",
      confirmDescription:
        "Fatura numarası alınacak, muhasebe fişi kesilecek ve (varsa) e-belge sağlayıcıya gönderilecek. Kesinleşen fatura değiştirilemez.",
      returnNotice: "İade faturası: {{no}} numaralı faturanın satırlarıyla dolduruldu.",
      requestNotice: "POS e-Arşiv talebinden oluşturuluyor: {{name}}",
    },
    totals: {
      title: "Toplamlar",
      empty: "Satır girdikçe toplamlar burada hesaplanır.",
      calculationError: "Toplam hesaplanamadı",
      grossNet: "Satır tutarı",
      discount: "İskonto",
      net: "Matrah",
      vatAt: "KDV (%{{rate}})",
      withheld: "Tevkifat",
      withholdingAt: "Tevkifat {{code}} ({{ratio}})",
      payable: "Ödenecek",
    },
    preview: {
      title: "Fatura önizlemesi",
      description: "Hiçbir şey kaydedilmez; numara tüketilmez.",
      summaryTitle: "Önizleme",
      noScenario: "Belirlenmedi",
      warnings: "Uyarılar",
      journalCaption: "Kesilecek fişin önizlemesi",
      account: "Hesap",
      debit: "Borç",
      credit: "Alacak",
      unmapped: "Eşleştirme eksik: {{key}}",
      noJournal: "Bu belge muhasebe fişi üretmez.",
    },
    receipts: {
      title: "ÖKC fişleri",
      caption: "Faturaya bağlanan ÖKC fişleri",
      cellLabel: "{{line}}. fiş {{field}}",
      deviceSerial: "ÖKC seri no",
      zNo: "Z no",
      receiptNo: "Fiş no",
      receiptDate: "Tarih",
      receiptTime: "Saat",
      amount: "Tutar",
      total: "Fiş toplamı",
      addRow: "Fiş satırı ekle",
      removeRow: "{{line}}. fiş satırını sil",
      matches: "Fiş toplamı fatura toplamıyla eşit.",
      difference: "Fark:",
      noRevenueTitle: "Bu fatura gelir ve KDV kaydı oluşturmaz",
      noRevenueBody:
        "Gelir ve KDV satış anında (ÖKC fişiyle) kaydedilmiştir; bu belge yalnızca fatura, fiş bağları ve e-belgedir.",
    },
    detail: {
      draftTitle: "Taslak fatura",
      identity: "Belge bilgileri",
      linesTitle: "Satırlar",
      documentActions: "Belge işlemleri",
      openItems: "Açık kalemler",
      statement: "Cari ekstresi",
      journalEntry: "Fiş {{no}}",
      originalInvoice: "Asıl fatura",
      returnsTitle: "İade faturaları",
      despatchesTitle: "Bağlı irsaliyeler",
      noDespatches: "Bu faturaya bağlı irsaliye yok.",
      linkDespatch: "İrsaliye bağla",
      addLink: "Bağla",
      unlinkDespatch: "Bağı kaldır",
      submissionsTitle: "Gönderim geçmişi",
      noSubmissions: "Henüz sağlayıcıya gönderim yapılmadı.",
      statusRefreshed: "Durum sağlayıcıdan yenilendi.",
      cancelTitle: "Faturayı iptal et",
      cancelDescription:
        "Fişin ters kaydı atılır, açık kalem geçersiz kılınır ve (varsa) e-Arşiv iptali sağlayıcıya bildirilir.",
      cancelled: "Fatura iptal edildi.",
      cancelledTitle: "Bu fatura iptal edildi",
      edocumentErrorTitle: "e-Belge hatası",
      ledgerQueuedBody: "Hesap eşleştirmesi tamamlanınca fiş kendiliğinden kesilir.",
    },
    edit: {
      title: "Taslak faturayı düzenle",
      description: "Yalnızca taslak faturalar düzenlenebilir; kesinleşen fatura değiştirilemez.",
      notDraftTitle: "Bu fatura düzenlenemez",
      notDraftBody: "Kesinleşmiş fatura değiştirilemez; düzeltme iptal ya da iade faturasıyla yapılır.",
    },
    submissions: {
      createdAt: "Zaman",
      operation: "İşlem",
      attempt: "Deneme",
      outcome: "Sonuç",
      error: "Hata / durum",
      duration: "Süre",
    },
    inbox: {
      description: "Sağlayıcıdan gelen faturalar: yanıt (kabul / red) ve deftere alma.",
      fetchNow: "Şimdi çek",
      fetched: "{{fetched}} belge çekildi, {{created}} yeni kayıt, {{matched}} cari eşleşmesi.",
      sender: "Gönderici",
      matchedCounterparty: "Eşleşen cari",
      noCounterparty: "Cari yok",
      noCounterpartyTitle: "Bu VKN ile cari bulunamadı",
      noCounterpartyBody:
        "{{name}} ({{taxId}}) için tedarikçi kartı açabilir ya da mevcut bir cariyle eşleştirebilirsiniz.",
      createSupplier: "Tedarikçi kartı aç",
      pickExisting: "Mevcut cariden seç",
      matchSelected: "Eşleştir",
      matched: "Cari eşleştirildi.",
      responseStatus: "Yanıt",
      responseDueDate: "Son yanıt günü",
      daysLeft: "{{count}} gün kaldı",
      bookingStatus: "Defter",
      bookedInvoice: "Alış faturası",
      openBookedInvoice: "Faturayı aç",
      accept: "Kabul et",
      accepted: "Fatura kabul edildi.",
      reject: "Reddet",
      rejectTitle: "Gelen faturayı reddet",
      rejectDescription: "Red gerekçesi karşı tarafa iletilir ve kayda geçer.",
      rejected: "Fatura reddedildi.",
      rejectedTitle: "Bu fatura reddedildi",
      searchPlaceholder: "Fatura no ya da gönderici",
      emptyTitle: "Gelen fatura yok",
      emptyDescription: '"Şimdi çek" ile sağlayıcıdan yeni belgeleri alabilirsiniz.',
    },
    booking: {
      title: "Deftere al",
      caption: "Deftere alma satırları",
      businessUnit: "İş birimi",
      learned: "öğrenildi ×{{count}}",
      fromProductCode: "ürün kodundan",
      learn: "Seçimleri bir sonraki fatura için hatırla",
      submit: "Deftere al",
      booked: "Fatura deftere alındı.",
      alreadyBooked: "Bu fatura deftere alındı.",
      ignored: "Yok sayıldı: {{reason}}",
      ignoredDone: "Fatura yok sayıldı.",
      incomplete: "Her satırda hedef ve KDV kodu seçilmelidir.",
      needsCounterparty: "Önce bir cari eşleştirin.",
      ignore: "Yok say",
      ignoreTitle: "Gelen faturayı yok say",
      ignoreDescription: "Belge deftere alınmaz; gerekçe kayda geçer.",
    },
    despatch: {
      listDescription: "Sevk ve alış irsaliyeleri, e-İrsaliye durumu ve faturaya bağlanma.",
      tabs: "İrsaliye yönü",
      caption: "{{flow}} listesi",
      new: "Yeni irsaliye",
      newDescription: "Sevk irsaliyesinin numarası kesinleştirmede verilir.",
      flow: "İrsaliye türü",
      despatchNo: "İrsaliye no",
      shipmentDate: "Sevk tarihi",
      shipmentTime: "Sevk saati",
      vehiclePlate: "Plaka",
      driverName: "Sürücü adı",
      driverTaxId: "Sürücü TCKN",
      kvkkHint: "Kişisel veridir; yalnızca gerekliyse girin (KVKK).",
      carrierName: "Taşıyıcı",
      carrierTaxId: "Taşıyıcı VKN/TCKN",
      deliveryAddress: "Teslim adresi",
      lineCount: "Satır",
      linesCaption: "İrsaliye satırları",
      receiptAdvice: "Teslim alma",
      receiptAdviceTitle: "Teslim alma yanıtı",
      receiptAdviceDescription: "Gelen irsaliyeye teslim alındı / kısmen / red yanıtı verin.",
      linkedInvoices: "Fatura",
      invoiceLink: "Faturayı aç",
      issued: "İrsaliye kesinleşti.",
      cancelTitle: "İrsaliyeyi iptal et",
      cancelDescription: "İptal gerekçesi kayda geçer.",
      searchPlaceholder: "İrsaliye no ya da cari",
      emptyTitle: "İrsaliye bulunamadı",
      emptyDescription: "Süzgeçleri değiştirin ya da yeni bir irsaliye oluşturun.",
    },
    requests: {
      description: "Kasadan bırakılan gün içi fatura talepleri.",
      receipt: "Fiş",
      buyer: "Alıcı",
      convert: "Faturaya dönüştür",
      reject: "Reddet",
      rejectTitle: "Talebi reddet",
      rejectDescription: "Red gerekçesi kayda geçer; talep faturaya dönüştürülemez.",
      rejected: "Talep reddedildi.",
      needsCounterpartyTitle: "Önce cari kartı gerekiyor",
      needsCounterpartyBody:
        "{{name}} ({{taxId}}) için cari kartı bulunamadı. Fatura kesmek için önce kartı açın.",
      createCounterparty: "Cari kartı aç",
      emptyTitle: "Bekleyen talep yok",
      emptyDescription: "Kasadan fatura talebi geldiğinde burada görünür.",
    },
    settings: {
      description: "Fatura ayarları, seriler ve e-belge sağlayıcısı.",
      tabsLabel: "Fatura ayarları bölümleri",
      tabs: { general: "Genel", series: "Seriler", provider: "Sağlayıcı" },
      readOnly: "Ayarları değiştirme yetkiniz yok; ekran salt okunurdur.",
      invalidDays: "Gün sayısı izin verilen aralıkta olmalıdır.",
      defaultPricingMode: "Varsayılan giriş modu",
      defaultEinvoiceScenario: "Varsayılan e-Fatura senaryosu",
      defaultEinvoiceScenarioHint: "Alıcı e-Fatura mükellefiyse bu senaryo kullanılır.",
      fields: {
        defaultDueDays: "Varsayılan vade (gün)",
        responseDeadlineDays: "Kabul / red süresi (gün)",
        responseAlertDays: "Alarm günü",
        taxpayerCacheDays: "Mükellef önbelleği (gün)",
      },
      hints: {
        defaultDueDays: "Vade boş bırakılan faturalarda belge tarihine eklenir.",
        responseDeadlineDays: "Mevzuat parametresi; mali müşavirinizle doğrulayın.",
        responseAlertDays: "Son güne kaç gün kala alarm üretilir.",
        taxpayerCacheDays: "Mükellef sorgusu sonucu bu süre boyunca yeniden sorulmaz.",
      },
      autoSend: "Kesinleşen e-belge sağlayıcı kuyruğuna otomatik alınsın",
      incomingFetchEnabled: "Gelen faturalar düzenli olarak çekilsin",
      seriesCaption: "Fatura serileri",
      newSeries: "Yeni seri",
      prefix: "Önek",
      family: "Belge ailesi",
      seriesDescription: "Açıklama",
      lastNumbers: "Son numaralar",
      isDefault: "Varsayılan",
      makeDefault: "Varsayılan yap",
      makeDefaultOnCreate: "Bu aile için varsayılan olsun",
      seriesCreated: "Seri eklendi.",
      providerCode: "Sağlayıcı",
      providerActive: "Sağlayıcı etkin",
      noProvider: "Sağlayıcı tanımlı değil: giden belgeler kâğıt kesilir.",
      einvoiceAlias: "Gönderici etiketi (e-Fatura)",
      edespatchAlias: "Gönderici etiketi (e-İrsaliye)",
      credentials: "Kimlik bilgileri",
      credentialsStored: "Kayıtlı ●●●● — boş bırakırsanız korunur.",
      credentialsEmpty: "Kayıtlı kimlik bilgisi yok.",
      clearCredentials: "Kimlik bilgilerini sil",
      credentialsWillBeCleared: "Kaydedince silinecek (vazgeçmek için tıklayın)",
      username: "Kullanıcı adı",
      password: "Parola",
      apiKey: "API anahtarı",
      mockOptions: "Deneme sağlayıcısı davranışı",
      mock: {
        stepSeconds: "Adım gecikmesi (sn)",
        failureRate: "Geçici hata oranı (%)",
        failFirstAttempts: "İlk N deneme hatalı",
        incomingPerDay: "Günlük gelen fatura",
        rejectTaxIds: "Reddeden alıcılar",
        permanentFailTaxIds: "Kalıcı hata veren alıcılar",
        einvoiceTaxIds: "Mükellef VKN listesi",
        listHint: "Virgül ya da boşlukla ayırın.",
        generateIncoming: "Gelen fatura üret (demo)",
      },
      taxpayerLookup: "Mükellef sorgusu",
      taxId: "VKN / TCKN",
      lookup: "Sorgula",
      title: "Ünvan",
      isEinvoiceUser: "e-Fatura mükellefi",
      isEdespatchUser: "e-İrsaliye mükellefi",
      checkedAt: "Sorgu zamanı",
      fromCache: "(önbellekten)",
      fresh: "(sağlayıcıdan)",
    },
  },

  approvals: {
    badge: { pendingSuffix: "talep kararınızı bekliyor" },
    list: {
      title: "Onaylar",
      description: "Kararınızı bekleyen talepler, kendi talepleriniz ve kiracıdaki tüm onay akışları.",
      tabs: "Onay kapsamı",
      caption: "{{scope}} listesi",
      emptyTitle: "Bekleyen talep yok",
      emptyDescription: "Bu kapsamda gösterilecek onay talebi bulunmuyor.",
    },
    fields: {
      docType: "Belge türü",
      title: "Başlık",
      amount: "Tutar",
      company: "Şirket",
      station: "İstasyon",
      requestedBy: "Talep eden",
      requestedAt: "Talep zamanı",
      currentStep: "Etkin adım",
      dueAt: "Kalan süre",
      policy: "Politika",
      note: "Not",
      decision: "Karar",
      decidedBy: "Karar veren",
      decidedAt: "Karar zamanı",
      onBehalfOf: "Kimin adına",
      onBehalfOfHint:
        "Vekâletle birden çok kişinin yetkisini kullanabiliyorsanız hangisiyle karar verdiğinizi seçin.",
      onBehalfOfSelf: "Kendi yetkimle",
      policyName: "Politika adı",
      priority: "Öncelik",
      priorityHint: "Birden çok politika eşleşirse önceliği büyük olan uygulanır.",
      allCompanies: "Tüm şirketler",
      description: "Açıklama",
      stations: "İstasyonlar",
      stationsHint: "Hiçbiri seçilmezse politika şirketin tüm istasyonlarında geçerlidir.",
      minAmount: "Alt sınır",
      maxAmount: "Üst sınır",
      amountHint: "Alt sınır dâhil, üst sınır hariç.",
      requiresStepUp: "Karar için yeniden kimlik doğrulama iste",
      stepName: "Adım adı",
      stepMode: "Karar biçimi",
      onTimeout: "Süre dolunca",
      timeoutHours: "Süre (saat)",
      approvers: "Onaycılar",
      escalationApprovers: "Yükseltme hedefleri",
      escalationApproversHint:
        "Bu kişiler YALNIZCA adımın süresi dolup karar yükseltildikten sonra karar verebilir.",
      approverKind: "Tür",
      approverTarget: "Onaycı",
    },
    due: {
      days: "{{count}} gün",
      hours: "{{count}} saat",
      overdue: "{{duration}} gecikti",
    },
    detail: {
      title: "Onay talebi",
      summary: "Belge özeti",
      steps: "Adımlar",
      stepNo: "{{no}}. adım",
      decisions: "Karar geçmişi",
      escalated: "{{at}} tarihinde yükseltildi",
      escalationApprover: "yükseltme hedefi",
      resolvedApprovers: "Karar verebilecekler",
      timeout: "{{hours}} saat içinde karar verilmezse: {{action}}",
      openDocument: "Belgeyi aç",
      ownRequest: "Onay bekliyor — kendi talebinizi onaylayamazsınız.",
      liveHint: "Talep durumu karar verildiğinde kendiliğinden güncellenir.",
    },
    actions: { approve: "Onayla", reject: "Reddet", cancel: "Geri çek" },
    dialog: {
      APPROVE: {
        title: "Talep onaylansın mı?",
        description: "Onayladığınızda belge kendi akışında ilerler (fiş, ödeme ya da fiyat planı).",
        confirm: "Onayla",
      },
      REJECT: {
        title: "Talep reddedilsin mi?",
        description: "Red gerekçesi zorunludur ve talep sahibine gösterilir.",
        confirm: "Reddet",
      },
      CANCEL: {
        title: "Talep geri çekilsin mi?",
        description: "Geri çekilen talep kapanır; belgeyi düzeltip yeniden onaya gönderebilirsiniz.",
        confirm: "Geri çek",
      },
    },
    done: { APPROVE: "Talep onaylandı", REJECT: "Talep reddedildi", CANCEL: "Talep geri çekildi" },
    summaryKeys: {
      categoryCode: "Kategori",
      paymentMethod: "Ödeme biçimi",
      docKind: "Belge türü",
      docDate: "Belge tarihi",
      netAmount: "Matrah",
      requestNo: "Talep no",
      effectiveAt: "Yürürlük",
      stationCount: "İstasyon sayısı",
      itemCount: "Kalem sayısı",
      paymentDate: "Ödeme tarihi",
      lineCount: "Satır sayısı",
      sourceTypes: "Kaynak türleri",
      requestedDeliveryDate: "İstenen teslim tarihi",
      totalLitres: "Toplam miktar",
      distributorName: "Dağıtıcı",
      dbsExceedsLimit: "DBS limiti aşılıyor mu?",
      nozzleLabel: "Tabanca",
      previousElectronicL: "Önceki endeks",
      newElectronicL: "Yeni endeks",
      adjustmentKind: "Düzeltme türü",
      // Vardiya farkı (SHIFT_DIFFERENCE) — `shift-closings.service.ts` onay talebine bunları koyar.
      staffName: "Personel",
      staffCode: "Personel kodu",
      shiftNo: "Vardiya no",
      businessDate: "İş günü",
      expectedAmount: "Beklenen",
      declaredTotal: "Beyan",
      difference: "Fark",
      direction: "Farkın yönü",
      toleranceLimit: "Tolerans sınırı",
      explanation: "Personelin açıklaması",
      // Market (Prompt 16): fire, sayım, tedarikçi siparişi ve fatura eşleştirme farkı talepleri.
      reason: "Neden",
      warehouseCode: "Depo",
      totalQuantity: "Toplam miktar",
      estimatedValue: "Tahmini tutar",
      kind: "Sayım türü",
      countedLines: "Sayılan satır",
      shortageValue: "Noksan",
      surplusValue: "Fazla",
      netValue: "Net fark",
      supplierName: "Tedarikçi",
      stationName: "İstasyon",
      expectedDate: "Beklenen teslim",
      invoiceNo: "Fatura no",
      receiptCount: "Mal kabul sayısı",
      amountDifference: "Tutar farkı",
      differenceLineCount: "Farklı satır",
    },
    policies: {
      title: "Onay politikaları",
      description: "Hangi belgenin hangi adımlardan geçeceğini belirleyen kurallar.",
      new: "Politika ekle",
      edit: "Politikayı düzenle",
      saved: "Politika kaydedildi",
      deleted: "Politika silindi",
      deleteTitle: "Politika silinsin mi?",
      deleteDescription:
        "Silinirse {{docType}} belgeleri otomatik onaylanır. Süren talepler kendi fotoğraflarıyla tamamlanır.",
      readOnly: "Politikaları görüntülüyorsunuz; düzenlemek için yetki gerekir.",
      noPermission: "Onay politikalarını görüntüleme yetkiniz yok.",
      systemDefault: "Sistem varsayılanı",
      conditions: "Koşullar",
      stepCount: "Adım",
      allStations: "Tüm istasyonlar",
      stationCount: "{{count}} istasyon",
      emptyTitle: "Tanımlı politika yok",
      autoApproveHint: "Politika yoksa talepler otomatik onaylanır.",
      steps: "Adımlar",
      addStep: "Adım ekle",
      moveUp: "Adımı yukarı taşı",
      moveDown: "Adımı aşağı taşı",
      removeStep: "Adımı sil",
      addApprover: "Onaycı ekle",
      removeApprover: "Onaycıyı sil",
    },
    delegations: {
      title: "Vekâletler",
      description: "Onay yetkisinin belirli bir süre için başka bir kullanıcıya devri.",
      new: "Vekâlet tanımla",
      newDescription: "Vekil, seçtiğiniz tarih aralığında ve belge türlerinde sizin adınıza karar verebilir.",
      created: "Vekâlet tanımlandı",
      revoke: "Kaldır",
      revoked: "Vekâlet kaldırıldı",
      revokedLabel: "Kaldırıldı",
      revokeTitle: "Vekâlet kaldırılsın mı?",
      revokeDescription:
        "Kaldırılan vekâlet silinmez, pasifleştirilir; verilmiş kararlar geçerliliğini korur.",
      active: "Etkin",
      delegator: "Yetkisini devreden",
      delegatorHint: "Boş bırakılırsa kendi yetkinizi devredersiniz.",
      delegatorSelf: "Kendim",
      delegate: "Vekil",
      period: "Geçerlilik",
      openEnded: "açık uçlu",
      allDocTypes: "Tüm belge türleri",
      docTypesHint: "Hiçbiri seçilmezse vekâlet tüm belge türlerinde geçerlidir.",
      validFrom: "Başlangıç",
      validTo: "Bitiş",
      validToHint: "Boş bırakılırsa açık uçludur.",
      reason: "Gerekçe",
      scope: "Kapsam",
      scopeMine: "Kendi vekâletlerim",
      scopeAll: "Tümü",
      emptyTitle: "Tanımlı vekâlet yok",
      emptyDescription: "İzne ayrılırken onay yetkinizi bir vekile devredebilirsiniz.",
    },
  },

  expenses: {
    list: {
      description: "Gider belgeleri: girişten onaya, onaydan fişe.",
      new: "Gider gir",
      statusTabs: "Gider durumu",
      draftNo: "(taslak)",
      allocated: "dağıtım anahtarı",
      from: "Başlangıç",
      to: "Bitiş",
      searchPlaceholder: "Açıklama, belge no ya da gider no",
      emptyTitle: "Gider kaydı yok",
      emptyDescription: "Seçili süzgeçlerle eşleşen gider belgesi bulunmuyor.",
    },
    form: {
      description: "Belge bilgileri, boyut, tutarlar ve ödeme biçimi.",
      editTitle: "Gideri düzenle",
      document: "Belge",
      dimension: "Boyut",
      utility: "Sayaç ve tüketim",
      amounts: "Tutarlar",
      payment: "Ödeme ve açıklama",
      liveTotals: "Anlık hesap",
      preview: "Önizle",
      previewTitle: "Önizleme",
      allocations: "Paylar",
      journalLines: "Fiş satırları",
      postingKey: "Kayıt anahtarı",
      account: "Hesap",
      mappingPending: "eşleştirme bekliyor",
      saveDraft: "Taslak kaydet",
      submit: "Onaya gönder",
      savedDraft: "Taslak kaydedildi",
      submitted: "Onaya gönderildi",
      autoApproved: "Onaylandı, fiş kesildi",
      uploading: "Dosya yükleniyor…",
      fileAttached: "Belge görseli eklendi",
      fileUploaded: "Belge görseli yüklendi",
      noPermission: "Gider girme yetkiniz yok.",
      onlyDraftEditable: "Yalnızca taslak gider düzenlenebilir. Onaylanmış gider iptal edilerek düzeltilir.",
    },
    fields: {
      expenseNo: "Gider no",
      docKind: "Belge türü",
      docNo: "Belge no",
      docDate: "Belge tarihi",
      dueDate: "Vade",
      dueDateHint: "Boş bırakılırsa belge tarihi kullanılır.",
      category: "Kategori",
      categoryCode: "Kod",
      categoryName: "Ad",
      parentCategory: "Üst kategori",
      defaultVatRateCode: "Varsayılan KDV",
      counterparty: "Cari",
      counterpartyHint: "Cariye borç yazılan giderde zorunludur.",
      dimension: "Boyut",
      dimensionStation: "Tek istasyon / iş birimi",
      dimensionAllocation: "Dağıtım anahtarı",
      station: "İstasyon",
      wholeCompany: "Şirket geneli",
      businessUnit: "İş birimi",
      allBusinessUnits: "Tüm iş birimleri",
      allocationKey: "Dağıtım anahtarı",
      allocationKeyName: "Anahtar adı",
      method: "Yöntem",
      revenueMonths: "Ciro ayı sayısı",
      weight: "Ağırlık",
      fixedAmount: "Sabit tutar",
      takesRemainder: "Kalanı alır",
      netAmount: "Matrah",
      vatRateCode: "KDV oranı",
      vatAmount: "KDV",
      withholdingRateCode: "Stopaj",
      withholdingHint: "Bu belge türünde genellikle stopaj uygulanır.",
      noWithholding: "Stopaj yok",
      withholdingAmount: "Stopaj",
      grossAmount: "Brüt",
      payableAmount: "Ödenecek",
      amount: "Tutar",
      paymentMethod: "Ödeme biçimi",
      cashRegister: "Kasa",
      bankAccount: "Banka hesabı",
      companyCard: "Şirket kartı",
      description: "Açıklama",
      documentFile: "Belge görseli",
      documentFileHint: "Fatura ya da fişin fotoğrafını / PDF'ini ekleyebilirsiniz.",
      meter: "Sayaç",
      meterName: "Sayaç adı",
      meterNo: "Sayaç no",
      meterType: "Sayaç türü",
      parentMeter: "Ana sayaç",
      consumption: "Tüketim",
      periodFrom: "Dönem başı",
      periodTo: "Dönem sonu",
      readingDate: "Okuma tarihi",
      readingValue: "Okuma değeri",
      cardName: "Kart adı",
      bank: "Banka",
      lastFour: "Son 4 hane",
      statementDay: "Ekstre günü",
      dueDay: "Vade günü",
      paymentBankAccount: "Ödeme hesabı",
      recurringName: "Tanım adı",
      amountMode: "Tutar modu",
      frequency: "Sıklık",
      dayOfMonth: "Ayın günü",
      startDate: "Başlangıç",
      endDate: "Bitiş",
      leadDays: "Ön hazırlık günü",
      nextDueDate: "Sonraki vade",
      submittedAt: "Onaya gönderilme",
      approvedAt: "Onay zamanı",
    },
    detail: {
      title: "Gider belgesi",
      summary: "Belge özeti",
      allocations: "Paylar",
      allocationsFrozen: "Paylar onay anında dondurulur; anahtar sonradan değişse de kesilmiş fiş değişmez.",
      journalEntries: "Muhasebe fişleri",
      draftEntry: "(taslak fiş)",
      documentFile: "Belge görseli",
      openDocumentFile: "Belge görselini aç",
      approval: "Onay talebi",
      rejectedTitle: "Talep reddedildi",
      cancelledTitle: "Gider iptal edildi",
      cancel: "Gideri iptal et",
      cancelTitle: "Gider iptal edilsin mi?",
      cancelDescription: "İptal, ters fiş keser ve varsa açık kalemi geçersiz kılar. İşlem geri alınamaz.",
      cancelReason: "İptal gerekçesi",
      done: { submit: "Gider onaya gönderildi", cancel: "Gider iptal edildi" },
    },
    definitions: {
      description: "Kategoriler, dağıtım anahtarları, sayaçlar, şirket kartları ve tekrarlayan giderler.",
      tabs: "Tanım sekmeleri",
      readOnly: "Tanımları görüntülüyorsunuz; değiştirmek için yetki gerekir.",
      categories: "Kategoriler",
      addCategory: "Kategori ekle",
      editCategory: "Kategoriyi düzenle",
      rootCategory: "Kök kategori",
      codeImmutable: "Kod sonradan değiştirilemez.",
      isUtility: "Sayaçlı gider (belgede sayaç ve tüketim istenir)",
      utility: "Sayaçlı",
      noCategories: "Tanımlı kategori yok",
      noCategoriesHint: "Gider girebilmek için en az bir kategori tanımlayın.",
      allocationKeys: "Dağıtım anahtarları",
      addAllocationKey: "Anahtar ekle",
      editAllocationKey: "Anahtarı düzenle",
      targets: "Hedefler",
      addTarget: "Hedef ekle",
      removeTarget: "Hedefi sil",
      noAllocationKeys: "Tanımlı dağıtım anahtarı yok",
      noAllocationKeysHint: "Ortak giderleri istasyonlara paylaştırmak için bir anahtar tanımlayın.",
      sharePreview: "Pay önizlemesi",
      sharePreviewHint: "Bir tutar girin; anahtarın hedeflerine düşen paylar hesaplansın.",
      areaMissingTitle: "Alan bilgisi eksik",
      areaMissingBody: "Alana göre dağıtımda alanı girilmemiş iş birimi pay almaz.",
      editBusinessUnits: "İstasyon iş birimlerini düzenle",
      meters: "Sayaçlar",
      addMeter: "Sayaç ekle",
      mainMeter: "Ana sayaç (üstü yok)",
      parentMeterHint: "Alt sayaç tanımlıyorsanız bağlı olduğu ana sayacı seçin.",
      noMeters: "Tanımlı sayaç yok",
      noMetersHint: "Elektrik, su ve doğalgaz tüketimini izlemek için sayaç tanımlayın.",
      readings: "Okumalar",
      selectMeter: "Okumaları görmek için soldaki listeden bir sayaç seçin.",
      addReading: "Okuma ekle",
      readingAdded: "Okuma eklendi",
      unitCostReport: "Birim maliyet raporu",
      unitCost: "Birim maliyet",
      period: "Dönem",
      companyCards: "Şirket kartları",
      addCard: "Kart ekle",
      editCard: "Kartı düzenle",
      editMeter: "Sayacı düzenle",
      editMeterLabel: "{{name}} sayacını düzenle",
      editRecurring: "Tekrarlayan gideri düzenle",
      lastFourHint: "Yalnızca son 4 hane saklanır; kart numarasının tamamı hiçbir zaman alınmaz.",
      noCards: "Tanımlı şirket kartı yok",
      noCardsHint: "Kartla ödenen giderleri izlemek için kart tanımlayın.",
      recurring: "Tekrarlayan giderler",
      addRecurring: "Tekrarlayan gider ekle",
      leadDaysHint: "Vadeden kaç gün önce taslak gider açılsın?",
      noRecurring: "Tanımlı tekrarlayan gider yok",
      noRecurringHint: "Kira, abonelik gibi düzenli giderleri otomatik açtırabilirsiniz.",
    },
  },

  payments: {
    description: "Vadesi gelen ödemeler, ödeme partileri ve banka toplu ödeme dosyası.",
    tabs: "Ödeme sekmeleri",
    fields: {
      sourceType: "Kaynak",
      sourceTypes: "Kaynak türleri",
      description: "Açıklama",
      counterparty: "Cari",
      dueDate: "Vade",
      dueTo: "Vadesi bu tarihe kadar",
      overdueDays: "Gecikme",
      overdue: "{{days}} gün",
      remainingAmount: "Kalan tutar",
      amount: "Tutar",
      batchNo: "Parti no",
      paymentDate: "Ödeme tarihi",
      bankAccount: "Banka hesabı",
      lineCount: "Satır",
      totalAmount: "Toplam",
      executedAt: "Yürütülme",
    },
    candidates: {
      title: "Ödeme listesi",
      select: "Seç",
      selectRow: "{{description}} kaydını seç",
      selectAll: "Tümünü seç",
      clearSelection: "Seçimi temizle",
      selectedCount: "{{count}} satır seçildi",
      inBatch: "{{batchNo}} partisinde",
      amountUnknown: "Tutar henüz bilinmiyor",
      createBatch: "Seçilenlerle parti oluştur",
      createBatchDescription: "{{count}} satır yeni bir ödeme partisine alınacak.",
      addToBatch: "Mevcut partiye ekle",
      addToBatchDescription: "{{count}} satır seçtiğiniz taslak partiye eklenecek.",
      addedToBatch: "Satırlar partiye eklendi",
      draftBatch: "Taslak parti",
      noDraftBatch: "Eklenebilecek taslak parti yok. Önce yeni bir parti oluşturun.",
      emptyTitle: "Vadesi gelen ödeme yok",
      emptyDescription: "Seçili süzgeçlerle eşleşen ödeme kaynağı bulunmuyor.",
    },
    batches: {
      title: "Ödeme partileri",
      detailTitle: "Ödeme partisi",
      created: "{{batchNo}} partisi oluşturuldu",
      summary: "Parti özeti",
      lines: "Satırlar",
      approval: "Onay talebi",
      submit: "Onaya gönder",
      execute: "Yürüt",
      executeTitle: "Parti yürütülsün mü?",
      executeDescription: "Her satır kendi işleminde ödenir; biri başarısız olursa diğerleri geri alınmaz.",
      cancel: "Partiyi iptal et",
      cancelTitle: "Parti iptal edilsin mi?",
      cancelDescription: "İptal edilen partinin satırları serbest kalır ve yeniden planlanabilir.",
      cancelReason: "İptal gerekçesi",
      cancelledTitle: "Parti iptal edildi",
      failedTitle: "{{count}} satır ödenemedi",
      editAmount: "Tutarı değiştir",
      editAmountDescription:
        "Tutar kaynağın kalanını aşamaz; kısmi ödeme yalnızca cari açık kaleminde yapılabilir.",
      amountUpdated: "Satır tutarı güncellendi",
      removeLine: "Satırı çıkar",
      lineRemoved: "Satır çıkarıldı",
      emptyTitle: "Ödeme partisi yok",
      emptyDescription: "Ödeme listesinden satır seçerek ilk partinizi oluşturun.",
      done: { submit: "Parti onaya gönderildi", execute: "Parti yürütüldü", cancel: "Parti iptal edildi" },
    },
    bankFile: {
      title: "Banka dosyası",
      description: "Dosyaya girecek ve IBAN'ı olmadığı için atlanacak satırlar.",
      includedCount: "Dosyaya girecek satır",
      includedAmount: "Dosya toplamı",
      fileName: "Dosya adı",
      skippedTitle: "Atlanan satırlar",
      unknownCounterparty: "Cari yok",
      ibanMasked: "IBAN ekranda gösterilmez; yalnızca indirilen dosyaya yazılır.",
      download: "CSV indir",
    },
  },

  taxCalendar: {
    description: "Beyan ve ödeme yükümlülükleri, hatırlatmalar ve KDV özeti.",
    viewTabs: "Görünüm",
    calendarView: "Takvim",
    listView: "Liste",
    calendarCaption: "{{month}} {{year}} yükümlülük takvimi",
    listCaption: "Yükümlülükler",
    previousMonth: "Önceki ay",
    nextMonth: "Sonraki ay",
    generate: "Yükümlülükleri üret",
    generated: "Ufuk içinde {{count}} yükümlülük var",
    generatedDetail: "{{created}} yeni yükümlülük üretildi · {{rules}} kural kontrol edildi",
    addManual: "Elle yükümlülük ekle",
    addManualDescription: "Kurallardan üretilmeyen bir vergi ya da SGK ödemesi ekleyin.",
    setAmount: "Tutarı kaydet",
    complete: "Tamamlandı işaretle",
    cancelObligation: "İptal et",
    obligationDescription: "{{period}} dönemi",
    emptyTitle: "Yükümlülük yok",
    emptyDescription: '"Yükümlülükleri üret" ile kurallardan dönemlik yükümlülükleri oluşturabilirsiniz.',
    daysLeft: "{{count}} gün kaldı",
    daysOverdue: "{{count}} gün gecikti",
    done: {
      amount: "Tutar kaydedildi",
      complete: "Yükümlülük tamamlandı",
      cancel: "Yükümlülük iptal edildi",
    },
    fields: {
      code: "Kod",
      codeHint: "Büyük harf, rakam ve _ (ör. MANUAL_SGK).",
      title: "Başlık",
      period: "Dönem",
      periodHint: "2026-08, 2026-Q3 ya da 2026.",
      dueDate: "Vade",
      daysLeft: "Kalan",
      amount: "Tutar",
      amountUnknown: "Bilinmiyor",
      estimate: "tahmini",
      exact: "kesin",
      markExact: "Tutar kesinleşti",
      payFromBank: "Bankadan öde",
      payFromBankHint: "Seçilirse tamamlandı işaretlerken aynı anda banka çıkışı kaydedilir.",
      noBankPayment: "Ödeme kaydetme",
      cancelReason: "İptal gerekçesi",
      note: "Not",
      ruleName: "Kural adı",
      frequency: "Sıklık",
      dueDay: "Vade günü",
      dueDayHint: "Dönemi izleyen ayın günü; o gün yoksa ayın son günü kullanılır.",
      dueMonthOffset: "Ay farkı",
      dueMonthOffsetHint: "Dönem sonundan kaç ay sonra beyan edilir?",
      reminderDays: "Hatırlatma günleri",
      reminderDaysHint: "Virgülle ayırın (ör. 7, 3, 1).",
      openObligations: "Açık yükümlülük",
    },
    rules: {
      title: "Takvim kuralları",
      description: "Platform şablonlarından gelen, şirkete göre düzenlenebilen beyan kuralları.",
      edit: "Kuralı düzenle",
      editDescription: "Kod ve sıklık değiştirilemez; üretilmiş yükümlülüklerin dönemleri bunlara bağlıdır.",
      needsVerification: "Doğrulanmalı",
      markVerified: "Doğrulandı olarak işaretle",
      verifyTitle: "Mevzuat teyidi",
      verifyBody:
        'Beyan gün ve süreleri değişebilir. "Doğrulanmalı" işaretli kuralları mali müşavirinizle doğrulayın.',
      emptyTitle: "Tanımlı kural yok",
      emptyDescription: "Yükümlülük üretildiğinde kurallar platform şablonlarından oluşturulur.",
    },
    vatSummary: {
      title: "KDV özeti",
      description: "Defter kayıtlarından ve belgelerden üretilen ön bilgi.",
      disclaimerTitle: "Bu rapor beyanname değildir",
      from: "Başlangıç",
      to: "Bitiş",
      thisMonth: "Bu ay",
      totals: "Özet",
      totalOutput: "Hesaplanan KDV",
      totalInput: "İndirilecek KDV",
      payable: "Ödenecek KDV",
      carriedForward: "Devreden KDV",
      period: "{{from}} – {{to}}",
      outputAccounts: "Hesaplanan KDV hesapları",
      inputAccounts: "İndirilecek KDV hesapları",
      taxesPayableAccounts: "Ödenecek vergi ve fonlar",
      net: "Net",
      documents: "Belge dökümü",
      source: "Kaynak",
      vatRateCode: "KDV oranı",
      documentCount: "Belge",
      netAmount: "Matrah",
      vatAmount: "KDV",
      withheldAmount: "Tevkifat",
    },
  },

  cashFlow: {
    description: "Açılış nakdi, vadesi gelen kalemler ve senaryolara göre gün gün nakit projeksiyonu.",
    noPermission: "Nakit akışı görüntüleme yetkiniz yok.",
    summary: "Özet",
    dailyTable: "Günlük projeksiyon",
    dailyTableHint:
      "Tarihe tıklayınca o günün kalemleri açılır. Açık öngörülen günler kırmızı vurgulanır ve satır sonunda metinle de belirtilir.",
    weeklyTable: "Haftalık projeksiyon",
    dayTitle: "{{date}} kalemleri",
    noItems: "Bu gün için kalem yok.",
    overdue: "Gecikmiş",
    inPaymentBatch: "Ödeme partisinde",
    originalDueDate: "Gerçek vade: {{date}}",
    shortfall: "Açık",
    noShortfall: "Yeterli",
    noShortfallForecast: "Açık öngörülmüyor",
    shortfallDayCount: "{{count}} açık günü",
    unknownAmountTitle: "Tutarı girilmemiş yükümlülük var",
    unknownAmountBody:
      "{{count}} vergi / SGK yükümlülüğünün tutarı girilmediği için projeksiyona girmedi. Tutarları girmek için:",
    beyondHorizon: "Ufkun dışında kaldığı için {{count}} kalem projeksiyona girmedi.",
    filters: {
      scenario: "Senaryo",
      horizon: "Ufuk",
      horizonDays: "{{count}} gün",
      station: "Kapsam",
      wholeCompany: "Şirket geneli",
      view: "Görünüm",
      daily: "Günlük",
      weekly: "Haftalık",
    },
    fields: {
      openingBalance: "Açılış nakdi",
      overdraftLimit: "KMH limiti",
      closingBalance: "Ufuk sonu bakiye",
      lowestAvailable: "En düşük kullanılabilir",
      lowestDate: "En düşük günü",
      shortfallDays: "Açık günleri",
      date: "Tarih",
      week: "Hafta",
      inflow: "Giriş",
      outflow: "Çıkış",
      net: "Net",
      closing: "Gün sonu bakiye",
      available: "Kullanılabilir",
      minAvailable: "Hafta içi en düşük",
    },
    compare: {
      title: "Senaryo karşılaştırması",
      hint: "Senaryolar yalnızca tahsilatları etkiler; ödemeler vadesinde varsayılır.",
    },
    settings: {
      title: "Nakit akış ayarları",
      description: "Varsayılan ufuk, alarm ve senaryo parametreleri.",
      readOnly: "Ayarları görüntülüyorsunuz; değiştirmek için yetki gerekir.",
      saved: "Nakit akış ayarları kaydedildi",
      horizonDays: "Varsayılan ufuk (gün)",
      alertScenario: "Alarm senaryosu",
      alertHorizonDays: "Alarm ufku (gün)",
      scenarioHint: "Senaryolar yalnızca tahsilatları etkiler; ödemeler vadesinde varsayılır.",
      receivableDelayDays: "Tahsilat gecikmesi (gün)",
      chequeBouncePercent: "Karşılıksız çek oranı (%)",
      posDelayDays: "POS gecikmesi (gün)",
      percentError: "Yüzde 0 ile 100 arasında, en çok iki ondalıklı olmalıdır",
    },
  },

  budget: {
    description: "Yıllık bütçe hücreleri, sürümler ve gerçekleşen karşılaştırması.",
    new: "Yeni bütçe",
    newDescription: "Yıl ve sapma eşiğini seçin; satırları sonraki adımda girersiniz.",
    defaultName: "{{year}} bütçesi",
    created: "Bütçe oluşturuldu",
    detailTitle: "Bütçe",
    detailSummary: "Bütçe özeti",
    detailTabs: "Bütçe sekmeleri",
    saveHeader: "Başlığı kaydet",
    activate: "Etkinleştir",
    activated: "Bütçe yürürlüğe alındı",
    activateTitle: "Bütçe yürürlüğe alınsın mı?",
    activateDescription:
      "{{year}} yılının yürürlükteki bütçesi arşivlenecek ve bu bütçe etkin olacak. Etkin bütçenin satırları değiştirilemez.",
    newVersion: "Yeni sürüm oluştur",
    newVersionTitle: "Yeni sürüm oluşturulsun mu?",
    newVersionDescription:
      "Satırlar kopyalanarak yeni bir TASLAK sürüm açılır; mevcut bütçe olduğu gibi kalır.",
    versionCreated: "Yeni sürüm oluşturuldu",
    emptyTitle: "Tanımlı bütçe yok",
    emptyDescription: "Yıllık hedeflerinizi izlemek için bir bütçe oluşturun.",
    fields: {
      name: "Bütçe adı",
      fiscalYear: "Yıl",
      versionNo: "Sürüm",
      lineCount: "Hücre",
      totalAmount: "Toplam",
      variancePercent: "Sapma eşiği (%)",
      variancePercentHint: "Olumsuz sapma bu yüzdeyi aşınca alarm üretilir.",
      notes: "Not",
      accountPrefix: "Hesap grubu",
      accountPrefixRow: "{{row}}. satırın hesap grubu",
      station: "İstasyon",
      stationRow: "{{row}}. satırın istasyonu",
      wholeCompany: "Şirket geneli",
      businessUnit: "İş birimi",
      businessUnitRow: "{{row}}. satırın iş birimi",
      allBusinessUnits: "Tümü",
      cellLabel: "{{account}} · {{month}}",
      newRow: "yeni satır",
    },
    lines: {
      title: "Satırlar",
      caption: "Bütçe hücreleri",
      save: "Satırları kaydet",
      saved: "Bütçe satırları kaydedildi",
      addRow: "Satır ekle",
      removeRow: "Satırı sil",
      copyAcross: "Ocak tutarını 12 aya kopyala",
      empty: "Henüz satır yok",
      readOnly:
        "Yürürlükteki ve arşivlenmiş bütçenin satırları değiştirilemez; revizyon için yeni sürüm açın.",
      duplicateTitle: "Aynı hücre birden çok satırda",
      warningTitle: "Hesap planında karşılığı olmayan grup",
      warningBody:
        "{{prefixes}} önekleri hesap planında bulunamadı; bütçe kaydedilir ama gerçekleşen eşleşmeyebilir.",
      unknownPrefix: "Hesap planında bulunamadı",
    },
    import: {
      title: "İçe aktar",
      columns: "Sütunlar: {{columns}} ve Ocak…Aralık.",
      downloadTemplate: "Şablon indir",
      file: "Dosya",
      uploading: "Yükleniyor…",
      rowCount: "Satır",
      cellCount: "Hücre",
      revenue: "Gelir toplamı",
      expense: "Gider toplamı",
      errors: "Hatalar",
      warnings: "Uyarılar",
      rowNumber: "Satır",
      column: "Sütun",
      message: "İleti",
      replaceWarning: "İçe aktarma mevcut satırların TAMAMINI değiştirir.",
      apply: "İçe aktar",
      applied: "{{count}} hücre içe aktarıldı",
    },
    report: {
      title: "Gerçekleşen–bütçe",
      description: "Yıl başından seçilen aya kadar bütçe, gerçekleşen ve sapma.",
      budget: "Bütçe",
      throughMonth: "Şu aya kadar",
      groupBy: "Gruplama",
      groupByAccount: "Hesaba göre",
      groupByStation: "İstasyona göre",
      totals: "Toplamlar",
      threshold: "Sapma eşiği: %{{percent}}",
      rows: "Bütçelenen hücreler",
      unbudgetedRows: "Bütçesiz harcamalar",
      cell: "Hücre",
      budgetAmount: "Bütçe",
      actual: "Gerçekleşen",
      difference: "Fark",
      percent: "%",
      month: "Ay",
      monthlyCaption: "{{cell}} için ay ay döküm",
      export: "Excel'e aktar",
      onTrack: "Hedefte",
      watch: "İzlemede",
      exceeded: "Sapma",
      unbudgeted: "Bütçesiz",
      noBudgetTitle: "Rapor için bütçe seçin",
      noBudgetDescription: "Önce bir bütçe oluşturup satırlarını girin.",
    },
  },

  agents: {
    description:
      "İstasyondaki ajan bilgisayarlar: durum, son görülme, kuyruk, adaptör sağlığı, komutlar ve kayıt kodları.",
    noPermission: "Ajanları görüntüleme yetkiniz yok.",
    disabledTitle: "İstasyon ajanı modülü kapalı",
    disabledDescription:
      "Bu hesapta istasyon ajanı ve cihaz entegrasyonu açık değil. Açtırmak için destek ekibine ulaşın.",
    noStationsTitle: "Görüntüleyebileceğiniz istasyon yok",
    noStationsDescription:
      "Ajan kurulabilmesi için önce bir istasyon tanımlanmalı ya da size istasyon yetkisi verilmelidir.",
    tabsLabel: "Ajan bölümleri",
    tab: {
      agents: "Ajanlar",
      codes: "Kayıt kodları",
    },
    caption: "Ajanlar",
    emptyTitle: "Kayıtlı ajan yok",
    emptyDescription:
      "Bir istasyona ajan kurmak için 'Kayıt kodları' sekmesinden kod üretin ve kodu istasyon bilgisayarında kullanın.",
    online: "Çevrimiçi",
    offline: "Çevrimdışı",
    clockSkewHigh: "Saat sapması yüksek",
    pagination: "Sayfalama",
    previousPage: "Önceki",
    nextPage: "Sonraki",
    fields: {
      station: "İstasyon",
      hostname: "Bilgisayar adı",
      online: "Bağlantı",
      lastSeenAt: "Son görülme",
      lastSyncAt: "Son senkron",
      lastHeartbeatAt: "Son heartbeat",
      version: "Sürüm",
      adapters: "Adaptörler",
      os: "İşletim sistemi",
      updateChannel: "Güncelleme kanalı",
      enrolledAt: "Kayıt tarihi",
      queueDepth: "Kuyruk derinliği",
      deadLetterCount: "Ölü mektup",
      oldestPendingAt: "En eski bekleyen",
      lastAckedSeq: "Son onaylı sıra",
      clockSkew: "Saat sapması",
      pendingCommands: "Bekleyen komut",
      uptime: "Çalışma süresi",
      disk: "Disk",
      diskValue: "{{free}} boş / {{total}}",
      memory: "Bellek",
    },
    summary: {
      notInstalled: "Ajan kurulmamış",
      notInstalledHint:
        "Bu istasyonda etkin ajan yok: pompa, tank ve ÖKC verisi otomatik gelmiyor. Kurulum için kayıt kodu üretin.",
      onlineOf: "{{online}} / {{total}} çevrimiçi",
      offline: "Çevrimdışı ajan",
      oldestPending: "En eski bekleyen",
      queueEmpty: "Kuyruk boş",
      openAlarms: "Kritik alarm (24 sa)",
    },
    adapters: {
      caption: "Adaptörler",
      emptyTitle: "Adaptör bildirilmedi",
      emptyDescription:
        "Ajan henüz adaptör bildirmedi. İlk heartbeat geldiğinde pompa, tank probu ve ÖKC adaptörleri burada listelenir.",
      id: "Adaptör",
      kind: "Tür",
      driver: "Sürücü",
      detail: "Ayrıntı",
      lastEventAt: "Son olay",
      none: "Adaptör bildirilmedi",
      allOk: "{{ok}} / {{total}} çalışıyor",
      failing: "Sorunlu adaptör: {{names}}",
    },
    devices: {
      caption: "Cihaz durumları",
      emptyTitle: "Cihaz durumu yok",
      emptyDescription: "Ajan henüz tabanca ya da cihaz durumu göndermedi.",
      ref: "Cihaz",
      kind: "Tür",
      kindOption: {
        NOZZLE: "Tabanca",
        DEVICE: "Cihaz",
      },
      receivedAt: "Alındığı an",
    },
    commands: {
      caption: "Komut geçmişi",
      emptyTitle: "Komut yok",
      emptyDescription: "Bu ajana henüz komut gönderilmedi.",
      type: "Komut türü",
      attempt: "Deneme",
      createdBy: "Oluşturan",
      bySystem: "Sistem",
      byUser: "Kullanıcı",
      timeline: "Zaman çizelgesi",
      result: "Sonuç",
      createdAt: "Oluşturuldu",
      deliveredAt: "İletildi",
      ackedAt: "Alındı",
      finishedAt: "Bitti",
      sendTitle: "Komut gönder",
      sendDescription:
        "Komut kuyruğa alınır; ajan bir sonraki sorgusunda alır. Süresi dolan komut uygulanmaz.",
      sendAction: "Gönder",
      sent: "Komut kuyruğa alındı",
      invalid: "Komut bilgileri eksik ya da geçersiz.",
      pricesHint:
        "Yürürlükteki istasyon fiyatları sunucuda hazırlanır ve ajana gönderilir; buradan fiyat girilmez.",
      masterDataHint: "Ajan ürün, tank, tabanca ve cari limit özetini yeniden indirir.",
      adapter: "Adaptör",
      noAdapters: "Son heartbeat'te adaptör bildirilmediği için yeniden başlatılacak adaptör seçilemiyor.",
      sinceMinutes: "Son kaç dakika",
      sinceMinutesHint: "Ajan bu süredeki günlükleri sıkıştırıp yükler.",
      configTitle: "Yapılandırma",
      configHint:
        "Boş bıraktığınız alanlar değişmez. Değerler saniye (ya da parti boyu için adet) cinsindendir.",
      keepCurrent: "Değiştirme",
      ttlMinutes: "Geçerlilik (dakika)",
      ttlMinutesHint: "Bu süre içinde ajana ulaşmazsa komutun süresi dolar.",
      cancelTitle: "Komutu iptal et",
      cancelDescription: '"{{type}}" komutu iptal edilecek. Ajana ulaşmış olsa bile sonucu beklenmez.',
      cancelAction: "Komutu iptal et",
      cancelled: "Komut iptal edildi",
    },
    config: {
      heartbeatIntervalSeconds: "Heartbeat aralığı (sn)",
      syncIntervalSeconds: "Senkron aralığı (sn)",
      syncBatchSize: "Parti boyu (adet)",
      totalizerReadingIntervalSeconds: "Endeks okuma aralığı (sn)",
      tankReadingIntervalSeconds: "Tank okuma aralığı (sn)",
    },
    heartbeats: {
      caption: "Heartbeat geçmişi",
      emptyTitle: "Heartbeat yok",
      emptyDescription: "Ajan henüz hiç heartbeat göndermedi.",
      chartLabel: "Kuyruk derinliği ve saat sapması grafiği",
      queueAxis: "Kuyruk (adet)",
      skewAxis: "Sapma (sn)",
      receivedAt: "Alındığı an",
    },
    alarms: {
      caption: "Cihaz alarmları",
      emptyTitle: "Alarm yok",
      emptyDescription: "Bu ajandan cihaz alarmı gelmedi.",
      severity: "Önem",
      code: "Kod",
      message: "İleti",
      raisedAt: "Zaman",
    },
    logs: {
      caption: "Günlük yüklemeleri",
      emptyTitle: "Yüklenen günlük yok",
      emptyDescription: '"Günlükleri gönder" komutuyla istenen günlükler burada listelenir.',
      uploadedAt: "Yüklenme",
      size: "Boyut",
      encoding: "Sıkıştırma",
      download: "İndir",
    },
    detail: {
      title: "Ajan",
      tabs: "Ajan ayrıntısı bölümleri",
      tab: {
        adapters: "Adaptörler ve cihazlar",
        commands: "Komutlar",
        heartbeats: "Heartbeat geçmişi",
        alarms: "Alarmlar",
        logs: "Günlük yüklemeleri",
      },
    },
    codes: {
      caption: "Kayıt kodları",
      emptyTitle: "Kayıt kodu yok",
      emptyDescription: "Yeni bir istasyon bilgisayarına ajan kurmak için kayıt kodu üretin.",
      createTitle: "Kayıt kodu üret",
      createDescription:
        "Kod tek kullanımlıktır, kısa ömürlüdür ve yalnızca bir kez gösterilir. Kodu istasyondaki ajan kurulumunda kullanın.",
      createAction: "Kodu üret",
      note: "Not",
      noteHint: "Hangi makine için üretildiği (ör. 'kasa bilgisayarı') — listede görünür.",
      createdAt: "Oluşturulma",
      expiresAt: "Son kullanma",
      remaining: "Kalan süre",
      activeAgentWarningTitle: "Bu istasyonda zaten etkin bir ajan var",
      activeAgentWarning:
        "Yedek makine kuruyorsanız sorun yok: bir istasyonda birden çok etkin ajan olabilir. Eski makineyi değiştiriyorsanız kurulum bittikten sonra eski ajanı iptal edin.",
      revealTitle: "Kayıt kodu üretildi",
      revealDescription: "Kodu istasyondaki ajan kurulumunda kullanın.",
      revealDone: "Kodu aldım",
      onceWarningTitle: "Bu kod bir daha gösterilmeyecek",
      onceWarning:
        "Kod yalnızca burada görünür; sunucuda yalnızca özeti saklanır. Kaybederseniz yeni bir kod üretmeniz gerekir.",
      installTitle: "Kurulum komutu",
      installHint: "İstasyon bilgisayarında ajan kurulduktan sonra bu komutu çalıştırın.",
      revokeTitle: "Kayıt kodunu iptal et",
      revokeDescription:
        "Kod bir daha kullanılamaz. Kurulum sürüyorsa yarıda kalır; yeni bir kod üretebilirsiniz.",
      revokeAction: "Kodu iptal et",
      revoked: "Kayıt kodu iptal edildi",
      state: {
        ACTIVE: "Bekliyor",
        USED: "Kullanıldı",
        EXPIRED: "Süresi doldu",
        REVOKED: "İptal edildi",
      },
    },
    revoke: {
      title: "Ajanı iptal et",
      description: "İptal geri alınamaz. Gerekçe denetim izine yazılır.",
      consequencesTitle: "İptal edilirse ne olur?",
      consequences:
        "Ajan bir daha veri gönderemez; yeniden kurmak için yeni kayıt kodu gerekir. Yerel kuyruktaki veriler silinmez.",
      reason: "Gerekçe",
      reasonHint: "Örn. 'Bilgisayar değiştirildi' ya da 'Makine hurdaya ayrıldı'.",
      reasonRequired: "Gerekçe en az 3 karakter olmalıdır.",
      action: "Ajanı iptal et",
      done: "Ajan iptal edildi",
      revokedTitle: "Bu ajan iptal edilmiş",
      revokedDescription: "{{at}} — {{reason}}",
    },
  },

  pos: {
    groupLabel: "Yerel kasa",
    noPermission: "Yerel kasa kayıtlarını görüntüleme yetkiniz yok.",
    disabledTitle: "Yerel kasa modülü kapalı",
    disabledDescription:
      "Bu hesapta istasyondaki yerel kasa (POS) açık değil. Açtırmak için destek ekibine ulaşın.",
    noStationsTitle: "Görüntüleyebileceğiniz istasyon yok",
    noStationsDescription:
      "Kasa kurulabilmesi için önce bir istasyon tanımlanmalı ya da size istasyon yetkisi verilmelidir.",
    fields: {
      station: "İstasyon",
    },
    sales: {
      description:
        "İstasyondaki kasadan kesilen fişler: ajan senkronuyla düşer, buradan girilmez ve değiştirilmez.",
      businessDateRange: "İş günü aralığı",
      tabsLabel: "Kasa bölümleri",
      tab: {
        sales: "Fişler",
        summary: "Özet",
      },
      caption: "Kasa satışları",
      emptyTitle: "Bu aralıkta kasa fişi yok",
      emptyDescription:
        "Seçilen iş günü aralığında kasa satışı bulunamadı. Süzgeçleri genişletin ya da ajanın senkronunu denetleyin.",
      flaggedOnly: "Yalnızca uyarılı",
      warningCount: "{{count}} uyarı",
      openShift: "Vardiyayı aç",
      openClosing: "Kasiyer hesabını aç",
      openAgent: "Ajanı aç",
      openEarchive: "e-Arşiv taleplerini aç",
      openOriginal: "İptal edilen fişi aç",
      openVoid: "İptal / iade kaydını aç",
      detailTitle: "Kasa fişi",
      detailDescription:
        "Fiş değiştirilmez: iptal ve iade ayrı kayıt olarak doğar, geçersiz kılınan ödeme satırı üstü çizili kalır.",
      afterDayLock: "Kilitli güne düştü",
      afterDayLockHint:
        "Bu satış kilitlenmiş bir iş gününe düştü. Kayıt reddedilmedi; düzeltme fişi elle yazılmalıdır.",
      ageConfirmed: "Yaş onayı alındı",
      voidReason: "İptal gerekçesi",
      linesTitle: "Satırlar",
      linesCaption: "Fiş satırları",
      vatCaption: "KDV kırılımı",
      ageRestricted: "Yaş sınırlı",
      fuelTxRef: "Pompa işlemi: {{ref}}",
      tendersTitle: "Tahsilatlar",
      tendersHint:
        "Ödeme düzeltmesiyle geçersiz kılınan satırlar silinmez; üstü çizili olarak gerekçesiyle kalır.",
      tendersCaption: "Fiş tahsilatları",
      superseded: "Geçersiz kılındı ({{at}}): {{reason}}",
      creditVerdict: {
        ALLOWED: "Limit yeterli",
        TOLERANCE: "Tolerans kullanıldı",
        BLOCKED: "Cari kapalı",
        LIMIT_EXCEEDED: "Limit aşıldı",
      },
      creditAvailable: "Kalan limit: {{before}} → {{after}}",
      creditOverridden: "Müdür onayıyla geçildi",
      warningsTitle: "Uyarılar",
      warningsHint: "Uyarılar satışı reddetmez; kayıt yazıldı ve incelenmek üzere işaretlendi.",
      fields: {
        receipt: "Fiş",
        occurredAt: "An",
        businessDate: "İş günü",
        staff: "Kasiyer",
        kind: "Tür",
        lineCount: "Satır",
        gross: "Brüt",
        discount: "İndirim",
        net: "Net",
        vat: "KDV",
        vatRate: "KDV oranı",
        vatBase: "Matrah",
        tenders: "Tahsilat",
        warnings: "Uyarı",
        shift: "Vardiya",
        closing: "Kasiyer hesabı",
        agent: "Ajan",
        earchive: "e-Arşiv talebi",
        cashRegister: "Kasa",
        agentSaleId: "Ajan satış kimliği",
        counterparty: "Cari",
        approvedBy: "Onaylayan",
        voidOf: "İptal edilen fiş",
        voidedBy: "İptal / iade kaydı",
        receiptPrintedAt: "Fiş basıldı",
        vehiclePlate: "Plaka",
        note: "Not",
        line: "No",
        product: "Ürün",
        quantity: "Miktar",
        unitPrice: "Birim fiyat",
        tenderType: "Ödeme türü",
        amount: "Tutar",
        changeGiven: "Para üstü",
        tenderDetail: "Ayrıntı",
      },
    },
    report: {
      caption: "Kasa özeti (gün × istasyon × kasiyer)",
      chartTitle: "Günlük net satış ve indirim",
      chartAria: "Kasa satışları — günlük net satış ve indirim sütun grafiği",
      chartTableLabel: "Günlük kasa toplamları",
      amountAxis: "Tutar (₺)",
      totalsTitle: "Dönem toplamı",
      noStaff: "Kasiyer atanmamış",
      emptyTitle: "Bu aralıkta kasa hareketi yok",
      emptyDescription: "Seçilen iş günü aralığında özetlenecek kasa satışı bulunamadı.",
      fields: {
        businessDate: "İş günü",
        saleCount: "Satış",
        returnCount: "İade",
        voidCount: "İptal",
        returnNet: "İade tutarı",
        tenders: "Tahsilat kırılımı",
      },
    },
    campaigns: {
      description:
        "Kasada uygulanan indirim kuralları. Tanım fiyatlama motorunundur; kasa çevrimdışıyken de aynı hesabı yapar.",
      caption: "Kampanyalar",
      newTitle: "Yeni kampanya",
      editTitle: "Kampanyayı düzenle",
      dialogDescription:
        "Kod ve şirket sonradan değişmez (satış satırları kampanyaya bağlıdır). Kampanya silinmez, kapatılır.",
      created: "Kampanya tanımlandı",
      updated: "Kampanya güncellendi",
      conflict: "Kampanya siz düzenlerken değişti. Pencereyi kapatıp yeniden açın.",
      emptyTitle: "Tanımlı kampanya yok",
      emptyDescription: "Kasada indirim uygulamak için 'Yeni kampanya' ile bir kural tanımlayın.",
      deactivate: "Kapat",
      deactivated: "Kampanya kapatıldı",
      deactivateTitle: "Kampanyayı kapat",
      deactivateConfirm: "Evet, kampanyayı kapat",
      deactivateDescription:
        "Kampanya silinmez: yürürlükten kalkar ve geçmiş fişlerde adı durmaya devam eder.",
      onlyActive: "Açık",
      onlyInactive: "Kapalı",
      allStations: "Tüm istasyonlar",
      stationCount: "{{count}} istasyon",
      scopeCount: "{{count}} kayıt",
      openEnd: "süresiz",
      everyDay: "Her gün",
      allDay: "Gün boyu",
      removeScope: "{{name}} kaydını kapsamdan çıkar",
      basketThreshold: "Sepet ≥",
      fuelBuyXPayY:
        "X al Y öde akaryakıtta litre üzerinden işler: 3 al 2 öde'de her 3 litrede 1 litre bedava olur. Bilerek seçtiğinizden emin olun.",
      state: {
        ACTIVE: "Yürürlükte",
        SCHEDULED: "Başlamadı",
        EXPIRED: "Süresi geçti",
        INACTIVE: "Kapalı",
      },
      sections: {
        scope: "Kapsam",
        effect: "Etki",
        conditions: "Koşullar",
        couponCross: "Kupon ve çapraz koşul",
      },
      requiresCouponBadge: "Kupon ister",
      cross: {
        NONE: "Çapraz koşul yok",
        BASKET_LINE_KIND_MIN_QUANTITY: "Aynı sepette belirli türde en az miktar",
        CONTEXT_FLAG: "Bağlam bayrağı",
      },
      fields: {
        code: "Kod",
        codeHint: "Fişlerde ve raporlarda görünür; sonradan değiştirilemez.",
        codeLocked: "Kod değiştirilemez.",
        name: "Ad",
        effect: "Etki",
        scope: "Kapsam",
        validity: "Geçerlilik",
        window: "Gün / saat",
        customerKind: "Müşteri türü",
        stations: "İstasyonlar",
        stationsHint: "Hiçbiri seçilmezse kampanya şirketin tüm istasyonlarını kapsar.",
        scopeKind: "Kapsam türü",
        businessUnits: "İş birimleri",
        businessUnitsHint: "Kampanya bu iş birimlerinden gelen satırlara uygulanır.",
        categories: "Ürün kategorileri",
        categoriesHint: "Seçilen kategorilerdeki ürünlere uygulanır.",
        products: "Ürünler",
        productsHint: "Kod ya da adla arayın; seçilen ürünler aşağıda listelenir.",
        productPlaceholder: "Ürün ara ve ekle",
        effectType: "Etki türü",
        percentValue: "Yüzde",
        percentValueHint: "0–100 arası; ondalık için virgül kullanın (ör. 7,5).",
        amountValue: "Birim başına indirim",
        amountValueHint: "Satırın her bir biriminden düşülecek tutar.",
        unitPriceValue: "Sabit birim fiyat",
        unitPriceValueHint: "Market satırında kuruş, akaryakıt satırında ₺/L olarak uygulanır.",
        buyQuantity: "Alınan adet (X)",
        buyQuantityHint: "Her X adette… (2–100)",
        payQuantity: "Ödenen adet (Y)",
        payQuantityHint: "…Y adedin bedeli ödenir; ör. 3 al 2 öde. Y, X'ten küçük olmalıdır.",
        priority: "Öncelik",
        priorityHint: "Küçük sayı önce denenir; bir satıra en çok bir kampanya uygulanır.",
        minQuantity: "Asgari miktar",
        minQuantityHint: "Boş bırakılırsa miktar koşulu yoktur.",
        minLineGross: "Asgari satır tutarı",
        minLineGrossHint: "Boş bırakılırsa tutar koşulu yoktur.",
        minBasketGross: "Sepet eşiği (₺)",
        minBasketGrossHint:
          "Boş bırakılırsa satır kampanyasıdır. Doluysa satır kampanyalarından sonra, indirimli sepet tutarı bu eşiğe ulaşınca yalnızca kampanya almamış satırlara uygulanır.",
        loyaltyTiers: "Seviye kodları",
        loyaltyTiersHint:
          "Virgülle ayırın; kodlar büyük / küçük harfe duyarlıdır. Sadakat kartı kasaya bağlanana kadar bu kampanya kasada uygulanmaz.",
        loyaltyTiersPlaceholder: "GOLD, PLATINUM",
        validFrom: "Başlangıç günü",
        validToDay: "Son geçerli gün",
        validToDayHint: "Bu gün dâhildir; boş bırakılırsa kampanya süresizdir.",
        timeFrom: "Saat başlangıcı",
        timeTo: "Saat bitişi",
        timeWindowHint: "İkisi de boşsa gün boyu geçerlidir; bitiş başlangıçtan küçükse gece yarısını aşar.",
        weekdays: "Haftanın günleri",
        weekdaysHint: "Hiçbiri seçilmezse kampanya her gün geçerlidir.",
        couponCross: "Kupon / çapraz koşul",
        requiresCoupon: "Kupon ister",
        requiresCouponHint:
          "İşletmenin kendi kuponu: kampanya yalnızca geçerli kupon kodu okutulunca uygulanır ve İNDİRİMDİR (KDV matrahını düşürür). Kodlar sadakat modülünde üretilir.",
        crossKind: "Çapraz koşul",
        crossKindHint: "Ör. 40 L üzeri yakıt alana yıkama indirimi; şarj sürerken kafe indirimi.",
        crossLineKind: "Sepetteki satır türü",
        crossMinQuantity: "En az miktar",
        crossMinQuantityHint: "Aynı sepette bu türdeki satırların toplam miktarı (akaryakıtta litre).",
        crossFlag: "Bayrak",
        crossFlagHint: "Bayrak kasadaki bağlamdan gelir (şarj oturumu şarj modülüyle dolar).",
      },
      preview: {
        title: "Örnek sepet",
        description:
          "Hesap kasadaki motorun aynısıyla yapılır: aşağıdaki örnek satırda bu kampanya ne indirim yapar?",
        quantity: "Örnek miktar",
        unitPrice: "Örnek birim fiyat",
        gross: "Brüt",
        discount: "İndirim",
        net: "Net",
        incomplete: "Önizleme için kampanyanın kapsamını ve etkisini tamamlayın.",
        noDiscount:
          "Bu örnek sepette indirim oluşmuyor. Kapsamı, asgari koşulları ve zaman penceresini gözden geçirin.",
        belowThreshold:
          "Örnek sepet {{threshold}} eşiğinin altında; sepet kampanyası uygulanmaz. Örnek miktarı ya da fiyatı artırın.",
        belowBuyQuantity:
          "X al Y öde indirimi miktar {{count}} adede ulaşınca başlar; örnek miktarı artırın.",
      },
    },
    settings: {
      description: "Kasanın davranışını belirleyen eşikler. Değerler işletme tarafından doğrulanmalıdır.",
      scope: "Ayar kapsamı",
      scopeHint: "Şirket satırı tüm istasyonlar için geçerlidir; istasyon seçerseniz ona özel kayıt yazılır.",
      companyScope: "Şirket geneli",
      saved: "Kasa ayarları kaydedildi",
      readOnly: "Kasa ayarlarını değiştirme yetkiniz yok; değerler salt okunur gösteriliyor.",
      conflictTitle: "Ayarlar siz düzenlerken değişti",
      conflictBody: "Başka bir kullanıcı bu ayarları kaydetti. Güncel değerleri yükleyip yeniden deneyin.",
      reload: "Güncel değerleri yükle",
      isDefaultTitle: "Bu değerler ürün varsayılanıdır",
      isDefaultBody: "Henüz kayıt yok: kaydettiğinizde şirket satırı oluşturulur.",
      noOverrideBody:
        "Bu istasyonun kendi ayarı yok; şirket değerleri gösteriliyor. Kaydederseniz istasyona özel kayıt oluşur.",
      needsVerificationTitle: "Değerler doğrulanmalı",
      needsVerificationBody:
        "Bu eşikler seed / varsayılan değerlerdir. İşletmenin kuralına göre gözden geçirip onaylayın.",
      markVerified: "Doğruladım",
      verified: "Doğrulandı",
      sections: {
        rules: "Kasa kuralları",
      },
      fiscalRequired: "ÖKC zorunlu",
      fiscalRequiredHint: "Açıkken yazar kasa yoksa ya da arızalıysa kasa satış yapmaz.",
      offlineCreditTolerance: "Çevrimdışı veresiye toleransı",
      offlineCreditToleranceHint:
        "Kasa çevrimdışıyken önbellekteki limitin bu kadar üstüne izin verilir; aşım senkronda alarma döner.",
      pendingFuelAutoSettleMinutes: "Bekleyen dolum otomatik kapanışı (dk)",
      pendingFuelAutoSettleMinutesHint:
        "Kasada ödenmeyen pompa satışı bu süre sonunda 'pompada nakit ödendi' sayılır. 0 = kapalı.",
      ageRestrictedConfirmation: "Yaş sınırlı üründe personel onayı",
      ageRestrictedConfirmationHint: "Tütün / alkol satırında kasiyerden açık onay istenir.",
      receiptFooter: "Fiş alt yazısı",
      receiptFooterHint: "Fişin altına basılan serbest metin (en çok 300 karakter).",
    },
    pin: {
      action: "PIN",
      title: "Kasa PIN'i",
      description: "Personelin kasaya giriş PIN'i",
      hasPin: "PIN tanımlı",
      noPin: "PIN yok",
      setAt: "Atanma tarihi",
      failedAttempts: "Yanlış deneme",
      noPermission: "Kasa PIN'i atama yetkiniz yok; yalnızca durumu görüntüleyebilirsiniz.",
      newPin: "Yeni PIN",
      policyHint: "{{min}}–{{max}} rakam. Ardışık (1234) ve tekrarlı (1111) PIN kabul edilmez.",
      repeatPin: "PIN (yeniden)",
      mismatch: "İki PIN aynı değil.",
      stepUpHint: "Güvenlik gereği PIN atarken ve kaldırırken kimliğiniz yeniden doğrulanır.",
      setAction: "PIN ata",
      changeAction: "PIN'i değiştir",
      removeAction: "PIN'i kaldır",
      removeTitle: "PIN kaldırılsın mı?",
      removeDescription: "PIN kaldırılırsa personel kasaya giriş yapamaz.",
      removeConfirm: "Evet, kaldır",
      saved: "Kasa PIN'i güncellendi",
      removed: "Kasa PIN'i kaldırıldı",
    },
  },
  market: {
    noPermission: "Market kayıtlarını görüntüleme yetkiniz yok.",
    disabledTitle: "Market modülü kapalı",
    disabledDescription:
      "Bu hesapta market (stok, sayım, transfer) modülü açık değil. Açtırmak için destek ekibine ulaşın.",
    noStationsTitle: "Görüntüleyebileceğiniz istasyon yok",
    noStationsDescription:
      "Market stoğu istasyon bazındadır: önce bir istasyon tanımlanmalı ya da size istasyon yetkisi verilmelidir.",
    fields: {
      station: "İstasyon",
      warehouse: "Depo",
      product: "Ürün",
      productCode: "Ürün kodu",
      category: "Kategori",
      shelfLocation: "Raf yeri",
      onHand: "Eldeki",
      minMax: "Min / max",
      minStock: "Asgari stok",
      maxStock: "Azami stok",
      isListed: "Bu istasyonda listede",
      averageUnitCost: "Ort. birim maliyet",
      unitCost: "Birim maliyet",
      stockValue: "Stok değeri",
      value: "Değer",
      valueAfter: "Sonraki değer",
      quantity: "Miktar",
      quantityAfter: "Sonraki miktar",
      remaining: "Kalan / ilk",
      lastSaleAt: "Son satış",
      lastReceiptAt: "Son kabul",
      lastCountedAt: "Son sayım",
      occurredAt: "Zaman",
      movementType: "Hareket türü",
      source: "Kaynak belge",
      lotNo: "Parti no",
      expiryDate: "SKT",
      expiryState: "SKT durumu",
      daysToExpiry: "SKT'ye kalan",
      receivedAt: "Giriş tarihi",
      trackExpiry: "SKT takibi",
      lineCount: "Satır",
      ledger: "Muhasebe fişi",
      note: "Not",
      cancelReason: "İptal nedeni",
      createdAt: "Oluşturulma",
    },
    ledger: {
      POSTED: "Fiş kesildi",
      QUEUED: "Eşleştirme bekliyor",
      openEntry: "Muhasebe fişini aç",
    },
    lossKey: {
      NORMAL_LOSS: "Normal fire",
      ABNORMAL_LOSS: "Olağandışı kayıp",
    },
    lines: {
      add: "Satır ekle",
      product: "{{number}}. satır ürünü",
      quantity: "{{number}}. satır miktarı",
      lot: "{{number}}. satır partisi",
      lotHint: "Boş bırakılırsa önce SKT'si en yakın partiden düşer (FEFO).",
      lotOption: "{{lot}} · SKT {{expiry}} · kalan {{quantity}}",
      fefo: "Otomatik (FEFO — ilk biten ilk çıkar)",
      fefoShort: "FEFO",
      note: "{{number}}. satır notu",
      remove: "{{number}}. satırı kaldır",
      problem: {
        product: "Ürün seçin.",
        quantity: "Miktar sıfırdan büyük, en fazla 3 ondalıklı olmalıdır (ör. 12,5).",
        duplicate: "Aynı ürün aynı partiden iki kez girilemez.",
      },
    },
    stock: {
      description:
        "Depo × ürün bakiyesi: eldeki miktar, stok değeri ve hareketli ortalama maliyet. Kasa satışı stoktan kendiliğinden düşer.",
      caption: "Market stoğu",
      searchPlaceholder: "Ad, kod ya da barkod",
      belowMinOnly: "Yalnızca asgari altı",
      negativeOnly: "Yalnızca negatif",
      hideZero: "Sıfırları gizle",
      belowMinBadge: "Asgari altında",
      negativeBadge: "Negatif stok",
      emptyTitle: "Henüz stok kaydı yok",
      emptyDescription:
        "Açılış stoğu girin ya da mal kabul yapın; kasa satışı olan ürünler de burada görünür.",
      emptyFilteredTitle: "Eşleşen stok yok",
      emptyFilteredDescription: "Arama metnini ya da süzgeçleri değiştirerek yeniden deneyin.",
    },
    opening: {
      action: "Açılış stoğu",
      title: "Açılış stoğu gir",
      description:
        "Depoda hiç hareketi olmayan ürünün başlangıç miktarı ve maliyeti. Muhasebe fişi üretmez; sonraki düzeltmeler sayımla yapılır.",
      quantity: "Miktar",
      unitCost: "Birim maliyet (₺, KDV hariç)",
      unitCostHint: "En fazla 6 ondalık (ör. 12,5).",
      unitCostInvalid: "Geçerli bir maliyet girin (ör. 12,50).",
      submit: "Açılış stoğunu kaydet",
      saved: "Açılış stoğu kaydedildi",
    },
    card: {
      title: "Ürün stok kartı",
      links: "Ayrıntılar",
      allMovements: "Tüm hareketler",
      allLots: "Tüm partiler",
      balances: "Depolar",
      noBalances: "Bu ürünün henüz stok kaydı yok.",
      lots: "Açık partiler (FEFO sırası)",
      noLots: "Açık parti yok.",
      recentMovements: "Son hareketler",
      noMovements: "Henüz hareket yok.",
      suppliers: "Tedarikçiler",
      noSuppliers: "Bu ürün henüz bir tedarikçiye bağlanmamış.",
      stationSettings: "İstasyon ayarları",
      noStationSettings: "Bu ürün için istasyon ayarı (min / max, raf yeri) girilmemiş.",
    },
    suppliers: {
      add: "Tedarikçi bağla",
      addTitle: "Ürünü tedarikçiye bağla",
      editTitle: "Tedarikçi bağını düzenle",
      dialogDescription:
        "Tercihli tedarikçi sipariş önerisinde kullanılır; ürün başına en çok bir tercihli tedarikçi olur.",
      editLabel: "{{name}} bağını düzenle",
      supplier: "Tedarikçi",
      supplierProductCode: "Tedarikçi ürün kodu",
      purchasePrice: "Alış fiyatı (₺, KDV hariç)",
      purchasePriceHint: "Satış birimi başına liste fiyatı.",
      packSize: "Koli içi adet",
      packSizeHint: "Boşsa ürünün koli içi adedi kullanılır.",
      minOrderQuantity: "Asgari sipariş",
      leadTimeDays: "Teslim süresi (gün)",
      days: "{{count}} gün",
      isPreferred: "Tercihli tedarikçi",
      isPreferredHint: "İşaretlenirse bu ürünün diğer tercihli bağı kaldırılır.",
      preferred: "Tercihli",
      saved: "Tedarikçi bağı kaydedildi",
    },
    stationSettings: {
      add: "İstasyon ayarı ekle",
      addTitle: "İstasyon ayarı ekle",
      editTitle: "İstasyon ayarını düzenle",
      dialogDescription: 'Asgari / azami stok sipariş önerisini ve "asgari altında" uyarısını belirler.',
      editLabel: "{{station}} ayarını düzenle",
      shelfHint: "Raf etiketi ve sayım listesinde görünür (ör. A-03).",
      isListedHint: "İşaret kaldırılırsa ürün bu istasyonun sipariş önerisine girmez.",
      saved: "İstasyon ayarı kaydedildi",
    },
    movements: {
      description:
        "Stok defteri: her hareket kendinden sonraki miktarı ve değeri taşır. Hareketler belgelerden doğar, buradan girilmez.",
      caption: "Stok hareketleri",
      businessDateRange: "İş günü aralığı",
      businessDate: "İş günü {{date}}",
      clearProduct: "Ürün süzgecini kaldır",
      emptyTitle: "Bu aralıkta hareket yok",
      emptyDescription: "Tarih aralığını genişletin ya da süzgeçleri kaldırın.",
      source: {
        OPENING_STOCK: "Açılış stoğu",
        STOCK_TRANSFER: "Transfer",
        STOCK_WRITE_OFF: "Fire / imha",
        STOCK_COUNT: "Sayım",
        POS_SALE: "Kasa fişi",
        POS_RETURN: "Kasa iadesi",
        GOODS_RECEIPT: "Mal kabul",
        INVOICE_MATCH: "Fatura eşleşmesi",
        OTHER: "Diğer belge",
      },
    },
    lots: {
      description:
        "SKT takipli ürünlerin açık partileri, SKT'ye göre sıralı. Durum istasyonun SKT uyarı günü ayarıyla hesaplanır.",
      caption: "SKT ve partiler",
      noLotNo: "Parti no yok",
      expiringOnly: "Yalnızca yaklaşanlar",
      includeEmpty: "Tükenen partileri de göster",
      clearProduct: "Tüm ürünleri göster",
      daysLeft: "{{count}} gün",
      daysAgo: "{{count}} gün geçti",
      emptyTitle: "Parti yok",
      emptyDescription:
        "SKT takipli ürünlerin mal kabulü ya da açılış stoğu girildiğinde partiler burada görünür.",
    },
    transfers: {
      description:
        "Aynı şirketin istasyonları arasında mal transferi: gönderen gönderir, alan teslim alır. Eksik gelen fire olarak yazılır.",
      caption: "Transferler",
      new: "Yeni transfer",
      newTitle: "Yeni transfer",
      editTitle: "Transfer taslağını düzenle",
      dialogDescription:
        "Yalnızca aynı şirketin istasyonları arasında transfer yapılabilir; başka şirkete mal çıkışı satış faturasıdır.",
      createDraft: "Taslak oluştur",
      saved: "{{no}} kaydedildi",
      detailTitle: "Transfer",
      direction: "Yön",
      outgoing: "Giden",
      incoming: "Gelen",
      from: "Gönderen",
      to: "Alan",
      toSr: "istasyonuna",
      sameWarehouse: "Gönderen ve alan depo aynı olamaz.",
      singleStation: "Transfer için en az iki istasyon gerekir.",
      lines: "Transfer satırları",
      summary: "Özet",
      send: "Gönder",
      receive: "Teslim al",
      cancel: "Transferi iptal et",
      inTransitHint: "Mal yolda. Alan istasyon teslim alınca stoğa girer ve muhasebe fişi kesilir.",
      valueTitle: "Değer özeti",
      valueBalanced: "Gönderilen değer = alınan + eksik değeri.",
      valueUnbalanced:
        "Değer tutarsız: gönderilen, alınan ve eksik toplamına eşit değil. Destek ekibine bildirin.",
      receiveTitle: "Transferi teslim al",
      receiveDescription:
        "Gelen miktarı girin; boş bırakılan satır tam gelmiş sayılır. Gönderilenden fazlası alınamaz.",
      receivedFor: "{{product}} — gelen miktar",
      sentHint: "Gönderilen: {{quantity}}",
      receivedInvalid: "Gelen miktar sıfır ile gönderilen arasında olmalıdır.",
      shortNoteFor: "{{product}} — eksik açıklaması",
      shortTitle: "Eksik gelen miktar fire olarak yazılır",
      shortBody: "{{count}} satırda eksik var. Eksik miktar olağandışı kayıp (fire) olarak muhasebeleşir.",
      confirmReceive: "Teslim al",
      cancelTitle: "Transfer iptal edilsin mi?",
      cancelDescription: "Yalnızca taslak transfer iptal edilebilir; stok değişmez.",
      emptyTitle: "Transfer yok",
      emptyDescription: "İstasyonlar arasında mal göndermek için yeni bir transfer oluşturun.",
      fields: {
        transferNo: "Transfer no",
        route: "Gönderen → alan",
        sentValue: "Gönderilen değer",
        receivedValue: "Alınan değer",
        shortValue: "Eksik değeri",
        sentQuantity: "Gönderilen",
        receivedQuantity: "Alınan",
        shortQuantity: "Eksik",
        sentAt: "Gönderim",
        receivedAt: "Teslim alma",
      },
      done: {
        send: "Transfer gönderildi; stok gönderen depodan düştü",
        receive: "Transfer teslim alındı",
        cancel: "Transfer iptal edildi",
      },
    },
    writeOffs: {
      description:
        "SKT'si geçen, hasarlı, çalınan ya da iç kullanıma alınan ürünler. Onaylanınca stoktan düşer ve kayıp fişi kesilir.",
      caption: "Fire / imha belgeleri",
      new: "Yeni fire",
      newTitle: "Yeni fire / imha",
      editTitle: "Fire taslağını düzenle",
      dialogDescription:
        "Neden, kayıp anahtarını belirler (market ayarı). Belge onaya gönderilince onay politikası varsa onay bekler.",
      createDraft: "Taslak oluştur",
      saved: "{{no}} kaydedildi",
      detailTitle: "Fire / imha",
      lines: "Fire satırları",
      summary: "Özet",
      submit: "Onaya gönder",
      reopen: "Taslağa döndür",
      cancel: "Fireyi iptal et",
      approval: "Onay",
      pendingHint: "Belge onay bekliyor. Onaylanınca stoktan düşer ve kayıp fişi kesilir.",
      rejectedHint:
        "Belge reddedildi; stok değişmedi. Taslağa döndürüp düzeltebilir ya da iptal edebilirsiniz.",
      cancelTitle: "Fire iptal edilsin mi?",
      cancelDescription: "Bekleyen onay talebi geri çekilir; stok değişmez.",
      emptyTitle: "Fire belgesi yok",
      emptyDescription:
        "SKT'si geçen ya da hasarlı ürünleri stoktan düşmek için yeni bir fire belgesi oluşturun.",
      fields: {
        writeOffNo: "Fire no",
        reason: "Neden",
        lossKey: "Kayıp türü",
        totalValue: "Tutar",
        estimatedValue: "Tahmini tutar",
        postedAt: "Kayıt zamanı",
      },
      done: {
        submitted: "Fire onaya gönderildi",
        posted: "Fire kaydedildi; stoktan düştü",
        reopen: "Fire taslağa döndü",
        cancel: "Fire iptal edildi",
      },
    },
    counts: {
      description:
        "Sayım açın, tabletle barkod okutun, gönderin ve fark raporunu onaylayın. Sayım sürerken yapılan satış fark doğurmaz.",
      caption: "Stok sayımları",
      new: "Sayım aç",
      newTitle: "Sayım aç",
      dialogDescription:
        "Açılışta kapsamdaki ürünlerin sistem miktarı dondurulur; fark, sayılan ile (bu fotoğraf + sonraki hareketler) arasındadır.",
      open: "Sayımı aç",
      created: "{{no}} açıldı",
      detailTitle: "Sayım",
      categories: "Kategoriler",
      addProduct: "Ürün ekle",
      selectedProducts: "Seçilen ürünler",
      removeProduct: "{{product}} ürününü çıkar",
      suggestions: "Önerilen ürünler ({{days}} gündür sayılmayan, değeri yüksek)",
      noSuggestions: "Bu depoda önerilecek ürün yok.",
      neverCounted: "hiç sayılmadı",
      lastCounted: "son sayım {{date}}",
      kindHint: {
        FULL: "Depodaki stoklu tüm ürünler sayılır. Bir depoda aynı anda tek açık tam sayım olabilir.",
        PARTIAL: "Seçtiğiniz kategoriler ve ürünler sayılır.",
        CYCLE: "Uzun süredir sayılmayan ve değeri yüksek ürünler önerilir; listeyi daraltabilirsiniz.",
      },
      approvalPending: "Onay bekliyor",
      progressLabel: "Sayılan ürün",
      progressValue: "{{counted}} / {{total}}",
      readOnlyCounting:
        "Sayım sürüyor. Okutma yetkiniz olmadığı için listeyi yalnızca görüntüleyebilirsiniz.",
      barcodeLabel: "Barkod okutun",
      barcodeHint: "Okuyucu barkodu yazıp Enter'a basar; her okutma bir adet sayar.",
      barcodeTooShort: "Barkod en az 4 karakter olmalıdır.",
      scan: "Okut",
      scanned: "{{product}}: sayılan {{counted}}",
      countedSet: "Sayılan miktar güncellendi",
      noSelection: "Ürün okutun ya da listeden seçin.",
      selectedCard: "Seçili ürün",
      counted: "Sayılan",
      notCounted: "Sayılmadı",
      increment: "{{product}} için bir adet ekle",
      decrement: "{{product}} için bir adet düş",
      setCounted: "Sayılanı elle gir",
      setCountedHint: "Satırın sayılanı bu değere ayarlanır (fark kadar düzeltme yazılır).",
      apply: "Uygula",
      setProblem: {
        invalid: "Geçerli bir miktar girin (ör. 12 ya da 1,5).",
        negative: "Sayılan miktar negatif olamaz.",
        unchanged: "Sayılan zaten bu değer.",
      },
      linesTitle: "Sayım listesi",
      linesFilter: "Liste süzgeci",
      filter: {
        uncounted: "Sayılmayanlar",
        counted: "Sayılanlar",
        all: "Tümü",
      },
      searchPlaceholder: "Ad, kod ya da barkod",
      noLines: "Bu süzgeçte ürün yok.",
      listLimited: "İlk {{shown}} ürün gösteriliyor (toplam {{total}}). Aramayla daraltın.",
      submit: "Sayımı gönder",
      submitTitle: "Sayım gönderilsin mi?",
      submitDescription:
        "Gönderimde beklenen miktarlar hesaplanır ve fark raporu oluşur. Gerekirse yeniden açılabilir.",
      uncountedWarning: "{{count}} ürün hiç okutulmadı.",
      uncountedAsZero: "Okutulmayan ürünler sıfır sayılsın",
      uncountedAsZeroHint:
        "Rafta olmadığı için okutulmayan ürünler noksan olarak yazılır. İşaretlenmezse fark doğurmaz.",
      allCounted: "Kapsamdaki tüm ürünler sayıldı.",
      cancel: "Sayımı iptal et",
      cancelTitle: "Sayım iptal edilsin mi?",
      cancelDescription: "Okutmalar saklanır ama stok değişmez; iptal edilen sayım yeniden açılamaz.",
      cancelledHint: "Bu sayım iptal edildi; stok değişmedi.",
      emptyTitle: "Sayım yok",
      emptyDescription: "Tam, kısmi ya da döngüsel bir sayım açıp tabletle barkod okutarak sayın.",
      reportTitle: "Fark raporu",
      reportCaption: "Sayım fark raporu",
      onlyDifferences: "Yalnızca farklı olanlar",
      noDifferences: "Fark yok.",
      shortageTotal: "Noksan ({{count}} ürün)",
      surplusTotal: "Fazla ({{count}} ürün)",
      inconsistent: "Satır farklarının toplamı başlıktaki tutarla uyuşmuyor. Sayımı yeniden açıp gönderin.",
      approve: "Farkı onayla",
      approveHint: "Onay kimliğinizi yeniden doğrulamanızı ister. Eşik aşılırsa onay motoruna gider.",
      cannotApprove: "Sayım farkını onaylama yetkiniz yok.",
      approvalPendingHint: "Fark, onay motorunda onay bekliyor. Onaylanınca stok düzeltilir ve fiş kesilir.",
      approvalTitle: "Onay",
      reopen: "Yeniden okutmaya aç",
      direction: {
        SHORTAGE: "Noksan",
        SURPLUS: "Fazla",
      },
      fields: {
        countNo: "Sayım no",
        kind: "Sayım türü",
        progress: "Sayılan",
        shortageValue: "Noksan",
        surplusValue: "Fazla",
        netValue: "Net fark",
        snapshot: "Fotoğraf",
        movementsSinceSnapshot: "Sonraki hareket",
        expected: "Beklenen",
        difference: "Fark",
        differenceValue: "Fark değeri",
        snapshotAt: "Fotoğraf zamanı",
        submittedAt: "Gönderim",
      },
      done: {
        submit: "Sayım gönderildi; fark raporu hazır",
        approve: "Sayım farkı onaylandı; stok düzeltildi",
        approvalRequested: "Fark eşiği aştı; onay motoruna gönderildi",
        reopen: "Sayım yeniden okutmaya açıldı",
        cancel: "Sayım iptal edildi",
      },
    },
    suggestions: {
      description:
        "Min / max stok, satış hızı, teslim süresi ve koli içi adede göre önerilen sipariş. Seçilen satırlardan tedarikçi başına taslak sipariş açılır.",
      supplier: "Tedarikçi",
      allSuppliers: "Tüm tedarikçiler",
      includeAll: "Stoğu yeterli ürünleri de göster",
      basis: "Satış hızı son {{days}} günden hesaplandı · iş günü {{date}}",
      bySupplier: "Tedarikçiye göre özet",
      noSupplierGroup: "Tedarikçisi olmayanlar",
      supplierLines: "{{count}} ürün",
      caption: "Sipariş önerisi",
      select: "Seç",
      selectProduct: "{{product}} ürününü seç",
      quantityFor: "{{product}} sipariş miktarı",
      quantityProblem: "Miktar sıfırdan büyük, en fazla 3 ondalıklı olmalıdır.",
      leadTime: "teslim {{count}} gün",
      reason: {
        BELOW_MIN_AT_ARRIVAL: "Teslimde asgarinin altında",
        NO_LIMITS: "Min / max tanımsız",
      },
      blocker: {
        noSupplier: "Tedarikçi bağı yok: stok kartından tercihli tedarikçi bağlayın.",
        noPrice: "Tedarikçinin liste alış fiyatı yok: stok kartından fiyat girin.",
      },
      fields: {
        openOrder: "Açık sipariş",
        pendingOrder: "Bekleyen (bilgi)",
        dailySales: "Günlük satış",
        projected: "Teslimdeki stok",
        suggested: "Önerilen",
        packSize: "Koli",
        supplier: "Tedarikçi / fiyat",
        estimated: "Tahmini tutar",
      },
      expectedDateHint: "Boş bırakılabilir.",
      createOrders: "Seçilenlerden sipariş oluştur ({{count}})",
      createHint:
        "Tedarikçi başına bir TASLAK sipariş açılır; taslakta satırları düzenleyip onaya gönderebilirsiniz. Değiştirdiğiniz miktarlar taslağa yazılır.",
      fixProblems: "{{count}} satırda sorun var; satırların altındaki iletiyi düzeltin.",
      created: "{{count}} taslak sipariş oluşturuldu",
      nothingCreated: "Sipariş oluşturulmadı: seçilen satırların hiçbiri siparişe dönüştürülemedi.",
      resultTitle: "Oluşturulan siparişler",
      skippedTitle: "{{count}} ürün siparişe alınamadı",
      resultHint: "Taslak siparişi açıp kontrol edin, ardından onaya gönderin.",
      emptyTitle: "Önerilecek ürün yok",
      emptyDescription:
        "Teslim anındaki tahmini stoğu asgarinin altına düşecek ürün yok. Tüm ürünleri görmek için süzgeci açın.",
    },
    orders: {
      description:
        "Tedarikçi siparişleri: taslak → onay → tedarikçiye gönderildi → mal kabullerle teslim → kapat.",
      caption: "Tedarikçi siparişleri",
      new: "Yeni sipariş",
      newTitle: "Yeni tedarikçi siparişi",
      editTitle: "Sipariş taslağını düzenle",
      dialogDescription: "Birim fiyat KDV hariçtir; boş bırakılırsa tedarikçinin liste fiyatı kullanılır.",
      editDescription:
        "Kaydedince taslağın tüm satırları bu listeyle değişir. Boş birim fiyat tedarikçinin liste fiyatıdır.",
      createDraft: "Taslak oluştur",
      saved: "{{no}} kaydedildi",
      supplierRequired: "Tedarikçi seçin.",
      lines: "Sipariş satırları",
      lineUnitPrice: "{{number}}. satır birim fiyatı",
      listPrice: "Liste fiyatı",
      lineAmount: "Satır tutarı",
      unitPriceHint: "Fiyat KDV hariç, satış birimi başınadır (en fazla 4 ondalık).",
      problem: {
        product: "Ürün seçin.",
        quantity: "Miktar sıfırdan büyük, en fazla 3 ondalıklı olmalıdır (ör. 12,5).",
        unitPrice: "Birim fiyat sıfır ya da pozitif, en fazla 4 ondalıklı olmalıdır.",
        duplicate: "Bir ürün siparişte yalnızca bir kez yer alabilir.",
      },
      detailTitle: "Tedarikçi siparişi",
      summary: "Özet",
      submit: "Onaya gönder",
      send: "Tedarikçiye gönderildi",
      startReceipt: "Mal kabul başlat",
      reopen: "Taslağa döndür",
      close: "Siparişi kapat",
      cancel: "Siparişi iptal et",
      approval: "Onay",
      receipts: "Mal kabuller",
      noReceipts: "Bu siparişten henüz mal kabul yapılmadı.",
      vatHint: "Tutarlar KDV hariçtir; kesin tutar alış faturasıyla oluşur.",
      pendingHint: "Sipariş onay bekliyor. Onaylanınca tedarikçiye gönderildi olarak işaretlenebilir.",
      rejectedHint: "Sipariş reddedildi. Taslağa döndürüp düzeltebilir ya da iptal edebilirsiniz.",
      approvedHint:
        'Sipariş onaylandı. Tedarikçiye ilettikten sonra "Tedarikçiye gönderildi" ile işaretleyin (e-posta gönderilmez).',
      closedTitle: "Kapatma gerekçesi",
      cancelledTitle: "İptal gerekçesi",
      closeTitle: "Sipariş kapatılsın mı?",
      closeDescription: "Kabul edilmemiş kalan iptal sayılır ve siparişten yeni mal kabul açılamaz.",
      cancelTitle: "Sipariş iptal edilsin mi?",
      cancelDescription:
        "Bekleyen onay talebi geri çekilir. Mal kabul yapılmış sipariş iptal edilemez, kapatılır.",
      fields: {
        orderNo: "Sipariş no",
        supplier: "Tedarikçi",
        orderDate: "Sipariş tarihi",
        expectedDate: "Beklenen teslim",
        netAmount: "Tutar (KDV hariç)",
        sentAt: "Gönderim",
        quantity: "Sipariş",
        unitPrice: "Birim fiyat",
        lineAmount: "Tutar",
        received: "Kabul edilen",
        remaining: "Kalan",
      },
      done: {
        submitted: "Sipariş onaya gönderildi",
        approved: "Sipariş onaylandı (onay politikası yok)",
        send: "Sipariş tedarikçiye gönderildi olarak işaretlendi",
        reopen: "Sipariş taslağa döndü",
        close: "Sipariş kapatıldı",
        cancel: "Sipariş iptal edildi",
      },
      emptyTitle: "Sipariş yok",
      emptyDescription: "Sipariş önerisinden ya da elle yeni bir tedarikçi siparişi oluşturun.",
    },
    receipts: {
      description:
        "Tedarikçiden gelen malın kabulü: tablette barkod okutun, hasarlıyı ayırın, SKT'yi girin ve kaydedin. Muhasebe fişini alış faturası keser.",
      caption: "Mal kabuller",
      new: "Yeni mal kabul",
      newTitle: "Yeni mal kabul",
      dialogDescription:
        "Siparişten açılan kabulde satırlar sipariş kalanıyla dolar. Aynı tedarikçinin aynı irsaliyesi iki kez kabul edilemez.",
      mode: "Kabul türü",
      modes: {
        order: "Siparişten",
        free: "Serbest (siparişsiz)",
      },
      fromOrder: "{{no}} numaralı siparişten ({{supplier}}) mal kabul açılacak.",
      chooseOrder: "Sipariş seçin",
      warehouseHint:
        "Boş bırakılırsa istasyonun varsayılan deposuna girer. Yıkama kimyasalları için yıkama deposunu seçin.",
      defaultWarehouse: "Varsayılan depo",
      noReceivableOrders: "Bu istasyonda teslim almaya açık (gönderilmiş) sipariş yok.",
      despatchHint: "Tedarikçinin irsaliye numarası; faturayla otomatik eşleştirmede kullanılır.",
      fillReceived: "Kabul miktarını beklenenle doldur",
      fillReceivedHint: "Okutmadan hızlı kabul: sonra satırlarda düzeltebilirsiniz.",
      problem: {
        order: "Sipariş seçin.",
        station: "İstasyon seçin.",
        supplier: "Tedarikçi seçin.",
      },
      open: "Mal kabulü aç",
      created: "{{no}} açıldı",
      detailTitle: "Mal kabul",
      despatchShort: "İrsaliye {{no}}",
      orderLink: "Sipariş {{no}}",
      free: "Serbest",
      openMatch: "Eşleşmeyi aç",
      barcodeHint: "Okuyucu barkodu yazıp Enter'a basar; her okutma bir adet kabul eder.",
      damagedNext: "Sonraki okutma hasarlı",
      scanned: "{{product}}: sağlam {{received}} · hasarlı {{damaged}}",
      scannedDamaged: "{{product}}: hasarlı olarak eklendi (sağlam {{received}} · hasarlı {{damaged}})",
      scannedNeedsExpiry: "{{product}} okutuldu — SKT takipli ürün: parti no ve SKT girin.",
      unknownBarcodeHint: "Okutmaya devam edebilirsiniz.",
      noSelection: "Barkod okutun ya da listeden bir satır seçin.",
      selectedCard: "Seçili satır",
      expected: "beklenen {{quantity}}",
      editLine: "Satırı düzenle",
      increment: "{{product}} — {{field}} bir artır",
      decrement: "{{product}} — {{field}} bir azalt",
      saveExpiry: "SKT'yi kaydet",
      expiryHint: "SKT takipli üründe son kullanma tarihi zorunludur; parti no isteğe bağlıdır.",
      expiryRequired: "SKT girilmeden kabul kaydedilemez.",
      expiryPast: "SKT geçmiş: bu ürün sağlam kabul edilemez.",
      moveToDamaged: "Hasarlıya taşı",
      expiryWarning: {
        REQUIRED: "SKT gerekli",
        PAST: "SKT geçmiş",
      },
      difference: {
        NONE: "Tam",
        SHORT: "Eksik {{quantity}}",
        OVER: "Fazla {{quantity}}",
        UNEXPECTED: "Siparişte yok",
      },
      linesTitle: "Kabul satırları",
      noLines: "Henüz satır yok. Barkod okutun ya da elle ürün ekleyin.",
      addLine: "Elle ürün ekle",
      addLineTitle: "Elle ürün ekle",
      addLineDescription:
        "Barkodu okunmayan ürünü seçip miktarını girin. Maliyet boşsa sipariş, yoksa tedarikçinin liste fiyatı kullanılır.",
      unitCostHint: "KDV hariç ₺; boş bırakılabilir.",
      lineQuantities: "sağlam {{received}} · hasarlı {{damaged}}",
      differenceTitle: "Fark görünümü",
      unexpectedLines: "{{count}} satır siparişte yok (fazla gelen olarak sayılır).",
      inconsistent: "Satır toplamları başlıktaki toplamlarla uyuşmuyor. Sayfayı yenileyin.",
      expiryBlockTitle: "SKT sorunları var",
      expiryBlockRequired: "{{count}} satırda SKT girilmemiş.",
      expiryBlockPast: "{{count}} satırda SKT geçmiş (sağlam kabul edilemez).",
      expiryBlockFix: "Düzeltilmeden kayıt yapılamaz.",
      editLineTitle: "{{product}} satırı",
      editLineDescription: "Kabul, hasarlı, parti / SKT, geçici birim maliyet ve not.",
      provisionalHint: "Geçici maliyet; faturayla eşleşince kesinleşir.",
      removeLine: "Satırı kaldır",
      lineProblem: {
        receivedQuantity: "Sıfır ya da pozitif, en fazla 3 ondalıklı miktar girin.",
        damagedQuantity: "Sıfır ya da pozitif, en fazla 3 ondalıklı miktar girin.",
        unitCost: "Birim maliyet sıfır ya da pozitif, en fazla 4 ondalıklı olmalıdır.",
      },
      post: "Kaydet (stoğa gir)",
      postTitle: "Mal kabul kaydedilsin mi?",
      postDescription:
        "Sağlam miktar geçici maliyetle stoğa girer; hasarlı miktar girmez. Muhasebe fişi alış faturası ile kesilir.",
      postShortHint: "Siparişe göre {{quantity}} eksik: sipariş kısmen teslim alınmış olur.",
      lotInvalidTitle: "SKT nedeniyle kaydedilemedi",
      lotInvalidHint:
        "SKT'si geçmiş ürünü \"Hasarlıya taşı\" ile hasarlıya alın ya da SKT'yi düzeltin; SKT'si eksik satıra SKT girin.",
      cancelDraft: "Kabulü iptal et",
      cancelDraftTitle: "Taslak mal kabul iptal edilsin mi?",
      cancelDraftDescription: "Taslak iptal edilir; stok değişmez, irsaliye numarası yeniden kullanılabilir.",
      cancel: "Mal kabulü iptal et",
      cancelTitle: "Kayıtlı mal kabul iptal edilsin mi?",
      cancelDescription:
        "Stoğa giren miktar ters hareketle çıkar. Faturayla eşleşmiş ya da partisi satılmış kabul iptal edilemez.",
      cancelledTitle: "Mal kabul iptal edildi",
      matchedHint: "Bu kabul faturayla eşleşti; iptal için önce eşleşme geri alınmalıdır.",
      provisionalNotice: "Maliyet geçicidir: alış faturasıyla eşleşince kesinleşir.",
      priceSuggestion: "Kabul için fiyat önerisi",
      summary: "Özet",
      reportCaption: "Mal kabul fark raporu",
      fields: {
        receiptNo: "Kabul no",
        despatchNo: "İrsaliye no",
        despatchDate: "İrsaliye tarihi",
        order: "Sipariş",
        cost: "Maliyet",
        expected: "Beklenen",
        received: "Sağlam (kabul)",
        damaged: "Hasarlı",
        short: "Eksik",
        over: "Fazla",
        shortOver: "Eksik / fazla",
        difference: "Fark",
        unitCost: "Birim maliyet",
        finalUnitCost: "Kesin maliyet",
        lineAmount: "Tutar",
        netAmount: "Tutar",
        match: "Fatura eşleşmesi",
        businessDate: "İş günü",
        postedAt: "Kayıt zamanı",
      },
      done: {
        post: "Mal kabul kaydedildi; stoğa girdi",
        cancel: "Mal kabul iptal edildi; stok ters hareketle düzeltildi",
        cancelDraft: "Taslak mal kabul iptal edildi",
      },
      emptyTitle: "Mal kabul yok",
      emptyDescription: "Siparişten ya da serbest bir mal kabul açıp tablette barkod okutarak kabul edin.",
    },
    matches: {
      description:
        "Alış faturasını sipariş ve mal kabullerle eşleştirin: satır bazında miktar ve fiyat farkı, fark raporu ve kesin maliyet.",
      tabsLabel: "Eşleştirme bölümleri",
      tab: {
        matches: "Eşleşmeler",
        new: "Yeni eşleştirme",
      },
      caption: "Fatura eşleşmeleri",
      chooseSupplier: "Tedarikçi seçin",
      pickSupplierTitle: "Tedarikçi seçin",
      pickSupplierDescription:
        "Tedarikçinin eşleşmemiş alış faturaları ve kayıtlı, eşleşmemiş mal kabulleri listelenir.",
      invoicesTitle: "Eşleşmemiş alış faturaları",
      receiptsTitle: "Eşleşmemiş mal kabuller",
      noInvoices: "Bu tedarikçinin eşleşmemiş, kesinleşmiş market alış faturası yok.",
      noReceipts: "Bu tedarikçinin eşleşmemiş kayıtlı mal kabulü yok.",
      selectInvoice: "Fatura seç",
      selectInvoiceLabel: "{{no}} faturasını seç",
      selectReceipts: "Mal kabul seç",
      selectReceiptLabel: "{{no}} mal kabulünü seç",
      receiptsTotal: "Seçilen kabullerin tutarı",
      previewDifference: "Ön fark (fatura − kabul)",
      previewHint:
        "Ön fark yalnızca bilgidir; kesin fark ürün bazında hesaplanır. Faturaya bağlı irsaliye no'suyla aynı kabuller önceden seçilir.",
      problem: {
        invoice: "Bir fatura seçin.",
        receipts: "En az bir mal kabul seçin.",
      },
      match: "Eşleştir",
      noInvoiceNo: "Numarasız fatura",
      system: "Sistem",
      detailTitle: "Fatura eşleşmesi",
      detailTitleWithNo: "Eşleşme — fatura {{no}}",
      summary: "Özet",
      unmatch: "Eşleşmeyi geri al",
      unmatchTitle: "Eşleşme geri alınsın mı?",
      unmatchDescription:
        "Kesin maliyet farkı terslenir, mal kabuller geçici maliyete döner ve yeniden eşleştirilebilir. Gerekçe denetim izine yazılır.",
      unmatchedTitle: "Eşleşme geri alındı",
      pendingHint: "Farklı eşleşme onay bekliyor. Onaylanınca kesin maliyet uygulanır.",
      automaticHint: "Bu eşleşme alış faturası kesinleşince irsaliye no'suyla sistem tarafından kuruldu.",
      costHint:
        "Kesin maliyet farkı: kabuldeki miktarın eldeki payı stok değerine, satılmış payı sonraki SMM kapanışına yazılır.",
      tolerancesValue: "Miktar {{quantity}} · Fiyat {{price}} · Tutar {{amount}}",
      receiptsSection: "Eşleşen mal kabuller",
      receiptActive: "Eşleşmede",
      receiptReleased: "Serbest bırakıldı",
      reportTitle: "Fark raporu",
      reportCaption: "Eşleştirme fark raporu",
      onlyDifferences: "Yalnızca farklı satırlar",
      noDifferences: "Farklı satır yok.",
      productless: "Ürünsüz fatura satırı",
      notInOrder: "Siparişte yok",
      notOrderedHint: "{{count}} fatura satırı sipariş / kabul dışında (nakliye, hizmet bedeli vb.).",
      inconsistent: "Satır farklarının toplamı başlıktaki tutarla uyuşmuyor. Destek ekibine bildirin.",
      approval: "Onay",
      fields: {
        invoice: "Fatura",
        result: "Sonuç",
        receipts: "Mal kabuller",
        despatchNos: "İrsaliye no",
        invoiceNet: "Fatura neti (KDV hariç)",
        payable: "Ödenecek",
        differenceLines: "Farklı satır",
        amountDifference: "Tutar farkı",
        costAdjustment: "Kesin maliyet farkı",
        tolerances: "Toleranslar",
        matchedAt: "Eşleştirme",
        approvedAt: "Onay",
        ordered: "Sipariş",
        received: "Kabul",
        invoiced: "Fatura",
        quantityDifference: "Miktar farkı",
        priceDifference: "Fiyat farkı",
      },
      done: {
        matched: "Fatura eşleştirildi; kesin maliyet uygulandı",
        pending: "Farklı eşleşme onaya gönderildi",
        unmatched: "Eşleşme geri alındı",
      },
      emptyTitle: "Eşleşme yok",
      emptyDescription:
        "Alış faturası kesinleşince irsaliye no'suyla kendiliğinden ya da buradan elle eşleştirilir.",
    },
    prices: {
      description:
        "Ortalama maliyet, KDV ve hedef marja göre satış fiyatı önerisi. Seçilenler fiyat modülünde taslak fiyat talebine dönüşür.",
      belowTargetOnly: "Yalnızca hedefin altındakiler",
      receiptFilter: "Mal kabul {{no}}",
      clearReceipt: "Mal kabul süzgecini kaldır",
      basis: "Öneri = maliyet × (1 + KDV) / (1 − hedef marj), {{roundTo}} adımına yukarı yuvarlanır.",
      caption: "Satış fiyatı önerisi",
      belowTarget: "Marj hedefin altında",
      noPrice: "Fiyat yok",
      priceFor: "{{product}} yeni fiyatı",
      priceProblem: "Fiyat sıfırdan büyük, en fazla 4 ondalıklı olmalıdır.",
      marginSource: {
        CATEGORY: "kategoriden",
        SETTINGS: "ayardan",
      },
      direction: {
        UP: "zam",
        DOWN: "indirim",
      },
      fields: {
        unitCost: "Maliyet",
        vat: "KDV",
        currentPrice: "Güncel fiyat",
        currentMargin: "Güncel marj",
        targetMargin: "Hedef marj",
        suggestedPrice: "Yeni fiyat",
        suggestedMargin: "Önerilen marj",
      },
      skippedTitle: "{{count}} ürün için öneri üretilemedi",
      apply: "Fiyat talebi oluştur ({{count}})",
      applyHint: "Talep taslak olarak açılır; onaya gönderme ve yayın Fiyatlar ekranındadır.",
      fixProblems: "{{count}} satırda fiyat geçersiz.",
      cannotApply: "Fiyat talebi oluşturma yetkiniz yok (fiyat değişikliği yetkisi gerekir).",
      created: "{{no}} fiyat talebi oluşturuldu",
      createdTitle: "Fiyat talebi oluşturuldu",
      openRequest: "{{no}} talebini aç",
      emptyTitle: "Öneri yok",
      emptyDescription:
        "Bu süzgeçte marjı hedefin altında ürün yok. Tüm ürünleri görmek için süzgeci kaldırın.",
    },
    labels: {
      description:
        "Seçilen dönemde fiyatı yürürlüğe giren market ürünleri; raf etiketi ızgarası yazdırılır. Birim fiyat ₺/kg ya da ₺/L.",
      range: "Yürürlük aralığı",
      caption: "Etiket basım listesi",
      missingTitle: "{{count}} üründe net içerik tanımsız",
      missingBody:
        'Bu ürünlerin etiketinde birim fiyat basılamaz ("—"). Ürün kartında net içerik ve birimini girin.',
      missingNetContent: "Net içerik yok",
      preview: "Yazdırma görünümü",
      print: "Etiketleri yazdır",
      sheet: "Raf etiketleri",
      previewHint: "Baskıda yalnızca etiketler basılır.",
      unitPriceLine: "Birim fiyat: {{value}}",
      effective: "Yürürlük {{date}}",
      fields: {
        barcode: "Barkod",
        oldPrice: "Eski fiyat",
        newPrice: "Yeni fiyat",
        unitPrice: "Birim fiyat",
        effectiveAt: "Yürürlük",
      },
      emptyTitle: "Bu dönemde fiyatı değişen ürün yok",
      emptyDescription: "Tarih aralığını genişletin ya da başka bir istasyon seçin.",
    },
    licenses: {
      description:
        "İstasyonun tütün / alkol satış belgeleri ve geçerlilikleri. v1'de satışı engellemez; bitişe yaklaşınca uyarı üretilir.",
      caption: "Satış belgeleri",
      new: "Belge ekle",
      newTitle: "Satış belgesi ekle",
      editTitle: "Satış belgesini düzenle",
      dialogDescription:
        "Belge dosyası (PDF ya da görsel) isteğe bağlıdır. Bitiş boş bırakılırsa süresiz sayılır.",
      warningHint:
        'Bitişine {{days}} gün ya da daha az kalan belge "süresi dolmak üzere" olur (market ayarı).',
      includeInactive: "Pasif belgeleri de göster",
      open: "süresiz",
      daysLeft: "{{count}} gün kaldı",
      daysAgo: "{{count}} gün önce doldu",
      expiresToday: "bugün doluyor",
      file: "Belge",
      downloadLabel: "{{name}} dosyasını indir",
      editLabel: "{{no}} belgesini düzenle",
      activate: "Etkinleştir",
      deactivate: "Pasife al",
      activateLabel: "{{no}} belgesini etkinleştir",
      deactivateLabel: "{{no}} belgesini pasife al",
      activated: "{{no}} etkinleştirildi",
      deactivated: "{{no}} pasife alındı",
      saved: "{{no}} kaydedildi",
      validUntilHint: "Boş = süresiz.",
      fileHint: "PDF ya da görsel yükleyin.",
      uploading: "Yükleniyor…",
      fileAttached: "Ekli dosya: {{name}}",
      fileUploaded: "Belge dosyası yüklendi",
      removeFile: "Dosyayı kaldır",
      problem: {
        documentNo: "Belge numarasını girin.",
        validFrom: "Geçerlilik başlangıcını girin.",
        validUntil: "Bitiş, başlangıçtan önce olamaz.",
      },
      fields: {
        type: "Belge türü",
        documentNo: "Belge no",
        issuer: "Veren kurum",
        issuedOn: "Düzenlenme tarihi",
        validFrom: "Geçerlilik başlangıcı",
        validUntil: "Geçerlilik bitişi",
        validity: "Geçerlilik",
        file: "Belge dosyası",
      },
      emptyTitle: "Satış belgesi yok",
      emptyDescription: "İstasyonun tütün ve alkol satış belgelerini ekleyerek bitiş tarihlerini takip edin.",
    },
    reports: {
      description:
        "Market ciro ve brüt kârı, sepet ortalaması, akaryakıt → market dönüşümü, ölü stok, stok devir hızı ve SKT yaklaşanlar.",
      tabsLabel: "Market raporları",
      tab: {
        sales: "Ciro ve brüt kâr",
        basket: "Sepet ve dönüşüm",
        deadStock: "Ölü stok",
        turnover: "Stok devir hızı",
        expiring: "SKT yaklaşanlar",
      },
      period: "İş günü aralığı",
      groupBy: "Kırılım",
      grouping: {
        STATION: "İstasyon",
        CATEGORY: "Kategori",
        PRODUCT: "Ürün",
      },
      expiringDays: "Gün içinde bitecekler",
      expiringDaysHint: "Boş = istasyonun SKT uyarı günü.",
      includeExpired: "SKT'si geçmişler de",
      totalsTitle: "Dönem toplamı",
      amountAxis: "Tutar (₺)",
      percentAxis: "Oran (%)",
      salesDefinition:
        "Ciro: kasa satışlarının KDV hariç neti (market, madeni yağ, kafe); iade ve iptaller düşülmüştür. SMM: aynı dönemin satış maliyeti. Brüt kâr = ciro − SMM.",
      salesChartTitle: "Ciro ve brüt kâr",
      salesChartTopTitle: "Ciroya göre ilk {{count}} kırılım",
      salesChartAria: "Ciro ve brüt kâr sütun grafiği",
      salesChartTable: "Ciro ve brüt kâr (grafik verisi)",
      salesCaption: "Market ciro ve brüt kâr",
      basketDefinition:
        "Sepet ortalaması: en az bir market satırı olan geçerli (iptal edilmemiş) fişlerin KDV hariç market neti / bu fişlerin sayısı.",
      conversionDefinition:
        "Dönüşüm oranı: akaryakıt satırı olan geçerli fişlerden market satırı da içerenlerin yüzdesi.",
      basketChartTitle: "İstasyon başına sepet ortalaması ve dönüşüm",
      basketChartAria: "Sepet ortalaması ve dönüşüm oranı grafiği",
      basketChartTable: "Sepet ortalaması ve dönüşüm (grafik verisi)",
      basketCaption: "Sepet ortalaması ve dönüşüm",
      deadStockDefinition:
        "Eldeki miktarı sıfırdan büyük olup son satışı istasyonun ölü stok gününden eski (ya da hiç satılmamış) ürünler.",
      deadStockCaption: "Ölü stok",
      neverSold: "Hiç satılmadı",
      daysSince: "{{count}} gün önce",
      turnoverDefinition:
        "Devir hızı = dönem SMM / ortalama stok değeri (dönem başı ve sonu, hareket defterinden). Gün = {{days}} günlük dönem / devir hızı.",
      turnoverCaption: "Stok devir hızı",
      expiringCaption: "SKT yaklaşan partiler",
      expiryState: {
        EXPIRED: "SKT geçti",
        EXPIRING: "Yaklaşıyor",
      },
      asOf: "Tarih",
      fields: {
        quantity: "Net miktar",
        revenue: "Ciro (KDV hariç)",
        cogs: "SMM",
        grossProfit: "Brüt kâr",
        margin: "Brüt marj",
        saleCount: "Fiş",
        marketSaleCount: "Market fişi",
        marketNet: "Market neti",
        averageBasket: "Sepet ortalaması",
        fuelSaleCount: "Akaryakıt fişi",
        fuelWithMarketCount: "Akaryakıt + market",
        conversion: "Dönüşüm oranı",
        lineCount: "Satır",
        deadStockDays: "Ölü stok eşiği (gün)",
        openingValue: "Dönem başı stok",
        closingValue: "Dönem sonu stok",
        averageValue: "Ortalama stok",
        turnover: "Devir hızı",
        daysOnHand: "Stokta kalma (gün)",
        estimatedValue: "Tahmini değer",
      },
      emptyTitle: "Bu süzgeçte veri yok",
      emptyDescription: "Tarih aralığını ya da istasyonu değiştirerek yeniden deneyin.",
    },
    closings: {
      description:
        "İstasyon × iş günü başına satılan malın maliyeti (SMM) fişi. Normalde vardiya gün sonu kendiliğinden kapatır.",
      caption: "Market gün kapanışları",
      range: "İş günü aralığı",
      closeDay: "Günü kapat",
      closeTitle: "Market gününü kapat",
      closeDescription:
        "O günün SMM fişi kesilir. Gün zaten kapandıysa mevcut kapanış döner. Kimliğinizi yeniden doğrulamanız istenir.",
      closed: "Market günü kapatıldı",
      alreadyClosed: "Bu gün zaten kapatılmıştı",
      resultCogs: "SMM {{amount}} ₺ · {{count}} hareket",
      lines: "Satırlar",
      openLines: "{{station}} {{date}} kapanış satırlarını aç",
      linesTitle: "Kapanış satırları",
      noLines: "Bu kapanışta satır yok (günde stok hareketi olmamış).",
      emptyTitle: "Bu aralıkta kapanış yok",
      emptyDescription: "Vardiya gün sonu kapanınca market kapanışı kendiliğinden oluşur.",
      fields: {
        businessDate: "İş günü",
        cogs: "Net SMM",
        movementCount: "Hareket",
        lateMovementCount: "Geç hareket",
        closedAt: "Kapanış zamanı",
        accountingGroup: "Muhasebe grubu",
        saleValue: "Satış maliyeti",
        returnValue: "İade maliyeti",
        lateValue: "Önceki günlerden",
        costAdjustment: "Maliyet düzeltmesi",
      },
    },
    settings: {
      description:
        "Şirket geneli market ayarları ve istasyona özel geçersiz kılmalar; depolar. Değerler işletme tarafından doğrulanmalıdır.",
      tabsLabel: "Market ayar bölümleri",
      tab: {
        settings: "Ayarlar",
        warehouses: "Depolar",
      },
      scope: "Kapsam",
      scopeHint: "İstasyon seçilirse yalnızca o istasyona özel değerler yazılır.",
      companyScope: "Şirket geneli",
      readOnly: "Ayarları görüntüleyebilirsiniz; değiştirmek için market ayarları yetkisi gerekir.",
      isDefaultTitle: "Varsayılan değerler",
      isDefaultBody: "Bu şirkette henüz market ayarı kaydedilmemiş; ürün varsayılanları gösteriliyor.",
      noOverrideBody:
        "Bu istasyona özel ayar yok; şirket değerleri gösteriliyor. Kaydederseniz istasyona özel olur.",
      needsVerificationTitle: "Değerler doğrulanmalı",
      needsVerificationBody: "Eşikler örnek değerlerdir; işletmenize uygun olduğunu doğrulayın.",
      markVerified: "Doğruladım",
      verified: "Doğrulandı",
      conflictTitle: "Ayarlar başka biri tarafından değiştirildi",
      conflictBody: "Son hâli yükleyip değişikliğinizi yeniden yapın.",
      reload: "Yeniden yükle",
      saved: "Market ayarları kaydedildi",
      lossKeyFor: "{{reason}} → kayıp türü",
      sections: {
        stock: "Stok ve SKT",
        writeOff: "Fire / imha",
        count: "Sayım",
        purchase: "Satın alma ve üçlü eşleştirme",
        pricing: "Fiyat önerisi ve belgeler",
      },
      fields: {
        allowNegativeStock: "Negatif stoğa izin ver",
        expiryWarningDays: "SKT uyarı günü",
        deadStockDays: "Ölü stok günü",
        salesVelocityDays: "Satış hızı penceresi (gün)",
        writeOffVatReversal: "Firede KDV düzeltmesi (bilgi)",
        countApprovalThreshold: "Sayım onay eşiği",
        cycleCountStaleDays: "Döngüsel sayım aralığı (gün)",
        matchQuantityTolerancePercent: "Miktar farkı toleransı (%)",
        matchPriceTolerancePercent: "Birim fiyat farkı toleransı (%)",
        matchAmountTolerance: "Satır tutar farkı toleransı",
        defaultTargetMarginPercent: "Varsayılan hedef marj (%)",
        priceRoundTo: "Fiyat yuvarlama adımı (₺)",
        licenseWarningDays: "Satış belgesi uyarı günü",
      },
      hints: {
        allowNegativeStock:
          "Kapalıysa transfer ve fire, stok yetersizse reddedilir. Kasa satışı hiçbir durumda reddedilmez.",
        expiryWarningDays: 'SKT\'ye bu kadar gün kala parti "yaklaşıyor" olarak işaretlenir.',
        deadStockDays: "Bu kadar gündür satılmayan ürün ölü stok raporuna girer.",
        salesVelocityDays: "Sipariş önerisinde satış hızı son bu kadar günden hesaplanır.",
        writeOffVatReversal:
          "Firede indirilen KDV'nin düzeltilmesi mevzuat sorusudur; v1'de yalnızca bilgi olarak tutulur, fiş üretmez.",
        countApprovalThreshold: "Sayım net farkı bu tutarı aşarsa onay motoru devreye girer.",
        cycleCountStaleDays: "Döngüsel sayımda bu kadar gündür sayılmayan ürünler önerilir.",
        matchQuantityTolerancePercent:
          "Sipariş – irsaliye – fatura miktar farkı bu oranı aşarsa eşleşme onay ister.",
        matchPriceTolerancePercent: "Birim fiyat farkı bu oranı aşarsa eşleşme onay ister.",
        matchAmountTolerance: "Satır tutar farkının mutlak toleransı.",
        defaultTargetMarginPercent: "Kategoride hedef marj yoksa satış fiyatı önerisi bunu kullanır.",
        priceRoundTo: "Satış fiyatı önerisi bu adıma yukarı yuvarlanır (ör. 0,25).",
        licenseWarningDays: "Tütün / alkol satış belgesinin bitişine bu kadar gün kala uyarı verilir.",
      },
    },
    warehouses: {
      title: "Depolar",
      description:
        "Kasa satışı istasyonun varsayılan deposundan düşer. Stoğu olan ya da varsayılan depo pasife alınamaz.",
      add: "Depo ekle",
      addTitle: "Depo ekle",
      editTitle: "Depoyu düzenle",
      editLabel: "{{code}} deposunu düzenle",
      empty: "Bu istasyonda depo yok. İlk belge ya da kasa satışında varsayılan depo kendiliğinden açılır.",
      default: "Varsayılan",
      makeDefault: "Varsayılan yap",
      makeDefaultLabel: "{{code}} deposunu varsayılan yap",
      activateLabel: "{{code}} deposunu etkinleştir",
      deactivateLabel: "{{code}} deposunu pasife al",
      codeHint: "1–20 karakter; büyük harf, rakam, - ve _ (ör. ARKA).",
      codeLocked: "Depo kodu değiştirilemez.",
      isDefault: "Varsayılan depo olsun",
      isDefaultHint: "Kasa satışı bundan sonra bu depodan düşer.",
      saved: "Depo kaydedildi",
      fields: {
        code: "Kod",
        name: "Ad",
        kind: "Tür",
      },
    },
  },
  customers: {
    masking: {
      badge: "maskeli",
      title: "Kişisel veriler maskeli gösteriliyor",
      description:
        "Ad, telefon, e-posta ve plaka bu hesapta maskelidir (KVKK — veri minimizasyonu). Açık görmek için “Müşterinin kişisel verilerini açık görüntüleme” izni gerekir.",
    },
    disabledTitle: "Müşteri ve sadakat modülü kapalı",
    disabledDescription:
      "Bu hesapta “Filo ve sadakat” modülü açık değil. Açılması için platform yöneticinizle görüşün.",
    noPermission: "Müşterileri görüntüleme yetkiniz yok.",
    fields: {
      code: "Kod",
      fullName: "Ad soyad",
      phone: "Telefon",
      email: "E-posta",
      cardNo: "Kart no",
      homeStation: "Ana istasyon",
      counterparty: "Cari",
      driverApp: "Müşteri uygulaması",
      notes: "Not",
    },
    driver: { linked: "Bağlı", notLinked: "Bağlı değil" },
    tabs: {
      overview: "Özet",
      loyalty: "Sadakat",
      vehicles: "Araçlar",
      consents: "Rızalar ve ileti izinleri",
      link: "Müşteri uygulaması",
    },
    list: {
      description:
        "Sadakat kartı, araç ya da telefonla tanınan müşteriler. Profil tüm istasyonlarda geçerlidir; kart her istasyonda okunur.",
      caption: "Müşteriler",
      new: "Yeni müşteri",
      searchPlaceholder: "Ad, telefon, kart no, kod ya da plaka",
      searchHint: "Aramak için en az 2 karakter girin.",
      emptyTitle: "Henüz müşteri yok",
      emptyDescription: "Müşteriler kasada, istasyonda ya da buradaki “Yeni müşteri” düğmesiyle açılır.",
      emptyFilteredTitle: "Aramaya uyan müşteri yok",
      emptyFilteredDescription: "Arama metnini ya da süzgeçleri değiştirip yeniden deneyin.",
    },
    form: {
      nameOrPhone: "Ad soyad ya da telefondan en az biri girilmelidir.",
      phoneHint:
        "Türkiye numarası E.164 biçimine çevrilir (+90…). Aynı telefonla ikinci etkin müşteri açılamaz.",
      homeStationHint: "Müşterinin en sık geldiği istasyon; yazma yetkisi bu istasyona göre denetlenir.",
      noHomeStation: "Ana istasyon yok",
      notesHint: "Kişisel veridir; yalnızca gerekliyse yazın (KVKK).",
      issueCard: "Sadakat kartı numarası üret",
      issueCardHint: "Kasa, kartı ya da müşteri uygulamasındaki QR'ı bu numarayla tanır.",
      personalLocked: "Kişisel veriler maskeli olduğu için bu alan düzenlenemez.",
    },
    create: {
      title: "Yeni müşteri",
      description:
        "Müşteri profilini açın; isterseniz aynı anda aydınlatma, açık rıza ve ticari ileti izinlerini kaydedin.",
      noPermission: "Müşteri açma yetkiniz yok.",
      profile: "Profil",
      submit: "Müşteriyi aç",
      created: "{{code}} kodlu müşteri açıldı",
      consentFailed:
        "{{code}} kodlu müşteri açıldı ancak {{count}} rıza / ileti izni kaydı yazılamadı. Rızalar sekmesinden yeniden kaydedin.",
      consents: {
        title: "İlk rıza ve ileti izinleri (isteğe bağlı)",
        description:
          "Yalnızca müşterinin gerçekten verdiği kararları işaretleyin. Kayıtlar yayımdaki metin sürümüne bağlanır ve değiştirilemez.",
        channel: "Rızanın alındığı kanal",
        channelHint: "Kararın nerede alındığı kanıt olarak kaydedilir.",
        noticeLegend: "Aydınlatma metni",
        noticeAcknowledged: "Müşteri aydınlatma metnini okudu",
        explicitLegend: "Açık rıza",
        explicitGranted: "Açık rıza verildi: {{purpose}}",
        messageLegend: "Ticari elektronik ileti izni",
        messageHint: "İzin kanal başına verilir ve İYS'ye gönderilir. Onay metni: {{text}}",
        messageChannel: "{{channel}} ile ileti izni verildi",
        noNotice: "Yayımda aydınlatma metni yok; “okundu” kaydı için önce metni yayımlayın.",
        noExplicit: "Yayımda açık rıza metni yok; rıza kaydı için önce metni yayımlayın.",
        noCommercial:
          "Yayımda ticari elektronik ileti onay metni yok; ileti izni vermek için önce metni yayımlayın.",
        noReadPermission:
          "KVKK metinlerini görüntüleme yetkiniz olmadığı için ilk rızalar buradan kaydedilemez.",
        textsLink: "KVKK metinlerine git",
        askPrivacyAdmin: "Metni KVKK yetkilisi yayımlar.",
      },
    },
    detail: {
      title: "Müşteri",
      tabsLabel: "Müşteri bölümleri",
      noCard: "Kart yok",
      anonymizedTitle: "Müşteri anonimleştirildi",
      anonymizedDescription:
        "Kişisel veriler {{at}} tarihinde KVKK başvurusuyla silindi. Kayıt yalnızca geçmiş için tutulur; düzenlenemez ve yeni karar yazılamaz.",
      editTitle: "Müşteriyi düzenle",
      editDescription: "Yalnızca değiştirdiğiniz alanlar kaydedilir.",
      updated: "Müşteri güncellendi",
      conflict: "Kayıt siz düzenlerken başka biri tarafından değiştirildi. Pencereyi kapatıp yeniden açın.",
      deactivateTitle: "Müşteri pasife alınsın mı?",
      deactivateDescription:
        "Pasif müşteri kasada tanınmaz ve kartı / QR'ı geçmez. Kayıt ve geçmişi silinmez; yeniden etkinleştirilebilir.",
      reactivate: "Yeniden etkinleştir",
      reactivateTitle: "Müşteri yeniden etkinleştirilsin mi?",
      reactivateDescription:
        "Müşteri kasada yeniden tanınır. Aynı telefonla etkin başka bir müşteri varsa etkinleştirme reddedilir.",
      reason: "Gerekçe (isteğe bağlı)",
      reasonHint: "Denetim izine yazılır.",
      reasonTooShort: "Gerekçe en az 3 karakter olmalıdır",
      deactivated: "Müşteri pasife alındı",
      reactivated: "Müşteri yeniden etkinleştirildi",
      reissueCard: "Kartı yeniden bas",
      issueCard: "Kart numarası üret",
      reissueTitle: "Kart yeniden basılsın mı?",
      reissueDescription:
        "Müşteriye yeni kart numarası verilir. Eski kart numarası ({{cardNo}}) artık tanınmaz; kasada okutulursa müşteri bulunamaz.",
      issueTitle: "Kart numarası üretilsin mi?",
      issueDescription: "Müşteriye sadakat kartı numarası verilir; kasa kartı bu numarayla tanır.",
      cardReissued: "Yeni kart numarası verildi",
    },
    overview: {
      period: "Dönem",
      periods: {
        p30: "Son 30 gün",
        p90: "Son 90 gün",
        p365: "Son 1 yıl",
        p1095: "Son 3 yıl",
      },
      periodRange: "{{from}} – {{to}}",
      summary: "Müşteri 360",
      totalSpending: "Toplam net harcama",
      saleCount: "Satış sayısı",
      returnCount: "İade / iptal sayısı",
      visits: "Ziyaret",
      visitsValue: "{{visits}} gün · ayda ort. {{perMonth}}",
      firstVisit: "İlk ziyaret",
      lastVisit: "Son ziyaret",
      preferredStation: "Tercih ettiği istasyon",
      preferredStationValue: "{{station}} ({{visits}} ziyaret)",
      loyalty: "Puan / seviye",
      points: "{{points}} puan",
      pendingPoints: "{{points}} puan beklemede",
      noTier: "Seviye yok",
      noLoyalty: "Sadakat hesabı yok",
      vehicleCount: "Araç sayısı",
      subscriptionCount: "Etkin abonelik",
      byBusinessUnit: "İş birimine göre harcama",
      chartLabel: "Müşterinin iş birimine göre net harcama grafiği",
      businessUnit: "İş birimi",
      netSpending: "Net harcama",
      amountAxis: "₺",
      lineCount: "Satır sayısı",
      otherUnit: "Diğer",
      noSpendingTitle: "Bu dönemde harcama yok",
      noSpendingDescription: "Müşteriye bağlı kasa kaydı bulunmuyor. Başka bir dönem seçebilirsiniz.",
      subscriptions: "Abonelikler",
      noSubscriptions: "Etkin abonelik yok.",
      plan: "Plan",
      currentPeriod: "Geçerli dönem",
      consentSummary: "Rıza özeti",
      explicitConsents: "Açık rızalar",
      messagePermissions: "Ticari ileti izni",
    },
    vehicles: {
      title: "Araçlar",
      add: "Araç ekle",
      newTitle: "Yeni araç",
      editTitle: "Aracı düzenle",
      dialogDescription:
        "Plaka etkin araçlar arasında tektir; kasa aracı plakayla ya da TTS etiketiyle tanır. Plaka kişisel veridir (KVKK).",
      plate: "Plaka",
      plateHint: "Örnek: 34 ABC 123",
      fuel: "Yakıt",
      noFuel: "Belirtilmedi",
      connector: "Şarj soketi",
      noConnector: "Yok",
      brand: "Marka",
      model: "Model",
      modelYear: "Model yılı",
      vehicle: "Marka / model / yıl",
      created: "Araç eklendi",
      updated: "Araç güncellendi",
      deactivated: "Araç pasife alındı",
      reactivated: "Araç etkinleştirildi",
      conflict: "Araç siz düzenlerken başka biri tarafından değiştirildi. Pencereyi kapatıp yeniden açın.",
      editFor: "Düzenle — {{plate}}",
      deactivateFor: "Pasife al — {{plate}}",
      reactivateFor: "Etkinleştir — {{plate}}",
      emptyTitle: "Kayıtlı araç yok",
      emptyDescription: "Araç eklenince kasa müşteriyi plakasından da tanır.",
      inactiveCustomer: "Pasif müşteriye araç eklenemez; önce müşteriyi yeniden etkinleştirin.",
    },
    consents: {
      noPermission:
        "Rıza ve ileti izni kayıtlarını görüntüleme yetkiniz yok (müşteri okuma ya da KVKK okuma izni gerekir).",
      anonymized:
        "Müşteri anonimleştirildi: kayıtlar hukuki dayanağın kanıtı olarak saklanır, yeni karar yazılamaz.",
      currentTitle: "Güncel durum",
      recordDecision: "Yeni karar kaydet",
      recordPermission: "İleti izni kaydet",
      noticeAcknowledged: "Okundu",
      noticeNeedsRefresh: "Yeni sürüm okutulmalı",
      noticeMissing: "Okunmadı",
      needsRefreshHint:
        "Aydınlatma metninin yeni sürümü yayımlandı. Müşteriye yeni sürümü okutup “okundu” kaydı yazın.",
      messageTitle: "Ticari ileti izni (kanal başına)",
      permissionNone: "Kayıt yok",
      permissionGranted: "Verildi",
      permissionDecision: { GRANTED: "Verildi", REVOKED: "Geri alındı" },
      explicitTitle: "Açık rıza ve ticari ileti onayları",
      noneRecorded: "Kayıt yok.",
      kindPurpose: "Amaç / tür",
      decision: "Karar",
      inForce: "Yürürlükte",
      channel: "Kanal",
      recordedAt: "Kayıt zamanı",
      recordedBy: "Kaydeden",
      byStaff: "Personel",
      byDriver: "Müşteri (uygulama)",
      evidence: "Kanıt",
      evidenceAttached: "Dosya var",
      evidenceDownload: "İndir",
      evidenceDownloadFor: "Kanıt dosyasını indir — {{time}} kaydı",
      evidenceOpen: "Dosyayı aç",
      evidenceExpires: "Bağlantı {{time}} saatine kadar geçerli",
      text: "Metin",
      textVersion: "{{title}} (sürüm {{revision}})",
      historyTitle: "Rıza ve aydınlatma geçmişi",
      historyEmpty: "Henüz rıza ya da aydınlatma kaydı yok.",
      permissionHistoryTitle: "İleti izni geçmişi",
      permissionHistoryEmpty: "Henüz ileti izni kaydı yok. Kayıt yoksa izin YOKTUR.",
      messageChannel: "İleti kanalı",
      sourceChannel: "Alındığı kanal",
      iys: "İYS durumu",
      decisionTitle: "Yeni rıza kararı",
      decisionDescription:
        "Karar yayımdaki metin sürümüne yazılır ve değiştirilemez. Yürürlükten kalkmış sürüme verilmiş rıza da geri alınabilir.",
      choice: "{{head}} · {{title}} (sürüm {{revision}})",
      retiredSuffix: "— yürürlükten kalktı",
      retiredHint: "Yürürlükten kalkmış sürüm: yalnızca geri alma kaydedilebilir.",
      note: "Not",
      evidenceFile: "Kanıt dosyası (isteğe bağlı)",
      evidenceHint: "İmzalı form ya da tebliğ kanıtı: PDF, JPEG, PNG ya da WEBP, en çok 10 MB.",
      noTexts: "Karar yazılabilecek yayımda metin yok.",
      recorded: "Karar kaydedildi",
      permissionTitle: "Ticari ileti izni",
      permissionDescription:
        "İzin kanal başına verilir ya da geri alınır ve İYS'ye gönderilir. İzin verme yayımdaki ticari ileti onay metnine bağlanır.",
      permissionRecorded: "İleti izni kaydedildi",
    },
    link: {
      title: "Müşteri uygulaması bağlantısı",
      description:
        "Müşteri, QR'ı ya da SMS'le gelen bağlantıyı müşteri uygulamasından açıp aydınlatma metnini ve bağlantı rızasını kabul ederek bu profile bağlanır.",
      inactive: "Yalnızca etkin müşteri müşteri uygulamasına bağlanabilir.",
      alreadyLinked:
        "Müşteri bir uygulama hesabına bağlı. Yeni davet için bağın önce müşteri uygulamasından koparılması gerekir.",
      replacesOpen:
        "Yeni davet, bu müşterinin açık davetlerini iptal eder. Davet 15 dakika geçerlidir ve tek kullanımlıktır.",
      createQr: "Bağlantı daveti oluştur (QR)",
      sendSms: "SMS ile gönder",
      noPhone: "Profilde telefon olmadığı için SMS gönderilemez; QR daveti kullanın.",
      created: "Bağlantı daveti oluşturuldu",
      smsSent: "Davet SMS ile gönderildi: {{to}}",
      qrAlt: "{{code}} müşterisinin bağlantı daveti QR kodu",
      deepLink: "Derin bağlantı",
      copyFailed: "Bağlantı kopyalanamadı; metni seçip elle kopyalayın.",
      expiresAt: "Son geçerlilik",
      remaining: "Kalan süre",
      expired: "Süresi doldu",
      singleUse: "Bağlantı tek kullanımlıktır; müşteri bağlanınca ya da süre dolunca geçersizleşir.",
    },
  },
  privacy: {
    noPermission: "Bu sayfayı görüntüleme yetkiniz yok. Yöneticinizden KVKK iznini isteyin.",
    deadline: {
      left: "{{count}} gün kaldı",
      today: "Son gün bugün",
      overdue: "{{count}} gün geçti",
    },
    customerPicker: {
      placeholder: "Ad, telefon, kart no, kod ya da plakayla arayın",
      results: "Müşteri arama sonuçları",
      noName: "(adsız)",
      anonymized: "anonim",
      empty: "Eşleşen müşteri yok",
      minLength: "Aramak için en az {{count}} karakter yazın",
      selected: "Seçilen müşteriler",
      remove: "{{code}} müşterisini listeden çıkar",
    },
    validation: {
      purposeRequired: "Açık rıza metninde amaç kodu zorunludur",
      purposeFormat: "Amaç kodu büyük harfle başlar; büyük harf, rakam ve _ içerir (ör. LOYALTY_PROFILING)",
      titleTooShort: "Başlık en az 3 karakter olmalıdır",
      titleTooLong: "Başlık en çok 200 karakter olabilir",
      bodyTooShort: "Metin en az 20 karakter olmalıdır",
      bodyTooLong: "Metin izin verilen uzunluğu aşıyor",
      bodyRequired: "İleti metni zorunludur",
      nameTooShort: "Başvuranın adı en az 2 karakter olmalıdır",
      nameTooLong: "Başvuranın adı en çok 160 karakter olabilir",
      contactTooShort: "İletişim bilgisi en az 3 karakter olmalıdır",
      contactTooLong: "İletişim bilgisi en çok 254 karakter olabilir",
      receivedRequired: "Başvurunun alındığı anı girin",
      receivedInvalid: "Geçerli bir tarih ve saat girin",
      receivedFuture: "Başvuru tarihi ileri bir tarih olamaz",
      descriptionTooShort: "Açıklama en az 5 karakter olmalıdır",
      descriptionTooLong: "Açıklama en çok 4.000 karakter olabilir",
      responseTooShort: "Yanıt en az 5 karakter olmalıdır",
      responseTooLong: "Yanıt en çok 4.000 karakter olabilir",
      subjectRequired: "E-posta iletisinde konu zorunludur",
      subjectTooLong: "Konu en çok 200 karakter olabilir",
      recipientsRequired: "En az bir müşteri seçin ya da segmenti kullanın",
      recipientsTooMany: "Bir gönderimde en çok 1.000 alıcı olabilir",
      retentionInvalid: "Gün sayısını tam sayı olarak girin",
      retentionRange: "Saklama süresi 1 ile 3.650 gün arasında olmalıdır",
      senderTooShort: "Gönderici adı en az 2 karakter olmalıdır (ya da boş bırakın)",
      senderTooLong: "Gönderici adı en çok 40 karakter olabilir",
    },
    texts: {
      description:
        "Aydınlatma, açık rıza ve ticari ileti onayı metinleri sürümlüdür. Yayımlanan metin değiştirilemez; yeni sürüm yayımlanınca eskisi yürürlükten kalkar.",
      newDraft: "Yeni taslak",
      newVersion: "Yeni sürüm",
      emptyTitle: "Henüz KVKK metni yok",
      emptyDescription:
        "Müşterilerden rıza alabilmek için önce aydınlatma metnini, gerekiyorsa açık rıza ve ticari ileti onayı metinlerini yazıp yayımlayın.",
      noMatchTitle: "Süzgeçle eşleşen metin yok",
      noMatchDescription: "Tür, amaç ya da durum süzgecini değiştirin.",
      currentRevision: "Yürürlükte: v{{revision}}",
      noCurrent: "Yürürlükte sürüm yok",
      historyCaption: "{{group}} — sürüm geçmişi",
      view: "Görüntüle",
      publish: "Yayımla",
      publishTitle: "v{{revision}} sürümünü yayımla",
      publishConfirmCurrent:
        "Yayımlanan metin DEĞİŞTİRİLEMEZ; aynı tür ve amaçtaki yürürlükteki sürüm (v{{revision}}) aynı anda yürürlükten kalkar.",
      publishConfirmFirst:
        "Yayımlanan metin DEĞİŞTİRİLEMEZ. Bu tür ve amaçta yürürlükte bir sürüm yok; bu sürüm ilk yürürlükteki metin olur.",
      published: "v{{revision}} yayımlandı",
      created: "Taslak kaydedildi (v{{revision}})",
      updated: "Taslak güncellendi (v{{revision}})",
      immutable: "Yayımlanmış metin değiştirilemez; yeni bir sürüm açın.",
      draftConflict:
        "Bu tür ve amaçta yayımlanmamış bir taslak zaten var. Yeni taslak açmak yerine o taslağı düzenleyin ya da yayımlayın.",
      versionConflict:
        "Taslak siz düzenlerken başka biri tarafından değiştirildi. Pencereyi kapatıp yeniden açın.",
      draftExistsTitle: "Bu metnin bir taslağı zaten var",
      draftExists:
        "Aynı tür ve amaçta yayımlanmamış v{{revision}} taslağı var; tür + amaç başına en çok bir taslak olabilir. O taslağı düzenleyin ya da yayımlayın.",
      newTitle: "Yeni metin taslağı",
      newVersionTitle: "Yeni sürüm taslağı",
      editTitle: "v{{revision}} taslağını düzenle",
      dialogDescription:
        "Taslak yayımlanana kadar düzenlenebilir. Sürüm numarası kayıtta verilir (aynı tür ve amaçta en büyük + 1).",
      createDraft: "Taslağı kaydet",
      saveDraft: "Değişiklikleri kaydet",
      viewTitle: "{{title}} (v{{revision}})",
      viewDescription: "Salt okunur görünüm — yayımlanmış metin değiştirilemez.",
      languages: {
        tr: "Türkçe",
        en: "İngilizce",
      },
      fields: {
        kind: "Metin türü",
        group: "Tür ve amaç",
        purpose: "Amaç",
        purposeHint: "Açık rıza hangi amaç için alınıyor? Her amaç ayrı sürümlenir.",
        purposeChoose: "Amaç seçin",
        purposeCustom: "Diğer — özel amaç kodu",
        customPurpose: "Özel amaç kodu",
        customPurposeHint: "Büyük harf, rakam ve _ (ör. KAMERA_KAYDI). Kayıttan sonra değişmez.",
        title: "Başlık",
        language: "Dil",
        body: "Metin",
        bodyHint:
          "En az {{min}} karakter ({{count}} karakter yazıldı). Paragraflar ve satır sonları korunur.",
        revision: "Sürüm",
        publishedAt: "Yayımlandı",
        retiredAt: "Yürürlükten kalktı",
        updatedAt: "Son değişiklik",
      },
    },
    requests: {
      description:
        "İlgili kişi başvuruları (KVKK md. 11) son gün takibiyle. Son gün, alındığı günden itibaren mevzuat süresinin (varsayılan 30 gün) son günüdür.",
      new: "Başvuru kaydet",
      caption: "KVKK başvuruları",
      emptyTitle: "Başvuru yok",
      emptyDescription: "Elden, e-postayla ya da KEP ile gelen başvuruları “Başvuru kaydet” ile kaydedin.",
      deadlineHint: "Son gün süzgeci yalnızca açık (alındı / işlemde) başvuruları gösterir.",
      created: "{{requestNo}} numaralı başvuru kaydedildi",
      newTitle: "Başvuru kaydet",
      newDescription:
        "Başvuran kayıtlı bir müşteriyse bağlayın: veri dökümü ve anonimleştirme yalnızca müşteriye bağlı başvuruda yapılabilir.",
      save: "Başvuruyu kaydet",
      erasureUnlinkedHint:
        "Silme başvurusu kayıtlı bir müşteriye bağlanmazsa anonimleştirme yapılamaz ve başvuru yalnızca reddedilebilir.",
      detailTitle: "Başvuru",
      infoTitle: "Başvuru bilgileri",
      notLinked: "Kayıtlı müşteriye bağlı değil",
      actionsTitle: "İşlemler",
      stepUpHint: "Başvuruyu işleme adımları kimliğinizi yeniden doğrulamanızı isteyebilir.",
      start: "İşleme al",
      export: "Veri dökümü oluştur",
      reexport: "Dökümü yeniden oluştur",
      download: "Dökümü indir",
      anonymize: "Anonimleştir",
      complete: "Tamamla",
      reject: "Reddet",
      completeBlocked: {
        notAnonymized:
          "Silme başvurusu, kişisel veriler anonimleştirilmeden tamamlanamaz. Önce “Anonimleştir”i kullanın.",
        erasureUnlinked:
          "Bu silme başvurusu kayıtlı bir müşteriye bağlı değil; anonimleştirilemediği için tamamlanamaz, yalnızca reddedilebilir.",
      },
      unlinkedHint:
        "Başvuru kayıtlı bir müşteriye bağlı değil: veri dökümü ve anonimleştirme yapılamaz, yalnızca yanıtlanabilir.",
      noProcessPermission: "Başvuruyu işlemek için “İlgili kişi başvurusunu işleme” izni gerekir.",
      downloadReady: "Veri dökümü indirmeye hazır",
      downloadOpen: "Dökümü indir (JSON)",
      downloadExpires:
        "Bağlantı kısa ömürlüdür (geçerlilik sonu: {{time}}). Her indirme denetim izine yazılır.",
      recordTitle: "Sonuç ve kayıtlar",
      exportReady: "Oluşturuldu",
      exportNone: "Yok",
      anonymizeTitle: "Kişisel verileri anonimleştir",
      anonymizeDescription:
        "Bu işlem GERİ ALINAMAZ. Müşteri profili silinmez ama kişisel alanları boşalır; araç plakaları geri döndürülemez bir takma ada döner.",
      anonymizeEffects: {
        profile:
          "Ad, telefon, e-posta ve not boşalır; müşteri uygulaması bağlantısı kesilir, profil “anonim” olur.",
        vehicles: "Araç plakaları takma ada (ANON…) döner, araçlar pasife alınır.",
        loyalty: "Sadakat puanı harcamaya kapatılır; kullanılmamış kuponlar iptal edilir.",
        legal: "Yasal saklama süresindeki satış, fatura ve fiş kayıtları DEĞİŞMEZ.",
        irreversible: "Anonimleştirilen veri geri getirilemez.",
      },
      anonymizeResultTitle: "Anonimleştirme sonucu",
      anonymizeAffected: "{{affected}} kayıt anonimleştirildi.",
      anonymizeModules: "Modül bazında anonimleştirilen kayıtlar",
      anonymizeLegalNote:
        "Rıza ve ileti izni defterleri işlemenin hukuki dayanağının kanıtıdır ve kişisel alan içermez; değişmez.",
      modules: {
        customers: "Müşteriler ve araçlar",
        fleet: "Filo kullanımı",
        loyalty: "Sadakat (puan ve kuponlar)",
        privacy: "KVKK kayıtları",
      },
      versionConflict: "Başvuru siz işlem yaparken değişti. Sayfa güncellendi; yeniden deneyin.",
      completeTitle: "Başvuruyu tamamla",
      completeDescription:
        "Başvurana verilen yanıtı yazın. Tamamlanan başvuru kapanır ve yanıt kayıtta saklanır.",
      rejectTitle: "Başvuruyu reddet",
      rejectDescription:
        "Ret gerekçesini başvurana verilecek yanıt olarak yazın. Reddedilen başvuru kapanır.",
      workflow: "Başvuru iş akışı",
      stepState: {
        done: "tamamlandı",
        current: "şu anki adım",
        upcoming: "sıradaki adım",
        skipped: "atlandı ya da bilinmiyor",
      },
      done: {
        start: "Başvuru işleme alındı",
        export: "Veri dökümü oluşturuldu",
        anonymize: "Kişisel veriler anonimleştirildi",
        complete: "Başvuru tamamlandı",
        reject: "Başvuru reddedildi",
      },
      fields: {
        requestNo: "Başvuru no",
        requestType: "Başvuru türü",
        subject: "Başvuran",
        subjectName: "Başvuranın adı",
        subjectContact: "İletişim (yanıt adresi)",
        subjectContactHint: "E-posta, KEP ya da posta adresi. Kişisel veridir.",
        channel: "Kanal",
        receivedAt: "Alındı",
        receivedAtHint: "Başvurunun ulaştığı an; ileri bir tarih olamaz. Son gün buna göre hesaplanır.",
        dueAt: "Son gün",
        deadline: "Son gün durumu",
        completedAt: "Kapanış",
        identityVerified: "Başvuranın kimliği doğrulandı",
        customer: "Kayıtlı müşteri",
        customerHint: "İsteğe bağlı. Döküm ve anonimleştirme bu müşterinin verisi üzerinde yapılır.",
        description: "Başvuru metni",
        descriptionHint: "Başvurudaki talebin özeti (en az 5 karakter). Kişisel veridir.",
        export: "Veri dökümü",
        anonymizedAt: "Anonimleştirildi",
        createdAt: "Kayıt",
        response: "Yanıt",
        rejectResponse: "Ret gerekçesi (yanıt)",
        responseHint: "En az 5 karakter. Başvurana iletilen yanıt olarak saklanır.",
        module: "Modül",
        affected: "Kayıt",
      },
    },
    marketing: {
      description:
        "Pazarlama SMS'i ve e-postası yalnızca buradan gider. İleti izni gönderim anında her alıcı için denetlenir; izni olmayana gitmez.",
      formTitle: "Yeni ileti",
      modes: {
        CUSTOMERS: "Seçili müşteriler",
        SEGMENT: "Segment: tüm etkin müşteriler",
      },
      permissionNote:
        "İzin gönderim ANINDA denetlenir: ileti izni olmayan, iletişim bilgisi olmayan ya da anonimleştirilmiş alıcıya ileti gitmez ve günlüğe gerekçesiyle yazılır.",
      send: "Gönder…",
      confirmSend: "Gönder",
      confirmTitle: "Pazarlama iletisini gönder",
      confirmDescription:
        "İleti izni gönderim ANINDA her alıcı için defterden denetlenir; izinsiz alıcıya ileti GİTMEZ. Gönderilen ileti geri alınamaz.",
      recipientsCustomers: "{{count}} seçili müşteri",
      recipientsSegment: "Tüm etkin müşteriler (en çok 1.000)",
      recipientsSegmentStation: "{{station}} ana istasyonlu etkin müşteriler (en çok 1.000)",
      sent: "Gönderim tamamlandı: {{total}} alıcı değerlendirildi",
      rateLimited:
        "Kısa sürede çok fazla gönderim yapıldı (dakikada en çok 10). Bir dakika bekleyip yeniden deneyin.",
      resultTitle: "Gönderim sonucu",
      summary: {
        SENT: "Gönderildi",
        SKIPPED_NO_PERMISSION: "İzin yok",
        SKIPPED_NO_CONTACT: "İletişim yok",
        SKIPPED_ANONYMIZED: "Anonim",
        FAILED: "Hata",
      },
      inconsistent: "Sayıların toplamı alıcı sayısını tutmuyor; günlüğü kontrol edin.",
      batchCaption: "Bu gönderimin günlüğü",
      noLogPermission: "Gönderim günlüğünü görmek için KVKK görüntüleme izni gerekir.",
      logTitle: "Gönderim günlüğü",
      logCaption: "Pazarlama iletisi günlüğü",
      emptyTitle: "Kayıt yok",
      emptyDescription: "Gönderilen ya da izin nedeniyle gönderilmeyen iletiler burada listelenir.",
      fields: {
        channel: "Kanal",
        subject: "Konu",
        body: "İleti metni",
        smsCounter: "{{count}} / {{max}} karakter",
        bodyHint: "En çok {{max}} karakter.",
        recipients: "Alıcılar",
        addCustomer: "Müşteri ekle",
        selectedCount: "{{count}} müşteri seçildi (en çok 1.000).",
        homeStation: "Ana istasyon (isteğe bağlı)",
        allStations: "Tüm istasyonlar",
        segmentHint:
          "Etkin müşterilerden en çok 1.000 alıcı; daha fazlası reddedilir, daha dar bir segment seçin.",
        createdAt: "Zaman",
        customer: "Müşteri",
        content: "İçerik",
        reason: "Gerekçe",
        providerRef: "Sağlayıcı no",
      },
    },
    settings: {
      description:
        "Plaka okuma / TTS kayıtlarının saklama süresi ve pazarlama iletisinde görünen gönderici adı. Süre dolan okumalar her gece fiziksel olarak imha edilir.",
      title: "Saklama ve gönderim",
      defaultBadge: "Varsayılan değerler — henüz kaydedilmedi",
      updatedAt: "Son değişiklik",
      readOnly: "Bu ayarları yalnızca görüntüleyebilirsiniz; değiştirmek için KVKK yönetim izni gerekir.",
      conflict:
        "Ayarlar siz düzenlerken başka biri tarafından değiştirildi. Güncel değerler yüklendi; yeniden kaydedin.",
      retentionDays: "Plaka okuma / TTS saklama süresi (gün)",
      retentionHint: "{{min}}–{{max}} gün. Varsayılan {{default}} gün.",
      senderName: "Pazarlama gönderici adı",
      senderNameHint: "SMS başlığında görünür (2–40 karakter). Boş bırakılabilir.",
      verifyTitle: "Süre doğrulanmalı",
      verifyBody:
        "Varsayılan 30 günlük saklama süresi bir öneridir; kişisel veri saklama ve imha politikanıza göre hukuk danışmanınızla doğrulayın.",
    },
  },
  fleet: {
    disabledTitle: "Filo modülü kapalı",
    disabledDescription:
      "Müşteri, filo ve sadakat modülü bu hesabın planında açık değil. Açmak için hesap yöneticinizle görüşün.",
    noPermission: "Filo ekranlarını görmek için yetkiniz yok.",
    conflict: "Kayıt başka bir kullanıcı tarafından değiştirilmiş. Sayfayı yenileyip yeniden deneyin.",
    accountStatus: { ACTIVE: "Etkin", SUSPENDED: "Askıda", UNCONFIGURED: "Filo ayarı yok" },
    requestStatus: { PENDING: "Bekliyor", APPROVED: "Onaylandı", REJECTED: "Reddedildi" },
    tagStatus: { ACTIVE: "Etkin", LOST: "Kayıp", INACTIVE: "Pasif" },
    tabs: {
      general: "Genel",
      rules: "Kurallar",
      vehicles: "Araçlar",
      drivers: "Sürücüler",
      tags: "TTS etiketleri",
      usage: "Kullanım",
      statement: "Ekstre",
      billing: "Dönem faturaları",
      portal: "Portal kullanıcıları",
    },
    detail: { tabsLabel: "Filo hesabı bölümleri" },
    fields: {
      counterparty: "Filo carisi",
      billingCycle: "Fatura dönemi",
      portal: "Filo portalı",
      activeVehicles: "Etkin araç",
      activeTags: "Etkin etiket",
      notes: "Not",
      vehicle: "Araç",
      plate: "Plaka",
      fuelProduct: "Yakıt",
      brand: "Marka",
      model: "Model",
      modelYear: "Model yılı",
      brandModel: "Marka / model",
      policyOverride: "Araç kuralı",
      driverName: "Sürücü",
      driverCard: "Sürücü kartı",
      tagUid: "Etiket / kart kimliği",
      tagKind: "Tür",
      validity: "Geçerlilik",
      validFrom: "Geçerlilik başı",
      validUntil: "Geçerlilik sonu",
      station: "İstasyon",
      product: "Ürün",
      litres: "Litre",
      quantity: "Miktar",
      amount: "Tutar",
      odometer: "Kilometre",
      occurredAt: "Zaman",
      source: "Kaynak",
      rule: "Kural",
      billed: "Faturalandı",
      from: "Başlangıç",
      to: "Bitiş",
      transactions: "İşlem",
      distance: "Mesafe",
      consumption: "Tüketim",
      averageUnitPrice: "Ort. birim fiyat",
      company: "Şirket",
    },
    accounts: {
      description:
        "Filo müşterisi rolündeki cariler, filo ayarları ve araç sayıları. Kredi limiti carinin kartından yönetilir.",
      searchPlaceholder: "Cari kodu ya da unvanı",
      emptyTitle: "Filo carisi yok",
      emptyFiltered: "Süzgeçle eşleşen filo carisi yok",
      emptyDescription: "Bir cariye “Filo müşterisi” rolü verildiğinde burada listelenir.",
      blocked: "Blokeli",
      open: "Filo hesabı aç",
      openTitle: "Filo hesabı aç",
      opened: "Filo hesabı açıldı",
      details: "Ayrıntı",
      editTitle: "Filo hesabı ayarları",
      billingCycleHint: "Dönem faturası bu aralıkla hazırlanır (fişli satış faturası).",
      portalEnabled: "Filo portalını aç",
      portalEnabledHint:
        "Açıkken filonun kendi kullanıcıları işlemlerini, faturalarını ve limitlerini portalda görür.",
      suspend: "Hesabı askıya al",
      suspendHint: "Askıdaki hesabın portal erişimi anında kesilir; açılınca geri gelir.",
    },
    general: {
      accountTitle: "Hesap ayarları",
      noAccountTitle: "Filo ayarı açılmamış",
      noAccountDescription:
        "Bu cari için fatura dönemi ve portal ayarı henüz yok. Kural ve araç tanımlamadan önce filo hesabını açın.",
      suggestedPeriod: "Faturalanacak son dönem",
      suspendedHint: "Hesap askıda: portal erişimi kapalı.",
      usageTitle: "Kullanım",
      usageDescription: "Tüm istasyonlar ve araçlar; İstanbul takvim günü ve ayı.",
      todayLitres: "Bugün ({{day}}) litre",
      todayAmount: "Bugün tutar",
      monthLitres: "Bu ay ({{month}}) litre",
      monthAmount: "Bu ay tutar",
      creditTitle: "Kredi",
      creditDescription:
        "Carinin kredi limiti ve riski şirket bazındadır; filo kuralları bunun üstüne eklenir.",
      openCard: "Cari kartını aç",
      noCredit: "Cari hiçbir şirkete bağlı değil.",
      creditNoPermission: "Kredi bilgisini görmek için cari limit okuma izni gerekir.",
      creditLimit: "Kredi limiti",
      totalRisk: "Toplam risk",
      available: "Kullanılabilir",
      unlimited: "Limitsiz",
      assetsTitle: "Tanımlar",
      activeVehicles: "Etkin araç",
      activeDrivers: "Etkin sürücü",
      activeTags: "Etkin TTS etiketi",
    },
    policy: {
      defaultTitle: "Cari varsayılan kuralı",
      defaultDescription:
        "Bu carinin TÜM araçlarına uygulanır. Boş bırakılan (varsayılan) alan kısıt getirmez; km ve sürücü kartı istenmez.",
      vehicleTitle: "Araç geçersiz kılması",
      vehicleDescription:
        "Seçilen araç için yalnızca FARKLI olması gereken alanları belirleyin; diğerleri üst düzeyden (cari varsayılanından) gelir.",
      noVehicles: "Etkin araç yok. Araçlar sekmesinden araç ekleyin.",
      noAccount: "Filo ayarı açılmamış: kural kaydedilebilir ama fatura ve portal için önce hesabı açın.",
      hasOverride: "özel kural",
      inheritsDefault: "Cari varsayılanı",
      source: "Kaynak",
      custom: "Bu düzeyde belirle",
      inheritDefault: "Varsayılan",
      inheritParent: "Üst düzeyden",
      noRestriction: "Kısıt yok",
      noLimit: "Limit yok",
      anyTime: "Her saat",
      everyDay: "Her gün",
      allDay: "gün boyu",
      noOptions: "Seçenek yok.",
      emptyMeansNoRestriction:
        "Hiçbiri seçili değil: bu düzeyde KISIT YOK (araçta seçilirse carinin kısıtı bu araç için kalkar).",
      noWindowsMeansAnyTime: "Pencere yok: her saat izinli (araçta seçilirse carinin saat kısıtı kalkar).",
      weekdays: "Günler (boş = her gün)",
      weekdayNames: {
        "0": "Pazar",
        "1": "Pazartesi",
        "2": "Salı",
        "3": "Çarşamba",
        "4": "Perşembe",
        "5": "Cuma",
        "6": "Cumartesi",
      },
      windowLabel: "Saat penceresi {{number}}",
      from: "Başlangıç saati",
      to: "Bitiş saati",
      removeWindow: "{{number}}. saat penceresini kaldır",
      addWeekdayWindow: "Hafta içi 06:00–22:00 ekle",
      addWindow: "Her gün 06:00–22:00 ekle",
      sameTimeAllDay: "Başlangıç ve bitiş aynı: gün boyu izinli.",
      overnight: "Bitiş başlangıçtan önce: pencere gece yarısını aşar.",
      limitValue: "Limit",
      vehicleLimitHint:
        "Araç, carinin limitini değiştirebilir ama kaldıramaz (limit alanı yalnızca pozitif değer alır).",
      required: "Zorunlu",
      notRequired: "İstenmez",
      fields: {
        allowedProducts: "İzinli ürünler",
        allowedProductsHint: "Yalnızca seçilen ürünler filoya yazılabilir.",
        allowedStations: "İzinli istasyonlar",
        allowedStationsHint: "Yalnızca seçilen istasyonlarda alım yapılabilir.",
        timeWindows: "İzinli gün ve saatler",
        timeWindowsHint: "İstanbul saatiyle; bitiş saati dâhil değildir.",
        dailyLitreLimit: "Günlük litre limiti",
        monthlyLitreLimit: "Aylık litre limiti",
        dailyAmountLimit: "Günlük tutar limiti",
        monthlyAmountLimit: "Aylık tutar limiti",
        requireOdometer: "Kilometre girişi",
        requireOdometerHint: "Zorunluysa eksik km geçersiz kılınamaz.",
        requireDriverCard: "Sürücü kartı",
        requireDriverCardHint: "Zorunluysa kart okutulmadan satış yapılamaz.",
        violationAction: "İhlalde",
        violationActionHint: "Limit / saat / ürün / istasyon ihlalinde ne olacağı.",
      },
      saveDefault: "Varsayılan kuralı kaydet",
      saveVehicle: "Araç kuralını kaydet",
      saved: "Kural kaydedildi",
      clearOverride: "Geçersiz kılmayı kaldır",
      clearTitle: "Araç kuralı kaldırılsın mı?",
      clearDescription: "Aracın tüm özel alanları boşaltılır; araç carinin varsayılan kuralına döner.",
      cleared: "Araç kuralı kaldırıldı",
      effectiveTitle: "Etkin kural önizlemesi",
      effectiveDescription:
        "Kasa ve istasyon ajanının uygulayacağı kural (kaydedilmemiş değişiklikler dâhil) ve her alanın kaynağı.",
      rule: "Kural",
      value: "Değer",
      sources: { VEHICLE: "Araç", COUNTERPARTY: "Cari varsayılanı", DEFAULT: "Sistem varsayılanı" },
    },
    preview: {
      title: "Yetkilendirme önizlemesi",
      description:
        "Örnek bir alımı kasadaki değerlendirmeyle AYNI kuralla ve gerçek kullanım defteriyle sınar; kayıt yazılmaz.",
      noProduct: "Ürün yok (yalnızca tutar)",
      amountHint: "Filoya yazılacak tutar (KDV dâhil).",
      driverCardPresented: "Sürücü kartı okutuldu",
      run: "Kuralı sına",
      allowed: "Satış kurala uygun",
      allowedDescription: "Bu alım kasada engellenmez.",
      blocked: "Satış engellenir",
      approvalRequired: "Yetkili onayı gerekir",
      notOverridable: "geçersiz kılınamaz",
      odometerDecreased: "Kilometre son okumanın gerisinde (sayaç değişimi olabilir) — yalnızca uyarı.",
      dayUsed: "Bugün kullanılan",
      monthUsed: "Bu ay kullanılan",
      remainingDay: "Bugün kalan",
      maxLitres: "En çok dolum",
    },
    vehicles: {
      caption: "Filo araçları",
      add: "Araç ekle",
      addTitle: "Filo aracı ekle",
      addDescription: "Plaka kiracıda etkin araçlar arasında tekildir.",
      added: "Araç eklendi",
      noFuel: "Belirtilmedi",
      editRules: "Kural",
      emptyTitle: "Araç yok",
      emptyDescription: "Filonun araçlarını ekleyin ya da portal talebini onaylayın.",
      deactivateHint:
        "Pasif araç kasada tanınmaz ve kurala bakılmaz; TTS etiketleri olduğu gibi kalır (kaybolan etiketi ayrıca «Kayıp» yapın).",
      deactivateFor: "Pasife al — {{plate}}",
      reactivateFor: "Etkinleştir — {{plate}}",
      deactivateTitle: "Aracı pasife al",
      deactivateDescription:
        "{{plate}} pasife alınınca kasada ve TTS okumasında tanınmaz, filo fişinde seçilemez. Geçmiş kullanım kayıtları kalır.",
      reactivateTitle: "Aracı yeniden etkinleştir",
      reactivateDescription:
        "{{plate}} yeniden etkinleşir; etkin etiketleriyle kasada tanınır. Aynı plakalı başka etkin araç varsa etkinleştirilemez.",
      deactivated: "Araç pasife alındı",
      reactivated: "Araç yeniden etkinleştirildi",
      staleStatus: "Aracın durumu siz bakarken değişmiş; liste yenilendi.",
    },
    drivers: {
      caption: "Filo sürücüleri",
      add: "Sürücü ekle",
      addTitle: "Filo sürücüsü ekle",
      editTitle: "Sürücüyü düzenle",
      added: "Sürücü eklendi",
      anonymized: "Anonim",
      phoneHint: "Ör. 0532 123 45 67 (E.164'e çevrilir).",
      cardHint: "Etkin kartlar arasında tekil; 3–40 harf, rakam ya da tire.",
      maskedEdit: "Kişisel veriler maskeli: ad ve telefonu değiştiremezsiniz; kart ve durum düzenlenebilir.",
      emptyTitle: "Sürücü yok",
      emptyDescription: "Sürücü kartı zorunluysa sürücüleri kart numaralarıyla tanımlayın.",
    },
    tags: {
      caption: "TTS etiketleri ve taşıt kartları",
      add: "Etiket ekle",
      addTitle: "TTS etiketi / taşıt kartı ekle",
      addDescription: "Etkin etiket kimliği kiracıda tekildir.",
      added: "Etiket eklendi",
      uidHint: "3–64 harf, rakam ya da : _ -",
      always: "Süresiz",
      openEnded: "süresiz",
      markLost: "Kayıp bildir",
      lostTitle: "Etiket kayıp olarak işaretlensin mi?",
      lostDescription:
        "{{uid}} artık tanınmaz ve YENİDEN ETKİNLEŞTİRİLEMEZ (çalınmış olabilir). Bulunursa yeni kayıtla tanımlanır.",
      emptyTitle: "Etiket yok",
      emptyDescription: "Depo halkası (RFID) ya da taşıt kartı tanımlayın; istasyonda araç otomatik tanınır.",
    },
    usage: {
      caption: "Filo kullanım defteri",
      emptyTitle: "Kullanım kaydı yok",
      emptyDescription: "Kasa satışları ve elle girilen filo fişleri burada listelenir.",
      noReceipt: "ÖKC fişi yok",
      violation: "Kural ihlali",
      overridden: "Onayla geçildi",
      billed: "Faturalandı",
    },
    statement: {
      totalsTitle: "{{from}} – {{to}} toplamları",
      unbilled: "Faturalanmamış",
      groupsCaption: "Araç ve sürücü kırılımı",
      vehiclesCaption: "Araç bazında tüketim",
      noVehicle: "Araçsız",
      noVehicleUsage: "Araç kullanımı yok",
      consumptionHint:
        "L/100 km doludan doluya hesaplanır: km'ye göre sıralı dolumlarda ilk dolum hesaba katılmaz.",
      emptyTitle: "Bu aralıkta kullanım yok",
      emptyDescription: "Tarih aralığını değiştirerek yeniden deneyin.",
      runsTitle: "Aralıkla kesişen dönem faturaları",
      rangeError: "Bitiş başlangıçtan önce olamaz",
    },
    billing: {
      noCompany: "Cari, görebildiğiniz bir şirkete bağlı değil; dönem faturası kesilemez.",
      previewTitle: "Dönem faturası hazırla",
      previewDescription:
        "Dönemdeki faturalanmamış ÖKC fişleri tek fişli satış faturasında toplanır. Fatura gelir ve KDV üretmez (gün sonu yazdı).",
      periodFrom: "Dönem başı",
      periodTo: "Dönem sonu",
      periodError: "Dönem başı ve sonu birlikte ve sırayla girilmelidir",
      periodHint: "Dönem boş bırakılırsa carinin fatura döneminde son biten dönem kullanılır.",
      preview: "Önizle",
      period: "Dönem",
      invoiceAmount: "Fatura tutarı",
      receipts: "Fiş",
      entries: "Kullanım satırı",
      exceptions: "İstisna",
      voided: "İptal edilmiş fiş",
      alreadyInvoiced: "Zaten faturalı fiş",
      activeRunExists: "Bu dönem için etkin bir dönem faturası zaten var (aşağıdaki listede).",
      nothingToBill: "Bu dönemde faturalanacak ÖKC fişi yok.",
      createDraft: "Taslak oluştur",
      draftCreated: "Dönem faturası taslağı oluşturuldu",
      receiptsCaption: "Faturaya girecek fişler",
      voidedCaption: "İptal / iade edilmiş fişler (faturaya girmez)",
      alreadyInvoicedCaption: "Başka faturaya bağlanmış fişler (faturaya girmez)",
      exceptionsTitle: "İstisnalar",
      exceptionsDescription:
        "ÖKC fiş bağı olmayan satırlar (elle filo fişi) fişli satış faturasına giremez; ayrıca faturalandırılmalıdır.",
      noFiscalReceipt: "ÖKC fişi yok",
      reason: "Neden",
      receipt: "Fiş",
      receiptNo: "Fiş {{no}}",
      receiptDate: "Fiş tarihi",
      noReceipts: "Fiş yok",
      runsCaption: "Dönem faturaları",
      runsEmptyTitle: "Dönem faturası yok",
      runsEmptyDescription: "Önizleme sonrası taslak oluşturduğunuzda burada listelenir.",
      invoice: "Fatura",
      issue: "Faturayı kes",
      issueTitle: "Dönem faturasını kes",
      issueDescription:
        "Fişli satış faturası kesilir; taslaktan sonra yeni fiş ya da iptal geldiyse işlem reddedilir ve taslak yeniden hazırlanmalıdır.",
      issueDate: "Fatura tarihi",
      issueDateHint: "Son fişin tarihinden önce olamaz.",
      dueDate: "Vade",
      dueDateHint: "Boşsa fatura ayarındaki varsayılan vade.",
      issued: "Dönem faturası kesildi",
      cancel: "İptal",
      cancelTitle: "Dönem faturası iptal edilsin mi?",
      cancelDescription:
        "Satırlar yeniden faturalanabilir hâle gelir. Kesilmiş faturada önce fatura iptal edilmelidir.",
      cancelReason: "İptal gerekçesi",
      cancelConfirm: "Dönem faturasını iptal et",
      cancelled: "Dönem faturası iptal edildi",
      cancelInvoiceFirst: "İptal için önce faturayı iptal edin",
      noPermission: "Dönem faturası hazırlamak için filo faturalama yetkisi gerekir.",
    },
    portalUsers: {
      title: "Portal kullanıcıları",
      description:
        "Filo carisinin kendi kullanıcıları: yalnızca bu filonun işlemlerini, faturalarını ve limitlerini görür.",
      invite: "Portal kullanıcısı davet et",
      inviteDescription: "Davet e-postayla gönderilir; kişi kabul edince filo portalına girer.",
      presetSummary: "{{role}} — {{counterparty}}",
      noPermission: "Portal kullanıcılarını görmek için kullanıcı görüntüleme yetkisi gerekir.",
      portalClosedTitle: "Portal kapalı",
      portalClosedDescription:
        "Portal kullanıcısı davet etmek için Genel sekmesinden hesabın portalını açın (hesap etkin olmalı).",
      emptyTitle: "Portal kullanıcısı yok",
      emptyDescription: "Filonun yöneticisini davet ederek başlayın.",
      user: "Kullanıcı",
      lastLogin: "Son giriş",
      invited: "Davet bekliyor",
      expires: "Son geçerlilik: {{date}}",
      manageHint: "Rol ve üyelik değişiklikleri:",
      membership: { ACTIVE: "Etkin", SUSPENDED: "Askıda", REMOVED: "Çıkarıldı" },
    },
    requests: {
      description: "Filo portalından gelen araç ekleme talepleri. Onaylanan talep araca dönüşür.",
      createdAt: "Talep zamanı",
      note: "Talep notu",
      approve: "Onayla",
      reject: "Reddet",
      approveTitle: "Araç talebini onayla",
      rejectTitle: "Araç talebini reddet",
      approveHint: "Araç filo carisine açılır; plaka etkin araçlar arasında tekil olmalıdır.",
      rejectHint: "Gerekçe filo portalında görünür (en az 3 karakter).",
      decisionNote: "Karar notu",
      approved: "Talep onaylandı, araç açıldı",
      rejected: "Talep reddedildi",
      emptyPending: "Bekleyen araç talebi yok",
      emptyTitle: "Araç talebi yok",
      emptyDescription: "Filo portalı kullanıcıları araç eklemek istediğinde talepler burada görünür.",
    },
    consumption: {
      description: "Araç bazında yakıt tüketimi, ortalama birim fiyat ve L/100 km.",
      caption: "Araç bazında tüketim",
      totalLitres: "Toplam litre",
      totalAmount: "Toplam tutar",
      withoutVehicle: "Araçsız kullanım",
      emptyTitle: "Bu aralıkta tüketim yok",
      emptyDescription: "Tarih aralığını ya da cariyi değiştirerek yeniden deneyin.",
    },
  },
  loyalty: {
    disabledTitle: "Sadakat modülü kapalı",
    disabledDescription:
      "Müşteri, filo ve sadakat modülü (FLEET_LOYALTY) bu hesapta etkin değil. Kurumsal paketle açılır.",
    noPermission: "Sadakat ekranlarını görmek için sadakat okuma yetkisi gerekir.",
    conflict:
      "Kayıt bu arada başka bir kullanıcı tarafından değiştirildi. Sayfayı yenileyip yeniden deneyin.",
    pointsUnit: "{{points}} puan",
    fields: {
      points: "Puan",
      value: "Tutar karşılığı",
      amount: "Tutar",
      station: "İstasyon",
      reason: "Gerekçe",
    },
    validation: {
      required: "Bu alan zorunludur",
      integer: "Tam sayı girin",
      range: "{{min}} ile {{max}} arasında bir değer girin",
      hexColor: "Renk #RRGGBB biçiminde olmalıdır (ör. #0F766E)",
      pointValue: "Puan değeri sıfırdan büyük, en çok 4 ondalıklı bir ₺ tutarı olmalıdır",
      positive: "Sıfırdan büyük bir değer girin",
      decimalScale: "En çok {{scale}} ondalık basamak girilebilir",
      tierCode: "Kod büyük harfle başlamalı; büyük harf, rakam ve _ (2–20 karakter)",
      templateCode: "Kod büyük harf, rakam, _ ve - içerebilir (2–40 karakter)",
      ruleCode: "Kod harf ya da rakamla başlamalı; harf, rakam, _ ve - (2–40 karakter)",
      length: "{{min}}–{{max}} karakter girin",
      dateOrder: "Bitiş günü başlangıçtan önce olamaz",
      rankTaken: "Bu sıra başka bir etkin seviyede kullanılıyor",
      coverage: "Plan en az bir satır türünü ya da ürünü kapsamalıdır",
      reason: "Gerekçe 3–300 karakter olmalıdır",
      exceedsBalance: "Düşülecek puan bakiyeyi ({{balance}}) aşamaz",
      prefix: "Önek yalnızca harf ve rakam içerebilir (en çok 12 karakter)",
    },
    program: {
      description:
        "Kiracının tek sadakat programı: marka, puan değeri ve ömrü, harcama kuralları, seviye penceresi ve kötüye kullanım sınırları.",
      formLabel: "Sadakat programı",
      defaultTitle: "Program henüz kaydedilmedi",
      defaultDescription:
        "Aşağıda varsayılan değerler gösteriliyor. Kaydedene kadar kasa satışları puan kazandırmaz.",
      readOnly: "Programı yalnızca görüntüleyebilirsiniz; değiştirmek için sadakat yönetimi yetkisi gerekir.",
      create: "Programı oluştur",
      save: "Programı kaydet",
      saved: "Sadakat programı kaydedildi",
      updatedAt: "Son kayıt: {{at}}",
      neverSaved: "Program henüz kaydedilmedi.",
      sections: {
        brand: "Program ve marka",
        brandHint: "Ad, logo ve renkler müşteri uygulamasında ve kartta görünür.",
        points: "Puan",
        pointsHint: "Puanın ₺ değeri, ömrü, harcama alt sınırı ve harcanabileceği iş birimleri.",
        tiers: "Seviye",
        abuse: "Kötüye kullanım",
        abuseHint:
          "Aynı müşteri pencere içinde bu sayıdan fazla kazanımlı işlem yaparsa ya da günlük tavanı aşarsa kazanım incelemeye düşer.",
      },
      fields: {
        name: "Program adı",
        isActive: "Program etkin",
        primaryColor: "Ana renk",
        secondaryColor: "İkincil renk",
        colorHint: "#RRGGBB biçiminde",
        colorPicker: "{{label}} seçici",
        logo: "Logo",
        pointValue: "Puan değeri",
        pointValueHint: "1 puanın ₺ karşılığı (en çok 4 ondalık, ör. 0,0100 ₺)",
        pointsExpiryMonths: "Puan ömrü (ay)",
        pointsExpiryMonthsHint: "Kazanılan puan bu süre sonunda düşer (en eski önce).",
        expiryWarningDays: "Süre sonu uyarısı (gün)",
        expiryWarningDaysHint: "Süresi dolmadan kaç gün önce uyarılır.",
        minRedeemPoints: "En az harcama (puan)",
        minRedeemPointsHint: "Kasada tek seferde harcanabilecek en az puan.",
        earnEnabled: "Puan kazanımı açık",
        redeemEnabled: "Puan harcaması açık",
        excludeAgeRestricted: "Yaş sınırlı ürünler (tütün / alkol) puan kazandırmaz ve puanla ödenmez",
        redeemableBusinessUnits: "Puanın harcanabileceği iş birimleri",
        redeemableBusinessUnitsHint: "Hiçbiri seçilmezse tüm iş birimlerinde harcanır.",
        tierWindowMonths: "Seviye penceresi (ay)",
        tierWindowMonthsHint: "Seviye, son bu kadar ayda kazanılan puana göre hesaplanır.",
        abuseMaxEarnTx: "Pencerede en çok kazanımlı işlem",
        abuseWindowMinutes: "Pencere (dakika)",
        abuseDailyPointCap: "Günlük kazanım tavanı (puan)",
        abuseDailyPointCapHint: "Boş bırakılırsa tavan yok.",
      },
      uploadLogo: "Logo yükle",
      replaceLogo: "Logoyu değiştir",
      removeLogo: "Logoyu kaldır",
      noLogo: "Logo yok",
      logoAlt: "Program logosu",
      logoHint: "PNG, JPEG, WebP ya da SVG; en çok 2 MB. Yüklenen logo program kaydedilince kullanılır.",
      logoType: "Logo PNG, JPEG, WebP ya da SVG olmalıdır.",
      logoSize: "Logo en çok 2 MB olabilir.",
      previewTitle: "Kart önizlemesi",
      previewHint: "Müşteri uygulamasındaki kart böyle görünecek (canlı önizleme).",
      previewNamePlaceholder: "Program adı",
      previewBalance: "Puan bakiyesi",
      previewPoints: "{{points}} puan",
      previewValue: "≈ {{value}}",
      previewTierPlaceholder: "Seviye",
      previewCaption: "Örnek bakiye; puan değeri {{value}}.",
    },
    tiers: {
      description:
        "Seviye, kayan pencerede kazanılan puana göre belirlenir. Yükselme kazanımda hemen, düşme gece değerlendirmesinde olur.",
      create: "Seviye ekle",
      createTitle: "Yeni seviye",
      editTitle: "Seviyeyi düzenle: {{code}}",
      dialogHint: "Seviye kodu kampanyalardaki sadakat seviyesi koşulunda kullanılır.",
      created: "Seviye eklendi",
      updated: "Seviye güncellendi",
      caption: "Sadakat seviyeleri",
      members: "Üye",
      noColor: "Renk yok",
      emptyTitle: "Henüz seviye yok",
      emptyDescription:
        "Seviye eklemeden de puan kazanılır; seviye, kazanıma çarpan ve kampanya koşulu ekler.",
      footnote: "Etkin seviyeler arasında sıra tekildir. Büyük sıra üst seviyedir.",
      fields: {
        code: "Kod",
        codeHint: "Büyük harf, rakam ve _ (ör. ALTIN). Sonradan değiştirilemez.",
        codeLocked: "Kod değiştirilemez (kampanya koşulu bu koda bağlıdır).",
        name: "Ad",
        rank: "Sıra",
        rankHint: "1–20; büyük sayı üst seviye.",
        thresholdPoints: "Eşik (puan)",
        thresholdHint: "Seviye penceresinde bu kadar puan kazanan müşteri bu seviyeye çıkar.",
        earnMultiplier: "Kazanım çarpanı",
        earnMultiplierHint: "Bu seviyedeki müşterinin kazandığı puan bununla çarpılır (ör. 1,5).",
        color: "Renk",
        colorHint: "İsteğe bağlı, #RRGGBB",
        colorPicker: "Seviye rengi seçici",
        benefits: "Ayrıcalıklar",
        isActive: "Seviye etkin",
      },
    },
    rules: {
      description:
        "Puan kazanım kuralları: litre ya da harcanan ₺ başına puan ve dönemsel çarpanlar. Kasa ve sunucu aynı motoru kullanır.",
      create: "Kural ekle",
      createTitle: "Yeni kazanım kuralı",
      editTitle: "Kuralı düzenle: {{code}}",
      formLabel: "Kazanım kuralı",
      created: "Kazanım kuralı eklendi",
      updated: "Kazanım kuralı güncellendi",
      caption: "Kazanım kuralları",
      validity: "Geçerlilik",
      openEnded: "süresiz",
      everyDay: "Her gün",
      pointsSuffix: "puan",
      removeScope: "{{name}} kapsamdan çıkar",
      emptyTitle: "Henüz kazanım kuralı yok",
      emptyDescription:
        "Kural olmadan satışlar puan kazandırmaz. Örneğin akaryakıtta litre başına 1 puan ekleyin.",
      footnote:
        "Satır başına en özel temel kural uygulanır (ürün > kategori > iş birimi > tümü; eşitlikte öncelik). Eşleşen çarpanlar ve seviye çarpanı üstüne çarpılır; satır puanı aşağı yuvarlanır.",
      sections: {
        effect: "Kazanım",
        scope: "Kapsam",
        scopeHint: "Kuralın uygulanacağı satışlar.",
        validity: "Geçerlilik",
      },
      fields: {
        code: "Kod",
        codeLocked: "Kod değiştirilemez.",
        name: "Ad",
        kind: "Tür",
        kindLocked: "Tür değiştirilemez.",
        pointsPerLitre: "Birim başına puan",
        pointsPerLitreHint: "Litre (ya da satış birimi) başına kazanılan puan.",
        pointsPerAmount: "₺ başına puan",
        pointsPerAmountHint: "Harcanan her 1 ₺ (net) için kazanılan puan.",
        multiplier: "Çarpan",
        multiplierHint: "Eşleşen satırların puanı bununla çarpılır (ör. hafta sonu 2).",
        priority: "Öncelik",
        priorityHint: "0–1000; aynı özgüllükte küçük sayı önce uygulanır.",
        scopeKind: "Kapsam",
        businessUnits: "İş birimleri",
        categories: "Kategoriler",
        products: "Ürünler",
        productsHint: "Kod ya da adla arayın; birden çok ürün eklenebilir.",
        productPlaceholder: "Ürün ara",
        validFrom: "Başlangıç günü",
        validTo: "Son geçerli gün",
        validToHint: "Boş bırakılırsa süresiz.",
        weekdays: "Günler",
        weekdaysHint: "Hiçbiri seçilmezse her gün geçerli.",
        isActive: "Kural etkin",
      },
      simulator: {
        title: "Kazanım simülatörü",
        description:
          "Örnek bir satışın kaç puan kazandıracağını kayıtlı kurallarla hesaplar (bugün, {{day}}). Kayıt yapılmaz.",
        product: "Ürün",
        quantity: "Miktar",
        net: "Satır tutarı (KDV dâhil, indirim sonrası)",
        tier: "Seviye",
        noTier: "Seviyesiz",
        pick: "Hesaplamak için bir ürün seçin.",
        result: "{{points}} puan kazandırır",
        appliedRule: "Uygulanan kural: {{name}}",
        noRule: "Bu satıra uyan temel kural yok",
        multipliers: "çarpanlar: {{names}}",
        tierApplied: "seviye çarpanı: {{name}}",
        raw: "Yuvarlamadan önce {{raw}} puan (satır puanı aşağı yuvarlanır)",
      },
    },
    reviews: {
      description:
        "Kötüye kullanım şüphesiyle incelemeye düşen kazanımlar. Onaylanan kazanım bakiyeye girer; reddedilen yazılmaz.",
      caption: "İncelemedeki kazanımlar",
      occurredAt: "Zaman",
      customer: "Müşteri",
      sale: "Satış",
      openSale: "Satışı aç",
      verdict: "Neden",
      verdicts: {
        TOO_FREQUENT: "Kısa sürede çok sayıda kazanım",
        DAILY_CAP: "Günlük kazanım tavanı aşıldı",
        unknown: "Belirtilmedi",
      },
      approve: "Onayla",
      reject: "Reddet",
      approveTitle: "Kazanımı onayla",
      rejectTitle: "Kazanımı reddet",
      dialogDescription: "Müşteri {{code}} · {{points}} puan",
      approveHint: "Puan müşterinin bakiyesine eklenir ve yeni bir kazanım partisi açılır.",
      rejectHint: "Gerekçe denetim izine yazılır (en az 3 karakter).",
      approved: "Kazanım onaylandı",
      rejected: "Kazanım reddedildi",
      emptyTitle: "İnceleme bekleyen kazanım yok",
      emptyDescription: "Kötüye kullanım sınırlarını aşan kazanımlar burada listelenir.",
    },
    owner: {
      customer: "müşteri kartını aç",
      fleet: "filo hesabını aç",
      noName: "Ad yok",
    },
    account: {
      title: "Puan hesabı",
      description: "Bakiye işlenmiş puan hareketlerinin toplamıdır; incelemedeki kazanım bakiyeye girmez.",
      noAccount: "Bu müşterinin henüz puan hareketi yok.",
      balance: "Bakiye",
      pending: "İncelemede",
      pendingHint: "Onaylanınca bakiyeye girer",
      lifetime: "Toplam kazanılan",
      pointValue: "Puan değeri",
      tier: "Seviye",
      noTier: "Seviye yok",
      tierChangedAt: "Değişim: {{at}}",
      nextTier: "Sonraki seviye",
      topTier: "En üst seviyede ya da seviye tanımlı değil",
      progressLabel: "{{name}} seviyesine ilerleme",
      progressText:
        "{{name}} için {{needed}} puan daha (pencerede {{window}}; eşik {{base}} → {{threshold}})",
      nextExpiry: "En yakın süre sonu",
      nextExpiryText: "{{points}} puan · {{date}}",
      lots: "Açık partiler",
      lotsText: "{{count}} parti · {{points}} puan",
      negativeBalance:
        "Bakiye eksi: iade yüzünden kazanım geri alındı. Harcama bakiye artıya dönene kadar kapalıdır.",
      blockedTitle: "Puan harcaması kapalı",
      blockedNoReason: "Gerekçe belirtilmemiş.",
      adjust: "Puan düzeltmesi",
      block: "Harcamayı kapat",
      unblock: "Harcamayı aç",
      blockTitle: "Puan harcamasını kapat",
      unblockTitle: "Puan harcamasını aç",
      blockHint: "Müşteri kasada puanla ödeme yapamaz; kazanım sürer.",
      unblockHint: "Müşteri yeniden puanla ödeme yapabilir.",
      blocked: "Puan harcaması kapatıldı",
      unblocked: "Puan harcaması açıldı",
      couponsTitle: "Kuponlar",
      couponsHint: "Müşteriye bağlı kupon kodları (tüm şirketlerin şablonlarından).",
      noCoupons: "Müşteriye bağlı kupon yok",
      noCouponsHint: "Elle verilen ya da kazanım kuponları burada görünür.",
      subscriptionsTitle: "Abonelikler",
      noSubscriptions: "Müşterinin aboneliği yok.",
    },
    adjustment: {
      title: "Puan düzeltmesi",
      description: "Güncel bakiye: {{balance}} puan. Düzeltme gerekçelidir ve kimlik doğrulaması ister.",
      direction: "İşlem",
      credit: "Puan ekle",
      debit: "Puan düş",
      stationHint: "Muhasebe boyutu ve kazanım partisinin istasyonu.",
      homeStation: "Müşterinin ana istasyonu ({{name}})",
      noHomeStation: "Ana istasyon yok — istasyon seçin",
      reasonHint: "Denetim izine ve fiş açıklamasına yazılır.",
      accountingHint:
        "Fiş anında kesilir: ekleme → B 760 / A 379; düşme → ters kayıt (varsayılan eşleştirme).",
      submit: "Düzeltmeyi kaydet",
      saved: "Puan düzeltmesi kaydedildi ({{points}})",
      stepUpCancelled: "Kimlik doğrulaması tamamlanmadığı için düzeltme kaydedilmedi.",
      ledger: {
        POSTED: "Muhasebe fişi kesildi.",
        QUEUED: "Fiş eşleştirme bekliyor (muhasebe › eşleştirme bekleyenler).",
        NOT_REQUIRED: "Fiş gerekmedi.",
      },
    },
    entries: {
      title: "Puan hareketleri",
      description: "Değiştirilemez defter; düzeltme ters hareketle yapılır.",
      caption: "Puan hareketleri",
      occurredAt: "Zaman",
      type: "Tür",
      source: "Kaynak",
      sale: "Satış",
      return: "İade / iptal",
      adjustment: "Elle düzeltme",
      lot: "Süre sonu",
      businessDate: "İş günü",
      emptyTitle: "Puan hareketi yok",
      emptyDescription: "Kasa satışları, iadeler, süre sonları ve düzeltmeler burada listelenir.",
    },
    coupons: {
      description:
        "İşletmenin kendi kuponları kampanya motorunda indirimdir: şablon, 'kupon ister' kampanyasına bağlanır. Toplu kod, elle verme ve kazanım kuponu.",
      create: "Kupon şablonu ekle",
      createTitle: "Yeni kupon şablonu",
      editTitle: "Kupon şablonunu düzenle: {{code}}",
      detailTitle: "Kupon şablonu",
      formLabel: "Kupon şablonu",
      created: "Kupon şablonu eklendi",
      updated: "Kupon şablonu güncellendi",
      caption: "Kupon şablonları",
      campaign: "Kampanya",
      template: "Şablon",
      customerBound: "Müşteriye bağlı",
      notCustomerBound: "Müşteriye bağlı değil",
      validity: "Geçerlilik",
      stats: "Kodlar",
      statsText: "{{total}} kod · {{issued}} kullanılabilir · {{redeemed}} kullanıldı",
      statTotal: "Toplam {{count}} kod",
      statBreakdown:
        "{{issued}} kullanılabilir · {{redeemed}} kullanıldı · {{expired}} süresi doldu · {{cancelled}} iptal",
      emptyTitle: "Henüz kupon şablonu yok",
      emptyDescription:
        "Önce kampanyalarda 'kupon ister' işaretli bir kampanya açın, sonra şablonu ona bağlayın.",
      summaryTitle: "Şablon",
      limits: "Sınırlar",
      perCode: "Kod başına {{count}} kullanım",
      perCustomer: "Müşteri başına en çok {{count}} kullanım",
      perCustomerNone: "Müşteri başına sınır yok",
      total: "En çok {{count}} kod",
      totalNone: "Kod sayısı sınırsız",
      days: "{{days}} gün",
      conditionLine: "Aynı satışta en az {{quantity}} {{kind}}",
      conditionBasket: "Sepet neti en az {{amount}}",
      conditionKinds: {
        LINE_QUANTITY: "En az miktar",
        BASKET_NET: "En az sepet tutarı",
      },
      noEngineCampaigns: "Bu şirkette 'kupon ister' işaretli kampanya yok.",
      openCampaigns: "Kampanyalara git",
      sections: {
        effect: "İndirim",
        effectHint: "İndirimi 'kupon ister' işaretli kampanya uygular; kupon yalnızca o kampanyayı açar.",
        issuance: "Veriliş",
        limits: "Geçerlilik ve sınırlar",
      },
      fields: {
        templateCode: "Şablon kodu",
        name: "Ad",
        locked: "Kurulduktan sonra değiştirilemez.",
        campaign: "Bağlı kampanya",
        campaignHint: "Yalnızca bu şirketin 'kupon ister' kampanyaları.",
        issuance: "Veriliş biçimi",
        customerBound: "Kod müşteriye bağlı olsun",
        earnCondition: "Kazanım koşulu",
        earnConditionHint:
          "Koşulu sağlayan tanınmış müşterinin satışından sonra kupon kendiliğinden verilir.",
        conditionKind: "Koşul",
        lineKind: "Satır türü",
        minQuantity: "En az miktar",
        minBasketNet: "En az sepet tutarı",
        validFrom: "Başlangıç günü",
        validUntil: "Son geçerli gün",
        validUntilHint: "Boş bırakılırsa süresiz.",
        codeValidityDays: "Kod geçerliliği (gün)",
        codeValidityDaysHint: "Verilen kodun kaç gün geçerli olacağı (kazanım kuponunda zorunlu).",
        maxUsesPerCode: "Kod başına kullanım",
        maxUsesPerCustomer: "Müşteri başına en çok kullanım",
        optionalLimit: "Boş bırakılırsa sınırsız.",
        totalLimit: "En çok kod",
        totalLimitHint: "Şablonda üretilebilecek toplam kod; boşsa sınırsız.",
        code: "Kupon kodu",
        customer: "Müşteri",
        issueValidUntilHint: "Boşsa şablonun kuralı uygulanır.",
        count: "Adet",
        countHint: "Tek istekte en çok 5.000 kod.",
        prefix: "Önek",
        prefixHint: "Boşsa şablon kodu ({{code}}) kullanılır.",
      },
      codesTitle: "Kodlar",
      codesCaption: "Kupon kodları",
      codesEmptyTitle: "Henüz kod yok",
      codesEmptyDescription: "Toplu şablonda kod üretin; elle verilen şablonda müşteriye kod verin.",
      uses: "Kullanım",
      usesText: "{{uses}} / {{max}} kullanım",
      validUntil: "Son geçerlilik",
      issuedAt: "Veriliş",
      unassigned: "Atanmadı",
      generate: "Kod üret",
      generateTitle: "Toplu kod üret",
      generateHint:
        "Karışmayan karakterlerle tekil, tek kullanımlık kodlar üretilir. Kalan kod hakkı: {{limit}}.",
      noLimit: "sınırsız",
      generated: "{{count}} kod üretildi",
      generatedList: "Üretilen kodlar",
      generatedMore: "ve {{count}} kod daha (tamamı dışa aktarımda)",
      copyCodes: "Kodları kopyala",
      issue: "Müşteriye ver",
      issueTitle: "Müşteriye kupon ver",
      issueHint: "Seçilen müşteriye bağlı yeni bir kod üretilir.",
      issued: "Kupon verildi: {{code}}",
      assign: "Müşteriye ata",
      assignTitle: "Kodu müşteriye ata: {{code}}",
      assignHint: "Kullanılmamış kod seçilen müşteriye bağlanır.",
      assigned: "Kod müşteriye atandı: {{code}}",
      cancelCoupon: "Kuponu iptal et",
      cancelTitle: "Kuponu iptal et: {{code}}",
      cancelHint: "İptal edilen kupon kasada kullanılamaz; gerekçe denetim izine yazılır.",
      cancelled: "Kupon iptal edildi: {{code}}",
      cancelReason: "İptal gerekçesi: {{reason}}",
      exportExcel: "Excel'e aktar",
      exportCsv: "CSV indir",
      exported: "{{count}} kod dışa aktarıldı",
      export: { customerCode: "Müşteri kodu", customerName: "Müşteri (maskeli ad)" },
      lookupTitle: "Kupon sorgula",
      lookupLabel: "Kupon kodu",
      lookup: "Sorgula",
      lookupNotFound: "{{code}} kodlu kupon bulunamadı.",
      redemptions: "Kullanımlar",
      reversed: "Geri alındı",
    },
    plans: {
      create: "Plan ekle",
      createTitle: "Yeni abonelik planı",
      editTitle: "Planı düzenle: {{code}}",
      formLabel: "Abonelik planı",
      created: "Abonelik planı eklendi",
      updated: "Abonelik planı güncellendi",
      caption: "Abonelik planları",
      coverage: "Kapsam",
      entitlement: "Hak",
      perMonth: "Ayda {{quantity}}",
      perDay: "Günde en çok {{quantity}}",
      vehicleBound: "Araca bağlı",
      noProduct: "Plan ürünü yok",
      activeSubscriptions: "Etkin abone",
      emptyTitle: "Henüz abonelik planı yok",
      emptyDescription: "Örneğin 'aylık 4 yıkama' planı ekleyin; kasada hakla sıfırlanır.",
      sections: {
        coverage: "Kapsam",
        coverageHint: "Hakla sıfırlanacak satır türleri ve / veya ürünler.",
        entitlement: "Hak ve ücret",
      },
      fields: {
        code: "Plan kodu",
        name: "Ad",
        businessUnit: "İş birimi",
        price: "Dönem ücreti",
        priceHint: "Aylık, KDV dâhil.",
        lineKinds: "Satır türleri",
        products: "Ürünler",
        quantityPerPeriod: "Dönem hakkı",
        quantityPerPeriodHint: "Ayda kullanılabilecek miktar (adet / litre).",
        dailyLimit: "Günlük sınır",
        dailyLimitHint: "Boş bırakılırsa günlük sınır yok.",
        product: "Plan ürünü (kasada satılan)",
        productHint: "Tanınmış müşteri kasada bu ürünü alınca abonelik açılır / yenilenir.",
        vehicleBound: "Araca bağlı (plaka)",
        isActive: "Plan etkin",
      },
    },
    subscriptions: {
      description:
        "Müşteri ve filo abonelikleri: dönem hakkı, günlük sınır ve kullanım. Kasada plan ürünü alınınca kendiliğinden açılır.",
      caption: "Abonelikler",
      tabsLabel: "Abonelik bölümleri",
      tabs: { subscriptions: "Abonelikler", plans: "Planlar" },
      create: "Abonelik aç",
      createTitle: "Abonelik aç",
      createHint:
        "Filo carisi ya da carili müşteri için faturalı; kasa aboneliği web'den yalnızca gerekçeli ücretsiz tanım olarak açılır.",
      created: "Abonelik açıldı",
      noPlans: "Etkin plan yok; önce plan ekleyin.",
      detailTitle: "Abonelik",
      summaryTitle: "Abonelik",
      plan: "Plan",
      subscriber: "Abone",
      subscriberCustomer: "Müşteri",
      subscriberFleet: "Filo carisi",
      fleetAccount: "Filo hesabı",
      billing: "Ücretlendirme",
      complimentary: "Ücretsiz tanım (gerekçeli)",
      invoice: "Faturalı",
      posBilling: "Kasa",
      complimentaryHint: "Ücret kaydı açılmaz, otomatik yenilenmez; dönem sonunda biter.",
      invoiceCustomerHint: "Müşterinin bağlı carisine dönem faturası kesilir (faturalama turu).",
      invoiceFleetHint: "Dönem ücreti faturalama turuyla filo carisine faturalanır.",
      complimentaryReason: "Ücretsiz tanım gerekçesi",
      complimentaryReasonHint: "Denetim izine yazılır (en az 3 karakter).",
      vehicle: "Araç",
      vehicleHint: "Plan araca bağlı: hak yalnızca bu plakada kullanılır.",
      startDate: "Başlangıç günü",
      autoRenew: "Otomatik yenile",
      noAutoRenew: "Otomatik yenilenmez",
      period: "Dönem",
      periodStart: "Dönem başı",
      remaining: "Kalan hak",
      remainingText: "{{remaining}} / {{total}}",
      usedPercent: "%{{percent}} kullanıldı",
      usedLabel: "Dönem hakkının kullanımı",
      noCurrentPeriod: "Bugünü kapsayan dönem yok",
      today: "Bugün",
      todayText: "{{used}} / {{limit}} kullanıldı",
      todayNoLimit: "{{used}} kullanıldı (günlük sınır yok)",
      startedAt: "Başlangıç",
      cancelReason: "İptal gerekçesi: {{reason}}",
      emptyTitle: "Abonelik yok",
      emptyDescription: "Kasada plan ürünü satın alınınca ya da buradan açılınca abonelikler listelenir.",
      chargesTitle: "Dönem ücretleri",
      chargesHint: "Her dönem en çok bir kez ücretlendirilir.",
      noCharges: "Henüz dönem ücreti yok; faturalama turunda kesilir.",
      noChargesPos: "Ücret kaydı yok (kasa satışıyla ya da ücretsiz tanımla açıldı).",
      chargeSource: "Belge",
      chargedAt: "Kayıt",
      usagesTitle: "Hak kullanımı",
      usagesEmptyTitle: "Henüz kullanım yok",
      usagesEmptyDescription: "Kasada hakla sıfırlanan satırlar burada listelenir.",
      usedAt: "Zaman",
      quantity: "Miktar",
      overuse: "Aşım",
      overuseYes: "Aşım (uyarı)",
      actions: {
        pause: "Duraklat",
        resume: "Sürdür",
        cancel: "İptal et",
        pauseTitle: "Aboneliği duraklat",
        resumeTitle: "Aboneliği sürdür",
        cancelTitle: "Aboneliği iptal et",
        pauseHint: "Duraklatılan abonelikte hak kullanılamaz.",
        resumeHint: "Abonelik yeniden etkin olur.",
        cancelHint: "İptal geri alınamaz; gerekçe zorunludur.",
        pauseDone: "Abonelik duraklatıldı",
        resumeDone: "Abonelik sürdürüldü",
        cancelDone: "Abonelik iptal edildi",
      },
    },
    billing: {
      open: "Faturalama turu",
      title: "Abonelik faturalama turu",
      hint: "Faturalı aboneliklerin ücreti kesilmemiş dönemleri için cari başına bir satış faturası kesilir. Aynı dönem iki kez faturalanmaz.",
      asOf: "Fatura tarihi",
      asOfHint: "Fatura ve vade günü; boşsa bugün.",
      run: "Faturaları kes",
      done: "{{count}} fatura kesildi",
      nothing: "Faturalanacak abonelik dönemi yok.",
      invoices: "Kesilen faturalar",
      openInvoice: "Faturayı aç",
      subscriptionCount: "{{count}} abonelik",
      skipped: "Atlanan {{count}} abonelik",
      openSubscription: "Aboneliği aç",
    },
    reports: {
      description:
        "Puan yükümlülüğü (açık puan ↔ muhasebe defteri) ve dönem özeti: kazanılan, harcanan, süresi dolan ve geri alınan puan.",
      tabsLabel: "Rapor türü",
      tabs: { liability: "Yükümlülük", summary: "Dönem özeti" },
      company: "Şirket",
      allCompanies: "Tüm şirketler",
      asOf: "Kesim günü",
      asOfHint: "Defter bakiyesinin kesim günü ve yaşlandırma referansı.",
      from: "Başlangıç",
      to: "Bitiş",
      liabilityTitle: "Puan yükümlülüğü",
      liabilityMeta: "Puan değeri {{value}} · hesaplandı {{at}}",
      outstanding: "Açık puan karşılığı",
      ledgerBalance: "Defter bakiyesi (379)",
      noLedger: "Eşleştirme yok",
      difference: "Fark",
      matched: "Uyumlu",
      different: "Fark var",
      unclosed: "Gün kapanışı bekleyen",
      unclosedHint: "Henüz deftere yazılmadı",
      pendingReview: "İncelemede",
      negativeBalances: "Eksi bakiyeler",
      negativeHint: "{{count}} hesap · {{points}} puan (kiracı geneli)",
      differenceTitle: "Açık puan ile defter bakiyesi arasında fark var",
      differenceSources:
        "Olası kaynaklar: kapanmamış günler (vardiya gün sonu yapılmadı), puanla ödemenin gün sonu fişine henüz girmemesi, eksi bakiyeler, puan değeri değişikliği ve şirketler arası harcama (A'da kazanılıp B'de harcanan puan).",
      noLedgerHint: "Şirkette sadakat yükümlülüğü (LOYALTY_LIABILITY) eşleştirmesi yok.",
      openMappings: "Eşleştirmelere git",
      warnings: "Uyarılar",
      agingTitle: "Yaşlandırma",
      agingHint: "Açık puanın süre sonuna kalan güne göre dağılımı.",
      agingChartAria: "Açık puanın süre sonuna göre ₺ karşılığı",
      agingTable: "Yaşlandırma tablosu",
      valueAxis: "Tutar (₺)",
      bucket: "Süre sonuna",
      share: "Pay",
      byStationTitle: "İstasyon kırılımı",
      noOutstanding: "Açık puan yok.",
      summaryTitle: "Dönem özeti: {{from}} – {{to}}",
      totals: {
        earned: "Kazanılan",
        redeemed: "Harcanan",
        expired: "Süresi dolan",
        reversed: "Geri alınan (iade)",
        restored: "Geri yüklenen",
        adjusted: "Düzeltme",
        pendingReview: "İncelemede",
      },
      activeMembers: "Etkin üye",
      byUnitTitle: "İş birimine göre kazanım",
      byUnitChartAria: "İş birimine göre kazanılan puan",
      byUnitTable: "İş birimine göre kazanım tablosu",
      businessUnit: "İş birimi",
      earnedPoints: "Kazanılan puan",
      unknownUnit: "Belirsiz",
      noEarn: "Dönemde kazanım yok.",
      tiersTitle: "Seviye dağılımı",
      tiersChartAria: "Seviyelere göre hesap sayısı",
      tiersTable: "Seviye dağılımı tablosu",
      tier: "Seviye",
      accounts: "Hesap",
      noTier: "Seviyesiz",
      noMembers: "Henüz sadakat hesabı yok.",
      byStationSummaryTitle: "İstasyon bazında hareketler",
      noMovements: "Dönemde puan hareketi yok.",
      noStation: "İstasyonsuz",
    },
  },
  portal: {
    title: "Filo portalı",
    navLabel: "Filo portalı menüsü",
    nav: {
      summary: "Özet",
      vehicles: "Araçlar",
      transactions: "İşlemler",
      invoices: "Faturalar",
      requests: "Araç taleplerim",
    },
    security: "Hesap güvenliği",
    backToPortalTitle: "Bu hesap filo portalı hesabıdır",
    backToPortal: "Filo portalına dön",
    noAccessTitle: "Filo portalı erişiminiz yok",
    noAccessDescription:
      "Filo portalı yalnızca bir filo carisine atanmış portal kullanıcıları içindir. Personel ekranlarını yönetim panelinden kullanın.",
    toStaffPanel: "Yönetim paneline git",
    noAccountsTitle: "Erişilebilir filo hesabı yok",
    noAccountsDescription:
      "Filo hesabınız askıya alınmış ya da portalı kapatılmış olabilir. İstasyon yetkilisiyle görüşün.",
    accountLabel: "Filo",
    selectAccount: "Filo hesabı",
    noLimit: "limit yok",
    unlimited: "Limitsiz",
    fields: {
      plate: "Plaka",
      vehicle: "Araç",
      dayLitres: "Bugün litre",
      monthLitres: "Bu ay litre",
      dayAmount: "Bugün tutar",
      monthAmount: "Bu ay tutar",
      lastOdometer: "Son km",
      limits: "Limitler",
      hours: "İzinli saatler",
      requirements: "Zorunluluklar",
      status: "Durum",
      occurredAt: "Zaman",
      station: "İstasyon",
      driver: "Sürücü",
      product: "Ürün",
      litres: "Miktar",
      amount: "Tutar",
      odometer: "Km",
      kind: "Tür",
      receipt: "ÖKC fişi",
      from: "Başlangıç",
      to: "Bitiş",
      invoiceNo: "Fatura no",
      company: "Kesen şirket",
      basis: "Fatura türü",
      issueDate: "Fatura tarihi",
      dueDate: "Vade",
      payable: "Ödenecek",
      requestedAt: "Talep zamanı",
      decision: "Karar",
      brand: "Marka",
      model: "Model",
      note: "Not",
      fuel: "Yakıt",
      allowed: "İzinli ürün / istasyon",
    },
    summary: {
      title: "Filo özeti",
      description: "Kredi durumu, filonun bugünkü ve bu ayki kullanımı ve araç başına limitler.",
      credit: "Kredi",
      noCredit: "Kredi bilgisi yok.",
      creditLimit: "Kredi limiti",
      balance: "Bakiye (risk)",
      available: "Kullanılabilir",
      usage: "Kullanım",
      today: "Bugün ({{day}}) litre",
      todayAmount: "Bugün tutar",
      month: "Bu ay ({{month}}) litre",
      monthAmount: "Bu ay tutar",
      billingCycle: "Fatura dönemi",
      vehiclesCaption: "Araç başına kullanım ve limitler",
    },
    vehicles: {
      title: "Araçlar",
      description: "Filonuzun araçları ve istasyonda uygulanan kuralları.",
      transactions: "işlemlerini göster",
      daily: "Günlük {{value}}",
      monthly: "Aylık {{value}}",
      anyTime: "Her saat",
      everyDay: "Her gün",
      allDay: "gün boyu",
      odometer: "Km zorunlu",
      driverCard: "Sürücü kartı zorunlu",
      onViolation: "İhlalde: {{action}}",
      allProducts: "Tüm ürünler",
      allStations: "Tüm istasyonlar",
      products: "Ürün: {{names}}",
      stations: "İstasyon: {{names}}",
      none: "hiçbiri",
      emptyTitle: "Araç yok",
      emptyDescription: "Araç eklemek için “Araç taleplerim” ekranından talep gönderin.",
    },
    transactions: {
      title: "İşlemler",
      description: "Filoya yazılan alımlar; iptal ve iadeler eksi tutarla görünür.",
      kind: { SALE: "Satış", REVERSAL: "İptal / iade" },
      emptyTitle: "İşlem yok",
      emptyDescription: "Seçilen süzgeçlerle eşleşen işlem bulunamadı.",
    },
    invoices: {
      title: "Faturalar",
      description: "Filonuza kesilen satış faturaları (yalnızca görüntüleme).",
      basis: { STANDARD: "Satış faturası", FISCAL_RECEIPTS: "Fişli satış faturası (dönem)" },
      status: { ISSUED: "Kesildi", CANCELLED: "İptal" },
      emptyTitle: "Fatura yok",
      emptyDescription: "Dönem faturaları kesildikçe burada listelenir.",
    },
    requests: {
      title: "Araç taleplerim",
      description:
        "Filoya yeni araç eklemek için talep gönderin; istasyon onaylayınca araç listenize eklenir.",
      newTitle: "Yeni araç talebi",
      newDescription: "Kurallar (limit, saat, izinli ürün) istasyon onayında belirlenir.",
      fuelHint: "Aracın kullandığı yakıt; istasyon onayda değiştirebilir.",
      noFuel: "Belirtilmedi",
      noteHint: "Ör. sürücü, kullanım amacı ya da istenen limit.",
      submit: "Talebi gönder",
      sent: "Araç talebi gönderildi",
      caption: "Araç talepleri",
      emptyTitle: "Talep yok",
      emptyDescription: "Gönderdiğiniz araç talepleri ve kararları burada görünür.",
    },
  },
  users: {
    description: "Hesabınıza erişebilen kişiler, rolleri ve bekleyen davetler.",
    tabs: { users: "Kullanıcılar", invitations: "Davetler" },
    invite: "Kullanıcı davet et",
    inviteDescription:
      "Davet e-postayla gönderilir ve sınırlı bir süre geçerlidir. Kişi daveti kabul edince seçtiğiniz rollerle hesaba katılır.",
    you: "siz",
    role: "Rol",
    roles: "Roller",
    rolesAndScopes: "Roller ve kapsamları",
    scopeType: "Kapsam türü",
    scope: "Kapsam",
    wholeAccount: "Tüm hesap",
    addAssignment: "Rol ekle",
    removeAssignment: "Rolü kaldır",
    sendInvitation: "Daveti gönder",
    invitationSent: "{{email}} adresine davet gönderildi",
    invitationRevoked: "Davet iptal edildi",
    revokeInvitation: "İptal et",
    pendingInvitations: "Bekleyen davetler",
    invitedAt: "Gönderilme",
    expiresAt: "Son geçerlilik",
    lastLogin: "Son giriş",
    noRoles: "Rol atanmamış",
    noRolesWarning: "Hiç rolü olmayan kullanıcı giriş yapabilir ama hiçbir veriye erişemez.",
    portalScopeHint:
      "Filo portalı kullanıcısı yalnızca seçilen filo carisinin verisini görür; personel ekranlarına erişemez.",
    noPortalAccounts:
      "Portalı açık etkin filo hesabı yok. Önce Filo hesapları ekranından hesabın portalını açın.",
    actionsFor: "{{name}} için işlemler",
    editRoles: "Rolleri düzenle",
    suspend: "Askıya al",
    reactivate: "Yeniden etkinleştir",
    remove: "Hesaptan çıkar",
    empty: { title: "Kullanıcı yok", description: "Ekip arkadaşlarınızı davet ederek başlayın." },
    invitationsEmpty: {
      title: "Davet yok",
      description: "Gönderdiğiniz davetler ve durumları burada listelenir.",
    },
    confirm: {
      ACTIVE: {
        title: "Üyelik yeniden etkinleştirilsin mi?",
        description: "{{name}} önceki rolleriyle yeniden giriş yapabilecek.",
        action: "Etkinleştir",
      },
      SUSPENDED: {
        title: "Üyelik askıya alınsın mı?",
        description:
          "{{name}} bu hesaba erişemeyecek ve açık oturumları kapatılacak. Rolleri korunur; dilediğinizde geri açabilirsiniz.",
        action: "Askıya al",
      },
      REMOVED: {
        title: "Kullanıcı hesaptan çıkarılsın mı?",
        description:
          "{{name}} bu hesaba erişimini kaybedecek ve tüm rolleri kaldırılacak. Geçmiş işlemlerindeki adı korunur.",
        action: "Hesaptan çıkar",
      },
    },
  },
  roles: {
    description:
      "Hazır rolleri kullanın ya da işletmenize özel roller oluşturun. Rolün geçerli olduğu kapsam, kullanıcıya atanırken seçilir.",
    add: "Rol oluştur",
    permission: "İzin",
    permissions: "İzinler",
    matrixCaption: "Rollere göre izin matrisi",
    systemRole: "Sistem rolü",
    systemRoleHint: "Sistem rolleri düzenlenemez; yeni modüllerin izinleri bu rollere kendiliğinden eklenir.",
    inactiveHint: "Bu rol pasif: atanmış kullanıcılara yetki vermez ve yeni atamalarda seçilemez.",
    stepUpRequired: "Yeniden kimlik doğrulama ister",
    stepUpLegend: "Bu simgeli izinler hassastır; işlem anında parola ya da doğrulama kodu yeniden istenir.",
    selectAllIn: "{{module}} modülündeki tüm izinleri seç",
    selectedCount: "{{count}} izin seçili",
    fields: { name: "Rol adı", description: "Açıklama" },
  },
  security: {
    description: "Hesabınızı koruyan ayarlar: iki adımlı doğrulama, parola ve açık oturumlar.",
    mfa: {
      short: "2FA",
      title: "İki adımlı doğrulama",
      description:
        "Girişte parolanıza ek olarak telefonunuzdaki doğrulama uygulamasının ürettiği kod istenir.",
      requiredBadge: "Zorunlu — kurulmamış",
      setup: "Kurulumu başlat",
      step1:
        "Telefonunuza bir doğrulama uygulaması kurun (Google Authenticator, Microsoft Authenticator, 1Password…).",
      step2: "Uygulamada QR kodu okutun ya da anahtarı elle girin.",
      step3: "Uygulamanın gösterdiği 6 haneli kodu aşağıya yazın.",
      qrAlt: "Doğrulama uygulamasına okutulacak QR kod",
      manualKey: "QR okutamıyorsanız bu anahtarı elle girin:",
      codeHint: "Doğrulama uygulamanızdaki 6 haneli kod.",
      enable: "Doğrula ve etkinleştir",
      recoveryTitle: "Kurtarma kodlarınızı saklayın",
      recoveryDescription:
        "Telefonunuza erişemezseniz bu kodlarla giriş yapabilirsiniz. Her kod bir kez kullanılır ve bu liste bir daha GÖSTERİLMEZ.",
      recoverySaved: "Kodları kaydettim",
      regenerate: "Kurtarma kodlarını yenile",
      regenerateDescription: "Eski kurtarma kodlarının tümü geçersiz olur.",
      disable: "İki adımlı doğrulamayı kapat",
      disableDescription:
        "Hesabınız yalnızca parolayla korunur. Onaylamak için parolanızı ve güncel bir doğrulama kodunu girin.",
      disableRequiredWarning:
        "İşletmeniz iki adımlı doğrulamayı zorunlu kılıyor: kapatırsanız yeniden kurana dek hesabı kullanamazsınız.",
    },
    password: {
      title: "Parola",
      description: "Parolanızı değiştirdiğinizde diğer cihazlardaki oturumlarınız kapatılır.",
      current: "Mevcut parola",
      new: "Yeni parola",
      change: "Parolayı değiştir",
      changed: "Parolanız değiştirildi",
      changedHint: "Diğer cihazlardaki oturumlarınız kapatıldı.",
    },
    sessions: {
      title: "Açık oturumlar",
      description:
        "Hesabınıza giriş yapılmış cihazlar. Tanımadığınız bir oturumu kapatın ve parolanızı değiştirin.",
      current: "Bu cihaz",
      unknownDevice: "Bilinmeyen cihaz",
      lastUsed: "Son kullanım: {{date}}",
      revoke: "Oturumu kapat",
      revoked: "Oturum kapatıldı",
      revokeOthers: "Diğer tüm oturumları kapat",
      revokeOthersConfirm:
        "Bu cihaz dışındaki {{count}} oturum kapatılacak. O cihazlarda yeniden giriş yapmak gerekecek.",
    },
    tenant: {
      title: "İşletme güvenlik ilkesi",
      description: "Bu ayar hesabınızdaki TÜM kullanıcılar için geçerlidir.",
      mfaRequired: "Tüm kullanıcılar için iki adımlı doğrulamayı zorunlu kıl",
      mfaRequiredHint:
        "Kurulum yapmamış kullanıcılar bir sonraki girişte kuruluma yönlendirilir ve tamamlayana dek başka işlem yapamaz.",
      enableOwnFirst: "Kendinizi hesabın dışında bırakmamak için önce kendi iki adımlı doğrulamanızı kurun.",
    },
  },
  profile: {
    description: "Kişisel bilgileriniz ve bu cihazdaki görünüm tercihleri.",
    personal: "Kişisel bilgiler",
    emailHint: "E-posta adresi giriş kimliğinizdir; değiştirmek için destek ekibine ulaşın.",
    appearance: "Görünüm",
    appearanceHint: "Bu tercihler hesabınıza değil bu cihaza kaydedilir.",
    theme: "Tema",
    themes: { light: "Açık", dark: "Koyu", system: "Sistem" },
    highContrast: "Yüksek kontrast",
    highContrastHint:
      "Metin ve kenarlık kontrastını artırır; parlak güneş altındaki ekranlarda ve az görenler için okumayı kolaylaştırır.",
    memberships: "Üyesi olduğunuz hesaplar",
  },
  wash: {
    disabledTitle: "Araç yıkama modülü kapalı",
    disabledDescription:
      "Yıkama üniteleri, programlar, el yıkama iş emirleri ve raporlar bu hesapta açık değil. Modülü planınızdan açabilirsiniz.",
    noPermission: {
      read: "Yıkama ekranlarını görüntüleme yetkiniz yok.",
      manage: "Yıkama tanımlarını yönetme yetkiniz yok.",
      operate: "Yıkama işlemlerini yürütme yetkiniz yok.",
      reports: "Yıkama maliyet ve marj raporlarını görüntüleme yetkiniz yok.",
    },
    noStationsTitle: "Yıkama birimi olan istasyon yok",
    noStationsDescription:
      "Yıkama istasyon bazındadır. İstasyonun iş birimlerinde araç yıkamayı açın ya da yetkili kişiden kapsamınıza bir yıkama istasyonu eklenmesini isteyin.",
    conflict:
      "Kayıt siz düzenlerken başka biri tarafından değiştirildi. Güncel hâli yüklendi; değişikliğinizi yeniden yapın.",
    weekdays: { 1: "Pzt", 2: "Sal", 3: "Çar", 4: "Per", 5: "Cum", 6: "Cmt", 7: "Paz" },
    weekdaysLong: {
      1: "Pazartesi",
      2: "Salı",
      3: "Çarşamba",
      4: "Perşembe",
      5: "Cuma",
      6: "Cumartesi",
      7: "Pazar",
    },
    paymentType: { CASH: "Nakit / jeton kutusu", CARD: "Makinenin kart okuyucusu" },
    fields: {
      station: "İstasyon",
      unit: "Ünite",
      program: "Program",
      code: "Kod",
      name: "Ad",
      kind: "Tür",
      product: "Satış ürünü",
      duration: "Süre",
      durationMinutes: "Tahmini süre (dk)",
      waterPerRun: "Çalışma başına su (L)",
      waterPerMinute: "Dakika başına su (L)",
      electricityPerRun: "Çalışma başına elektrik (kWh)",
      electricityPerMinute: "Dakika başına elektrik (kWh)",
      startMode: "Başlatma biçimi",
      deviceRef: "Cihaz başvurusu",
      deviceProgramCode: "Makine kodu",
      capacity: "Kapasite (eşzamanlı araç)",
      slotMinutes: "Randevu aralığı (dk)",
      waterMeter: "Su alt sayacı",
      electricityMeter: "Elektrik alt sayacı",
      trigger: "Tetik",
      startedAt: "Başlangıç",
      endedAt: "Bitiş",
      localDay: "İş günü",
      reason: "Gerekçe",
      plate: "Plaka",
      customer: "Müşteri kaydı",
      cardLast4: "Kart …{{last4}}",
      contactName: "Ad soyad",
      contactPhone: "Telefon",
      note: "Not",
      staff: "Personel",
    },
    units: {
      description:
        "Ünitelerin canlı durumu, sürmekte olan çalışma, bugünkü çalışma sayısı ve başlatma biçimi. Durum ajandan anlık gelir.",
      listLabel: "Yıkama üniteleri",
      emptyTitle: "Bu istasyonda yıkama ünitesi yok",
      emptyDescription: "Üniteler istasyon ayarlarındaki yıkama birimlerinden gelir.",
      todayTotal: "Bugünkü çalışma",
      todayCycles: "Bugün",
      lastCycle: "Son çalışma",
      since: "{{at}} itibarıyla",
      noState: "Durum bilgisi yok",
      current: "Çalışıyor: {{program}}",
      currentUnknown: "Çalışıyor",
      currentUnknownHint:
        "Program bilinmiyor (makinenin kendi tahsilatı ya da kredi); çalışma bitince kaydedilir.",
      startedAt: "Başlangıç {{at}}",
      remaining: "kalan ≈ {{duration}}",
      elapsed: "geçen {{duration}}",
      overdue: "tahmini süre doldu",
      waterMeter: "Su: {{name}}",
      electricityMeter: "Elektrik: {{name}}",
      programs: "Programlar (makine kodu)",
      noPrograms: "Program tanımlanmamış",
      minutes: "{{count}} dk",
      defaultSettings: "Ünite ayarı henüz kaydedilmedi (varsayılan: elle başlatma).",
    },
    unitSettings: {
      open: "Ayarlar",
      openFor: "Ayarlar: {{name}}",
      title: "Ünite ayarı: {{name}}",
      description:
        "Başlatma biçimi, cihaz başvurusu, alt sayaçlar ve ünitede sunulan programlar. Kaydedince istasyonun yıkama kimyasal deposu (market açıksa) kendiliğinden açılır.",
      formLabel: "Ünite ayarı",
      startModeHint:
        "Uzaktan: ajan makineyi başlatır. Kod: fişe basılan tek kullanımlık kod makinede girilir. Elle: entegrasyon yok, çalışma elle kaydedilir.",
      handWashManual: "El yıkama ünitesi yalnızca elle çalışır.",
      deviceRefHint: "Ajan adaptöründeki bölme / makine adı (ör. BAY-1); istasyonda tekildir.",
      deviceRefRequired: "Uzaktan ya da kodla başlatılan ünitede cihaz başvurusu zorunludur.",
      capacityHint: "Aynı anda kaç araç işlenebilir (randevu uygunluğu buna göre hesaplanır).",
      slotHint: "Randevu başlangıçlarının önerildiği adım (5–240 dk).",
      openingHours: "Çalışma saatleri",
      openingHoursHint:
        "Randevular bu pencerelerin içine tamamen sığmalıdır. Gün seçilmeyen satır her gün geçerlidir; saatler İstanbul saatidir, bitiş hariçtir.",
      noOpeningHours: "Çalışma saati tanımlı değil — randevu alınamaz.",
      windowDays: "{{index}}. pencerenin günleri",
      everyDay: "Her gün",
      from: "{{index}}. pencere başlangıç",
      to: "{{index}}. pencere bitiş",
      removeWindow: "Sil: {{index}}. pencere",
      addWindow: "Pencere ekle",
      rowIssue: {
        time: "Saat HH:MM biçiminde olmalıdır.",
        order: "Bitiş saati başlangıçtan sonra olmalıdır.",
        overlap: "Aynı günde başka bir pencereyle örtüşüyor.",
      },
      meters: "Alt sayaçlar",
      metersHint:
        "Ünite sayacı varsa su / elektrik maliyeti o sayacın okumalarından bu ünitenin çalışmalarına paylaştırılır; yoksa istasyonun yıkama alt sayacı (altındaki ünite sayaçları düşülerek) ya da programın tahmini kullanılır.",
      meterParent: "üst sayaç: {{name}}",
      noMeter: "Sayaç yok (istasyon sayacı / tahmin)",
      programs: "Ünitede sunulan programlar",
      programsHint:
        "Makinedeki program kodu uzaktan ve kodla başlatmada makineye gönderilir (ünitede tekil).",
      programsHandHint: "El yıkama hizmetleri randevu ve iş emrinde seçilebilir.",
      noPrograms: "Bu ünite türüne uygun program yok. Önce Programlar ekranında program tanımlayın.",
      deviceProgramCodeFor: "{{code}} için makine kodu",
      saved: "{{name}} ünitesinin ayarı kaydedildi",
    },
    remoteStart: {
      open: "Uzaktan başlat",
      openFor: "Uzaktan başlat: {{name}}",
      title: "Uzaktan başlat: {{name}}",
      description:
        "İstasyon ajanına başlatma komutu gönderilir. Sonuç ajan makineyi başlatınca (ya da komutun süresi dolunca) burada görünür.",
      noPrograms: "Bu ünitede etkin program yok.",
      submit: "Başlat",
      status: "Durum:",
      pendingHint: "Ajanın yanıtı bekleniyor (komut en geç {{at}} itibarıyla düşer).",
      retryHint: "Başlatılamadı. Makineyi ve ajan bağlantısını kontrol edip yeniden deneyin.",
      failedTitle: "Başlatma gönderilemedi",
      errors: {
        WASH_AGENT_UNAVAILABLE:
          "İstasyon ajanına ulaşılamıyor: istasyonda yıkama destekli, çevrimiçi bir ajan yok. Ajan bağlantısını kontrol edin ya da makineyi kasadan başlatın.",
        WASH_START_UNSUPPORTED:
          "Bu ünite uzaktan başlatılamaz: başlatma biçimi 'uzaktan' değil, cihaz başvurusu eksik ya da program ünitede etkin değil.",
      },
    },
    manualCycle: {
      open: "Elle çalışma kaydı",
      short: "Elle kaydet",
      openFor: "Elle kaydet: {{name}}",
      title: "Elle çalışma kaydı",
      description:
        "Entegrasyonu olmayan (elle başlatılan) ünitede yapılan çalışmayı kaydedin; kimyasal tüketimi ve raporlar buna göre hesaplanır.",
      noUnits: "Elle başlatılan etkin ünite yok.",
      noPrograms: "Ünitede program yok",
      invalidTime: "Geçerli bir tarih ve saat girin.",
      notManual: "Bu ünite elle başlatılmıyor; çalışmalar ajandan gelir.",
      submit: "Kaydet",
      saved: "Çalışma kaydedildi",
    },
    programs: {
      description:
        "Yıkama programları: satış ürünü (fiyat ürünün istasyon fiyatıdır), süre, tahmini su / elektrik ve kimyasal reçetesi.",
      add: "Program ekle",
      caption: "Yıkama programları",
      count: "{{count}} program",
      emptyTitle: "Henüz yıkama programı yok",
      emptyDescription:
        "Program ekleyip satış ürününü ve kimyasal reçetesini tanımlayın; sonra ünitelere atayın.",
      createTitle: "Yeni yıkama programı",
      editTitle: "Programı düzenle: {{code}}",
      editLabel: "Düzenle: {{code}}",
      dialogHint:
        "Fiyat programda tutulmaz: satış ürününün istasyon fiyatı geçerlidir. Kod ve tür kaydedildikten sonra değişmez.",
      formLabel: "Yıkama programı",
      codeHint: "1–30 karakter; büyük harf, rakam, - ve _.",
      codeLocked: "Kod kaydedildikten sonra değiştirilemez.",
      kindLocked: "Tür kaydedildikten sonra değiştirilemez.",
      productHint: "İş birimi yıkama olan hizmet ürünü (yıkama hizmeti ya da hizmet).",
      productMinuteHint: "Self-servis kredisi DAKİKA birimli ürünle satılır (satış miktarı = dakika).",
      durationHint: "Makinenin bir çalışmasının tahmini süresi (ör. 7,5).",
      durationRequired: "Self-servis dışındaki programda süre zorunludur.",
      isActive: "Program etkin",
      recipe: "Kimyasal reçetesi",
      recipeHint: "Çalışma başına düşülecek sarf malzemesi miktarları (ürün biriminde).",
      recipeMinuteHint: "Self-serviste miktarlar DAKİKA başınadır; kullanılan süreyle çarpılır.",
      noChemicals:
        "Sarf malzemesi (kimyasal) ürünü yok. Ürün kataloğunda türü 'Sarf malzemesi' olan ürün ekleyin.",
      chemical: "{{index}}. kimyasal",
      quantity: "{{index}}. miktar {{unit}}",
      removeLine: "Sil: {{index}}. reçete satırı",
      addLine: "Kimyasal ekle",
      noRecipe: "Reçete yok",
      units: "Sunan üniteler",
      noUnits: "Henüz hiçbir ünitede sunulmuyor.",
      unitsHint: "Program ünitelere Üniteler ekranındaki ünite ayarından atanır.",
      unknownUnit: "Görünmeyen ünite",
      perMinute: "Dakika başına",
      perMinuteShort: "/ dk",
      utilities: "Su · elektrik",
      created: "{{code}} programı eklendi",
      updated: "{{code}} programı güncellendi",
    },
    cycles: {
      description:
        "Makinelerin her çalışması: kasadan, koddan, krediden, uygulamadan, makinenin kendi tahsilatından ya da elle.",
      tabsLabel: "Çalışmalar ve başlatmalar",
      tabs: { cycles: "Çalışmalar", activations: "Başlatmalar" },
      caption: "Yıkama çalışmaları",
      emptyTitle: "Bu aralıkta çalışma yok",
      emptyDescription:
        "Makine çalışmaları ajandan gelir; elle başlatılan ünitede çalışmayı elle kaydedebilirsiniz.",
      machineAmount: "Makine tahsilatı",
      unknownUnit: "tanınmayan ünite",
      links: "Bağlantılar",
      workOrder: "İş emri",
      credit: "Kredi",
      closed: "Gün kapanışında",
      warnings: "Uyarı: {{codes}}",
    },
    activations: {
      caption: "Yıkama başlatmaları",
      emptyTitle: "Başlatma kaydı yok",
      emptyDescription:
        "Kasadan, müşteri uygulamasından ya da web'den yapılan başlatmalar burada listelenir.",
      createdAt: "İstek",
      source: "Kaynak",
      method: "Biçim",
      hasCode: "Kodlu (kod gösterilmez)",
      sale: "Satış bağı",
      openSale: "Kasa fişi",
      line: "satır {{no}}",
      subscription: "Abonelik hakkı",
      finishedAt: "Sonuç zamanı",
    },
    credits: {
      description:
        "Self-servis süre kredileri. Başlatma kodu gizlidir ve hiçbir ekranda gösterilmez; kalıcı kart numarası maskelidir.",
      caption: "Self-servis kredileri",
      codeNotice:
        "Kod taşıyana aittir (bearer): sistemde yalnızca özeti tutulur, ekranda ve dışa aktarımda yer almaz.",
      emptyTitle: "Kredi bulunamadı",
      emptyDescription: "Self-servis dakika ürünü kasadan satıldığında kredi kendiliğinden açılır.",
      card: "Kart",
      codeCredit: "Kodlu kredi (kartsız)",
      noCard: "Kartsız (yalnızca kod)",
      balance: "Bakiye",
      expiresAt: "Bitiş",
      createdAt: "Açılış",
      updatedAt: "Son değişiklik",
      detailTitle: "Kredi",
      detailHeading: "Kredi: {{label}}",
      negativeHint:
        "Bakiye eksiye düşmüş: kredi çevrimdışıyken iki bölmede kullanılmış olabilir. Kullanım reddedilmez; gerekirse düzeltme girin.",
      ledger: "Kredi defteri",
      noEntries: "Defter satırı yok",
      noEntriesDescription: "Satın alma, kullanım, düzeltme ve süre sonu satırları burada görünür.",
      occurredAt: "Zaman",
      entryType: "Hareket",
      seconds: "Süre",
      source: "Kaynak",
      fromCycle: "Makine çalışması",
      adjust: "Düzelt",
      adjustTitle: "Kredi bakiyesini düzelt",
      adjustDescription: "Güncel bakiye: {{balance}}. Düzeltme deftere ayrı bir satır olarak yazılır.",
      direction: "İşlem",
      add: "Süre ekle",
      subtract: "Süre düş",
      minutes: "Süre (dk)",
      minutesHint: "Ondalık girilebilir (2,5 = 2 dk 30 sn).",
      minutesRequired: "Süre girin.",
      minutesInvalid: "Sıfırdan büyük bir süre girin.",
      adjustSubmit: "Düzeltmeyi kaydet",
      adjusted: "Kredi düzeltildi ({{duration}})",
      block: "Kilitle",
      unblock: "Kilidi aç",
      blockTitle: "Krediyi kilitle",
      unblockTitle: "Kredinin kilidini aç",
      blockDescription: "Kilitli kredi makinelerde kullanılamaz (ajan ana verisinden düşer).",
      unblockDescription: "Kredi yeniden kullanılabilir olur; süresi dolmuşsa 'süresi doldu' olarak açılır.",
      reasonOptional: "İsteğe bağlı (en az 3 karakter); denetim izine yazılır.",
      reasonShort: "Gerekçe en az 3 karakter olmalıdır.",
      blocked: "Kredi kilitlendi",
      unblocked: "Kredinin kilidi açıldı",
    },
    chemicals: {
      description:
        "İstasyonun yıkama deposundaki kimyasallar: bakiye, son dönem tüketimi ve kaç gün yeteceği. Alım ve sayım market ekranlarından yapılır.",
      caption: "Yıkama kimyasalları",
      tracked: "Stok market stok defterinde, yıkama deposunda tutuluyor.",
      untracked: "Bu istasyonda market modülü kapalı: kimyasal stoğu tutulmuyor.",
      untrackedHint:
        "Tüketim reçete × çalışmadan TEORİK hesaplanır; maliyet hesaplanmaz. Stok takibi için istasyonda market iş birimini açın.",
      theoretical: "Teorik",
      period: "Son {{days}} günün tüketimine göre; {{threshold}} günden az kalanlar uyarılır.",
      noWarehouse: "Yıkama deposu henüz açılmadı: ilk ünite ayarı ya da ilk tüketimle kendiliğinden açılır.",
      lowTitle: "{{count}} kimyasal azalıyor",
      lowHint:
        "{{threshold}} günden az yetecek ya da tükenmiş kimyasallar var. Market mal kabulüyle yıkama deposuna alım girin.",
      receipts: "Mal kabul",
      counts: "Sayım",
      stock: "Yıkama deposu stoğu",
      emptyTitle: "Kimyasal yok",
      emptyDescription: "Program reçetesinde ya da yıkama deposunda kimyasal bulunmuyor.",
      product: "Kimyasal",
      quantity: "Bakiye",
      value: "Değer",
      averageCost: "ort. {{cost}} ₺ / {{unit}}",
      consumed: "Son {{days}} gün",
      dailyAverage: "Günlük ort.",
      cover: "Kapsama",
      coverUnknown: "Tüketim yok",
      coverNone: "Tükendi",
      coverLow: "{{days}} gün (az)",
      coverOk: "{{days}} gün",
      programs: "Reçetesindeki programlar",
      unused: "Reçetede yok",
      notTracked: "Takip yok",
    },
    appointments: {
      description:
        "El yıkama randevuları: seçilen hizmetlere göre boş kapasiteli saatler, randevu alma ve günün randevuları.",
      noHandUnitTitle: "Bu istasyonda el yıkama ünitesi yok",
      noHandUnitDescription:
        "Randevu el yıkama (detaylı temizlik) ünitesinde alınır. İstasyon ayarlarında 'El yıkama' türünde yıkama birimi ekleyin.",
      openStation: "İstasyon ayarlarını aç",
      day: "Gün",
      today: "Bugün",
      availability: "Uygun saatler",
      services: "Hizmetler",
      pickService: "Uygun saatleri görmek için en az bir hizmet seçin.",
      noServices: "Bu ünitede etkin el yıkama hizmeti yok. Ünite ayarından program atayın.",
      duration: "Toplam süre: {{minutes}} dk",
      noOpeningHours: "Ünitenin çalışma saati tanımlı değil; ünite ayarından çalışma saatlerini girin.",
      closedDay: "{{date}} günü ünite kapalı.",
      capacity: "Kapasite {{capacity}} araç · {{slot}} dakikalık adımlar",
      slots: "Saatler",
      free: "{{count}} boş",
      full: "dolu",
      book: "Randevu al",
      bookTitle: "Randevu al — {{unit}}",
      bookDescription: "{{date}} günü için randevu. Müşteri kaydı ya da ad / telefon gereklidir.",
      bookFormLabel: "Randevu",
      slot: "Saat",
      slotHint: "Boş kapasitesi olan saatler önerilir.",
      noSlots: "Uygun saat yok",
      manualTime: "Ya da saat girin",
      manualTimeHint: "Slot hizası zorunlu değildir; sunucu kapasite ve çalışma saatini yine denetler.",
      startRequired: "Randevu saatini seçin.",
      missingPrice: "Bazı hizmetlerin fiyatı tanımsız — geldi işaretlenirken iş emri açılamaz.",
      customerHint:
        "Kayıtlı müşteriyi ad, telefon, kart no ya da plakayla arayın (en az 3 karakter); ad maskeli görünür.",
      phoneHint: "Hazır SMS'i bu numaraya gider.",
      bookSubmit: "Randevuyu kaydet",
      booked: "{{unit}} için {{at}} randevusu alındı",
      bookFailed: "Randevu alınamadı",
      errors: {
        WASH_SLOT_FULL:
          "Bu saat dolu: seçilen süre boyunca ünitenin kapasitesi başka randevularla dolmuş. Başka bir saat seçin.",
        WASH_OUTSIDE_HOURS:
          "Randevu ünitenin çalışma saatleri dışında kalıyor (hizmet süresi pencereye tamamen sığmalı). Daha erken bir saat seçin.",
      },
      dayList: "{{date}} randevuları",
      emptyTitle: "Bu gün randevu yok",
      emptyDescription: "Uygun saatlerden birini seçerek randevu alabilirsiniz.",
      cancelReason: "İptal gerekçesi: {{reason}}",
      openWorkOrder: "İş emri {{no}}",
      checkIn: "Geldi",
      checkInFor: "Geldi: {{at}} randevusu",
      checkInTitle: "Müşteri geldi",
      checkInDescription:
        "{{at}} randevusu ({{services}}) için bekleyen iş emri açılır; fiyat güncel istasyon fiyatıdır.",
      checkInSubmit: "İş emrini aç",
      checkedIn: "İş emri açıldı: {{no}}",
      noShow: "Gelmedi",
      noShowFor: "Gelmedi: {{at}} randevusu",
      noShowDone: "Randevu 'gelmedi' olarak işaretlendi",
      cancel: "İptal",
      cancelFor: "İptal: {{at}} randevusu",
      cancelTitle: "Randevuyu iptal et",
      cancelDescription: "{{at}} randevusu iptal edilir; kapasite yeniden açılır.",
      cancelSubmit: "Randevuyu iptal et",
      cancelled: "Randevu iptal edildi",
    },
    workOrders: {
      description:
        "El yıkama iş emirleri: bekleyen, işlemdeki ve hazır araçlar. Hazır olunca müşteriye SMS gider; teslim ödeme ister.",
      new: "Yeni iş emri",
      emptyTitle: "Açık iş emri yok",
      emptyDescription: "Randevudan 'geldi' ile ya da randevusuz gelen araç için 'Yeni iş emri' ile açılır.",
      columns: {
        WAITING: "Bekliyor",
        IN_PROGRESS: "İşlemde",
        READY: "Hazır",
        DELIVERED: "Bugün teslim edilen",
      },
      columnEmpty: "Araç yok",
      sinceClock: "{{at}} itibarıyla",
      eta: "Tahmini hazır",
      etaAt: "tahmini hazır {{at}}",
      payment: { paid: "Ödendi", warning: "Ödeme uyarısı", unpaid: "Ödeme yok" },
      forward: { IN_PROGRESS: "Başla", READY: "Hazır", DELIVERED: "Teslim et" },
      forwardFor: {
        IN_PROGRESS: "Başla: {{no}}",
        READY: "Hazır: {{no}}",
        DELIVERED: "Teslim et: {{no}}",
      },
      transitioned: {
        IN_PROGRESS: "{{no}} işleme alındı",
        READY: "{{no}} hazır",
        DELIVERED: "{{no}} teslim edildi",
        CANCELLED: "{{no}} iptal edildi",
      },
      createTitle: "Yeni iş emri (randevusuz)",
      editTitle: "İş emrini düzenle: {{no}}",
      formHint:
        "Hizmet fiyatı kayıt anındaki istasyon fiyatıdır. Hazır olunca telefon varsa 'aracınız hazır' SMS'i gönderilir.",
      formLabel: "İş emri",
      noUnit: "Ünite seçilmedi",
      noStaff: "Atanmadı",
      staffHint: "İstasyonun etkin personeli.",
      phoneHint: "Hazır SMS'i bu numaraya gider; boşsa müşteri kaydının telefonu kullanılır.",
      lines: "Hizmetler",
      service: "{{index}}. hizmet",
      quantity: "{{index}}. adet",
      quantityShort: "Adet",
      removeLine: "Sil: {{index}}. hizmet",
      addLine: "Hizmet ekle",
      linesRequired: "En az bir hizmet seçin.",
      estimate: "Tahmini tutar",
      missingPrice: "Bazı hizmetlerin fiyatı tanımsız — iş emri açılamaz.",
      priceSnapshotHint:
        "Fiyat kayıt anında sabitlenir; sonraki fiyat değişikliği bu iş emrini etkilemez. Ödeme kasadan iş emri numarasıyla alınır.",
      createSubmit: "İş emrini aç",
      created: "İş emri açıldı: {{no}}",
      updated: "{{no}} güncellendi",
      detailTitle: "İş emri {{no}}",
      masked: "Kişisel veriler yetkinize göre maskeli gösteriliyor.",
      erased: "Kişisel veriler {{at}} tarihinde anonimleştirildi.",
      appointment: "Randevu",
      walkIn: "Randevusuz",
      openCustomer: "Müşteri kartını aç",
      customerLinked: "Kayıtlı müşteriye bağlı",
      cancel: "İptal et",
      unitPrice: "Birim fiyat",
      amount: "Tutar",
      paymentTitle: "Ödeme",
      paidAmount: "Kasada ödenen",
      paymentHint:
        "Kasada satış {{no}} numarasıyla alındığında ödeme buraya kendiliğinden bağlanır. Ödemesiz teslim gerekçe ister.",
      timelineTitle: "Zaman çizelgesi",
      timeline: {
        WAITING: "Açıldı (bekliyor)",
        IN_PROGRESS: "İşleme alındı",
        READY: "Hazır",
        DELIVERED: "Teslim edildi",
        CANCELLED: "İptal edildi",
      },
      notYet: "Henüz değil",
      sms: "Hazır SMS'i",
      unpaidNote: "Ödemesiz teslim: {{reason}}",
      cancelNote: "Gerekçe: {{reason}}",
      deliverTitle: "Teslim et: {{no}}",
      deliverPaid:
        "Kasa ödemesi bağlı. Teslimde her hizmet için bir çalışma kaydı yazılır (kimyasal tüketimi dâhil).",
      deliverUnpaid:
        "Bu iş emrine bağlı kasa ödemesi yok. Abonelik, garanti ya da ikram gibi ödemesiz teslimin gerekçesini yazın.",
      unpaidReason: "Ödemesiz teslim gerekçesi",
      unpaidReasonHint: "En az 3 karakter (ör. abonelik, garanti, ikram).",
      unpaidReasonOptional: "Ödeme bağlı olduğu için isteğe bağlı.",
      unpaidRequired: "Bağlı ödeme yok: ödemesiz teslim gerekçesi zorunludur.",
      paymentRequired:
        "{{no}} için kasada ödeme bulunamadı. Kasada iş emri numarasıyla satış yapın ya da ödemesiz teslim gerekçesi girin.",
      deliverSubmit: "Teslim et",
      cancelTitle: "İş emrini iptal et: {{no}}",
      cancelDescription: "Yalnızca bekleyen ya da işlemdeki iş emri iptal edilebilir.",
      cancelSubmit: "İş emrini iptal et",
    },
    photos: {
      title: "Fotoğraflar",
      phase: "{{phase}} ({{count}} / {{max}})",
      add: "{{phase}} fotoğrafı ekle",
      addShort: "{{phase}} fotoğrafı",
      list: "{{phase}} fotoğrafları",
      none: "Fotoğraf yok",
      alt: "{{no}} — {{phase}} fotoğrafı {{index}}",
      purged: "İmha edildi ({{at}})",
      remove: "Sil: {{phase}} fotoğrafı {{index}}",
      removeConfirm: "Fotoğraf dosyası silinecek; kayıtta 'imha edildi' kalır. Devam edilsin mi?",
      removed: "Fotoğraf kaldırıldı",
      uploaded: "{{phase}} fotoğrafı eklendi",
      type: "Yalnızca JPEG, PNG ya da WebP fotoğraf yüklenebilir.",
      size: "Fotoğraf en çok 10 MB olabilir.",
      retentionHint:
        "Fotoğraflar ayarlardaki saklama süresi dolunca dosya olarak imha edilir; teslim edilmiş iş emrinde kaldırılamaz.",
    },
    queue: {
      description:
        "Müşterilerin gördüğü sıra ekranı: plaka maskeli, ad ve telefon yok. TV için tam ekran açın.",
      openFullscreen: "Tam ekran (TV)",
      privacy: "Ekranda plakalar maskelidir; müşteri adı ve telefonu gösterilmez.",
      updatedAt: "Güncelleme: {{at}}",
      columns: { WAITING: "Sırada", IN_PROGRESS: "Yıkanıyor", READY: "Hazır" },
      empty: "Araç yok",
      waitingSince: "Sıraya giriş: {{at}}",
      inProgressSince: "Başlangıç: {{at}}",
      eta: "Tahmini hazır: {{at}}",
      readySince: "Hazır olma: {{at}}",
      tvTitle: "Yıkama sırası {{station}}",
      tvHeading: "Yıkama sırası",
      clock: "Saat",
      tvFooter: "Aracınız hazır olduğunda SMS ile bilgilendirilirsiniz.",
    },
    reports: {
      description:
        "Ünite ve program bazında adet, ciro, kimyasal / su / elektrik maliyeti ve marj; doluluk, arıza süreleri ve gün kapanışları.",
      range: "Tarih aralığı",
      groupBy: "Kırılım",
      byProgram: "Programa göre",
      byUnit: "Üniteye göre",
      tabsLabel: "Yıkama raporları",
      tabs: {
        summary: "Maliyet ve marj",
        occupancy: "Doluluk",
        faults: "Arızalar",
        closings: "Gün kapanışları",
      },
      summaryCaption: "Yıkama maliyet ve marj özeti",
      count: "Adet",
      revenue: "Ciro (KDV hariç)",
      chemicalCost: "Kimyasal",
      waterCost: "Su",
      electricityCost: "Elektrik",
      totalCost: "Toplam maliyet",
      margin: "Marj",
      marginPercent: "Marj %",
      unassigned: "Atanmamış",
      chemicalSource: "Kimyasal maliyeti:",
      stockLedger: "Stok defteri",
      theoretical: "Teorik (maliyet hesaplanmadı)",
      utilitySources: "Su / elektrik:",
      utility: { WATER: "Su", ELECTRICITY: "Elektrik" },
      utilityLower: { WATER: "su", ELECTRICITY: "elektrik" },
      meter: "Sayaç",
      deducted: "altındaki ünite sayaçları düşüldü: {{quantity}}",
      unallocatedRow: "Paylaştırılamayan {{utility}} — {{meter}}",
      unallocatedTitle: "Paylaştırılamayan su / elektrik",
      unallocatedHint:
        "Bu tüketim çalışmalara paylaştırılamadı (eşit bölünmez): ünite / program satırlarına girmez, rapor toplamına ve marja dâhildir. Programların tahmini su / elektrik tüketimini girerseniz sonraki raporlarda çalışmalara dağıtılır.",
      unallocatedReasonLabel: "Neden",
      unallocatedReason: {
        NO_CYCLES: "Dönemde kapsadığı çalışma yok",
        NO_WEIGHTED_CYCLES: "Programların tahmini tüketimi 0",
      },
      source: {
        UNIT_METER: "Ünite sayacı",
        STATION_METER: "İstasyon yıkama sayacı",
        ESTIMATE: "Program tahmini",
      },
      metered: "sayaç",
      estimated: "tahmini",
      emptyTitle: "Bu aralıkta veri yok",
      emptyDescription: "Seçilen aralıkta yıkama çalışması ya da satış bulunmuyor.",
      chartTitle: "Ciro, maliyet ve marj",
      chartAria: "{{from}}–{{to}} yıkama ciro, maliyet ve marj grafiği",
      chartTable: "Ciro, maliyet ve marj verisi",
      sourcesTitle: "Su ve elektrik maliyet kaynakları",
      utilityLabel: "Kalem",
      sourceLabel: "Kaynak",
      cycles: "Çalışma",
      quantity: "Tüketim",
      unitCost: "Birim maliyet",
      cost: "Maliyet",
      noUnitCost: "Fatura yok",
      occupancy: "Doluluk",
      occupancyTitle: "Doluluk (hafta günü × saat)",
      occupancySummary: "{{units}} ünite · toplam çalışma {{duration}}",
      occupancyAria: "{{from}}–{{to}} yıkama doluluk ısı haritası",
      occupancyTable: "Doluluk yüzdeleri (hafta günü × saat)",
      occupancyHint:
        "Yüzde: o saat diliminde makinelerin çalıştığı süre / (dönemde o dilimin tekrar sayısı × 60 dk × ünite sayısı).",
      weekday: "Gün",
      noFaultsTitle: "Bu aralıkta arıza yok",
      noFaultsDescription: "Ünitelerin arıza süreleri ajandan gelen durum değişimlerinden hesaplanır.",
      faultsTitle: "Arıza süreleri",
      faultsTotal: "Toplam {{duration}}",
      faultsAria: "{{from}}–{{to}} arıza süreleri (ünite × arıza kodu)",
      faultsTable: "Arıza süreleri (ünite × arıza kodu)",
      faultsByUnit: "Ünite bazında arıza",
      faultCode: "Arıza kodu",
      faultCount: "Arıza sayısı",
      minutes: "dk",
      noClosingsTitle: "Bu aralıkta gün kapanışı yok",
      noClosingsDescription: "Yıkama gün kapanışı vardiya gün sonu akışıyla kendiliğinden yapılır.",
      closingsCaption: "Yıkama gün kapanışları",
      businessDate: "İş günü",
      consumptionValue: "Kimyasal tüketimi",
      machineRevenue: "Makine tahsilatı (KDV dahil)",
      journals: "Fişler",
      consumptionEntry: "Tüketim fişi",
      revenueEntry: "Tahsilat fişi",
      closedAt: "Kapanış",
      closingStatus: { POSTED: "Fişlendi", QUEUED: "Eşleştirme bekliyor", EMPTY: "Hareket yok" },
    },
    settings: {
      description:
        "Kod ve kredi geçerliliği, kod deneme sınırı, fotoğraf saklama süresi ve 'aracınız hazır' SMS metni — tüm istasyonlarda geçerlidir.",
      formLabel: "Yıkama ayarları",
      readOnly: "Ayarları yalnızca görüntüleyebilirsiniz.",
      tenantScopeOnly:
        "Bu ayar tüm istasyonları etkiler: değiştirmek için tüm hesap kapsamında yıkama yönetim yetkisi gerekir.",
      defaults: "Henüz kaydedilmiş ayar yok; varsayılan değerler gösteriliyor.",
      machineTitle: "Başlatma kodu ve self-servis kredisi",
      codeValidityMinutes: "Kod geçerliliği (dk)",
      codeValidityHint: "Fişe basılan başlatma kodu bu süre içinde kullanılmalıdır (5 dk – 30 gün).",
      codeAttemptLimit: "Hatalı kod sınırı",
      codeAttemptHint: "Ünite başına dakikada en çok hatalı kod denemesi (1–20).",
      creditValidityDays: "Kredi geçerliliği (gün)",
      creditValidityHint: "Self-servis kredisinin süresi; dolunca kalan bakiye sıfırlanır.",
      handWashTitle: "El yıkama",
      photoRetentionDays: "Fotoğraf saklama süresi (gün)",
      photoRetentionHint: "Süre dolunca iş emri fotoğrafları dosya olarak imha edilir (kayıt kalır).",
      readySmsTemplate: "'Aracınız hazır' SMS metni",
      readySmsHint: "İşlemsel iletidir: pazarlama içeriği yazmayın (10–300 karakter).",
      placeholders: "Yer tutucular",
      insertPlaceholder: "{{token}} yer tutucusunu ekle ({{meaning}})",
      placeholder: { plaka: "araç plakası", istasyon: "istasyon adı", isEmriNo: "iş emri numarası" },
      unknownPlaceholders: "Tanınmayan yer tutucu: {{tokens}}. Metinde olduğu gibi gönderilir.",
      preview: "Önizleme",
      previewMeta: "{{length}} karakter · {{segments}} SMS",
      sampleStation: "Kadıköy İstasyonu",
      saved: "Yıkama ayarları kaydedildi",
      updatedAt: "Son kayıt: {{at}}",
    },
  },
  alarms: {
    disabledTitle: "Alarm ve bildirim modülü kapalı",
    disabledDescription:
      "Bu hesapta alarm ve bildirim özelliği açık değil. Açtırmak için yöneticinize ya da destek ekibine başvurun.",
    noPermission: "Alarmları görüntüleme yetkiniz yok. Yetki için yöneticinize başvurun.",
    autoResolved: "Kendiliğinden çözüldü",
    escalatedLevel: "Yükseltildi ({{level}}. halka)",
    scope: { company: "Şirket geneli · {{name}}", tenant: "İşletme geneli" },
    fields: {
      severity: "Önem",
      alarm: "Alarm",
      scope: "Kapsam",
      station: "İstasyon",
      category: "Kategori",
      rule: "Kural",
      status: "Durum",
      firstOccurredAt: "Oluşma",
      lastOccurredAt: "Son oluşma",
      occurrenceCount: "Tekrar",
      assignee: "Atanan",
      acknowledged: "Görüldü",
      resolved: "Çözüldü",
      escalation: "Yükseltme",
    },
    summary: {
      openTitle: "Açık alarmlar",
      countsLabel: "Önem sayıları",
      count: "{{count}} {{severity}}",
      total: "Toplam {{count}} açık alarm",
      openCount: "{{count}} açık alarm",
      assignedToMe: "Bana atanan {{count}} alarm",
      all: "Tüm alarmlar",
      latestLabel: "En yeni kritik ve önemli alarmlar",
      noUrgent: "Açık kritik ya da önemli alarm yok.",
    },
    list: {
      description:
        "Kapsamınızdaki alarmlar: önem, durum, istasyon, kategori ve kurala göre süzün; ayrıntıdan görün, atayın ya da çözün.",
      allStations: "Tüm istasyonlar",
      linkedStation: "Bağlantıdaki istasyon",
      openOnly: "Yalnızca açıklar",
      assignedToMe: "Bana atananlar",
      emptyOpenTitle: "Açık alarm yok",
      emptyTitle: "Alarm bulunamadı",
      emptyDescription: "Bu süzgeçlerle eşleşen alarm yok. Süzgeçleri değiştirerek yeniden deneyin.",
    },
    detail: {
      title: "Alarm",
      notFoundTitle: "Alarm bulunamadı",
      notFoundDescription: "Alarm kapsamınız dışında olabilir ya da bağlantı hatalıdır.",
      backToList: "Alarm listesine dön",
      openRelated: "İlgili ekrana git",
      byAt: "{{name}} · {{at}}",
      assignedBy: "{{name}} (atayan {{by}} · {{at}})",
      autoResolvedAt: "Sistem (kendiliğinden) · {{at}}",
      escalation: "{{level}}. halka · {{at}}",
      readOnly: "Bu alarmda işlem yetkiniz yok (salt okuma).",
      timeline: "Zaman çizelgesi",
      timelineEmpty: "Zaman çizelgesinde kayıt yok.",
    },
    timeline: {
      transition: "{{from}} → {{to}}",
      fromCheck: "Kontrol işi tespit etti",
      fromEvent: "Kaynak olaydan",
      occurrence: "Tekrar sayısı {{count}}",
      assignee: "Atanan: {{name}}",
      escalationLevel: "Halka {{from}} → {{to}}",
      noNewRecipients: "yeni alıcı yok",
      notifiedUsers: "{{count}} kişiye bildirildi",
      fallbackOwners: "alıcı bulunamadığı için sahiplere düştü",
      reasonUnknown: "Sorun ortadan kalktı",
      reason: {
        LEVEL_RECOVERED: "Tank seviyesi normale döndü",
        SOURCE_EVENT: "Kaynak kayıtta sorun giderildi",
        CHECK: "Kontrol işinde sorun kalmadı",
        DAY_ENDED: "Gün bitti",
        SALES_RECOVERED: "Satışlar toparlandı",
        NO_SHORTFALL: "Nakit açığı öngörüsü kalktı",
      },
    },
    actions: {
      acknowledge: "Görüldü",
      acknowledged: "Alarm görüldü olarak işaretlendi",
      assign: "Ata",
      reassign: "Yeniden ata",
      assignTitle: "Alarmı ata",
      reassignTitle: "Alarmı yeniden ata",
      assignDescription:
        "Alarmı görebilen etkin kullanıcılardan birine atayın; atanan kişiye bildirim gider.",
      assignee: "Atanacak kişi",
      assigneeRequired: "Atanacak kişiyi seçin",
      self: "(siz)",
      currentAssignee: "(şu an atanmış)",
      assignNote: "Not",
      assignNoteHint: "İsteğe bağlı; zaman çizelgesine yazılır, bildirime girmez.",
      assigned: "Alarm {{name}} kişisine atandı",
      resolve: "Çöz",
      resolveTitle: "Alarmı çöz",
      resolveDescription:
        "Sorunun nasıl giderildiğini yazın; not zaman çizelgesine ve denetim izine yazılır.",
      resolutionNote: "Çözüm notu",
      resolved: "Alarm çözüldü",
      reopen: "Yeniden aç",
      reopenTitle: "Alarmı yeniden aç",
      reopenDescription:
        "Çözülmüş alarm yeniden açılır; görüldü / atama bilgisi sıfırlanır ve yükseltme süresi yeniden başlar.",
      reopenReason: "Yeniden açma gerekçesi",
      reopened: "Alarm yeniden açıldı",
      addNote: "Not ekle",
      noteTitle: "Alarma not ekle",
      noteDescription: "Not zaman çizelgesine yazılır; alarmın durumu değişmez.",
      note: "Not",
      noteAdded: "Not eklendi",
      conflict: "Alarm siz bakarken değişti. Güncel hâli yüklendi; kontrol edip yeniden deneyin.",
      openDuplicate: "Açık alarma git",
    },
    rules: {
      description:
        "Alarm kurallarını işletme ya da istasyon düzeyinde açın / kapatın, önemini ve eşiklerini ayarlayın. Etkin değer: istasyon > işletme > varsayılan.",
      level: "Düzey",
      tenantLevel: "İşletme geneli",
      tenantHint: "İşletme geneli ayar tüm istasyonlara uygulanır; istasyon ayarı onu geçersiz kılar.",
      stationHint:
        "Bu istasyonun ayarı işletme genelindeki ayarı geçersiz kılar. Boş bırakılan alan işletme ayarından gelir.",
      readOnly: "Kural ayarlarını değiştirme yetkiniz yok; ayarları görüntülüyorsunuz.",
      cannotEditTenant:
        "İşletme geneli ayar işletme kapsamlı yetki ister; istasyon seçerek o istasyonun ayarını değiştirebilirsiniz.",
      cannotEditStation: "Bu istasyonun kural ayarını değiştirme yetkiniz yok.",
      tableLabel: "{{category}} kuralları",
      defaultSeverity: "Varsayılan önem",
      effectiveSeverity: "Etkin önem",
      bySignal: "Duruma göre ({{severities}})",
      thresholds: "Eşikler",
      moduleShort: "Modül ayarından",
      moduleThresholds:
        "Bu kuralın eşikleri ilgili modülün kendi ayarından gelir (ör. tank asgari seviyesi, vardiya toleransı); burada yalnızca açık / kapalı ve önem ayarlanır.",
      escalation: "Yükseltme",
      minutes: "{{count}} dk",
      source: "Kaynak",
      sourceLabel: { CATALOG: "Varsayılan", TENANT: "İşletme", STATION: "İstasyon" },
      on: "Açık",
      off: "Kapalı",
      editLabel: "{{rule}} kuralını düzenle",
      resetLabel: "{{rule}} kuralını varsayılana döndür",
      reset: "Varsayılana dön",
      resetTitle: "{{rule}} varsayılana dönsün mü?",
      resetTenantDescription:
        "İşletme genelindeki ayar kaldırılır; kural varsayılan değerleriyle çalışır (istasyon ayarları korunur).",
      resetStationDescription:
        "{{station}} istasyonunun ayarı kaldırılır; kural işletme ayarıyla ya da varsayılanla çalışır.",
      resetDone: "{{rule}} varsayılana döndü",
      editTitle: "{{rule}}",
      editTenant: "İşletme geneli ayar",
      editStation: "İstasyon ayarı · {{station}}",
      enabled: "Durum",
      severity: "Önem",
      severityHint: "Boş bırakılırsa önem olaya göre belirlenir (ör. şüpheli → önemli, kritik → kritik).",
      inherit: "Üst düzeyden ({{value}})",
      thresholdHint: "Üst düzey: {{value}} · aralık {{min}}–{{max}}",
      escalationMinutes: "Yükseltme süresi (dk)",
      escalationHint: "Üst düzey: {{value}} dk · 1–1440. Yalnızca kritik ve görülmemiş alarmlar yükseltilir.",
      escalationRange: "Yükseltme süresi 1 ile 1440 dakika arasında bir tam sayı olmalıdır",
      invalidNumber: "Geçerli bir sayı girin",
      integerRequired: "Tam sayı girin",
      twoDecimals: "En çok iki ondalık basamak girilebilir",
      outOfRange: "Değer {{min}} ile {{max}} arasında olmalıdır",
      minWeeksAboveWeeks: "En az eşleşen hafta, karşılaştırılan hafta sayısından büyük olamaz",
      saved: "{{rule}} kuralı kaydedildi",
      conflict: "Kural ayarı siz düzenlerken değişti. Güncel hâli yüklendi; kontrol edip yeniden kaydedin.",
    },
  },
  notifications: {
    unread: "okunmadı",
    unreadBadge: "Okunmadı",
    markAllRead: "Tümünü okundu say",
    kind: {
      ALARM: "Alarm",
      ALARM_GROUP: "Alarm grubu",
      DIGEST_DAILY: "Sabah özeti",
      DIGEST_WEEKLY: "Haftalık özet",
      TEST: "Test",
    },
    bell: {
      labelUnread: "Bildirimler, {{count}} okunmamış",
      labelCritical: "Bildirimler, {{count}} okunmamış ({{critical}} kritik)",
      unreadSuffix: "· {{count}} okunmamış",
      emptyDescription: "Alarmlar ve özetler burada görünecek.",
      all: "Tüm bildirimler",
      latest: "Son bildirimler",
    },
    center: {
      description:
        "Size gelen alarm bildirimleri ve özetler; bildirimlerin hangi kanaldan neden gitmediğini teslim günlüğünde görün.",
      tabs: "Bildirim merkezi bölümleri",
      inbox: "Gelen kutusu",
      deliveries: "Teslim günlüğü",
      unreadOnly: "Yalnızca okunmamışlar",
      unreadCount: "({{count}} okunmamış)",
      markedAll: "{{count}} bildirim okundu olarak işaretlendi",
      listLabel: "Bildirimler",
      emptyTitle: "Bildirim yok",
      emptyUnreadTitle: "Okunmamış bildirim yok",
      emptyDescription: "Yeni alarm bildirimleri ve sabah özetleri burada görünür.",
      openAlarm: "Alarma git",
      openGroup: "Alarmları göster",
      open: "Aç",
      markRead: "Okundu say",
      pagination: "Bildirim sayfaları",
      previous: "Önceki",
      next: "Sonraki",
    },
    deliveries: {
      whyTitle: "Bildirim neden gelmedi?",
      whyDescription:
        "Her bildirim her kanal için ayrı teslim edilir. Uygulama içi bildirim hemen yazılır; e-posta, SMS ve mobil bildirim sıradan gönderilir ve hata alırsa yeniden denenir. Atlanan teslimin nedeni aşağıdadır.",
      explain: {
        PREFERENCE_OFF:
          "Bu kanal bildirim tercihlerinizde (ya da rol varsayılanınızda) bu alarm için kapalı.",
        QUIET_HOURS:
          "Sessiz saatlerinizde e-posta, SMS ve mobil bildirim gönderilmez; uygulama içi bildirim yazılır.",
        BELOW_MIN_SEVERITY: "Alarmın önemi bu kanal için seçtiğiniz asgari önemin altında.",
        NO_ADDRESS: "Profilinizde bu kanal için adres yok (e-posta, telefon ya da kayıtlı mobil cihaz).",
        CHANNEL_DISABLED: "Kanal bu ortamda yapılandırılmamış (ör. e-posta sunucusu tanımlı değil).",
      },
      explainFailed:
        "Sağlayıcı hata döndürdü; deneme sınırına kadar yeniden denendi. Hata kodu destek ekibine iletilebilir.",
      toPreferences: "Bildirim tercihlerini düzenle",
      caption: "Teslim günlüğü",
      createdAt: "Zaman",
      notification: "Bildirim",
      channel: "Kanal",
      reason: "Neden / hata",
      attempts: "Deneme",
      sentAt: "Gönderim",
      nextAttempt: "Sonraki deneme {{at}}",
      emptyTitle: "Teslim kaydı yok",
      emptyDescription: "Size bir bildirim gönderildiğinde her kanalın teslim durumu burada görünür.",
      showMore: "Daha fazla göster",
    },
    test: {
      open: "Test bildirimi gönder",
      title: "Test bildirimi gönder",
      description:
        "Kendinize bir test bildirimi gönderin; tercihler ve sessiz saat uygulanmaz. Dakikada en çok {{max}} test gönderilebilir.",
      channels: "Kanallar",
      channelsHint: "Seçmezseniz uygulama içi ve adresiniz olan tüm kanallardan gönderilir.",
      send: "Gönder",
      sent: "Test bildirimi oluşturuldu:",
      nothingSent: "Seçilen kanalların hiçbirine gönderilemedi:",
      pendingHint: "Sırada; birkaç saniye içinde gönderilir",
      rateLimitedTitle: "Test bildirimi sınırı aşıldı.",
    },
    preferences: {
      description:
        "Hangi alarmları hangi kanaldan alacağınızı, sessiz saatlerinizi ve özet saatinizi ayarlayın.",
      tabs: "Tercih bölümleri",
      matrixTab: "Kanal tercihleri",
      settingsTab: "Sessiz saat ve özetler",
      previewTab: "Özet önizlemesi",
    },
    matrix: {
      title: "Kanal tercihleri",
      description:
        "Her satır için kanalı açın, kapatın ya da asgari önemi seçin. Varsayılan satır daha genel satırdan ya da rolünüzden gelir; en özgül ayar kazanır (kural > kategori > tümü, istasyon > tüm istasyonlar).",
      roleDefaults: "Rolünüzün varsayılanları:",
      scope: "Kapsam",
      allStations: "Tüm istasyonlar",
      allStationsHint:
        "Tüm istasyonlar için geçerli tercihler. Tek bir istasyon seçerek o istasyona özel ayar yapabilirsiniz.",
      stationHint:
        "Yalnızca {{station}} istasyonunun alarmları için geçerli; boş hücreler tüm istasyonlar ayarından gelir.",
      tableLabel: "Bildirim tercih matrisi",
      alarm: "Alarm",
      allAlarms: "Tüm alarmlar",
      cellLabel: "{{row}} · {{channel}}",
      customRules: "({{count}} kural özel)",
      default: "Varsayılan",
      defaultOn: "Varsayılan: açık ({{severity}})",
      defaultOff: "Varsayılan: kapalı",
      on: "Açık · {{severity}}",
      onShort: "açık ({{severity}})",
      onChannelDefault: "Açık · kanal varsayılanı",
      off: "Kapalı",
      minSeverity: { INFO: "tümü", IMPORTANT: "önemli ve üstü", CRITICAL: "yalnızca kritik" },
      resetAll: "Tüm istasyonlar ayarlarını varsayılana döndür",
      resetStation: "{{station}} ayarlarını varsayılana döndür",
      unsaved: "Kaydedilmemiş değişiklikler var",
      discard: "Değişiklikleri geri al",
      saved: "Bildirim tercihleri kaydedildi",
    },
    settings: {
      title: "Sessiz saat ve özetler",
      description:
        "Sessiz saatlerde e-posta, SMS ve mobil bildirim gönderilmez (uygulama içi bildirim yazılır). Özetler İstanbul saatiyle gönderilir.",
      defaults: "Henüz ayar kaydetmediniz; varsayılanlar gösteriliyor.",
      noPhone: "Profilinizde telefon numarası olmadığı için SMS bildirimi gönderilemez.",
      quietHours: "Sessiz saat",
      quietEnabled: "Sessiz saat kullan",
      quietHint: "Aralık gece yarısını aşabilir (ör. 22:00–07:00).",
      quietStart: "Başlangıç",
      quietEnd: "Bitiş",
      muteCritical: "Kritik alarmlar da sussun",
      muteCriticalHint: "İşaretlemezseniz kritik alarmlar sessiz saatte de gönderilir.",
      digests: "Özetler",
      dailyDigest: "Sabah özeti",
      dailyDigestHint:
        "Dünün cirosu, açık alarmlar, bugün vadesi gelen çekler ve ödemeler, kritik tanklar (uygulama içi + e-posta).",
      digestTime: "Özet saati",
      digestTimeHint: "Haftalık özet pazartesi aynı saatte gönderilir.",
      weeklyDigest: "Haftalık özet",
      weeklyDigestHint: "Geçen haftanın cirosu ve alarmları (e-posta).",
      saved: "Bildirim ayarları kaydedildi",
      conflict: "Ayarlar siz düzenlerken değişti. Güncel hâli yüklendi; kontrol edip yeniden kaydedin.",
    },
    preview: {
      title: "Özet önizlemesi",
      description:
        "Seçtiğiniz gün size gönderilecek özetin içeriği (gönderim yapılmaz). Yalnızca görme yetkiniz olan bilgiler yer alır.",
      kind: "Özet",
      day: "Gün",
      dayHint: "Boş bırakılırsa bugün; haftalık özette seçilen günün haftası.",
      dailyPeriod: "Özet günü {{day}} · ciro günü {{revenueDay}}",
      weeklyPeriod: "Gönderim {{weekStart}} · özetlenen hafta {{from}} – {{to}}",
      deliveryOn: "Gönderim açık · saat {{time}} · {{channels}}",
      deliveryOff: "Bu özet ayarlarınızda kapalı; gönderilmez.",
      noChannel: "kanal tercihleriniz kapalı",
      empty: "Bu gün için özetin içeriği boş; gönderilmez.",
    },
    digest: {
      revenueDay: "Ciro · {{day}}",
      weekRevenue: "Haftanın cirosu · {{period}}",
      weekRange: "{{from}} – {{to}}",
      businessUnit: "İş birimi",
      revenue: "Ciro",
      previousDay: "Önceki gün",
      previousWeek: "Önceki hafta",
      lastWeekSameDay: "Geçen hafta aynı gün",
      change: "Değişim",
      openAlarms: "Açık alarmlar",
      chequesToday: "Bugün vadesi gelen çek ve senetler",
      collections: "Tahsil:",
      chequePayments: "Ödeme:",
      countAmount: "{{count}} adet ·",
      paymentsToday: "Bugünkü ödeme listeleri",
      tanks: "Kritik / düşük tanklar",
      tankLow: "Düşük",
      litres: "{{volume}} L",
      alarmsByRule: "Haftanın alarmları",
      opened: "Açılan",
      resolved: "Çözülen",
      stillOpen: "Hâlâ açık",
      noWeekAlarms: "Geçen hafta alarm açılmadı.",
      longestOpen: "En uzun açık kalanlar",
      openDays: "{{count}} gündür açık",
      emptyContent: "Bu özette gösterilecek bölüm yok.",
    },
  },
  ev: {
    disabledTitle: "Elektrikli araç şarjı modülü kapalı",
    disabledDescription:
      "Şarj üniteleri, oturumlar, tarifeler ve raporlar bu hesapta açık değil. Modülü planınızdan açabilirsiniz.",
    noPermission: {
      read: "Şarj ekranlarını görüntüleme yetkiniz yok.",
      manage: "Şarj tanımlarını yönetme yetkiniz yok.",
      operate: "Şarj işlemlerini yürütme yetkiniz yok.",
      reports: "Şarj enerji, maliyet ve doluluk raporlarını görüntüleme yetkiniz yok.",
      exports: "Şarj dışa aktarım profillerini görüntüleme yetkiniz yok.",
    },
    noStationsTitle: "Şarj birimi olan istasyon yok",
    noStationsDescription:
      "Şarj istasyon bazındadır. İstasyonun iş birimlerinde elektrikli araç şarjını açın ya da yetkili kişiden kapsamınıza bir şarj istasyonu eklenmesini isteyin.",
    conflict:
      "Kayıt siz düzenlerken başka biri tarafından değiştirildi. Güncel hâli yüklendi; değişikliğinizi yeniden yapın.",
    weekdays: { 1: "Pzt", 2: "Sal", 3: "Çar", 4: "Per", 5: "Cum", 6: "Cmt", 7: "Paz" },
    weekdaysLong: {
      1: "Pazartesi",
      2: "Salı",
      3: "Çarşamba",
      4: "Perşembe",
      5: "Cuma",
      6: "Cumartesi",
      7: "Pazar",
    },
    source: { OCPP: "Kendi ünitemiz (OCPP)", PARTNER: "Şarj ağı (içe aktarım)" },
    invoiceStatus: {
      NONE: "Fatura yok",
      PENDING: "Fatura bekliyor",
      ISSUED: "Fatura kesildi",
      FAILED: "Fatura hatası",
    },
    commandSource: {
      WEB: "Panel",
      APP: "Müşteri uygulaması",
      POS: "Kasa",
      LOAD_MANAGER: "Yük yöneticisi",
      SYSTEM: "Sistem",
    },
    closeReason: {
      CLOSED: "Ünite kapattı",
      REPLACED: "Yeni bağlantı açıldı",
      PING_TIMEOUT: "Yanıt vermedi (ping)",
      SERVER_SHUTDOWN: "Sunucu yeniden başladı",
      STALE_INSTANCE: "Sunucu süreci kapandı",
      ERROR: "Bağlantı hatası",
    },
    loadMethod: { EQUAL: "Eşit paylaştırma", PRIORITY: "Öncelikli paylaştırma" },
    limitReason: {
      SESSION_STARTED: "Oturum başladı",
      SESSION_FINISHED: "Oturum bitti",
      PERIODIC: "Dönemsel dengeleme",
      SETTINGS_CHANGED: "Ayar değişti",
      CONNECTOR_CHANGED: "Konnektör değişti",
    },
    fields: {
      station: "İstasyon",
      company: "Şirket",
      charger: "Şarj ünitesi",
      connector: "Konnektör",
      connectorType: "Tür",
      ocppIdentity: "OCPP kimliği",
      power: "Güç",
      energy: "Enerji",
      duration: "Süre",
      soc: "Batarya (SoC)",
      limit: "Güç sınırı",
      startedAt: "Başlangıç",
      identification: "Tanımlama",
      phase: "Evre",
      totalAmount: "Tutar",
      payment: "Ödeme",
      paymentStatus: "Ödeme durumu",
      invoiceStatus: "Fatura durumu",
      source: "Kaynak",
    },
    connector: {
      no: "Konnektör {{no}}",
      noStatus: "Durum bilgisi yok",
      online: "Çevrimiçi",
      offline: "Çevrimdışı",
      since: "{{at}} itibarıyla",
      lastKnown: "Son bilinen durum ({{at}})",
      errorCode: "Hata kodu: {{code}}",
    },
    dashboard: {
      description:
        "Konnektörlerin canlı durumu, sürmekte olan şarj (kWh, güç, süre, batarya) ve bugünün özeti. Durum şarj ünitesinden anlık gelir.",
      todayTitle: "Bugün",
      generatedAt: "Güncellendi: {{at}}",
      sessions: "Oturum",
      live: "Süren",
      completed: "Tamamlanan",
      energy: "Enerji",
      amount: "Tutar (tamamlanan)",
      unpaid: "Ödenmemiş",
      unpaidCount: "{{count}} oturum (tüm günler)",
      faulted: "Arızalı konnektör",
      offline: "Çevrimdışı ünite",
      openUnpaid: "Ödenmemiş oturumları göster",
      gridLabel: "Konnektörler",
      emptyTitle: "Bu istasyonda şarj ünitesi yok",
      emptyDescription: "Üniteler ve konnektörler istasyon varlıklarında tanımlanır.",
      openSession: "Oturumu aç",
      openSessionFor: "Oturumu aç: {{name}}",
      partnerTitle: "Bu istasyonun şarjını şarj ağı işletmecisi işletiyor",
      partnerHint:
        "Üniteler bu sunucuya bağlanmaz; canlı durum ve uzaktan komut yoktur. Oturumlar şarj ağından içe aktarılır.",
    },
    remoteStart: {
      open: "Uzaktan başlat",
      openFor: "Uzaktan başlat: {{name}}",
      title: "Uzaktan başlat: {{name}}",
      description:
        "Ünite, panelin ürettiği tek kullanımlık tanımlamayla şarjı başlatır. Araç konnektöre takılı olmalı; tutar kasada ödenir.",
      submit: "Başlat",
      sent: "{{name}} · konnektör {{no}} için başlatma komutu gönderildi",
      sentHint: "Ünite en geç 60 saniye içinde yanıt verir; sonuç komut listesinde görünür.",
    },
    sessionActions: {
      stop: "Durdur",
      stopFor: "Durdur: {{name}}",
      stopTitle: "Şarjı durdur: {{name}} · konnektör {{no}}",
      stopDescription:
        "Üniteye uzaktan durdurma komutu gönderilir. Araç takılı kalırsa oturum bekleme evresine geçer ve bekleme ücreti işleyebilir.",
      stopSent: "Durdurma komutu gönderildi",
      stopSentHint: "Oturum, ünite durdurmayı bildirince güncellenir.",
      completeOpen: "Takılı oturumu kapat",
      completeTitle: "Takılı oturumu kapat",
      completeDescription:
        "Ünite durdurma ya da 'araç çekildi' bildirmediyse oturum son ölçümle TAMAMLANIR ve tutar kesinleşir. Bu işlem geri alınamaz.",
      completeHint:
        "Kesinleşecek enerji: {{energy}}. Oturuma 'Yönetici tarafından kapatıldı' uyarısı yazılır.",
      completeWord: "KAPAT",
      complete: "Oturumu kapat",
      completed: "Oturum kapatıldı; tutar kesinleşti",
      retryInvoice: "Faturayı yeniden dene",
      retryQueued: "Fatura yeniden kuyruğa alındı",
    },
    commands: {
      open: "Komut gönder",
      title: "Komut gönder: {{name}}",
      description:
        "Komut kuyruğa yazılır; ünite bağlıysa hemen gönderilir, bağlı değilse süresi dolunca düşer.",
      formLabel: "Ünite komutu",
      type: "Komut",
      maintenanceTag: "bakım",
      help: {
        Reset:
          "Üniteyi yeniden başlatır. Yumuşak: süren oturum düzgün kapatılır; sert: hemen yeniden başlar.",
        UnlockConnector: "Konnektör kilidini açar (kablo takılı kaldıysa).",
        ChangeAvailability: "Konnektörü ya da üniteyi kullanıma açar / kapatır (bakım, arıza).",
        ClearChargingProfile: "Ünitedeki güç sınırı profillerini kaldırır.",
        GetConfiguration: "Ünitenin OCPP yapılandırmasını okur; yanıt yapılandırma tablosuna yazılır.",
        ChangeConfiguration: "Bir OCPP yapılandırma anahtarını değiştirir (bakım yetkisi).",
        UpdateFirmware: "Ünitenin yazılımını verilen adresten günceller (bakım yetkisi).",
        GetDiagnostics: "Ünitenin tanılama dosyasını verilen adrese yükletir (bakım yetkisi).",
      },
      stepUpTitle: "Kimliğinizi yeniden doğrulamanız istenebilir",
      stepUpHint:
        "Bakım komutları son 5 dakika içinde kimlik doğrulama ister; gerekirse parola ya da doğrulama kodu penceresi açılır.",
      resetType: "Yeniden başlatma türü",
      soft: "Yumuşak (Soft)",
      hard: "Sert (Hard)",
      wholeUnit: "Ünitenin tamamı",
      allProfiles: "Tüm profiller",
      availability: "Durum",
      operative: "Kullanıma aç",
      inoperative: "Kullanıma kapat",
      keys: "Anahtarlar",
      keysHint: "Boş bırakılırsa tüm anahtarlar okunur; birden çok anahtarı virgülle ayırın.",
      key: "Anahtar",
      value: "Değer",
      firmwareUrl: "Yazılım dosyası adresi",
      uploadUrl: "Tanılama dosyasının yükleneceği adres",
      urlHint: "https:// ya da ftp:// ile başlayan tam adres.",
      retrieveDate: "İndirme günü",
      retrieveTime: "İndirme saati",
      startDate: "Tanılama başlangıç günü",
      stopDate: "Tanılama bitiş günü",
      issue: {
        connector: "Konnektör seçin",
        key: "Anahtar zorunludur (en çok 50 karakter)",
        location: "Geçerli bir https:// ya da ftp:// adresi girin",
        date: "Geçerli bir tarih girin",
      },
      submit: "Gönder",
      queued: "{{type}} komutu kuyruğa alındı",
      queuedHint: "Sonuç komut listesinde görünür.",
      listTitle: "Komutlar",
      last30: "Son 30 gün:",
      emptyTitle: "Henüz komut yok",
      emptyDescription: "Panelden, kasadan ya da yük yöneticisinden gönderilen komutlar burada listelenir.",
      createdAt: "Zaman",
      payload: "İçerik",
      source: "Kaynak",
      response: "Yanıt",
      finishedAt: "Sonuç: {{at}}",
      configurationKeys: "{{count}} anahtar okundu",
      progress: "İlerleme bildirimleri",
    },
    credentials: {
      title: "OCPP kimlik bilgisi: {{name}}",
      description:
        "Ünite OCPP sunucusuna güvenlik profili 1 (HTTP Basic) ile bağlanır: kullanıcı adı OCPP kimliği, parola sunucunun ürettiği rastgele dizgedir.",
      rotateWarningTitle: "Mevcut parola hemen geçersiz olur",
      rotateWarning:
        "Yeni parola üretildiği anda eski parola çalışmaz. Ünitenin OCPP ayarına yeni parolayı girmeden ünite yeniden bağlanamaz.",
      securityProfile: "Güvenlik profili",
      profile1: "Profil 1 — HTTP Basic (üretimde TLS ters vekilde)",
      generate: "Kimlik bilgisi üret",
      rotate: "Parolayı yenile",
      revealTitle: "Yeni parola: {{name}}",
      revealDescription: "Parolayı şimdi kopyalayın ve ünitenin OCPP ayarına girin.",
      onceTitle: "Parola yalnızca bir kez gösterilir",
      once: "Bu pencere kapanınca parola bir daha gösterilmez; sunucuda yalnızca özeti saklanır. Kaybederseniz yeniden üretmeniz gerekir.",
      username: "Kullanıcı adı (OCPP kimliği)",
      password: "Parola",
      copyPassword: "Parolayı kopyala",
      url: "Merkezi sistem adresi",
      copyUrl: "Adresi kopyala",
      rotatedAt: "Üretildi",
      urlHint:
        "Ünitenin OCPP ayarına merkezi sistem (CSMS) adresi olarak girin; alt protokol ocpp1.6, kullanıcı adı OCPP kimliği.",
      done: "Kopyaladım, kapat",
      disable: "Devre dışı bırak",
      disableTitle: "Kimlik bilgisini devre dışı bırak: {{name}}",
      disableDescription:
        "Ünite bir sonraki bağlanma denemesinde reddedilir. Yeniden bağlanabilmesi için yeni kimlik bilgisi üretmeniz gerekir.",
      disableHint: "Şu an açık olan bağlantı, ünite yeniden bağlanana dek sürer (sunucu ayrıca koparmaz).",
      disabled: "{{name}} kimlik bilgisi devre dışı bırakıldı",
    },
    chargers: {
      description:
        "Ünitelerin OCPP bağlantısı, cihaz bilgisi, kimlik bilgisi durumu ve konnektörleri. Ünitenin kendisi istasyon varlıklarında tanımlanır.",
      caption: "Şarj üniteleri",
      emptyTitle: "Bu istasyonda şarj ünitesi yok",
      emptyDescription: "Üniteler ve konnektörler istasyon varlıklarında (Ayarlar › İstasyon) tanımlanır.",
      connection: "Bağlantı",
      device: "Cihaz",
      credentialLabel: "Kimlik bilgisi",
      model: "İşletme modeli",
      connectors: "Konnektörler",
      connectorsOf: "{{name}} konnektörleri",
      noIdentity: "OCPP kimliği yok",
      maxPower: "Azami {{power}}",
      notManaged: "Bu sunucuya bağlanmaz",
      lastSeen: "Son görülme: {{at}}",
      firmware: "Yazılım {{version}}",
      rotatedAt: "Parola: {{at}}",
      credential: {
        partner: "Şarj ağı işletiyor",
        noIdentity: "OCPP kimliği tanımsız",
        none: "Parola üretilmedi",
        disabled: "Devre dışı",
        active: "Etkin",
      },
      partnerNote:
        "Bu istasyonun şarjını şarj ağı işletmecisi işletiyor: ünite bu sunucuya bağlanmaz, kimlik bilgisi ve komut yoktur.",
      unmanagedNote:
        "Ünite bu sunucuya bağlanamaz (OCPP kimliği tanımsız ya da ünite hizmetten çıkarılmış). Kimliği istasyon varlıklarında tanımlayın.",
      connectionTitle: "OCPP bağlantısı",
      connectedSince: "Bağlanma",
      lastSeenLabel: "Son görülme",
      lastBoot: "Son açılış",
      profileNo: "Profil {{no}}",
      deviceTitle: "Cihaz",
      vendor: "Üretici",
      modelName: "Model",
      serialNo: "Seri no",
      firmwareVersion: "Yazılım sürümü",
      firmwareStatus: "Yazılım güncelleme durumu",
      diagnosticsStatus: "Tanılama durumu",
      maxPowerLabel: "Azami güç",
      assetStatus: "Varlık durumu",
      connectorsTitle: "Konnektörler",
      ocppStatus: "OCPP durumu",
      statusSince: "Durum zamanı",
      liveSessions: "Süren oturumlar",
      connectionsTitle: "Son bağlantılar",
      noConnections: "Ünite henüz hiç bağlanmadı.",
      connectedAt: "Bağlandı",
      disconnectedAt: "Koptu",
      stillConnected: "Bağlı",
      closeReasonLabel: "Kopma nedeni",
      configurationTitle: "OCPP yapılandırması",
      configurationReadAt: "Son okuma: {{at}}",
      configurationNever: "Yapılandırma henüz okunmadı.",
      configurationEmpty: "Anlık görüntü yok. 'Yapılandırmayı oku' komutuyla üniteden okunur.",
      readonly: "Salt okunur",
    },
    sessions: {
      description:
        "Şarj oturumları: enerji, süreler, tutar ve ödeme. Oturumu açarak zaman çizelgesini, grafiği, tutar kalemlerini ve uyarıları görün.",
      caption: "Şarj oturumları",
      startDay: "Başlangıç günü",
      emptyTitle: "Oturum yok",
      emptyDescription: "Süzgeçlere uyan şarj oturumu bulunamadı.",
      partner: "Şarj ağı · {{code}}",
      tx: "İşlem {{id}}",
      warningCount: "{{count}} uyarı",
      chargingIdle: "Şarj / bekleme",
      idle: "bekleme {{duration}}",
    },
    sessionDetail: {
      title: "Şarj oturumu · {{at}}",
      summary: "Özet",
      chargingDuration: "Şarj süresi",
      idleDuration: "Bekleme süresi",
      maxPower: "Azami güç",
      meter: "Sayaç",
      stopReason: "Durdurma nedeni",
      covered: "Abonelikle karşılanan",
      identification: "Tanımlama ve müşteri",
      idTag: "Tanımlama etiketi (idTag)",
      customer: "Müşteri / araç / filo",
      plate: "Plaka {{plate}}",
      transactionId: "OCPP işlem no",
      partnerRef: "Şarj ağı oturum no",
      kvkk: "Kişisel veri",
      erased: "Anonimleştirildi",
      payment: "Ödeme",
      method: "Ödeme yolu",
      paidAt: "Ödeme zamanı",
      awaitingPos: "Oturum kasada ödenmeyi bekliyor (kasanın Şarj sekmesinde listelenir).",
      posSale: "Kasa satışı",
      posSaleLink: "Kasa fişi · {{at}}",
      invoice: "Fatura",
      invoiceDraft: "Numarasız fatura",
      invoiceError: "Deneme {{attempts}}: {{error}}",
      warnings: "Uyarılar",
      timeline: "Zaman çizelgesi",
      step: {
        started: "Başlangıç",
        chargingEnded: "Şarj bitti",
        stopped: "Durdu",
        completed: "Araç çekildi (tamamlandı)",
      },
      pending: "Bekleniyor",
      chartTitle: "Güç ve enerji",
      samples: "{{shown}} / {{total}} ölçüm",
      chartAria: "Oturumun güç ve enerji grafiği, toplam {{energy}}",
      chartTable: "Ölçüm serisi",
      chart: {
        power: "Güç (kW)",
        energy: "Enerji (kWh)",
        soc: "Batarya (%)",
        limit: "Güç sınırı (kW)",
        powerAxis: "kW",
        energyAxis: "kWh",
      },
      time: "Zaman",
      lines: "Tutar kalemleri",
      tariffName: "Tarife: {{name}}",
      noLines: "Tutar kalemi yok (tarife bulunamadı ya da ücretsiz oturum).",
      linesPending: "Tutar, araç çekilince (oturum tamamlanınca) kesinleşir.",
      component: "Kalem",
      product: "Ürün",
      quantity: "Miktar",
      unitPrice: "Ortalama birim fiyat",
      amount: "Tutar",
      snapshot: "Tarife anlık görüntüsü (oturum başındaki)",
      limits: "Uygulanan güç sınırları",
      commands: "Komutlar",
    },
    tariffs: {
      description:
        "Şarj tarifeleri: kapsam, geçerlilik, kWh / dakika / bekleme ücreti ve saat bantları. Başlamış oturumlar tarifenin anlık görüntüsünü taşır.",
      caption: "Şarj tarifeleri",
      add: "Tarife ekle",
      newTitle: "Yeni şarj tarifesi",
      editTitle: "Tarifeyi düzenle: {{name}}",
      editFor: "Düzenle: {{name}}",
      dialogDescription:
        "Öncelik: ünite > güç sınıfı > istasyon > şirket; aynı düzeyde en yeni yürürlük. Fiyatlar KDV dahil ₺.",
      formLabel: "Şarj tarifesi",
      created: "{{name}} tarifesi eklendi",
      updated: "{{name}} tarifesi güncellendi",
      emptyTitle: "Tarife yok",
      emptyDescription:
        "Tarife olmadan başlayan oturumun tutarı hesaplanamaz (oturum 'tarife yok' uyarısıyla kalır).",
      coveringStation: "Kapsadığı istasyon",
      includeInactive: "Devre dışı ve süresi dolmuşları da göster",
      allStations: "Tüm istasyonlar",
      anyCurrent: "AC ya da DC",
      extras: "Dakika / bekleme",
      minuteShort: "Dakika",
      idleShort: "Bekleme",
      graceShort: "{{count}} dk ücretsiz",
      capShort: "tavan {{cap}} ₺",
      minutes: "{{count}} dk",
      noCap: "Tavansız",
      noProduct: "Seçilmedi",
      everyDay: "Her gün",
      until: "{{at}} tarihine dek",
      openEnded: "Süresiz",
      scopeHint: "Güç sınıfı: konnektörün akım türü ve gücüne göre (üst sınır hariç).",
      powerClassStationHint: "Boş bırakılırsa şirketin tüm istasyonlarında geçerlidir.",
      minPowerHint: "Konnektör gücü ≥ (kW)",
      maxPowerHint: "Konnektör gücü < (kW)",
      validityHint: "İstanbul saati. Bitiş anı hariçtir; boş bırakılırsa süresizdir.",
      pricesHint:
        "₺, KDV dahil, en çok 4 ondalık (ör. 8,49). Bekleme ücreti şarj bittikten sonra ücretsiz süre dolunca dakika başına işler.",
      idleGraceHint: "Şarj bittikten sonra ücretsiz bekleme (dk)",
      idleCapHint: "Bekleme ücretinin üst sınırı (₺); boş = tavansız",
      bandsHint:
        "Saat bandında kWh fiyatı temel fiyatın yerine geçer. Gün seçilmeyen bant her gün geçerlidir; saatler İstanbul saatidir, bitiş hariçtir (24:00 olabilir).",
      noBands: "Saat bandı yok — tüm gün temel kWh fiyatı uygulanır.",
      bandDays: "{{index}}. bandın günleri",
      bandFrom: "{{index}}. bant başlangıç",
      bandTo: "{{index}}. bant bitiş",
      bandPrice: "{{index}}. bant kWh fiyatı (₺)",
      removeBand: "Sil: {{index}}. bant",
      addBand: "Saat bandı ekle",
      sections: {
        scope: "Kapsam",
        validity: "Geçerlilik",
        prices: "Fiyatlar",
        products: "Satış ürünleri",
        bands: "Saat bantları",
      },
      fields: {
        name: "Tarife adı",
        scope: "Kapsam",
        currentType: "Akım türü",
        minPower: "Alt güç (kW)",
        maxPower: "Üst güç (kW)",
        validity: "Geçerlilik",
        validFromDate: "Başlangıç günü",
        validFromTime: "Başlangıç saati",
        validToDate: "Bitiş günü",
        validToTime: "Bitiş saati",
        energyPrice: "kWh fiyatı",
        minutePrice: "Dakika ücreti",
        idlePrice: "Bekleme ücreti (dk)",
        idleGrace: "Ücretsiz bekleme (dk)",
        idleCap: "Bekleme tavanı (₺)",
        energyProduct: "Enerji ürünü",
        timeProduct: "Süre ürünü",
        idleProduct: "Bekleme ürünü",
        bands: "Saat bantları",
      },
      state: {
        ACTIVE: "Yürürlükte",
        SCHEDULED: "Başlayacak",
        EXPIRED: "Süresi doldu",
        INACTIVE: "Devre dışı",
      },
      deactivate: "Devre dışı bırak",
      deactivateFor: "Devre dışı bırak: {{name}}",
      deactivateTitle: "Tarifeyi devre dışı bırak: {{name}}",
      deactivateDescription:
        "Tarife yeni oturumlarda kullanılmaz; başlamış oturumlar anlık görüntüsüyle devam eder. Yerine geçen tarife yoksa yeni oturumların tutarı hesaplanamaz.",
      deactivated: "{{name}} tarifesi devre dışı bırakıldı",
    },
    preview: {
      open: "Tarife dene",
      openFor: "Dene: {{name}}",
      short: "Dene",
      title: "Tarife deneme",
      titleFor: "Tarife deneme: {{name}}",
      description:
        "Ünite, konnektör, başlangıç ve süreleri girin; yürürlükteki (ya da seçilen) tarifenin tutar kırılımı hesaplanır.",
      formLabel: "Tarife deneme",
      noChargers: "Denenecek ünite yok.",
      date: "Başlangıç günü",
      time: "Başlangıç saati",
      energyKwh: "Enerji (kWh)",
      chargingMinutes: "Şarj süresi (dk)",
      idleMinutes: "Bekleme (dk)",
      coveredKwh: "Abonelikle karşılanan (kWh)",
      submit: "Hesapla",
      resolved: {
        RESOLVED: "Yürürlükteki tarife: {{name}}",
        GIVEN: "Seçilen tarife: {{name}}",
        NONE: "Bu an ve konnektör için yürürlükte tarife yok (tutar 0).",
      },
      linesLabel: "Deneme kalemleri",
      noLines: "Ücretlendirilecek kalem yok.",
      billableIdle: "Ücretlenen bekleme: {{minutes}} dk",
    },
    settings: {
      description:
        "İstasyonun şarj işletme modeli, yük yönetimi (şebeke gücü, paylaştırma yöntemi, öncelikler), tanınmayan kart politikası ve enerji maliyeti sayacı.",
      formTitle: "İstasyon şarj ayarı",
      defaults: "Henüz kaydedilmiş ayar yok; varsayılan değerler gösteriliyor.",
      updatedAt: "Son kayıt: {{at}}",
      readOnly: "Ayarları yalnızca görüntüleyebilirsiniz (değiştirmek için şarj yönetim yetkisi gerekir).",
      saved: "Şarj ayarı kaydedildi; güç yeniden paylaştırıldı",
      sections: {
        operation: "İşletme modeli ve tanımlama",
        load: "Yük yönetimi",
        cost: "Enerji maliyeti",
      },
      operationHint:
        "Kendi şarj yönetiminde üniteler bu sunucuya bağlanır. Şarj ağı işletmecisi modelinde bağlantı reddedilir, oturumlar içe aktarılır.",
      fields: {
        operationModel: "İşletme modeli",
        unknownIdTagPolicy: "Tanınmayan kart / etiket",
        partnerCode: "Şarj ağı kodu",
        partnerStationRef: "Şarj ağındaki istasyon kimliği",
        partnerConfig: "Şarj ağı ayarları",
        loadMethod: "Paylaştırma yöntemi",
        maxGridKw: "Şebeke azami gücü (kW)",
        safetyMargin: "Emniyet payı (%)",
        minSessionPower: "Asgari oturum gücü (kW)",
        priorityFleet: "Filo önceliği",
        prioritySubscription: "Abonelik önceliği",
        priorityApp: "Uygulama önceliği",
        electricityMeter: "EV alt sayacı",
      },
      unknownIdTagHint: "Kabul edilirse oturum açılır, ödeme kasada alınır.",
      partnerCodeHint: "Büyük harf, rakam, _ ve - (2–40).",
      partnerConfigHint: "Her satıra bir ayar: anahtar=değer. Gizli bilgi (anahtar, parola) yazmayın.",
      loadHint:
        "Açıkken süren oturumlara güç, şebeke gücünden emniyet payı düşülerek paylaştırılır; asgari güç verilemeyen oturum askıya alınır.",
      maxGridHint: "Trafo / şebeke bağlantısının azami gücü",
      safetyMarginHint: "Paylaştırmada ayrılan pay (en çok %50)",
      minSessionPowerHint: "Bu güç verilemeyen oturum askıya alınır (0 W)",
      priorityHint: "Öncelikli paylaştırmada büyük değer önce güç alır (0–100).",
      meterHint:
        "Enerji maliyeti ve kayıp raporu bu sayacın onaylı faturalarından hesaplanır; seçilmezse istasyonun elektrik sayaçları kullanılır ve kayıp hesaplanmaz.",
      noMeter: "Seçilmedi (istasyon sayaçları)",
      evMeter: "şarj alt sayacı",
    },
    load: {
      title: "Yük yönetimi — canlı görünüm",
      maxGrid: "Şebeke gücü",
      safetyMargin: "Emniyet payı",
      available: "Paylaştırılabilir güç",
      drawing: "Şu an çekilen",
      noLimit: "Sınır yok (yük yönetimi kapalı)",
      usage: "Güç kullanımı",
      usageText: "Paylaştırılabilir gücün {{percent}} kullanılıyor",
      liveTitle: "Süren oturumlar ve son sınır",
      noLive: "Süren oturum yok.",
      unlimited: "Sınırsız",
      suspended: "Askıda (0 kW)",
      historyTitle: "Sınır tarihçesi (son 20)",
      noHistoryTitle: "Sınır tarihçesi yok",
      noHistoryDescription:
        "Yük yönetimi açıkken oturum başlayıp bittikçe uygulanan sınırlar burada listelenir.",
      method: "Yöntem",
      reasonLabel: "Neden",
      command: "Komut",
    },
    imports: {
      description:
        "Şarj ağı işletmecisi modelindeki istasyonların oturumları ortak adaptörüyle içe aktarılır (tekrar içe aktarımda aynı oturum atlanır). Tutar istasyon geliri değildir.",
      caption: "Şarj ağı içe aktarımları",
      run: "İçe aktar",
      noPartnerStations:
        "Şarj ağı işletmecisi modelinde istasyon yok; içe aktarım yalnızca o istasyonlarda yapılır.",
      createdAt: "Zaman",
      period: "Dönem",
      status: { COMPLETED: "Tamamlandı", FAILED: "Başarısız" },
      mockAdapter: "Deneme adaptörü (gerçek şarj ağı bağlantısı yok)",
      counts: "Oturumlar",
      imported: "{{count}} içe aktarıldı",
      skipped: "{{count}} atlandı (zaten vardı)",
      partnerAmount: "Şarj ağı tutarı",
      sessions: "Oturumlar",
      openSessions: "Oturumları gör",
      sessionsFor: "Oturumları gör: {{station}}",
      emptyTitle: "İçe aktarım yok",
      emptyDescription: "Şarj ağından yapılan içe aktarımlar burada listelenir.",
      dialogTitle: "Şarj ağından içe aktar",
      dialogDescription:
        "Seçilen günlerde şarj ağında tamamlanan oturumlar alınır; daha önce alınmış oturumlar atlanır.",
      range: "Oturum günleri",
      rangeHint: "İstanbul günleri, bitiş günü dâhil; en çok 31 gün.",
      rangeRequired: "Başlangıç ve bitiş günü seçin.",
      submit: "İçe aktar",
      done: "{{imported}} oturum içe aktarıldı, {{skipped}} atlandı",
    },
    exports: {
      description:
        "Tamamlanmış oturumların düzenleyici için dışa aktarımı: alanları, sırası ve başlıkları profilde seçilen CSV ya da JSON dosyası.",
      notOfficialTitle: "Bu biçim resmî bir düzenleyici biçimi DEĞİLDİR",
      notOfficial:
        "Düzenleyicinin istediği biçim henüz netleşmediği için dosya uydurulmuş bir şablona göre değil, seçtiğiniz alanlarla üretilir. Alanları ve başlıkları düzenleyicinin istediğine göre profilde düzenleyin ve göndermeden önce doğrulayın. Kişisel veri alanı yoktur.",
      run: "Dışa aktar",
      runFor: "Dışa aktar: {{name}}",
      addProfile: "Profil ekle",
      listLabel: "Dışa aktarım profilleri",
      emptyTitle: "Dışa aktarım profili yok",
      emptyDescription: "Düzenleyicinin istediği alanları seçen bir profil ekleyin.",
      columnsOf: "{{name}} sütunları",
      headerColumn: "Sütun başlığı",
      fieldKey: "Alan",
      meta: "{{count}} sütun · son değişiklik {{at}}",
      editFor: "Düzenle: {{name}}",
      newTitle: "Yeni dışa aktarım profili",
      editTitle: "Profili düzenle: {{name}}",
      profileDescription:
        "Alanlar kapalı listeden seçilir (kişisel veri yok); sıra ve sütun başlıkları profilde tutulur. Tutarlar ₺, zamanlar ISO 8601 (UTC), kod alanları İngilizce sabittir.",
      profileForm: "Dışa aktarım profili",
      profileSaved: "{{name}} profili kaydedildi",
      codeHint: "Büyük harf, rakam, _ ve - (2–40). Sonradan değişmez.",
      codeLocked: "Profil kodu değiştirilemez.",
      fields: {
        code: "Profil kodu",
        name: "Profil adı",
        format: "Biçim",
        delimiter: "CSV ayracı",
        active: "Etkin",
      },
      delimiterHint: "Ayraç virgül değilse sayısal alanlar ondalık virgülle yazılır (Excel Türkçe).",
      delimiter: {
        semicolon: "Noktalı virgül (;)",
        comma: "Virgül (,)",
        pipe: "Dikey çizgi (|)",
        tab: "Sekme",
      },
      columns: "Sütunlar",
      columnsHint: "Sütunlar bu sırayla yazılır; başlıkları düzenleyebilirsiniz.",
      selectedColumns: "Seçili sütunlar",
      header: "{{field}} sütun başlığı",
      moveUp: "Yukarı taşı: {{field}}",
      moveDown: "Aşağı taşı: {{field}}",
      removeField: "Çıkar: {{field}}",
      addFields: "Alan ekle",
      runTitle: "Oturumları dışa aktar",
      runDescription: "Yalnızca tamamlanmış oturumlar, başladıkları İstanbul gününe göre (en çok 366 gün).",
      profile: "Profil",
      range: "Oturum günleri",
      rangeHint: "Bitiş günü dâhil.",
      rangeRequired: "Profil, başlangıç ve bitiş günü seçin.",
      download: "Dosyayı indir",
      downloaded: "Dosya indirildi",
    },
    reports: {
      description:
        "Enerji, maliyet ve marj; konnektör doluluğu; erişilebilirlik ve arızalar; şarj müşterisinin istasyondaki harcaması.",
      range: "Oturum günleri",
      rangeHint: "Aralık oturumun başladığı İstanbul günüdür (en çok 366 gün).",
      tabsLabel: "Şarj raporları",
      tabs: {
        energy: "Enerji ve marj",
        occupancy: "Doluluk",
        availability: "Erişilebilirlik ve arıza",
        customers: "Müşteri harcaması",
      },
      emptyTitle: "Bu aralıkta veri yok",
      emptyDescription: "Seçilen günlerde başlamış tamamlanmış şarj oturumu bulunamadı.",
      warnings: "Rapor uyarıları",
      energy: {
        totalsTitle: "Toplamlar",
        sessions: "Oturum",
        energy: "Enerji (kWh)",
        revenueNet: "Gelir (KDV hariç)",
        revenueGross: "Gelir (KDV dahil)",
        energyCost: "Enerji maliyeti",
        margin: "Marj",
        marginPercent: "Marj %",
        unpaid: "Ödenmemiş",
        partnerAmount: "Şarj ağı tutarı",
        covered: "Abonelikle karşılanan",
        avgSession: "Ortalama oturum",
        avgChargingIdle: "Ortalama şarj / bekleme",
        costTitle: "Enerji maliyeti ve kayıp",
        costSource: "Birim maliyet kaynağı",
        source: {
          EV_METER: "Şarj alt sayacı",
          STATION_METER: "İstasyon elektrik sayacı",
          NONE: "Kaynak yok",
        },
        unitCost: "Birim maliyet",
        meterConsumption: "Alt sayaç tüketimi",
        sessionEnergy: "Oturumların enerjisi",
        loss: "Kayıp",
        lossPercent: "Kayıp %",
        costHintMeter:
          "Birim maliyet şarj alt sayacının onaylı faturalarından; kayıp = alt sayaç tüketimi − oturumların enerjisi. Rapor hesabıdır, fiş üretmez.",
        costHintStation:
          "Alt sayaç seçilmediği için istasyonun elektrik sayaçlarının birim maliyeti kullanıldı; kayıp hesaplanmaz.",
        costHintNone: "Onaylı elektrik faturası olmadığı için enerji maliyeti hesaplanamadı.",
        chartTitle: "Günlük enerji, gelir ve maliyet",
        chartAria: "{{from}} – {{to}} arası günlük şarj enerjisi, geliri, maliyeti ve marjı",
        energyAxis: "kWh",
        moneyAxis: "₺",
        byDay: "Günlük kırılım",
        day: "Gün",
        byCharger: "Ünite kırılımı",
        byPayment: "Ödeme durumu kırılımı",
      },
      occupancy: {
        title: "Konnektör doluluğu (hafta günü × saat)",
        summary: "{{connectors}} konnektör · toplam dolu {{duration}}",
        series: "Doluluk",
        aria: "{{from}} – {{to}} arası konnektör doluluğu ısı haritası",
        table: "Doluluk tablosu (%)",
        weekday: "Gün",
        hint: "Hücre: o hafta günü ve saatte konnektörlerin dolu (hazırlanıyor, şarj, askıda, bitti) geçen süre oranı.",
        byConnector: "Konnektör başına doluluk",
        occupied: "Dolu süre",
        percent: "Doluluk",
      },
      availability: {
        totalsTitle: "Erişilemezlik",
        downtime: "Erişilemez süre",
        fault: "Arıza",
        offline: "Bağlantı kopukluğu",
        faultCount: "Arıza sayısı",
        chartTitle: "Konnektör durum dağılımı (saat)",
        chartAria: "{{from}} – {{to}} arası konnektörlerin durum dağılımı",
        table: "Durum dağılımı",
        hoursAxis: "saat",
        hoursUnit: "sa",
        bucket: {
          AVAILABLE: "Boş",
          OCCUPIED: "Dolu",
          RESERVED: "Rezerve",
          FAULTED: "Arızalı",
          UNAVAILABLE: "Kullanım dışı",
          OFFLINE: "Bağlantı yok",
        },
        availabilityPercent: "Erişilebilirlik",
        chargersTitle: "Ünite bağlantısı",
        disconnects: "Kopma sayısı",
        neverConnected: "Hiç bağlanmadı",
        connectedBefore: "Bağlandı",
        faultsTitle: "Hata kodları",
        noFaults: "Bu aralıkta arıza yok.",
        errorCode: "Hata kodu",
      },
      customers: {
        totalsTitle: "Şarj müşterileri",
        customers: "Tanınan müşteri",
        evAmount: "Şarj tutarı",
        during: "Şarj sırasında",
        sameDay: "Aynı gün (istasyonda)",
        market: "Market",
        cafe: "Kafe",
        other: "Diğer",
        hint: "Tanınan müşterinin oturum günlerinde bu istasyondaki kasa harcaması (şarj satırları hariç, KDV dahil, indirim sonrası).",
        caption: "Müşteri harcaması",
        customer: "Müşteri",
        emptyTitle: "Tanınan şarj müşterisi yok",
        emptyDescription: "Müşteri kartı / etiketiyle tanınan şarj oturumu bu aralıkta yok.",
      },
    },
  },
  reports: {
    gate: {
      disabledTitle: "Raporlar modülü kapalı",
      disabledDescription: "Raporlar ve panolar bu kiracının aboneliğinde açık değil. Yöneticinizle görüşün.",
      forbiddenTitle: "Bu sayfayı görme yetkiniz yok",
      forbiddenDescription: "Rapor görme ya da yönetme yetkisi için yöneticinizle görüşün.",
    },
    filter: {
      label: "Rapor süzgeci",
      range: "Dönem",
      company: "Şirket",
      allCompanies: "Tüm şirketler",
      station: "İstasyon",
      stations: "İstasyonlar",
      allStations: "Tüm istasyonlar",
      stationsSelected: "{{count}} istasyon seçili",
    },
    export: {
      label: "Dışa aktar",
      excel: "Excel",
      pdf: "PDF",
      downloaded: "Rapor indirildi",
      failed: "Rapor indirilemedi",
    },
    filters: {
      menu: "Filtreler",
      saved: "Kaydedilmiş filtreler",
      none: "Henüz kaydedilmiş filtre yok.",
      default: "Varsayılan",
      saveCurrent: "Bu süzgeci kaydet…",
      manage: "Sil",
      deleteNamed: "“{{name}}” filtresini sil",
      deleted: "Filtre silindi",
      failed: "Filtre işlemi başarısız",
      applied: "“{{name}}” uygulandı",
      saveTitle: "Süzgeci kaydet",
      saveHintPreset:
        "Kaydedilen filtre dönemi hazır aralık olarak saklar (ör. “Son 30 gün”); her açılışta bugüne göre yeniden hesaplanır.",
      saveHintFixed:
        "Seçili dönem hazır bir aralık değil: filtre yalnızca şirket / istasyon seçimini saklar, dönem o anki seçimde kalır.",
      name: "Filtre adı",
      nameRequired: "Filtre adı zorunludur",
      makeDefault: "Bu raporu açınca varsayılan olarak uygula",
      savedToast: "Filtre kaydedildi",
    },
    metrics: {
      revenue: "Ciro",
      revenueNet: "Ciro (KDV hariç)",
      fuelLitres: "Litre",
      transactions: "{{count}} pompa işlemi",
      marketConversion: "Market dönüşümü",
      marketConversionHint: "Her 100 pompa işlemine düşen market fişi",
      lossRate: "Fire oranı",
      shiftShortage: "Vardiya açığı",
      outOfTolerance: "{{count}} tolerans dışı kapanış",
    },
    columns: {
      station: "İstasyon",
      unit: "İş birimi",
      total: "TOPLAM",
      date: "Tarih",
      product: "Ürün",
      amount: "Tutar",
      share: "Pay",
      nozzle: "Pompa / tabanca",
      fuelTransactions: "Pompa işlemi",
      marketReceipts: "Market fişi",
      washPerUnit: "Yıkama / ünite / gün",
      evUtilization: "Şarj kullanımı",
      loss: "Fire (L)",
      stationProduct: "İstasyon · ürün",
      price: "Fiyat",
      beforeAfter: "Önce → sonra (L / gün)",
      volumeChange: "Hacim değişimi",
    },
    center: {
      description:
        "Görebildiğiniz raporlar: ekranda inceleyin ya da seçtiğiniz dönemle biçimli Excel / PDF olarak indirin. Yıldızla favorilerinize ekleyin.",
      exportScope: "Dışa aktarım dönemi",
      exportHint:
        "Aşağıdaki Excel / PDF düğmeleri bu dönemi ve şirket seçimini kullanır. Finans özeti anlık durumdur.",
      listLabel: "Raporlar",
      open: "Aç",
      exportOnly: "Yalnızca dışa aktarım (istasyon × gün × iş birimi tablosu)",
      favorite: "“{{name}}” raporunu favorilere ekle",
      unfavorite: "“{{name}}” raporunu favorilerden çıkar",
      favoriteFailed: "Favori güncellenemedi",
      periodic: "Dönemli · en çok {{days}} gün",
      snapshot: "Anlık durum",
      unavailable: "Yetki yok",
      unavailableHint: "Bu raporun kaynağını görme yetkiniz yok.",
      companyNeeded: "Kârlılık raporu için bir şirket seçin.",
    },
    comparison: {
      description:
        "Seçilen dönemde istasyonların ciro, litre, market dönüşümü, yıkama / şarj kullanımı, vardiya açığı ve fire göstergeleri.",
      totals: "Dönem toplamları",
      chartTitle: "Ciroya göre istasyonlar",
      chartDescription: "KDV dahil ciro; tüm satış birimleri (akaryakıt, market, yıkama, şarj…).",
      chartAria: "İstasyonların ciro karşılaştırma grafiği",
      chartTable: "İstasyonların cirosu",
      tableTitle: "İstasyon göstergeleri",
      refreshedAt: "Özetler {{at}} itibarıyla güncel.",
      notRefreshed: "Bu dönem için özet henüz hesaplanmadı.",
      sortBy: "Sırala",
      sorts: {
        revenue: "Ciro (yüksekten)",
        fuelLitres: "Litre (yüksekten)",
        marketConversionRate: "Market dönüşümü",
        lossRate: "Fire oranı",
        shiftShortage: "Vardiya açığı",
        evUtilization: "Şarj kullanımı",
      },
      note: "Market dönüşümü: her 100 pompa işlemine düşen market fişi. Fire oranı: onaylı mutabakat kaybı / satış litresi (eksi değer fazla). Yetkiniz olmayan göstergeler “—”.",
      emptyTitle: "Bu dönemde satış yok",
      emptyDescription: "Seçilen dönem ve istasyonlarda okuma modelinde satış bulunmuyor.",
    },
    fuel: {
      description:
        "Yoğun saatler, tabanca başına hacim, ürün karışımı ve fiyat değişikliklerinin hacme etkisi. Dönem en çok 92 gün.",
      window: "Fiyat değişimi penceresi",
      windowDays: "{{count}} gün önce / sonra",
      heatmapTitle: "Yoğun saatler (ortalama litre / saat)",
      heatmapDescription: "Haftanın günü × saat; her hücre o dilimin dönemdeki ortalama pompa satışıdır.",
      peaks: "En yoğun dilimler: {{list}}",
      heatmapAria: "Haftanın günü ve saate göre ortalama pompa satışı ısı haritası",
      heatmapTable: "Haftanın günü × saat ortalama litre tablosu",
      averageLitres: "Ortalama litre",
      weekday: "Gün",
      mixTitle: "Ürün karışımı",
      mixDescription: "Dönemdeki pompa satışının ürünlere göre dağılımı (litre payı).",
      mixAria: "Ürünlere göre pompa satışı grafiği",
      mixTable: "Ürünlere göre pompa satışı",
      priceTitle: "Fiyat değişimi öncesi / sonrası",
      priceDescription:
        "Değişiklik gününden önceki ve sonraki {{count}} günün günlük ortalama litresi (değişim günü hariç).",
      noPriceChanges: "Bu dönemde uygulanmış fiyat değişikliği yok.",
      partial: "(kısmi pencere)",
      nozzlesTitle: "Tabanca başına hacim",
      nozzlesDescription: "Saatlik tabanca satışından; en çok satandan.",
      nozzlesShown: "{{total}} tabancadan {{shown}} tanesi gösteriliyor.",
      nozzlesAll: "Tümünü göster",
      nozzlesLess: "İlk 20'yi göster",
      emptyTitle: "Bu dönemde pompa satışı yok",
      emptyDescription: "Seçilen dönem ve istasyonda pompa satışı bulunmuyor.",
    },
    profitability: {
      description:
        "Kârlılık ana defterden (kesinleşmiş fişler; isteğe bağlı taslaklar) istasyon ve iş birimi boyutlarıyla; altta operasyonel satışla tutarlılık.",
      groupBy: "Kırılım",
      groupings: {
        STATION_BUSINESS_UNIT: "İstasyon × iş birimi",
        STATION: "İstasyon",
        BUSINESS_UNIT: "İş birimi",
      },
      includeDrafts: "Taslak fişleri dahil et",
      withDrafts: "Taslaklar dahil",
      ledgerTitle: "Ana defter kârlılığı",
      ledgerDescription:
        "Gelir ve gider hesaplarına istasyon / iş birimi boyutuyla atılmış kayıtlar; boyut atanmamış kayıtlar ayrı satırda.",
      revenue: "Gelir",
      expense: "Gider",
      net: "Net",
      noStation: "İstasyon atanmamış",
      noUnit: "İş birimi atanmamış",
      emptyTitle: "Bu dönemde fiş yok",
      emptyDescription: "Seçilen şirket ve dönemde boyutlu gelir / gider fişi bulunmuyor.",
    },
    consistency: {
      title: "Operasyonel satış ↔ ana defter tutarlılığı",
      description:
        "Okuma modelindeki KDV hariç ciro ile ana defterdeki gelir, istasyon × iş birimi bazında. Farkların çoğu henüz fişlenmemiş gün sonlarıdır.",
      operational: "Operasyonel (KDV hariç)",
      ledger: "Defterdeki gelir",
      difference: "Fark",
      differencePercent: "Fark %",
      status: "Durum",
      unpostedDays: "Fişlenmemiş gün",
      vatMissing: "Bazı kaynaklarda KDV oranı bilinmiyor; operasyonel KDV hariç tutar yaklaşık hesaplandı.",
      hint: "Fişlenmemiş günler gün sonu kapanınca deftere işlenir.",
      dayEndLink: "Gün sonu işlemlerine git",
    },
    finance: {
      description:
        "Şirketin anlık nakit pozisyonu, çek / senet portföyü ve alacak yaşlandırması. Yetkiniz olmayan bölümler gösterilmez.",
      asOf: "{{company}} · {{date}} itibarıyla",
      cashTitle: "Nakit pozisyonu",
      cash: "Kasalar",
      bank: "Banka",
      bankAvailable: "Kullanılabilir banka",
      bankAvailableHint: "Bakiye + kullanılabilir KMH",
      posPending: "POS'ta bekleyen",
      netToday: "Bugünkü net hareket",
      openTreasury: "Finansa git",
      chequesTitle: "Çek / senet portföyü",
      receivableOpen: "Portföyde (alınan)",
      endorsedOpen: "Ciro edilen",
      problemOpen: "Sorunlu",
      issuedOpen: "Verilen (ödenecek)",
      maturityTitle: "Vade dağılımı",
      maturity: "Vade",
      receivable: "Tahsil edilecek",
      payable: "Ödenecek",
      openInstruments: "Çek / senetlere git",
      receivablesTitle: "Alacak yaşlandırma",
      receivablesDescription: "Vadesine göre açık alacaklar ve en büyük borçlular.",
      agingTitle: "Vade kovalarına göre açık alacak",
      topTitle: "En büyük açık alacaklar",
      counterparty: "Cari",
      openReceivable: "Açık alacak",
      openCounterparties: "Carilere git",
      emptyTitle: "Gösterilecek finans bölümü yok",
      emptyDescription: "Hazine, çek / senet ya da cari rapor yetkiniz yok.",
    },
    schedules: {
      description:
        "Raporlar seçtiğiniz sıklıkta kiracı üyelerine e-postayla gider. Rapor her alıcı için KENDİ yetkisiyle üretilir; göremediği istasyonun verisi ona gönderilmez.",
      new: "Yeni zamanlama",
      newTitle: "Yeni zamanlanmış rapor",
      editTitle: "Zamanlanmış raporu düzenle",
      dialogHint:
        "Günlük rapor dünü, haftalık rapor geçen haftayı (pazartesi–pazar), aylık rapor geçen ayı kapsar. Saat İstanbul saatidir.",
      name: "Ad",
      report: "Rapor",
      format: "Biçim",
      frequency: "Sıklık",
      time: "Gönderim saati",
      weekday: "Haftanın günü",
      monthDay: "Ayın günü",
      when: "Ne zaman",
      recipients: "Alıcılar",
      recipientsHint: "Yalnızca bu kiracının etkin üyeleri seçilebilir (dış e-posta adresi yok).",
      stationsHint: "Boş bırakılırsa alıcının görebildiği tüm istasyonlar.",
      next: "Sonraki gönderim",
      last: "Son koşu",
      owner: "Sahibi",
      paused: "Durduruldu",
      pausedToast: "Zamanlama durduruldu",
      resumedToast: "Zamanlama sürdürüldü",
      saved: "Zamanlama kaydedildi",
      failed: "İşlem başarısız",
      invalid: "Zamanlama geçersiz",
      history: "“{{name}}” koşu geçmişi",
      runNow: "“{{name}}” raporunu şimdi gönder",
      edit: "“{{name}}” zamanlamasını düzenle",
      pause: "“{{name}}” zamanlamasını durdur",
      resume: "“{{name}}” zamanlamasını sürdür",
      archive: "“{{name}}” zamanlamasını arşivle",
      archiveTitle: "Zamanlama arşivlensin mi?",
      archiveDescription: "“{{name}}” artık gönderilmez; koşu geçmişi saklanır.",
      archiveConfirm: "Arşivle",
      archived: "Zamanlama arşivlendi",
      ran: "Rapor gönderimi: {{status}}",
      ranDetail: "{{sent}} / {{total}} alıcıya gönderildi.",
      emptyTitle: "Henüz zamanlanmış rapor yok",
      emptyDescription:
        "Sabah satış özetini ya da haftalık karşılaştırmayı otomatik e-postayla almak için bir zamanlama oluşturun.",
      historyTitle: "{{name}} — koşu geçmişi",
      historyDescription: "Son 50 koşu; her alıcının sonucu ve atlanma nedeni.",
      noRuns: "Henüz koşu yok.",
      triggers: { SCHEDULE: "Zamanlanmış", MANUAL: "Elle (şimdi gönder)" },
      recipientStatus: { SENT: "Gönderildi", SKIPPED: "Atlandı", FAILED: "Başarısız" },
    },
    settings: {
      description: "PDF raporların antedindeki logo ve altbilgi notu. Değişiklikler denetim izine yazılır.",
      logoTitle: "Rapor logosu",
      logoHint:
        "PNG ya da JPEG, en çok 1 MB. Yatay logolar en iyi görünür (PDF'te en çok 140 × 42 pt). Logo yoksa kiracı adı yazılır.",
      logoPreview: "Rapor logosu önizlemesi",
      noLogo: "Logo yok",
      chooseLogo: "Logo seç",
      removeLogo: "Logoyu kaldır",
      logoType: "Logo PNG ya da JPEG olmalıdır.",
      logoSize: "Logo en çok 1 MB olabilir.",
      footerNote: "Altbilgi notu",
      footerHint:
        "PDF sayfalarının altında üretim anının yanında görünür (ör. “Gizlidir — yalnızca iç kullanım”). En çok 200 karakter.",
      saved: "Rapor ayarları kaydedildi",
      updatedAt: "Son değişiklik {{at}}",
      neverSaved: "Henüz kaydedilmedi.",
    },
  },
  maintenance: {
    disabledTitle: "Bakım ve uyum modülü kapalı",
    disabledDescription: "Varlık bakımı ve uyum takvimi paketinizde ya da bu istasyonda etkin değil.",
    noPermission: "Bu ekran için yetkiniz yok. Bakım ya da uyum yetkisi için yöneticinize başvurun.",
    allStations: "Tüm istasyonlar",
    stationWide: "İstasyon geneli",
    none: "Seçilmedi",
    minThree: "En az 3 karakter yazın",
    positive: "Sıfırdan büyük olmalıdır",
    fields: {
      station: "İstasyon",
      asset: "Varlık",
      assetKind: "Varlık türü",
      workOrder: "İş emri",
      workType: "İş türü",
      priority: "Öncelik",
      status: "Durum",
      source: "Kaynak",
      title: "Başlık",
      description: "Açıklama",
      serviceCounterparty: "Servis firması",
      serviceHint: "İstasyonun şirketine bağlı tedarikçi carileri",
      assignedUser: "Atanan personel",
      assignee: "Atanan",
      totalCost: "Maliyet",
      createdAt: "Açılış",
      responseDueAt: "Yanıt son anı",
      resolveDueAt: "Çözüm son anı",
      respondedAt: "Yanıt",
      completedAt: "Tamamlanma",
      plan: "Plan",
      dueOn: "vade",
      alarm: "Alarm",
      completionMeter: "Bakımdaki sayaç değeri",
      expense: "Gider kaydı",
      resolutionNote: "Çözüm notu",
      cancelReason: "İptal gerekçesi",
      costKind: "Maliyet türü",
      quantity: "Miktar",
      unitPrice: "Birim fiyat",
      amount: "Tutar",
      vatRate: "KDV oranı",
      docKind: "Belge türü",
      docNo: "Belge no",
      docDate: "Belge tarihi",
      trigger: "Tetik",
      usageSource: "Kullanım kaynağı",
      planName: "Plan adı",
      intervalDays: "Aralık (gün)",
      intervalUsage: "Aralık (saat / adet)",
      leadDays: "Kaç gün önce açılsın",
      leadUsage: "Pay (saat / adet)",
      startsOn: "Başlangıç",
      instructions: "Talimat",
      interval: "Aralık",
      due: "Vade",
      lastCompletedOn: "Son bakım",
      installedOn: "Kurulum",
      warrantyEndsOn: "Garanti bitişi",
      openWorkOrders: "Açık iş emri",
      activePlans: "Plan",
      nextPlanDueOn: "Yaklaşan bakım",
      documents: "Belgeler",
      serialNo: "Seri no",
      brandModel: "Marka / model",
      meter: "Sayaç",
      meterValue: "Sayaç değeri",
      note: "Not",
      file: "Dosya",
      period: "Dönem",
    },
    actions: {
      ASSIGN: "Ata",
      START: "Çalışmaya başla",
      HOLD: "Beklemeye al",
      RESUME: "Çalışmaya dön",
      COMPLETE: "Tamamla",
      CANCEL: "İptal et",
      NOTE: "Not ekle",
      ADD_COST: "Maliyet ekle",
      ADD_PHOTO: "Fotoğraf ekle",
      CREATE_EXPENSE: "Gider kaydı oluştur",
    },
    actionDone: {
      START: "Çalışma başladı",
      RESUME: "Çalışmaya dönüldü",
      HOLD: "İş emri beklemeye alındı",
      COMPLETE: "İş emri tamamlandı",
      CANCEL: "İş emri iptal edildi",
      NOTE: "Not eklendi",
    },
    actionHint: {
      HOLD: "Neden beklediğini yazın (ör. parça bekleniyor); zaman çizelgesine eklenir.",
      COMPLETE: "Yapılan işi yazın. Plandan açılan iş emrinde sonraki bakım dönemi bugünden sayılır.",
      CANCEL: "İptal gerekçesini yazın. Kapanmış iş emri yeniden açılmaz.",
      NOTE: "Not zaman çizelgesine eklenir.",
    },
    actionLabel: {
      HOLD: "Bekleme nedeni",
      COMPLETE: "Çözüm notu",
      CANCEL: "İptal gerekçesi",
      NOTE: "Not",
    },
    workOrders: {
      description:
        "Arıza ve bakım iş emirleri: alarmdan, bakım planından ya da elle açılır; SLA, atama, maliyet ve fotoğrafla takip edilir.",
      new: "Yeni iş emri",
      newDescription:
        "İstasyon, varlık ve öncelik seçin. Servis firması ya da personel seçerseniz iş emri atanmış açılır.",
      create: "İş emrini aç",
      created: "{{no}} numaralı iş emri açıldı",
      assetHint: "Varlıksız iş emri istasyon geneli sayılır.",
      priorityHint: "Yanıt ve çözüm son anları önceliğin SLA'sından hesaplanır.",
      openAll: "Açık olanlar",
      slaOnly: "Yalnızca SLA'sı aşılanlar",
      searchPlaceholder: "No ya da başlık",
      emptyTitle: "İş emri yok",
      emptyDescription: "Süzgeçlere uyan iş emri bulunmuyor.",
      detailTitle: "İş emri",
      notFoundTitle: "İş emri bulunamadı",
      notFoundDescription: "İş emri silinmiş olamaz; görme yetkiniz olmayabilir ya da bağlantı hatalı.",
      assigned: "Atama kaydedildi",
      assignDescription: "Servis firması ve / veya personel seçin; açık iş emri atanmış olur.",
      assignRequired: "Servis firması ya da personel seçin",
      meterHint:
        "Plan elle sayaçlı: bakım anındaki değer sonraki dönemin tabanı olur (son okumadan küçük olamaz).",
    },
    costs: {
      title: "Maliyet",
      none: "Henüz maliyet satırı yok.",
      net: "Toplam (KDV hariç)",
      added: "Maliyet satırı eklendi",
      removed: "Maliyet satırı silindi",
      remove: "{{description}} satırını sil",
      description:
        "Parça, işçilik ya da diğer maliyet (KDV hariç). Gider kaydı oluşunca satırlar kilitlenir.",
      netHint: "KDV hariç",
      preview: "Satır tutarı:",
    },
    expense: {
      description:
        "Maliyet toplamından gider modülünde TASLAK gider açılır (cari: servis firması, kategori: bakım ayarındaki). Onay ve muhasebe gider ekranındadır.",
      created: "Taslak gider kaydı oluşturuldu",
      noService: "İş emrinde servis firması yok: cariye borç yazılamaz. Önce servis firması atayın.",
      net: "Gider tutarı (KDV hariç):",
      draft: "Taslak",
    },
    photos: {
      title: "Fotoğraflar",
      uploaded: "Fotoğraf eklendi",
      type: "Yalnızca JPEG, PNG ya da WEBP fotoğraf yüklenebilir",
      size: "Fotoğraf en fazla 10 MB olabilir",
      alt: "{{no}} iş emri fotoğrafı {{index}}",
    },
    timeline: {
      title: "Zaman çizelgesi",
      system: "Sistem",
      kinds: {
        CREATED: "Açıldı",
        ASSIGNED: "Atandı",
        STATUS_CHANGED: "Durum değişti",
        NOTE: "Not",
        COST_ADDED: "Maliyet eklendi",
        COST_REMOVED: "Maliyet silindi",
        PHOTO_ADDED: "Fotoğraf eklendi",
        EXPENSE_CREATED: "Gider kaydı oluşturuldu",
        ALARM_RESOLVED: "Kaynak alarm çözüldü",
      },
    },
    plans: {
      description:
        "Önleyici bakım planları: her N günde, N çalışma saatinde ya da N adette. Vadesi gelen plana iş emri kendiliğinden açılır (her sabah).",
      new: "Yeni plan",
      edit: "Planı düzenle",
      editNamed: "{{name}} planını düzenle",
      create: "Planı kur",
      created: "{{name}} planı kuruldu",
      saved: "{{name}} planı kaydedildi",
      dialogDescription:
        "Tetik ve kullanım kaynağı plan kurulduktan sonra değiştirilemez; gerekirse yeni plan kurun.",
      evaluate: "Şimdi değerlendir",
      evaluated: "{{evaluated}} plan değerlendirildi, {{count}} iş emri açıldı",
      dueNow: "Vadesi geldi",
      onTrack: "Zamanında",
      dueOnly: "Yalnızca vadesi gelenler",
      progress: "{{name}} ilerlemesi",
      emptyTitle: "Bakım planı yok",
      emptyDescription: "Varlıklarınız için periyodik bakım planı kurun.",
      usageSourceHint:
        "Kullanım diğer modüllerden okunur (yıkama, şarj, pompa) ya da elle sayaç okumasından hesaplanır.",
      leadDaysHint: "Vadeden bu kadar gün önce iş emri açılır",
      leadDaysRange: "0–365 arası tam sayı girin",
      leadUsageHint: "Eşiğin bu kadar altına inince iş emri açılır",
      startsOnHint: "İlk dönem bu günden sayılır",
      serviceHint: "Boşsa varlığın servis firması kullanılır",
      assetService: "Varlığın servis firması",
      active: "Plan etkin",
    },
    assets: {
      description:
        "Tank, pompa, cihaz, şarj ve yıkama üniteleri tek listede: seri no, kurulum, garanti, servis firması, açık iş emri ve bakım planları.",
      searchPlaceholder: "Ad ya da seri no",
      emptyTitle: "Varlık yok",
      emptyDescription: "Süzgeçlere uyan varlık bulunmuyor.",
      detailTitle: "Varlık",
      notFoundTitle: "Varlık bulunamadı",
      notFoundDescription: "Varlık başka bir istasyonda olabilir ya da görme yetkiniz yok.",
      editHint: "Seri no, kurulum, garanti ve servis firması istasyon varlık ekranından düzenlenir.",
      usage30: "Son 30 gün · {{source}}",
      addReading: "Sayaç okuması gir",
      readingDescription:
        "Elle sayaç (çalışma saati / adet). Sayaç değiştiyse sıfırlama işaretleyin; önceki okumalarla fark alınmaz.",
      readingSaved: "Sayaç okuması kaydedildi",
      meterHours: "Çalışma saati",
      meterCount: "Adet",
      isReset: "Sayaç değişti / sıfırlandı",
      readings: "Sayaç okumaları",
      noReadings: "Elle sayaç okuması yok.",
      hoursUnit: "saat",
      countUnit: "adet",
      resetMark: "sıfırlama",
      addDocument: "Belge ekle",
      documentDescription:
        "Fatura, garanti belgesi, kılavuz, sertifika ya da servis raporu (PDF ya da görsel).",
      documentAdded: "Belge eklendi",
      documentArchived: "Belge arşivlendi",
      noDocuments: "Belge yok.",
      openFile: "Dosyayı aç",
      archive: "Arşivle",
      archiveConfirm: "{{title}} belgesi arşivlensin mi? Belge silinmez, listeden kalkar.",
      fileHint: "PDF, JPEG, PNG ya da WEBP · en fazla 25 MB",
      fileType: "Yalnızca PDF, JPEG, PNG ya da WEBP yüklenebilir",
      fileSize: "Dosya en fazla 25 MB olabilir",
      noPlans: "Bu varlık için bakım planı yok.",
      recentWorkOrders: "Son iş emirleri",
      noWorkOrders: "Bu varlığın iş emri yok.",
    },
    reports: {
      description:
        "Varlık bazında arıza sıklığı, ortalama onarım süresi, önleyici bakım, SLA aşımı ve bakım maliyeti. Excel / PDF olarak da alınabilir.",
      failures: "Arıza",
      mttr: "Ort. onarım süresi",
      preventiveDone: "Önleyici bakım",
      slaBreaches: "SLA aşımı",
      totalCost: "Toplam maliyet",
      open: "Açık",
      parts: "Parça",
      labor: "İşçilik",
      byAsset: "Varlık bazında",
      empty: "Bu dönemde iş emri yok.",
      note: "Arıza: dönemde açılan arıza iş emri. Onarım süresi ve maliyet: dönemde tamamlanan iş emirleri (KDV hariç). Açık: şu anki durum.",
    },
    settings: {
      description:
        "Öncelik başına SLA, cihaz arızası alarmından otomatik iş emri ve bakım giderinin kategorisi.",
      slaTitle: "SLA (saat)",
      slaHint:
        "İşletme hedefidir, mevzuat değildir. Yanıt: atama ya da çalışmaya başlama; çözüm: tamamlanma.",
      responseHours: "{{priority}} — yanıt (saat)",
      resolveHours: "{{priority}} — çözüm (saat)",
      hoursInvalid: "1 ya da daha büyük tam sayı girin",
      resolveBeforeResponse: "Çözüm süresi yanıt süresinden kısa olamaz",
      autoWorkOrder: "Cihaz arızası alarmından otomatik iş emri aç",
      autoWorkOrderHint: "Ajan cihazı, yıkama ve şarj ünitesi arızalarında alarm başına tek iş emri açılır.",
      expenseCategory: "Bakım gider kategorisi",
      expenseCategoryHint: "İş emri maliyetinden açılan TASLAK giderin kategorisi",
      defaultCategory: "Varsayılan (Bakım ve onarım)",
    },
  },
  compliance: {
    fields: {
      type: "Belge türü",
      typeName: "Tür adı",
      code: "Kod",
      appliesTo: "Kapsam",
      validityMonths: "Önerilen geçerlilik",
      reminderDays: "Hatırlatma günleri",
      verification: "Doğrulama",
      activeDocuments: "Etkin belge",
      description: "Açıklama",
      company: "Şirket",
      scope: "İstasyon / şirket",
      documentNo: "Belge no",
      issuedOn: "Veriliş",
      expiresOn: "Bitiş",
      expiry: "Bitiş durumu",
      recordStatus: "Kayıt",
      nextReminderOn: "Sonraki hatırlatma",
      responsible: "Sorumlu",
      file: "Belge dosyası",
      notes: "Not",
      reason: "Gerekçe",
      createdAt: "Kayıt zamanı",
      authority: "Kurum",
      authorityName: "Kurum adı",
      visitDate: "Ziyaret tarihi",
      inspectionStatus: "Durum",
      result: "Sonuç",
      penaltyAmount: "Ceza tutarı",
      reportFile: "Tutanak",
      correctiveActions: "Düzeltici faaliyetler",
      actionDescription: "Faaliyet",
      dueDate: "Son tarih",
      completionNote: "Kapanış notu",
      evidenceFile: "Kanıt dosyası",
    },
    summary: {
      unverifiedTypes: "Doğrulanmamış tür",
      openActions: "Açık faaliyet",
      overdue: "{{count}} gecikmiş",
      plannedInspections: "Planlı denetim",
    },
    types: {
      description:
        "Belge türleri ve hatırlatma günleri kiracıya aittir. Öneriden eklenen türlerin süreleri ÖNERİDİR: mevzuata göre doğrulayın.",
      adopt: "Öneriden ekle",
      adoptDescription:
        "Platformun önerdiği türlerden seçin. Geçerlilik ve hatırlatma günleri sonradan düzenlenebilir.",
      adoptSubmit: "Seçilenleri ekle ({{count}})",
      adopted: "{{count}} tür eklendi",
      allAdopted: "Tüm öneriler zaten eklenmiş.",
      selectOne: "En az bir tür seçin",
      verifyWarning:
        "Öneri süreleri mevzuattan doğrulanmamıştır. Ekledikten sonra her türü kontrol edip doğrulayın.",
      new: "Yeni tür",
      edit: "Türü düzenle",
      editNamed: "{{name}} türünü düzenle",
      created: "Belge türü eklendi",
      saved: "Belge türü kaydedildi",
      dialogDescription: "Kod ve kapsam sonradan değiştirilemez (belgeler türe bağlıdır).",
      codeHint: "Büyük harf, rakam ve alt çizgi (ör. ODA_FAALIYET_BELGESI)",
      codeInvalid: "Büyük harfle başlayan, 2–40 karakter kod girin",
      validityHint: "Ay; boşsa süresiz. Bitiş önerisi bu süreden hesaplanır.",
      validityInvalid: "1–240 arası tam sayı girin",
      remindersHint: "Bitişten kaç gün önce hatırlatılsın (ör. 60, 30, 7); en fazla 6",
      remindersInvalid: "Virgülle ayrılmış, tekrarsız 1–730 arası en fazla 6 gün girin",
      validityMonths: "{{count}} ay",
      noValidity: "Süresiz",
      reminders: "hatırlatma: {{days}}",
      verify: "Doğrula",
      verifyConfirm:
        "{{name}} türünün geçerlilik ve hatırlatma sürelerini mevzuattan kontrol ettiniz mi? Doğrulama kaydınıza işlenir.",
      verified: "{{name}} doğrulandı",
      verifiedBadge: "Doğrulandı",
      unverifiedBadge: "Doğrulayın",
      active: "Tür etkin",
      emptyTitle: "Belge türü yok",
      emptyDescription: "Öneriden ekleyin ya da kendi türünüzü tanımlayın.",
    },
    documents: {
      description:
        "Lisans, ruhsat, muayene, sigorta ve diğer uyum belgeleri. Bitiş yaklaşınca türün hatırlatma günlerinde alarm üretilir.",
      new: "Yeni belge",
      createDescription: "Türü seçin; kapsamına göre şirket, istasyon ya da varlık istenir.",
      detailTitle: "Uyum belgesi",
      notFoundTitle: "Belge bulunamadı",
      notFoundDescription: "Belge başka bir kapsamda olabilir ya da görme yetkiniz yok.",
      searchPlaceholder: "Tür, belge no ya da varlık",
      emptyTitle: "Belge yok",
      emptyDescription: "Süzgeçlere uyan uyum belgesi bulunmuyor.",
      noNumber: "Numarasız",
      noExpiry: "Süresiz",
      renew: "Yenile",
      edit: "Kaydı düzelt",
      archive: "Arşivle",
      archiveDescription: "Belge silinmez; arşivlenir ve alarmları kapanır.",
      history: "Yenileme geçmişi",
      noHistory: "Önceki belge yok.",
      openFile: "Belgeyi aç",
      expiresHint: "Süresiz belgede boş bırakın",
      expiryBeforeIssue: "Bitiş veriliş tarihinden önce olamaz",
      useSuggestion: "Önerilen bitişi kullan: {{date}}",
      titles: {
        create: "Yeni uyum belgesi",
        renew: "Belgeyi yenile",
        edit: "Kaydı düzelt",
        archive: "Belgeyi arşivle",
      },
      submit: {
        create: "Belgeyi ekle",
        renew: "Yeni belgeyi kaydet",
        edit: "Kaydet",
      },
      done: {
        create: "Belge eklendi",
        renew: "Belge yenilendi; eski belge geçmişe alındı",
        edit: "Belge kaydı düzeltildi",
        archive: "Belge arşivlendi",
      },
    },
    inspections: {
      description:
        "Kurum denetim ziyaretleri: planlı ziyaretler, sonuç ve ceza, tutanak ve düzeltici faaliyetlerin takibi.",
      new: "Yeni ziyaret",
      newDescription: "Planlı bir ziyaret ya da yapılmış bir denetim kaydedin.",
      created: "Denetim ziyareti kaydedildi",
      planned: "Planlı",
      completed: "Yapıldı",
      complete: "Sonuçlandır",
      completeDescription: "Denetim sonucunu ve varsa ceza tutarı ile tutanağı girin.",
      completedToast: "Denetim sonuçlandırıldı",
      cancel: "Ziyareti iptal et",
      cancelDescription: "İptal gerekçesi ziyaretin notuna eklenir.",
      cancelled: "Ziyaret iptal edildi",
      detailTitle: "Denetim ziyareti",
      notFoundTitle: "Ziyaret bulunamadı",
      notFoundDescription: "Ziyaret başka bir istasyonda olabilir ya da görme yetkiniz yok.",
      openActionsOnly: "Açık faaliyeti olanlar",
      actionCounts: "{{open}} açık / {{total}}",
      openReport: "Tutanağı aç",
      emptyTitle: "Denetim kaydı yok",
      emptyDescription: "Süzgeçlere uyan ziyaret bulunmuyor.",
    },
    actions: {
      add: "Faaliyet ekle",
      edit: "Faaliyeti düzenle",
      added: "Düzeltici faaliyet eklendi",
      saved: "Faaliyet kaydedildi",
      complete: "Tamamla",
      completed: "Faaliyet tamamlandı",
      cancel: "Faaliyeti iptal et",
      cancelled: "Faaliyet iptal edildi",
      dialogDescription: "Son tarih yaklaşınca ve geçince sorumlulara alarm gider.",
      none: "Düzeltici faaliyet yok.",
      overdue: "Gecikti",
      dueSoon: "Yaklaşıyor",
      openEvidence: "Kanıtı aç",
    },
    calendar: {
      description:
        "Belge bitişleri ve hatırlatmaları, denetim ziyaretleri, düzeltici faaliyetler, iş emri son anları ve bakım vadeleri.",
      previous: "Önceki ay",
      next: "Sonraki ay",
      today: "Bugün",
      monthView: "Ay",
      listView: "Liste ({{count}})",
      more: "+{{count}} olay",
      empty: "Bu ayda olay yok.",
      hidden: "Yetkiniz olmadığı için gösterilmeyen olaylar: {{kinds}}.",
      tones: {
        INFO: "Bilgi",
        WARNING: "Yaklaşıyor",
        CRITICAL: "Kritik",
        DONE: "Tamamlandı",
      },
    },
  },
  platform: {
    title: "Platform paneli",
    navLabel: "Platform menüsü",
    toTenantPanel: "İşletme paneline dön",
    deniedTitle: "Platform paneline erişiminiz yok",
    deniedDescription: "Bu alan yalnızca platform ekibi içindir. İşletme panelinize dönebilirsiniz.",
    loadFailed: "Platform yetkileri yüklenemedi. Sayfayı yenileyin.",
    mfaRequiredTitle: "İki adımlı doğrulama gerekli",
    mfaRequiredDescription:
      "Platform ekibinin hesaplarında iki adımlı doğrulama zorunludur. Güvenlik ayarlarından etkinleştirdikten sonra panel açılır.",
    noPermissionTitle: "Bu ekran için yetkiniz yok",
    noPermissionDescription:
      "Rolünüz bu bölümü kapsamıyor. Gerekirse bir süper yöneticiden rol değişikliği isteyin.",
    requiredFields: "Zorunlu alanları doldurun.",
    reasonRequired: "Neden en az 3 karakter olmalıdır.",
    all: "Tümü",
    choose: "Seçin",
    yes: "Evet",
    no: "Hayır",
    inactive: "Pasif",
    unlimited: "Sınırsız",
    openEnded: "süresiz",
    nav: {
      overview: "Özet",
      tenants: "Kiracılar",
      plans: "Planlar",
      invoices: "Faturalar",
      payments: "Tahsilat",
      transfers: "İstasyon devirleri",
      support: "Destek erişimi",
      releases: "Yayınlar",
      health: "Sistem sağlığı",
      announcements: "Duyurular",
      staff: "Personel",
      settings: "Ayarlar",
    },
    fields: {
      actions: "İşlemler",
      address: "Adres",
      agents: "Ajan",
      allocations: "Kapatılan faturalar",
      amount: "Tutar",
      anonymizationResult: "Anonimleştirilen kayıtlar",
      anonymizedAt: "Anonimleştirme",
      audience: "Hedef kitle",
      billableStations: "Faturalanan istasyon",
      billingCompany: "Faturayı kesen şirket",
      billingPeriod: "Faturalama dönemi",
      billingTenant: "Faturalama kiracısı",
      body: "Metin",
      cancelReason: "İptal nedeni",
      channel: "Kanal",
      city: "İl",
      closedAt: "Kapanış",
      completedAt: "Tamamlanma",
      coverage: "Kapsam",
      createdAt: "Oluşturulma",
      criticalAlarms: "Kritik alarm",
      currentPeriod: "Geçerli dönem",
      date: "Tarih",
      description: "Açıklama",
      discount: "İndirim",
      discountKind: "İndirim türü",
      district: "İlçe",
      dueDate: "Vade",
      duration: "Süre",
      edocument: "Yasal fatura",
      effective: "Sonuç",
      effectiveDate: "Devir tarihi",
      email: "E-posta",
      estimatedRows: "Tahmini satır",
      expiresAt: "Geçerlilik sonu",
      expiresOn: "Yayından kalkış",
      feature: "Özellik",
      graceDays: "Salt okunura düşme (gün)",
      hours: "Süre (saat)",
      inPlan: "Planda",
      invoiceEmail: "Fatura e-postası",
      invoiceNo: "Fatura no",
      issueDate: "Düzenleme tarihi",
      kind: "Tür",
      lastActivity: "Son kullanım",
      lastLogin: "Son giriş",
      lastMeasured: "Son ölçüm",
      legalName: "Unvan",
      linked: "Cari bağı",
      maxStations: "Azami istasyon",
      members: "Kullanıcı",
      method: "Yöntem",
      mfa: "İki adımlı doğrulama",
      name: "Ad",
      net: "KDV hariç",
      nextChange: "Sonraki dönem",
      note: "Not",
      onboarding: "Kurulum",
      online: "Çevrimiçi",
      outstanding: "Kalan",
      overdueAmount: "Gecikmiş borç",
      override: "Geçersiz kılma",
      ownerEmail: "Sahibin e-postası",
      ownerName: "Sahibin adı soyadı",
      paidOn: "Ödeme tarihi",
      paymentTerm: "Ödeme vadesi",
      paymentTermDays: "Ödeme vadesi (gün)",
      percent: "Yüzde",
      period: "Dönem",
      plan: "Plan",
      planCode: "Plan kodu",
      planName: "Plan adı",
      platform: "İşletim sistemi",
      quantity: "Miktar",
      queue: "Kuyruk",
      reason: "Neden",
      reasonKind: "Kapanış nedeni",
      reference: "Dekont / referans",
      releasedAt: "Yayın tarihi",
      reminderDays: "Hatırlatma günleri",
      reminders: "Gönderilen hatırlatmalar",
      request: "İstek",
      requestedAt: "İstenme",
      requestedBy: "İsteyen",
      requestedVia: "Kaynak",
      requests: "İstek sayısı",
      retentionUntil: "Saklama sonu",
      retentionYears: "Saklama süresi (yıl)",
      role: "Rol",
      rollout: "Kademeli yayın",
      rolloutPercent: "Yayın yüzdesi",
      rows: "Satır",
      search: "Ara",
      size: "Boyut",
      sourceTenant: "Devreden kiracı",
      staff: "Personel",
      startedOn: "Başlangıç",
      state: "Durum",
      station: "İstasyon",
      stationMonthlyPrice: "İstasyon başına aylık (KDV hariç)",
      stations: "İstasyon",
      status: "Durum",
      statusChangedAt: "Durum değişikliği",
      statusCode: "Yanıt",
      statusReason: "Durum nedeni",
      strategy: "Yöntem",
      subscription: "Abonelik",
      table: "Tablo",
      targetCompany: "Devralan şirket",
      targetTenant: "Devralan kiracı",
      taxId: "VKN / TCKN",
      taxOffice: "Vergi dairesi",
      tenant: "Kiracı",
      tenantName: "Kiracı adı",
      ticketRef: "Destek kaydı no",
      time: "Zaman",
      title: "Başlık",
      total: "Toplam",
      trialDays: "Deneme süresi (gün)",
      trialEndsOn: "Deneme bitişi",
      unallocated: "Artan",
      unitPrice: "Birim fiyat",
      updatedAt: "Güncelleme",
      users: "Kullanıcı",
      validFrom: "Geçerlilik başlangıcı",
      validTo: "Geçerlilik bitişi",
      vatRateCode: "KDV oranı kodu",
      version: "Sürüm",
      voidReason: "İptal nedeni",
      yearlyDiscount: "Yıllık ödeme indirimi (%)",
    },
    overview: {
      title: "Platform özeti",
      description: "Kiracılar, alacaklar ve sistemin genel durumu.",
      tenants: "Kiracılar",
      active: "Etkin",
      trial: "Denemede",
      readOnly: "Salt okunur",
      suspended: "Askıda",
      stations: "Etkin istasyon",
      pendingSupport: "Onay bekleyen destek isteği",
      receivables: "Alacaklar",
      allInvoices: "Tüm faturalar",
      outstanding: "Açık alacak",
      overdue: "Gecikmiş alacak",
      overdueInvoices: "Gecikmiş fatura",
      pastDueTenants: "Ödemesi geciken kiracı",
      overdueList: "Vadesi geçmiş faturalar",
      health: "Sistem sağlığı",
      healthDetail: "Ayrıntılar",
    },
    tenants: {
      title: "Kiracılar",
      description: "İşletmeci hesapları, abonelik durumları ve kullanım.",
      detail: "Kiracı",
      create: "Kiracı oluştur",
      new: "Yeni kiracı",
      newDescription:
        "Deneme aboneliğiyle başlar. Sahibin hesabı varsa hemen bağlanır; yoksa e-postasına davet gönderilir.",
      created: "Kiracı oluşturuldu",
      createdInvited: "Kiracı oluşturuldu, sahibe davet gönderildi",
      trialHint: "Boş bırakılırsa planın deneme süresi uygulanır.",
      ownerHint: "Hesabı yoksa bu adrese davet gider.",
      empty: "Koşullara uyan kiracı yok.",
      searchPlaceholder: "Kiracı adı",
      onlyOverdue: "Yalnızca borcu gecikenler",
      billingLock: "Ödeme nedeniyle",
      billingLockDescription:
        "Bu kiracı ödenmeyen fatura nedeniyle salt okunura düştü. Veriler silinmez; ödeme kaydedilince kendiliğinden açılır.",
      tabsLabel: "Kiracı bölümleri",
      tab: {
        general: "Genel",
        subscription: "Abonelik",
        invoices: "Faturalar",
        features: "Özellikler",
        support: "Destek",
        data: "Veri",
      },
      general: "Genel bilgiler",
      owners: "Sahipler",
      noOwner: "Sahip atanmamış.",
      invited: "Davet edildi",
      companies: "Şirketler",
      noCompany: "Henüz şirket tanımlanmamış.",
      stations: "İstasyonlar",
      noStation: "Henüz istasyon yok.",
      onboardingDone: "Tamamlandı",
      onboardingPending: "Sürüyor",
      statusChanged: "Kiracı durumu: {{status}}",
      statusAction: {
        ACTIVE: "Etkinleştir",
        SUSPENDED: "Askıya al",
        READ_ONLY: "Salt okunura al",
      },
      statusTitle: {
        ACTIVE: "Kiracıyı etkinleştir",
        SUSPENDED: "Kiracıyı askıya al",
        READ_ONLY: "Kiracıyı salt okunura al",
      },
      statusDescription: {
        ACTIVE: "Kullanıcılar yeniden tam yetkiyle çalışabilir.",
        SUSPENDED: "Kullanıcılar oturum açamaz; veriler korunur. Neden kiracının denetim izine yazılır.",
        READ_ONLY:
          "Kullanıcılar verilerini görür ve dışa aktarabilir, yeni kayıt giremez. Neden kiracının denetim izine yazılır.",
      },
    },
    subscription: {
      title: "Abonelik",
      none: "Abonelik yok",
      change: "Aboneliği değiştir",
      changeDescription: "Plan ve dönem değişikliği bir sonraki dönemden geçerlidir.",
      changeTrialDescription: "Deneme süresinde plan değişikliği hemen geçerlidir.",
      saved: "Abonelik güncellendi",
      termInvalid: "Ödeme vadesi 0–90 gün olmalıdır.",
      cancelAtPeriodEnd: "Dönem sonunda sona ersin",
      endTrialNow: "Denemeyi bugün bitir",
      addDiscount: "İndirim ekle",
      discountDescription: "Yüzde ya da tutar; geçerlilik aralığındaki faturalara uygulanır.",
      discountAdded: "İndirim eklendi",
      discountDeactivated: "İndirim pasifleştirildi",
      discounts: "İndirimler",
      deactivate: "Pasifleştir",
      kindPercent: "Yüzde",
      kindAmount: "Tutar",
      days: "{{count}} gün",
      usage: "Kullanım",
      dailyUsage: "Günlük kullanım",
      notMeasured: "Henüz ölçüm yok.",
      preview: "Fatura önizlemesi",
    },
    billingProfile: {
      title: "Fatura profili",
      edit: "Fatura profili",
      create: "Profil oluştur",
      description:
        "Faturalar bu unvan ve vergi numarasına kesilir; e-posta ödeme hatırlatmaları için kullanılır.",
      saved: "Fatura profili kaydedildi",
      invalid: "Unvan, 10 ya da 11 haneli vergi numarası ve e-posta zorunludur.",
      missing: "Fatura profili yok — fatura kesilemez.",
      linked: "Cari açıldı",
      notLinked: "Cari bekliyor",
    },
    invoices: {
      title: "Faturalar",
      description: "Dönem sonunda kesilen abonelik ve kullanım faturaları.",
      detail: "Fatura",
      detailTitle: "Fatura {{no}}",
      empty: "Fatura yok.",
      summary: "Özet",
      lines: "Fatura satırları",
      vat: "KDV (%{{rate}})",
      overdueDays: "{{count}} gün gecikti",
      reminderDay: "{{count}}. gün",
      state: {
        OPEN: "Ödenmedi",
        OVERDUE: "Gecikti",
        PAID: "Ödendi",
        VOID: "İptal",
      },
      runNow: "Faturalamayı çalıştır",
      runAll: "Faturalamayı çalıştır",
      runIssued: "{{count}} fatura kesildi",
      runNothing: "Kesilecek fatura yok",
      retry: "Yasal faturayı yeniden dene",
      edocumentCreated: "Yasal fatura kesildi",
      edocumentFailed: "Yasal fatura kesilemedi",
      void: "Faturayı iptal et",
      voidTitle: "{{no}} faturasını iptal et",
      voidDescription:
        "Yalnızca ödeme almamış ve yasal faturası kesilmemiş fatura iptal edilir. Fatura silinmez; iptal nedeniyle birlikte saklanır.",
      voided: "Fatura iptal edildi",
    },
    payments: {
      title: "Tahsilat",
      description:
        "Ödemeler en eski açık faturadan başlayarak kapatılır; hatalı kayıt ters çevrilir, silinmez.",
      empty: "Ödeme kaydı yok.",
      none: "Bu faturaya ödeme eşleşmedi.",
      record: "Ödeme kaydet",
      recordDescription: "Tutar kiracının açık faturalarına en eskiden başlayarak dağıtılır.",
      recordedToast: "Ödeme kaydedildi ({{count}} fatura kapandı)",
      recorded: "Kayıtlı",
      reverse: "Ters çevir",
      reverseTitle: "Ödemeyi ters çevir",
      reverseDescription:
        "Eşleşmeler geri alınır ve faturalar yeniden açılır; gecikme kuralları bugünkü tarihle yeniden değerlendirilir.",
      reversed: "Ters çevrildi",
      reversedToast: "Ödeme ters çevrildi",
    },
    plans: {
      title: "Planlar",
      description: "İstasyon başına fiyatlar (geçerlilik tarihli), özellikler ve kullanım fiyatları.",
      empty: "Plan tanımlı değil.",
      new: "Yeni plan",
      edit: "Düzenle",
      editTitle: "{{name}} planını düzenle",
      dialogDescription:
        "Fiyat değişikliği geçmişi silmez; yeni fiyat geçerlilik tarihinden itibaren uygulanır.",
      codeHint: "BÜYÜK harf, rakam ve alt çizgi (ör. PRO_2027).",
      maxStationsHint: "Boş → sınırsız.",
      newInvalid: "Plan kodu biçimi ya da fiyat hatalı.",
      created: "Plan oluşturuldu",
      saved: "Plan kaydedildi",
      active: "Satışta",
      features: "Özellikler",
      tenantCount: "{{count}} kiracı",
      newPrice: "Yeni fiyat",
      addPrice: "{{name}} için yeni fiyat",
      addPriceSubmit: "Fiyatı ekle",
      priceDescription: "Önceki fiyatlar silinmez; faturalar dönemin başındaki fiyatla hesaplanır.",
      priceAdded: "Fiyat eklendi",
      priceHistory: "Fiyat geçmişi ({{count}})",
      usagePrices: "Kullanım fiyatları",
      usageTitle: "{{name}} kullanım fiyatları",
      usageDescription: "Dahil miktarı aşan her birim, birim fiyatla faturalanır.",
      usageInvalid: "Dahil miktar tam sayı olmalıdır.",
      usageSaved: "Kullanım fiyatları kaydedildi",
      editUsage: "Kullanım fiyatları",
      noUsagePrices: "Kullanım fiyatı yok.",
      included: "{{count}} dahil",
      includedOf: "{{item}} — dahil miktar",
      unitPriceOf: "{{item}} — birim fiyat",
    },
    features: {
      title: "Özellikler",
      description:
        "Sonuç sırası: plan → kademeli yayın → kiracı geçersiz kılması. İstasyon kısıtı yalnızca kapatır.",
      followPlan: "Plana bırak",
      forceOn: "Açık",
      forceOff: "Kapalı",
      on: "Açık",
      off: "Kapalı",
      overrideFor: "{{feature}} için geçersiz kılma",
      rolloutIncluded: "Yayında",
      rolloutExcluded: "Yayın dışı",
      saved: "Özellik güncellendi",
      stationTitle: "İstasyon kısıtı",
      stationDescription: "Bir özelliği tek bir istasyonda kapatır; kaldırınca kiracının ayarı geçerli olur.",
      stationOff: "Bu istasyonda kapat",
      stationClear: "Kısıtı kaldır",
      stationSaved: "İstasyon kısıtı kaydedildi",
      stationOffBadge: "{{feature}} kapalı",
      agentChannel: "Ajan güncelleme kanalı",
      agentChannelDescription: "Kiracının tüm etkin ajanlarını seçilen kanala alır (beta: erken sürümler).",
      applyChannel: "Kanalı uygula",
      channelSaved: "{{count}} ajan güncellendi",
    },
    rollouts: {
      title: "Özellik yayınları",
      description:
        "Planında özellik bulunan kiracılara kademeli açılış. Yüzde yöntemi kiracıyı kalıcı bir kovaya yerleştirir; yüzde artınca eklenenler açık kalır.",
      empty: "Süren kademeli yayın yok.",
      new: "Yeni yayın",
      edit: "{{feature}} yayını",
      editShort: "Düzenle",
      dialogDescription: "Yayın tamamlanana kadar kapsam dışındaki kiracılarda özellik kapalı kalır.",
      strategy: {
        PERCENT: "Yüzde",
        LIST: "Kiracı listesi",
      },
      tenants: "Kiracılar",
      percentInvalid: "Yüzde 0–100 arası tam sayı olmalıdır.",
      listEmpty: "En az bir kiracı seçin.",
      saved: "Yayın kaydedildi",
      percentValue: "%{{percent}}",
      listValue: "{{count}} kiracı",
      coverage: "{{included}} / {{eligible}} kiracı",
      complete: "Tamamla",
      completeTitle: "{{feature}} yayınını tamamla",
      completeDescription: "Yayın kaldırılır; özellik planında olan tüm kiracılarda açılır.",
      completed: "Yayın tamamlandı",
    },
    releases: {
      title: "Yayınlar",
      description: "Özelliklerin kademeli açılışı ve istasyon ajanlarının sürüm dağılımı.",
      distribution: "Ajan sürüm dağılımı",
      totals: "{{agents}} ajan · {{online}} çevrimiçi · {{beta}} beta kanalında",
      noAgents: "Kayıtlı ajan yok.",
      byTenant: "Kiracılara göre",
      tenantLine: "{{agents}} ajan, {{beta}} beta",
      agentReleases: "Ajan sürümleri",
      empty: "Yayınlanmış ajan sürümü yok.",
      active: "Etkin",
      changeRollout: "Yüzdeyi değiştir",
      rollout: "{{version}} yayın yüzdesi",
      rolloutDescription: "Ajanlar kararlı bir kovaya göre yükselir; %100 tüm ajanlar demektir.",
      saved: "Yayın yüzdesi kaydedildi",
    },
    transfers: {
      title: "İstasyon devirleri",
      description:
        "Devreden ve devralan kiracının yetkilileri onaylar; devir tarihinde yürütülür. Eski kiracının geçmiş verisi onda kalır.",
      empty: "Devir isteği yok.",
      new: "Devir isteği aç",
      newDescription:
        "İki kiracıya da onay isteği düşer; devir, iki onay ve devir tarihinden sonra yürütülür.",
      create: "İsteği aç",
      created: "Devir isteği açıldı",
      sameTenant: "Devreden ve devralan kiracı aynı olamaz.",
      status: {
        PENDING: "Onay bekliyor",
        COMPLETED: "Tamamlandı",
        CANCELLED: "İptal",
      },
      sourceApproval: "Devreden onayı",
      targetApproval: "Devralan onayı",
      pendingApproval: "Bekliyor",
      execute: "Devri yürüt",
      executed: "Devir tamamlandı",
      waitingApprovals: "İki kiracının onayı bekleniyor.",
      waitingDate: "Devir tarihi gelmedi.",
      cancel: "İptal et",
      cancelTitle: "Devir isteğini iptal et",
      cancelDescription: "İstek iptal edilir; iki kiracıya da bildirim gider.",
      cancelled: "Devir isteği iptal edildi",
      report: "Devir raporu",
      moved: "Taşınanlar",
      stayed: "Eski kiracıda kalanlar",
      warnings: "Uyarılar",
    },
    support: {
      title: "Destek erişimi",
      description:
        "Kiracının onayıyla, süreli ve salt okunur erişim. Her istek kiracının göreceği kayda yazılır; kiracı istediği an geri alabilir.",
      readOnlyNotice:
        "Destek oturumunda hiçbir kayıt değiştirilemez. Girişte ekranın üstünde kiracı adıyla bir şerit görünür.",
      empty: "Destek erişimi kaydı yok.",
      request: "Erişim iste",
      requestDescription: "Kiracının yetkilisine onay isteği gider. Neden ve süre kiracıya gösterilir.",
      sendRequest: "İsteği gönder",
      requested: "Erişim isteği gönderildi",
      hoursHint: "En çok 8 saat.",
      hoursOption: "{{count}} saat",
      hours: "{{count}} sa",
      remaining: "{{time}} kaldı",
      enter: "Kiracıya gir",
      withdraw: "Geri çek",
      end: "Sonlandır",
      cancelled: "Erişim sonlandırıldı",
      events: "İstek kaydı",
      eventsDescription: "Destek oturumunda yapılan her istek (yöntem, yol, yanıt kodu).",
      eventKind: {
        ENTER: "Giriş",
        REQUEST: "İstek",
        EXIT: "Çıkış",
      },
      onlyMine: "Yalnızca benimkiler",
    },
    exports: {
      title: "Veri dışa aktarımı",
      description:
        "Kiracının tüm verisi tablo başına NDJSON olarak ZIP'lenir; bağlantı kısa ömürlüdür ve indirme kiracının denetim izine yazılır.",
      empty: "Dışa aktarım yok.",
      request: "Dışa aktarım başlat",
      requested: "Dışa aktarım kuyruğa alındı",
      download: "İndir",
      status: {
        QUEUED: "Sırada",
        RUNNING: "Hazırlanıyor",
        READY: "Hazır",
        FAILED: "Hata",
        EXPIRED: "Süresi doldu",
      },
      via: {
        PLATFORM: "Platform",
        TENANT: "Kiracı",
        CLOSURE: "Kapanış",
      },
    },
    closure: {
      title: "Kapanış ve anonimleştirme",
      description:
        "Kapanışta son bir dışa aktarım alınır, abonelik iptal edilir ve saklama süresi başlar. Süre dolunca kişisel veriler anonimleştirilir; kayıtlar silinmez.",
      close: "Kiracıyı kapat",
      closeDescription: "Kullanıcılar oturum açamaz. Yasal saklama süresi boyunca veriler korunur.",
      warning: "Bu işlem geri alınamaz. Kapanıştan sonra kiracı yeniden açılamaz.",
      confirmLabel: "Onay için kiracı adını yazın: {{name}}",
      confirmMismatch: "Kiracı adı eşleşmiyor.",
      closed: "Kiracı kapatıldı",
      anonymize: "Kişisel veriyi anonimleştir",
      anonymizeDescription:
        "Kullanıcı, müşteri ve personel gibi kişisel alanlar geri döndürülemez biçimde maskelenir. Mali kayıtlar korunur.",
      anonymizeWarning: "Bu işlem geri alınamaz.",
      anonymized: "Kişisel veriler anonimleştirildi",
      status: {
        CLOSED: "Kapalı (saklama süresinde)",
        ANONYMIZED: "Anonimleştirildi",
      },
    },
    announcements: {
      title: "Duyurular",
      description:
        "Sürüm notları, duyurular ve planlı bakımlar. Önemli olanlar kiracının ekranında şerit olarak görünür.",
      empty: "Duyuru yok.",
      new: "Yeni duyuru",
      edit: "Duyuruyu düzenle",
      editShort: "Düzenle",
      dialogDescription: "Taslak olarak kaydedilir; yayınlayınca hedef kiracıların duyuru merkezine düşer.",
      important: "Önemli (ekranda şerit olarak göster)",
      importantBadge: "Önemli",
      plans: "Planlar",
      plansEmpty: "En az bir plan seçin.",
      saved: "Duyuru kaydedildi",
      audience: {
        ALL: "Tüm kiracılar",
        PLANS: "Seçili planlar",
        TENANTS: "Seçili kiracılar",
      },
      status: {
        DRAFT: "Taslak",
        PUBLISHED: "Yayında",
        ARCHIVED: "Arşivde",
      },
      publishedAt: "Yayın: {{time}}",
      notPublished: "Yayınlanmadı",
      expiresAt: "Bitiş: {{time}}",
      readCount: "{{count}} kiracı okudu",
      publish: "Yayınla",
      publishTitle: "“{{title}}” yayınlansın mı?",
      publishDescription: "Hedef kiracıların duyuru merkezine hemen düşer.",
      published: "Duyuru yayınlandı",
      archive: "Arşivle",
      archiveTitle: "“{{title}}” arşivlensin mi?",
      archiveDescription: "Duyuru kiracıların listesinden kalkar; kayıt silinmez.",
      archived: "Duyuru arşivlendi",
    },
    health: {
      title: "Sistem sağlığı",
      description: "Kuyruklar, olay akışı, e-belge hataları, çevrimdışı ajanlar ve veritabanı boyutu.",
      refresh: "Yenile",
      generatedAt: "Ölçüm zamanı: {{time}}",
      outboxPending: "Bekleyen olay",
      outboxLag: "Olay gecikmesi",
      seconds: "{{count}} sn",
      failedJobs: "Başarısız işler",
      noFailedJobs: "Başarısız iş yok.",
      attempts: "{{count}} deneme",
      offlineAgents: "Çevrimdışı ajan",
      noOfflineAgents: "Çevrimdışı ajan yok.",
      neverSeen: "hiç bağlanmadı",
      edocumentErrors: "e-Belge hataları",
      noEdocumentErrors: "e-Belge hatası yok.",
      edocumentLine: "{{invoices}} fatura, {{despatches}} irsaliye",
      databaseSize: "Veritabanı",
      queues: "İş kuyrukları",
      waiting: "Bekleyen",
      active: "Çalışan",
      delayed: "Ertelenen",
      failed: "Başarısız",
      tables: "En büyük tablolar",
    },
    staff: {
      title: "Personel",
      description:
        "Platform rolleri: süper yönetici, destek, finans, salt okunur. Rol yalnızca var olan bir kullanıcı hesabına verilir.",
      empty: "Platform personeli yok.",
      add: "Personel ekle",
      addDescription:
        "Kullanıcının hesabı önceden açılmış olmalıdır; rol eklenince platform paneline erişir.",
      added: "Personel eklendi",
      roleFor: "{{name}} rolü",
      roleChanged: "Rol değiştirildi",
      remove: "Yetkiyi kaldır",
      removeTitle: "{{name}} platform yetkisini kaldır",
      removeDescription: "Kullanıcı hesabı kalır; yalnızca platform paneline erişimi sona erer.",
      removed: "Platform yetkisi kaldırıldı",
      mfaOn: "Açık",
      mfaOff: "Kapalı",
    },
    settings: {
      title: "Platform ayarları",
      description: "Kendi faturalarımız, gecikme kuralları ve saklama süresi.",
      saved: "Ayarlar kaydedildi",
      billing: "Faturalama",
      billingDescription:
        "Abonelik faturaları bu kiracının bu şirketinden, e-belge altyapısıyla kesilir. KDV oranı kodu o kiracının vergi tablosundan gelir.",
      configured: "Yapılandırıldı",
      notConfigured: "Yapılandırılmadı",
      dunning: "Gecikme kuralları",
      dunningDescription:
        "Vadeden sonraki hatırlatma günleri ve kiracının salt okunura düşeceği gün. Veriler hiçbir aşamada silinmez.",
      reminderDaysHint: "Virgülle ayırın (ör. 1, 7).",
      dunningInvalid: "Hatırlatma günleri 1–60, salt okunur süresi 1–120 gün olmalıdır.",
      retention: "Saklama süresi",
      retentionDescription:
        "Kapanan kiracının verisi bu süre boyunca saklanır; ardından kişisel veriler anonimleştirilebilir.",
      retentionInvalid: "Saklama süresi 1–30 yıl olmalıdır.",
    },
  },
  account: {
    noPermission: "Bu ekran için yetkiniz yok. Hesap yöneticinizden izin isteyin.",
    subscription: {
      description:
        "Planınız, kullanımınız, platform faturalarınız, fatura bilgileriniz ve verinizin tamamının dışa aktarımı.",
      plan: "Plan",
      features: "Plandaki modüller",
      changeHint:
        "Plan ya da dönem değişikliği için platform ekibiyle iletişime geçin; değişiklik bir sonraki dönemden geçerli olur.",
      usage: "Bu dönemin kullanımı",
      usageHint:
        "Faturalanan istasyon sayısı, dönem içinde aynı gün etkin olan en yüksek istasyon sayısıdır.",
      outstandingTitle: "Ödenmemiş faturanız var",
      outstandingDescription: "Açık tutar:",
      editProfile: "Fatura bilgilerini düzenle",
      profileMissing: "Fatura bilgisi girilmemiş — faturalarınız bu unvan ve vergi numarasına kesilir.",
      exportDescription:
        "Hesabınızdaki tüm veri tablo başına dosyalar hâlinde tek bir ZIP'e hazırlanır. Bağlantı kısa ömürlüdür; her indirme denetim izine yazılır.",
      exportRequested: "Dışa aktarım hazırlanıyor; hazır olunca listeden indirebilirsiniz.",
    },
    support: {
      description: "Platform destek ekibinin hesabınıza erişim istekleri, onaylarınız ve her erişimin kaydı.",
      howTitle: "Destek erişimi nasıl çalışır?",
      howDescription:
        "Platform ekibi yalnızca sizin onayınızla, istediği süre boyunca ve SALT OKUNUR girebilir. Erişim sürerken ekranınızın üstünde bir uyarı görünür; dilediğiniz an geri alabilirsiniz. Yapılan her istek aşağıdaki kayıtta görünür.",
      empty: "Destek erişimi isteği yok.",
      staff: "Destek personeli",
      note: "Not (isteğe bağlı)",
      approve: "Onayla",
      deny: "Reddet",
      revoke: "Erişimi geri al",
      title: {
        approve: "Destek erişimini onayla",
        deny: "Destek erişimini reddet",
        revoke: "Destek erişimini geri al",
      },
      dialogDescription: {
        approve: "{{staff}} hesabınızı {{hours}} saat boyunca salt okunur görüntüleyebilecek.",
        deny: "{{staff}} hesabınıza erişemeyecek.",
        revoke: "{{staff}} kullanıcısının destek oturumu hemen sona erer.",
      },
      done: {
        approve: "Destek erişimi onaylandı",
        deny: "Destek erişimi reddedildi",
        revoke: "Destek erişimi geri alındı",
      },
    },
    transfers: {
      description: "Hesabınızın taraf olduğu istasyon devirleri: onayınız, devir tarihi ve devir raporu.",
      empty: "İstasyon devri yok.",
      emptyDescription:
        "Bir istasyonun satışı ya da devri platform ekibince açıldığında onay isteği burada görünür.",
      side: {
        SOURCE: "Devreden taraf",
        TARGET: "Devralan taraf",
      },
      explain: {
        SOURCE:
          "Devir tarihinden sonra istasyonun yeni kayıtları devralan hesaba geçer; bugüne kadarki geçmiş veriniz sizde kalır.",
        TARGET:
          "Devir tarihinden itibaren istasyon hesabınızda seçtiğiniz şirkete bağlanır; önceki geçmiş devreden hesapta kalır.",
      },
      approve: "Devri onayla",
      approved: "Devir onaylandı",
      confirmTitle: "{{station}} devrini onayla",
      confirmDescription: {
        SOURCE: "İstasyon {{date}} tarihinde {{target}} hesabına devredilecek. Bu onay geri alınamaz.",
        TARGET: "İstasyon {{date}} tarihinde hesabınıza devralınacak. Bu onay geri alınamaz.",
      },
    },
    announcements: {
      description: "Sürüm notları, duyurular ve planlı bakımlar.",
      empty: "Henüz duyuru yok.",
      new: "Yeni",
      markRead: "Okundu olarak işaretle",
    },
    banner: {
      supportSessionTitle: "Destek oturumu: {{tenant}}",
      supportSessionDescription:
        "Bu hesabı salt okunur görüntülüyorsunuz; yaptığınız her istek hesabın sahiplerinin göreceği kayda yazılır. Kalan süre: {{time}}.",
      exitSupport: "Destek oturumundan çık",
      supportActiveTitle: "Platform desteği hesabınızı görüntülüyor",
      supportActiveDescription: "{{staff}} onayınızla salt okunur erişimde. Kalan süre: {{time}}.",
      manageSupport: "Erişimi yönet",
      supportPendingTitle: "{{count}} destek erişimi isteği onayınızı bekliyor",
      reviewRequests: "İstekleri incele",
      billingReadOnlyTitle: "Hesap ödeme nedeniyle salt okunur",
      billingReadOnlyDescription:
        "Vadesi geçen faturanız ödenene kadar yeni kayıt girilemez. Verileriniz silinmez; görüntüleyebilir ve dışa aktarabilirsiniz. Ödeme kaydedilince hesap kendiliğinden açılır.",
      toSubscription: "Faturaları görüntüle",
      allAnnouncements: "Tüm duyurular",
    },
  },
} as const;

export type TranslationResources = typeof tr;
